/** Generate by swagger-axios-codegen */
// tslint:disable
/* eslint-disable */
import axiosStatic, { AxiosInstance } from 'axios';

export interface IRequestOptions {
  headers?: any;
  baseURL?: string;
  responseType?: string;
}

export interface IRequestConfig {
  method?: any;
  headers?: any;
  url?: any;
  data?: any;
  params?: any;
}

// Add options interface
export interface ServiceOptions {
  axios?: AxiosInstance;
}

// Add default options
export const serviceOptions: ServiceOptions = {};

// Instance selector
export function axios(configs: IRequestConfig, resolve: (p: any) => void, reject: (p: any) => void): Promise<any> {
  if (serviceOptions.axios) {
    return serviceOptions.axios
      .request(configs)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
  } else {
    throw new Error('please inject yourself instance like axios  ');
  }
}

export function getConfigs(method: string, contentType: string, url: string, options: any): IRequestConfig {
  const configs: IRequestConfig = { ...options, method, url };
  configs.headers = {
    ...options.headers,
    'Content-Type': contentType
  };
  return configs;
}

export class IList<T> extends Array<T> {}
export class List<T> extends Array<T> {}

export interface IListResult<T> {
  items?: T[];
}

export class ListResultDto<T> implements IListResult<T> {
  items?: T[];
}

export interface IPagedResult<T> extends IListResult<T> {
  totalCount: number;
}

export class PagedResultDto<T> implements IPagedResult<T> {
  totalCount!: number;
}

// customer definition
// empty

export class AccountService {
  /**
   *
   */
  static authorize(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/connect/oauth2/authorize';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAuthUrl(options: IRequestOptions = {}): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = '/api/Account/GetAuthUrl';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static qyWeiXinLogin(
    params: {
      /**  */
      code?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/Account/QyWeiXinLogin';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { code: params['code'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static qyWeiXinLogin1(
    params: {
      /** requestBody */
      body?: QyWeiXinLoginPostModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ExternalAuthenticateResultModel> {
    return new Promise((resolve, reject) => {
      let url = '/api/Account/QyWeiXinLogin';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static isTenantAvailable(
    params: {
      /** requestBody */
      body?: IsTenantAvailableInput;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<IsTenantAvailableOutput> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Account/IsTenantAvailable';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 微信用户登录
   */
  static weiXinLogin(
    params: {
      /**  */
      weiXinUser?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<LoginPostRespDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Account/WeiXinLogin';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { weiXinUser: params['weiXinUser'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 注册
   */
  static register(
    params: {
      /** requestBody */
      body?: RegisterInput;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<RegisterOutput> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Account/Register';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 登录
   */
  static login(
    params: {
      /** requestBody */
      body?: LoginPostReqDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<LoginPostRespDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Account/Login';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static checkUserMobilePhone(
    params: {
      /**  */
      phone?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AbpInvokeReturn> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Account/CheckUserMobilePhone';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { phone: params['phone'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getVerificationCode(
    params: {
      /**  */
      phone?: string;
      /**  */
      verificationCode?: VerificationCode;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Account/GetVerificationCode';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { phone: params['phone'], verificationCode: params['verificationCode'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static checkVerificationCode(
    params: {
      /**  */
      phone?: string;
      /**  */
      code?: string;
      /**  */
      verificationCode?: VerificationCode;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AbpInvokeReturn> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Account/CheckVerificationCode';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { phone: params['phone'], code: params['code'], verificationCode: params['verificationCode'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class ActivityService {
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ActivityDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Activity/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAllByPortal(
    params: {
      /** 标题 */
      title?: string;
      /** 状态 */
      status?: ActivityStatus;
      /** 是否为志愿者活动 */
      isVolunteerActivity?: boolean;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ActivityDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Activity/GetAllByPortal';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Title: params['title'],
        Status: params['status'],
        IsVolunteerActivity: params['isVolunteerActivity'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 发布活动
   */
  static publish(
    params: {
      /** requestBody */
      body?: Int64EntityDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Activity/Publish';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 取消发布活动
   */
  static cancelPublish(
    params: {
      /** requestBody */
      body?: Int64EntityDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Activity/CancelPublish';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取二维码
   */
  static downQrCode(
    params: {
      /**  */
      id?: number;
      /**  */
      qrType?: ActivityQrType;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Activity/DownQrCode';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { id: params['id'], qrType: params['qrType'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 更新阅读数量
   */
  static updateReadCount(
    params: {
      /** requestBody */
      body?: Int64EntityDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Activity/UpdateReadCount';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 判断活动是否可以报名
   */
  static canSignupActivity(
    params: {
      /** requestBody */
      body?: Int64EntityDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AbpInvokeReturn> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Activity/CanSignupActivity';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: ActivityCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ActivityDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Activity/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: ActivityCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ActivityDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Activity/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Activity/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getForEdit(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ActivityCreateOrUpdateDtoGetForEditOutput> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Activity/GetForEdit';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /** 标题 */
      title?: string;
      /** 状态 */
      status?: ActivityStatus;
      /** 是否为志愿者活动 */
      isVolunteerActivity?: boolean;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ActivityDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Activity/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Title: params['title'],
        Status: params['status'],
        IsVolunteerActivity: params['isVolunteerActivity'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class ActivityApplyService {
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ActivityApplyDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ActivityApply/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: ActivityApplyCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ActivityApplyDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ActivityApply/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取服务记录统计
   */
  static getTotalDetails(
    params: {
      /**  */
      activityId?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ActivityApply/GetTotalDetails';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { activityId: params['activityId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAllPaid(
    params: {
      /**  */
      activityId?: number;
      /**  */
      activityTitle?: string;
      /**  */
      applyUserPhone?: string;
      /**  */
      applyUserName?: string;
      /**  */
      isPay?: boolean;
      /**  */
      isPriced?: boolean;
      /**  */
      isOnlyMine?: boolean;
      /** 1:已付款；2:未付款；3:已关闭 */
      specialType?: number;
      /**  */
      status?: ActivityApplyStatus;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ActivityApplyDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ActivityApply/GetAllPaid';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        ActivityId: params['activityId'],
        ActivityTitle: params['activityTitle'],
        ApplyUserPhone: params['applyUserPhone'],
        ApplyUserName: params['applyUserName'],
        IsPay: params['isPay'],
        IsPriced: params['isPriced'],
        IsOnlyMine: params['isOnlyMine'],
        SpecialType: params['specialType'],
        Status: params['status'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAllPriced(
    params: {
      /**  */
      activityId?: number;
      /**  */
      activityTitle?: string;
      /**  */
      applyUserPhone?: string;
      /**  */
      applyUserName?: string;
      /**  */
      isPay?: boolean;
      /**  */
      isPriced?: boolean;
      /**  */
      isOnlyMine?: boolean;
      /** 1:已付款；2:未付款；3:已关闭 */
      specialType?: number;
      /**  */
      status?: ActivityApplyStatus;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ActivityApplyDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ActivityApply/GetAllPriced';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        ActivityId: params['activityId'],
        ActivityTitle: params['activityTitle'],
        ApplyUserPhone: params['applyUserPhone'],
        ApplyUserName: params['applyUserName'],
        IsPay: params['isPay'],
        IsPriced: params['isPriced'],
        IsOnlyMine: params['isOnlyMine'],
        SpecialType: params['specialType'],
        Status: params['status'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static postToAudit(
    params: {
      /** requestBody */
      body?: Int64EntityDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ActivityApply/PostToAudit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 下载导入模板
   */
  static downloadTemplate(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ActivityApply/DownloadTemplate';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static import(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ImportResult> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ActivityApply/Import';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 导出活动名单
   */
  static exportExcel(
    params: {
      /** requestBody */
      body?: ActivityApplyPagedResultRequestDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ActivityApply/ExportExcel';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 导出活动名单
   */
  static exportOrderExcel(
    params: {
      /** requestBody */
      body?: ActivityApplyPagedResultRequestDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ActivityApply/ExportOrderExcel';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getForEdit(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ActivityApplyCreateOrUpdateDtoGetForEditOutput> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ActivityApply/GetForEdit';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 报名签到,有管理权限的可以为别人签到
   */
  static checkIn(
    params: {
      /** requestBody */
      body?: Int64EntityDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ActivityApply/CheckIn';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 取消报名记录（不处理订单）
   */
  static cancelActivityApply(
    params: {
      /** requestBody */
      body?: Int64EntityDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ActivityApply/CancelActivityApply';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 未支付取消(用户可以取消自己的报名,管理员可以任意取消)
   */
  static unPaidCancel(
    params: {
      /** requestBody */
      body?: Int64EntityDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ActivityApply/UnPaidCancel';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 未支付取消(用户可以取消自己的报名,管理员可以任意取消)
   */
  static unPaidToAudited(
    params: {
      /** requestBody */
      body?: Int64EntityDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ActivityApply/UnPaidToAudited';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 报名
   */
  static signUp(
    params: {
      /** requestBody */
      body?: ActivityApplyCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ActivityApplyDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ActivityApply/SignUp';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取活动报名订单
   */
  static getActivityApplyOrder(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<OrderDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ActivityApply/GetActivityApplyOrder';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取活动报名
   */
  static getActivityApplyByOrderNo(
    params: {
      /**  */
      orderNo?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ActivityApplyDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ActivityApply/GetActivityApplyByOrderNo';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { orderNo: params['orderNo'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 处理支付回调
   */
  static processOrderResponse(
    params: {
      /** requestBody */
      body?: PaymentReponseInputDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ActivityApply/ProcessOrderResponse';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAllByPortal(
    params: {
      /**  */
      activityId?: number;
      /**  */
      activityTitle?: string;
      /**  */
      applyUserPhone?: string;
      /**  */
      applyUserName?: string;
      /**  */
      isPay?: boolean;
      /**  */
      isPriced?: boolean;
      /**  */
      isOnlyMine?: boolean;
      /** 1:已付款；2:未付款；3:已关闭 */
      specialType?: number;
      /**  */
      status?: ActivityApplyStatus;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ActivityApplyDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ActivityApply/GetAllByPortal';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        ActivityId: params['activityId'],
        ActivityTitle: params['activityTitle'],
        ApplyUserPhone: params['applyUserPhone'],
        ApplyUserName: params['applyUserName'],
        IsPay: params['isPay'],
        IsPriced: params['isPriced'],
        IsOnlyMine: params['isOnlyMine'],
        SpecialType: params['specialType'],
        Status: params['status'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取用户报名活动信息
   */
  static getUserActivityApplyInfo(
    params: {
      /**  */
      userId?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UserActivityApplyInfoDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ActivityApply/GetUserActivityApplyInfo';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { userId: params['userId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 检查订单金额
   */
  static checkOrderPriceTotal(
    params: {
      /**  */
      orderNo?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AbpBoolDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ActivityApply/CheckOrderPriceTotal';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { orderNo: params['orderNo'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 审核
   */
  static audit(
    params: {
      /** requestBody */
      body?: AuditUserLogProxy;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ActivityApply/Audit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: ActivityApplyCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ActivityApplyDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ActivityApply/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ActivityApply/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static actualAudit(
    params: {
      /** requestBody */
      body?: AuditUserLog;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ActivityApply/ActualAudit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getMyAll(
    params: {
      /**  */
      activityId?: number;
      /**  */
      activityTitle?: string;
      /**  */
      applyUserPhone?: string;
      /**  */
      applyUserName?: string;
      /**  */
      isPay?: boolean;
      /**  */
      isPriced?: boolean;
      /**  */
      isOnlyMine?: boolean;
      /** 1:已付款；2:未付款；3:已关闭 */
      specialType?: number;
      /**  */
      status?: ActivityApplyStatus;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ActivityApplyDtoListResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ActivityApply/GetMyAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        ActivityId: params['activityId'],
        ActivityTitle: params['activityTitle'],
        ApplyUserPhone: params['applyUserPhone'],
        ApplyUserName: params['applyUserName'],
        IsPay: params['isPay'],
        IsPriced: params['isPriced'],
        IsOnlyMine: params['isOnlyMine'],
        SpecialType: params['specialType'],
        Status: params['status'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getLogs(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuditUserLogDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ActivityApply/GetLogs';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getStatus(
    params: {
      /**  */
      audit?: number;
      /**  */
      auditStatus?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ActivityApply/GetStatus';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { audit: params['audit'], auditStatus: params['auditStatus'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /**  */
      activityId?: number;
      /**  */
      activityTitle?: string;
      /**  */
      applyUserPhone?: string;
      /**  */
      applyUserName?: string;
      /**  */
      isPay?: boolean;
      /**  */
      isPriced?: boolean;
      /**  */
      isOnlyMine?: boolean;
      /** 1:已付款；2:未付款；3:已关闭 */
      specialType?: number;
      /**  */
      status?: ActivityApplyStatus;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ActivityApplyDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ActivityApply/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        ActivityId: params['activityId'],
        ActivityTitle: params['activityTitle'],
        ApplyUserPhone: params['applyUserPhone'],
        ApplyUserName: params['applyUserName'],
        IsPay: params['isPay'],
        IsPriced: params['isPriced'],
        IsOnlyMine: params['isOnlyMine'],
        SpecialType: params['specialType'],
        Status: params['status'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class ActivitySignInRecordService {
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ActivitySignInRecordDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ActivitySignInRecord/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /**  */
      skipCount?: number;
      /**  */
      maxResultCount?: number;
      /**  */
      sorting?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ActivitySignInRecordDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ActivitySignInRecord/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        SkipCount: params['skipCount'],
        MaxResultCount: params['maxResultCount'],
        Sorting: params['sorting']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: ActivitySignInRecordCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ActivitySignInRecordDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ActivitySignInRecord/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: ActivitySignInRecordCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ActivitySignInRecordDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ActivitySignInRecord/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ActivitySignInRecord/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class AlbumService {
  /**
   * 获取相册信息
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AlbumDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Album/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 创建相册
   */
  static create(
    params: {
      /** requestBody */
      body?: AlbumCreateUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AlbumDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Album/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 更新相册
   */
  static update(
    params: {
      /** requestBody */
      body?: AlbumCreateUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AlbumDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Album/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 删除相册
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Album/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取所有相册
   */
  static getAllAlbums(
    params: {
      /**  */
      name?: string;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AlbumDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Album/GetAllAlbums';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Name: params['name'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 上传照片到相册
   */
  static uploadPhoto(options: IRequestOptions = {}): Promise<AlbumPhotoDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Album/UploadPhoto';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 删除照片
   */
  static deletePhoto(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Album/DeletePhoto';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取照片列表
   */
  static getAllPhotos(
    params: {
      /**  */
      albumId?: number;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AlbumPhotoDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Album/GetAllPhotos';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        AlbumId: params['albumId'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 将照片转到新相册
   */
  static moveToNewAlbum(
    params: {
      /** requestBody */
      body?: AlbumPhotoMoveInput;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Album/MoveToNewAlbum';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 将照片设为相册封面
   */
  static setAsCover(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Album/SetAsCover';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 重命名照片
   */
  static renamePhoto(
    params: {
      /** requestBody */
      body?: RenameAlbumPhotoInput;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AlbumPhotoDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Album/RenamePhoto';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static download(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Album/Download';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static batchDownload(
    params: {
      /** 相册Id */
      albumId: number;
      /** 相册图片Id（多个用,隔开） */
      albumPhotoId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Album/BatchDownload';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { AlbumId: params['albumId'], AlbumPhotoId: params['albumPhotoId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class ApplicationPaymentService {
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: ApplicationPaymentCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ApplicationPaymentDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ApplicationPayment/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getLogs(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuditUserLogDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ApplicationPayment/GetLogs';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAllLogs(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuditUserLogDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ApplicationPayment/GetAllLogs';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ApplicationPaymentDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ApplicationPayment/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /** 申请人姓名 */
      applicantName?: string;
      /** 标题 */
      title?: string;
      /**  */
      fundId?: number;
      /** 基金名称 */
      fundName?: string;
      /** 基金项目名称 */
      fundProjectName?: string;
      /** 审批状态 */
      isAudited?: boolean;
      /** 验证状态 */
      validationStatus?: ApplicationPaymentValidationStatus;
      /**  */
      endDate?: string;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ApplicationPaymentDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ApplicationPayment/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        ApplicantName: params['applicantName'],
        Title: params['title'],
        FundID: params['fundId'],
        FundName: params['fundName'],
        FundProjectName: params['fundProjectName'],
        IsAudited: params['isAudited'],
        ValidationStatus: params['validationStatus'],
        EndDate: params['endDate'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: ApplicationPaymentCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ApplicationPaymentDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ApplicationPayment/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 设置发票号码
   */
  static setInvoiceNumbers(
    params: {
      /** requestBody */
      body?: ApplicationPaymentInvoiceNumberInput;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ApplicationPayment/SetInvoiceNumbers';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取发票号码
   */
  static getInvoiceNumbers(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ApplicationPayment/GetInvoiceNumbers';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 增值税发票识别
   */
  static vatInvoice(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ApplicationPayment/VatInvoice';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 检查拨款
   */
  static checkFunding(
    params: {
      /** requestBody */
      body?: Int32EntityDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ApplicationPayment/CheckFunding';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 确认拨款
   */
  static confirmFunding(
    params: {
      /** requestBody */
      body?: ConfirmFundingInput;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ApplicationPayment/ConfirmFunding';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * TestNc
   */
  static testNc(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ApplicationPayment/TestNc';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 审核
   */
  static audit(
    params: {
      /** requestBody */
      body?: AuditUserLogProxy;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ApplicationPayment/Audit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ApplicationPayment/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static actualAudit(
    params: {
      /** requestBody */
      body?: AuditUserLog;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ApplicationPayment/ActualAudit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getMyAll(
    params: {
      /** 申请人姓名 */
      applicantName?: string;
      /** 标题 */
      title?: string;
      /**  */
      fundId?: number;
      /** 基金名称 */
      fundName?: string;
      /** 基金项目名称 */
      fundProjectName?: string;
      /** 审批状态 */
      isAudited?: boolean;
      /** 验证状态 */
      validationStatus?: ApplicationPaymentValidationStatus;
      /**  */
      endDate?: string;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ApplicationPaymentDtoListResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ApplicationPayment/GetMyAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        ApplicantName: params['applicantName'],
        Title: params['title'],
        FundID: params['fundId'],
        FundName: params['fundName'],
        FundProjectName: params['fundProjectName'],
        IsAudited: params['isAudited'],
        ValidationStatus: params['validationStatus'],
        EndDate: params['endDate'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getStatus(
    params: {
      /**  */
      audit?: number;
      /**  */
      auditStatus?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ApplicationPayment/GetStatus';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { audit: params['audit'], auditStatus: params['auditStatus'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class AreaService {
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: AreaCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AreaDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Area/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: AreaCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AreaDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Area/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAllList(
    params: {
      /**  */
      cityId?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AreaDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Area/GetAllList';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { cityId: params['cityId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AreaDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Area/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /**  */
      areaName?: string;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AreaDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Area/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        AreaName: params['areaName'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Area/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class AttachmentService {
  /**
   *
   */
  static getAttachments(
    params: {
      /**  */
      hostId?: string;
      /**  */
      hostType?: AttachmentHostType;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AttachmentDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Attachment/GetAttachments';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { hostId: params['hostId'], hostType: params['hostType'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 上传到临时目录
   */
  static uploadToTemp(options: IRequestOptions = {}): Promise<UploadResult> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Attachment/UploadToTemp';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 上传到Oss
   */
  static uploadToOss(options: IRequestOptions = {}): Promise<UploadResult> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Attachment/UploadToOss';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 下载附件
   */
  static download(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Attachment/Download';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class AuditFlowService {
  /**
   *
   */
  static getForEdit(
    params: {
      /**  */
      id?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuditFlowCreateOrEditDtoGetForEditOutput> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/AuditFlow/GetForEdit';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static active(
    params: {
      /** requestBody */
      body?: GuidEntityDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/AuditFlow/Active';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static canAudit(
    params: {
      /** requestBody */
      body?: CanAuditRequestDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<boolean> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/AuditFlow/CanAudit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuditFlowDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/AuditFlow/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: AuditFlowCreateOrEditDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuditFlowDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/AuditFlow/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: AuditFlowCreateOrEditDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuditFlowDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/AuditFlow/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /**  */
      desc?: string;
      /**  */
      sorting?: string;
      /**  */
      skipCount?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuditFlowDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/AuditFlow/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Desc: params['desc'],
        Sorting: params['sorting'],
        SkipCount: params['skipCount'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/AuditFlow/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class AuditFlowProxyService {
  /**
   * CreateAsync
   */
  static create(
    params: {
      /** requestBody */
      body?: AuditFlowCreateOrEditProxyDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuditFlowDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/AuditFlowProxy/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * GetForEdit
   */
  static getForEdit(
    params: {
      /**  */
      id?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuditFlowCreateOrEditProxyDtoGetForEditOutput> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/AuditFlowProxy/GetForEdit';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /**  */
      desc?: string;
      /**  */
      sorting?: string;
      /**  */
      skipCount?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuditFlowDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/AuditFlowProxy/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Desc: params['desc'],
        Sorting: params['sorting'],
        SkipCount: params['skipCount'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * UpdateAsync
   */
  static update(
    params: {
      /** requestBody */
      body?: AuditFlowCreateOrEditProxyDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuditFlowDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/AuditFlowProxy/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/AuditFlowProxy/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 此记录当前用户是否可以进行审核
   */
  static canAudit(
    params: {
      /** requestBody */
      body?: CanAuditRequestDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<boolean> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/AuditFlowProxy/CanAudit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getDetail(
    params: {
      /**  */
      scope?: AuditFlowScope;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuditFlowCreateOrEditDtoGetForEditOutput> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/AuditFlowProxy/GetDetail';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { scope: params['scope'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuditFlowDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/AuditFlowProxy/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class AuditNodePreDefineService {
  /**
   *
   */
  static getForEdit(
    params: {
      /**  */
      id?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuditNodePreDefineCreateOrEditDtoGetForEditOutput> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/AuditNodePreDefine/GetForEdit';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuditNodePreDefineDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/AuditNodePreDefine/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /**  */
      desc?: string;
      /**  */
      sorting?: string;
      /**  */
      skipCount?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuditNodePreDefineDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/AuditNodePreDefine/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Desc: params['desc'],
        Sorting: params['sorting'],
        SkipCount: params['skipCount'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: AuditNodePreDefineCreateOrEditDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuditNodePreDefineDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/AuditNodePreDefine/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: AuditNodePreDefineCreateOrEditDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuditNodePreDefineDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/AuditNodePreDefine/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/AuditNodePreDefine/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class AutoInvoicingService {
  /**
   * 获取最新待开票
   */
  static getInvoiceList(options: IRequestOptions = {}): Promise<InvoiceDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/AutoInvoicing/GetInvoiceList';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getInvoiceListAsCsv(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/AutoInvoicing/GetInvoiceListAsCsv';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 开票完成
   */
  static complete(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/AutoInvoicing/Complete';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class BankNameService {
  /**
   *
   */
  static syncBankNamesFromNc(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/BankName/SyncBankNamesFromNC';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BankNameDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/BankName/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /**  */
      name?: string;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BankNameDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/BankName/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Name: params['name'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: BankNameCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BankNameDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/BankName/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: BankNameCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BankNameDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/BankName/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/BankName/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class BankReconciliationService {
  /**
   * 银行对账收入统计
   */
  static getBankReconciliationIncomeReport(
    params: {
      /**  */
      year?: number;
      /** 账号 */
      bankAccount?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<DecimalMonthlyItem[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/BankReconciliation/GetBankReconciliationIncomeReport';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Year: params['year'], BankAccount: params['bankAccount'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 银行对账支出统计
   */
  static getBankReconciliationExpenseReport(
    params: {
      /**  */
      year?: number;
      /** 账号 */
      bankAccount?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<DecimalMonthlyItem[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/BankReconciliation/GetBankReconciliationExpenseReport';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Year: params['year'], BankAccount: params['bankAccount'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class BankTypeService {
  /**
   *
   */
  static syncBankTypesFromNc(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/BankType/SyncBankTypesFromNC';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BankTypeDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/BankType/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /**  */
      name?: string;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BankTypeDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/BankType/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Name: params['name'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: BankTypeCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BankTypeDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/BankType/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: BankTypeCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BankTypeDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/BankType/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/BankType/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class BeneficiaryService {
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BeneficiaryDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Beneficiary/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: BeneficiaryCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BeneficiaryDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Beneficiary/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: BeneficiaryCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BeneficiaryDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Beneficiary/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Beneficiary/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static checkExist(
    params: {
      /** requestBody */
      body?: BeneficiaryCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Beneficiary/CheckExist';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 审核
   */
  static audit(
    params: {
      /** requestBody */
      body?: AuditUserLogProxy;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Beneficiary/Audit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static actualAudit(
    params: {
      /** requestBody */
      body?: AuditUserLog;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Beneficiary/ActualAudit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getMyAll(
    params: {
      /** 个案编号 */
      code?: string;
      /** 姓名 */
      realName?: string;
      /** 性别 */
      sex?: string;
      /** 最小年龄 */
      minAge?: number;
      /** 最大年龄 */
      maxAge?: number;
      /** 民族 */
      nation?: string;
      /** 省份Id */
      provinceId?: number;
      /** 城市Id */
      cityId?: number;
      /** 区域Id */
      areaId?: number;
      /** 街道Id */
      townId?: number;
      /** 是否享受低保政策 */
      isEnjoyTheSubsistenceAllowancePolicy?: boolean;
      /** 是否为建档立卡户 */
      isEnjoyOtherSalvation?: boolean;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BeneficiaryDtoListResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Beneficiary/GetMyAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Code: params['code'],
        RealName: params['realName'],
        Sex: params['sex'],
        MinAge: params['minAge'],
        MaxAge: params['maxAge'],
        Nation: params['nation'],
        ProvinceId: params['provinceId'],
        CityId: params['cityId'],
        AreaId: params['areaId'],
        TownId: params['townId'],
        IsEnjoyTheSubsistenceAllowancePolicy: params['isEnjoyTheSubsistenceAllowancePolicy'],
        IsEnjoyOtherSalvation: params['isEnjoyOtherSalvation'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getLogs(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuditUserLogDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Beneficiary/GetLogs';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getStatus(
    params: {
      /**  */
      audit?: number;
      /**  */
      auditStatus?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Beneficiary/GetStatus';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { audit: params['audit'], auditStatus: params['auditStatus'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /** 个案编号 */
      code?: string;
      /** 姓名 */
      realName?: string;
      /** 性别 */
      sex?: string;
      /** 最小年龄 */
      minAge?: number;
      /** 最大年龄 */
      maxAge?: number;
      /** 民族 */
      nation?: string;
      /** 省份Id */
      provinceId?: number;
      /** 城市Id */
      cityId?: number;
      /** 区域Id */
      areaId?: number;
      /** 街道Id */
      townId?: number;
      /** 是否享受低保政策 */
      isEnjoyTheSubsistenceAllowancePolicy?: boolean;
      /** 是否为建档立卡户 */
      isEnjoyOtherSalvation?: boolean;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BeneficiaryDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Beneficiary/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Code: params['code'],
        RealName: params['realName'],
        Sex: params['sex'],
        MinAge: params['minAge'],
        MaxAge: params['maxAge'],
        Nation: params['nation'],
        ProvinceId: params['provinceId'],
        CityId: params['cityId'],
        AreaId: params['areaId'],
        TownId: params['townId'],
        IsEnjoyTheSubsistenceAllowancePolicy: params['isEnjoyTheSubsistenceAllowancePolicy'],
        IsEnjoyOtherSalvation: params['isEnjoyOtherSalvation'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class BeneficiaryServiceRecordServiceService {
  /**
   *
   */
  static getAll(
    params: {
      /**  */
      serviceRecordType?: ServiceRecordType;
      /**  */
      beneficiaryName?: string;
      /**  */
      schoolName?: string;
      /**  */
      projectName?: string;
      /**  */
      projectId?: number;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ServiceRecordDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/BeneficiaryServiceRecordService/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        ServiceRecordType: params['serviceRecordType'],
        BeneficiaryName: params['beneficiaryName'],
        SchoolName: params['schoolName'],
        ProjectName: params['projectName'],
        ProjectId: params['projectId'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: ServiceRecordCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ServiceRecordDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/BeneficiaryServiceRecordService/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: ServiceRecordCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ServiceRecordDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/BeneficiaryServiceRecordService/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static export(
    params: {
      /** requestBody */
      body?: ServiceRecordPagedResultRequestDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/BeneficiaryServiceRecordService/Export';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 审核
   */
  static audit(
    params: {
      /** requestBody */
      body?: AuditUserLogProxy;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/BeneficiaryServiceRecordService/Audit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/BeneficiaryServiceRecordService/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static actualAudit(
    params: {
      /** requestBody */
      body?: AuditUserLog;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/BeneficiaryServiceRecordService/ActualAudit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getMyAll(
    params: {
      /**  */
      serviceRecordType?: ServiceRecordType;
      /**  */
      beneficiaryName?: string;
      /**  */
      schoolName?: string;
      /**  */
      projectName?: string;
      /**  */
      projectId?: number;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ServiceRecordDtoListResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/BeneficiaryServiceRecordService/GetMyAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        ServiceRecordType: params['serviceRecordType'],
        BeneficiaryName: params['beneficiaryName'],
        SchoolName: params['schoolName'],
        ProjectName: params['projectName'],
        ProjectId: params['projectId'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getLogs(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuditUserLogDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/BeneficiaryServiceRecordService/GetLogs';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getStatus(
    params: {
      /**  */
      audit?: number;
      /**  */
      auditStatus?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/BeneficiaryServiceRecordService/GetStatus';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { audit: params['audit'], auditStatus: params['auditStatus'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ServiceRecordDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/BeneficiaryServiceRecordService/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class CapitalExpenseRecordAppserviceService {
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CapitalExpenseRecordCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CapitalExpenseRecordDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CapitalExpenseRecordAppservice/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: CapitalExpenseRecordCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CapitalExpenseRecordDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CapitalExpenseRecordAppservice/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取变更历史记录
   */
  static getRecordChangeList(
    params: {
      /**  */
      recordId?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CapitalExpenseRecordDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CapitalExpenseRecordAppservice/GetRecordChangeList';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { recordId: params['recordId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getContractNoInformation(
    params: {
      /**  */
      contractNo?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ContractNoInformationDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CapitalExpenseRecordAppservice/GetContractNoInformation';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { contractNo: params['contractNo'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取内部项目预算项及实际使用金额
   */
  static getInternalBudgetItemAndUseRecord(
    params: {
      /**  */
      projectId?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<InternalBudgetItemAndUseRecordDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CapitalExpenseRecordAppservice/GetInternalBudgetItemAndUseRecord';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { projectId: params['projectId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static import(options: IRequestOptions = {}): Promise<ImportResult> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CapitalExpenseRecordAppservice/Import';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 下载导入模板
   */
  static downloadTemplate(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CapitalExpenseRecordAppservice/DownloadTemplate';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static export(
    params: {
      /** requestBody */
      body?: CapitalExpenseRecordPagedResultRequestDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CapitalExpenseRecordAppservice/Export';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 保存变更申请
   */
  static changeApply(
    params: {
      /** requestBody */
      body?: CapitalExpenseRecordCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CapitalExpenseRecordAppservice/ChangeApply';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 取消变更申请
   */
  static cancelChangeApply(
    params: {
      /** requestBody */
      body?: CapitalExpenseRecordCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CapitalExpenseRecordAppservice/CancelChangeApply';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getProjectReportList(
    params: {
      /**  */
      projectName?: string;
      /**  */
      year?: number;
      /**  */
      projectSeriesId?: number;
      /**  */
      projectType?: string;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ProjectReportDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CapitalExpenseRecordAppservice/GetProjectReportList';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        ProjectName: params['projectName'],
        Year: params['year'],
        ProjectSeriesId: params['projectSeriesId'],
        ProjectType: params['projectType'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getProjectRepprtDetailList(
    params: {
      /**  */
      projectName?: string;
      /**  */
      startDate?: string;
      /**  */
      endDate?: string;
      /**  */
      minAmount?: number;
      /**  */
      maxAmount?: number;
      /**  */
      projectId?: number;
      /**  */
      itemName?: string;
      /**  */
      remark?: string;
      /**  */
      summary?: string;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ProjectDetailReprotDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CapitalExpenseRecordAppservice/GetProjectRepprtDetailList';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        ProjectName: params['projectName'],
        StartDate: params['startDate'],
        EndDate: params['endDate'],
        MinAmount: params['minAmount'],
        MaxAmount: params['maxAmount'],
        ProjectId: params['projectId'],
        ItemName: params['itemName'],
        Remark: params['remark'],
        Summary: params['summary'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getExpenseRecordDetailByYear(
    params: {
      /**  */
      isInternal?: boolean;
      /**  */
      year?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CapitalExpenseRecordDetail[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CapitalExpenseRecordAppservice/GetExpenseRecordDetailByYear';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { isInternal: params['isInternal'], year: params['year'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 保存支付时间
   */
  static savePayDate(
    params: {
      /**  */
      id?: number;
      /**  */
      payDate?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CapitalExpenseRecordAppservice/SavePayDate';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { id: params['id'], payDate: params['payDate'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 审核
   */
  static audit(
    params: {
      /** requestBody */
      body?: AuditUserLogProxy;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CapitalExpenseRecordAppservice/Audit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CapitalExpenseRecordAppservice/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static actualAudit(
    params: {
      /** requestBody */
      body?: AuditUserLog;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CapitalExpenseRecordAppservice/ActualAudit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getMyAll(
    params: {
      /** 收款单位 */
      payeeName?: string;
      /** 开户银行 */
      payeeBankAccount?: string;
      /** 付款方式 */
      payType?: PayType;
      /** 合同编号 */
      contractNo?: string;
      /** 开始日期 */
      startDate?: string;
      /** 截止日期 */
      endDate?: string;
      /**  */
      projectName?: string;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CapitalExpenseRecordDtoListResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CapitalExpenseRecordAppservice/GetMyAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        PayeeName: params['payeeName'],
        PayeeBankAccount: params['payeeBankAccount'],
        PayType: params['payType'],
        ContractNo: params['contractNo'],
        StartDate: params['startDate'],
        EndDate: params['endDate'],
        ProjectName: params['projectName'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getLogs(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuditUserLogDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CapitalExpenseRecordAppservice/GetLogs';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getStatus(
    params: {
      /**  */
      audit?: number;
      /**  */
      auditStatus?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CapitalExpenseRecordAppservice/GetStatus';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { audit: params['audit'], auditStatus: params['auditStatus'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CapitalExpenseRecordDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CapitalExpenseRecordAppservice/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /** 收款单位 */
      payeeName?: string;
      /** 开户银行 */
      payeeBankAccount?: string;
      /** 付款方式 */
      payType?: PayType;
      /** 合同编号 */
      contractNo?: string;
      /** 开始日期 */
      startDate?: string;
      /** 截止日期 */
      endDate?: string;
      /**  */
      projectName?: string;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CapitalExpenseRecordDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CapitalExpenseRecordAppservice/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        PayeeName: params['payeeName'],
        PayeeBankAccount: params['payeeBankAccount'],
        PayType: params['payType'],
        ContractNo: params['contractNo'],
        StartDate: params['startDate'],
        EndDate: params['endDate'],
        ProjectName: params['projectName'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class CapitalIncomeRecordFromDonationService {
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CapitalIncomeRecordFromDonationCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CapitalIncomeRecordFromDonationDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CapitalIncomeRecordFromDonation/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: CapitalIncomeRecordFromDonationCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CapitalIncomeRecordFromDonationDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CapitalIncomeRecordFromDonation/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取资金捐赠合计金额
   */
  static getDonationTotalMoney(
    params: {
      /**  */
      incomeDate?: string;
      /**  */
      incomeDateStart?: string;
      /**  */
      incomeDateEnd?: string;
      /**  */
      donatorName?: string;
      /**  */
      incomeType?: PayType;
      /**  */
      bankAccount?: string;
      /**  */
      totalIncomeMoney?: number;
      /**  */
      totalIncomeMoneyStart?: number;
      /**  */
      totalIncomeMoneyEnd?: number;
      /**  */
      capitalProperty?: CapitalProperty;
      /**  */
      currencyType?: CurrencyType;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<number> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CapitalIncomeRecordFromDonation/GetDonationTotalMoney';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        IncomeDate: params['incomeDate'],
        IncomeDateStart: params['incomeDateStart'],
        IncomeDateEnd: params['incomeDateEnd'],
        DonatorName: params['donatorName'],
        IncomeType: params['incomeType'],
        BankAccount: params['bankAccount'],
        TotalIncomeMoney: params['totalIncomeMoney'],
        TotalIncomeMoneyStart: params['totalIncomeMoneyStart'],
        TotalIncomeMoneyEnd: params['totalIncomeMoneyEnd'],
        CapitalProperty: params['capitalProperty'],
        CurrencyType: params['currencyType'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static import(options: IRequestOptions = {}): Promise<ImportResult> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CapitalIncomeRecordFromDonation/Import';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 下载导入模板
   */
  static downloadTemplate(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CapitalIncomeRecordFromDonation/DownloadTemplate';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static export(
    params: {
      /** requestBody */
      body?: CapitalIncomeRecordFromDonationPagedResultRequestDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CapitalIncomeRecordFromDonation/Export';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 审核
   */
  static audit(
    params: {
      /** requestBody */
      body?: AuditUserLogProxy;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CapitalIncomeRecordFromDonation/Audit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CapitalIncomeRecordFromDonation/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static actualAudit(
    params: {
      /** requestBody */
      body?: AuditUserLog;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CapitalIncomeRecordFromDonation/ActualAudit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getMyAll(
    params: {
      /**  */
      incomeDate?: string;
      /**  */
      incomeDateStart?: string;
      /**  */
      incomeDateEnd?: string;
      /**  */
      donatorName?: string;
      /**  */
      incomeType?: PayType;
      /**  */
      bankAccount?: string;
      /**  */
      totalIncomeMoney?: number;
      /**  */
      totalIncomeMoneyStart?: number;
      /**  */
      totalIncomeMoneyEnd?: number;
      /**  */
      capitalProperty?: CapitalProperty;
      /**  */
      currencyType?: CurrencyType;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CapitalIncomeRecordFromDonationDtoListResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CapitalIncomeRecordFromDonation/GetMyAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        IncomeDate: params['incomeDate'],
        IncomeDateStart: params['incomeDateStart'],
        IncomeDateEnd: params['incomeDateEnd'],
        DonatorName: params['donatorName'],
        IncomeType: params['incomeType'],
        BankAccount: params['bankAccount'],
        TotalIncomeMoney: params['totalIncomeMoney'],
        TotalIncomeMoneyStart: params['totalIncomeMoneyStart'],
        TotalIncomeMoneyEnd: params['totalIncomeMoneyEnd'],
        CapitalProperty: params['capitalProperty'],
        CurrencyType: params['currencyType'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getLogs(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuditUserLogDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CapitalIncomeRecordFromDonation/GetLogs';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getStatus(
    params: {
      /**  */
      audit?: number;
      /**  */
      auditStatus?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CapitalIncomeRecordFromDonation/GetStatus';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { audit: params['audit'], auditStatus: params['auditStatus'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CapitalIncomeRecordFromDonationDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CapitalIncomeRecordFromDonation/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /**  */
      incomeDate?: string;
      /**  */
      incomeDateStart?: string;
      /**  */
      incomeDateEnd?: string;
      /**  */
      donatorName?: string;
      /**  */
      incomeType?: PayType;
      /**  */
      bankAccount?: string;
      /**  */
      totalIncomeMoney?: number;
      /**  */
      totalIncomeMoneyStart?: number;
      /**  */
      totalIncomeMoneyEnd?: number;
      /**  */
      capitalProperty?: CapitalProperty;
      /**  */
      currencyType?: CurrencyType;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CapitalIncomeRecordFromDonationDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CapitalIncomeRecordFromDonation/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        IncomeDate: params['incomeDate'],
        IncomeDateStart: params['incomeDateStart'],
        IncomeDateEnd: params['incomeDateEnd'],
        DonatorName: params['donatorName'],
        IncomeType: params['incomeType'],
        BankAccount: params['bankAccount'],
        TotalIncomeMoney: params['totalIncomeMoney'],
        TotalIncomeMoneyStart: params['totalIncomeMoneyStart'],
        TotalIncomeMoneyEnd: params['totalIncomeMoneyEnd'],
        CapitalProperty: params['capitalProperty'],
        CurrencyType: params['currencyType'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class CapitalIncomeRecordFromOtherService {
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CapitalIncomeRecordFromOtherCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CapitalIncomeRecordFromOtherDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CapitalIncomeRecordFromOther/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: CapitalIncomeRecordFromOtherCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CapitalIncomeRecordFromOtherDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CapitalIncomeRecordFromOther/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取其他收入合计金额
   */
  static getOtherTotalMoney(
    params: {
      /**  */
      incomeDate?: string;
      /**  */
      incomeDateStart?: string;
      /**  */
      incomeDateEnd?: string;
      /**  */
      incomeType?: PayType;
      /**  */
      bankAccount?: string;
      /**  */
      totalIncomeMoney?: number;
      /**  */
      totalIncomeMoneyStart?: number;
      /**  */
      totalIncomeMoneyEnd?: number;
      /**  */
      incomeCategory?: IncomeCategory;
      /**  */
      currencyType?: CurrencyType;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<number> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CapitalIncomeRecordFromOther/GetOtherTotalMoney';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        IncomeDate: params['incomeDate'],
        IncomeDateStart: params['incomeDateStart'],
        IncomeDateEnd: params['incomeDateEnd'],
        IncomeType: params['incomeType'],
        BankAccount: params['bankAccount'],
        TotalIncomeMoney: params['totalIncomeMoney'],
        TotalIncomeMoneyStart: params['totalIncomeMoneyStart'],
        TotalIncomeMoneyEnd: params['totalIncomeMoneyEnd'],
        IncomeCategory: params['incomeCategory'],
        CurrencyType: params['currencyType'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static import(options: IRequestOptions = {}): Promise<ImportResult> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CapitalIncomeRecordFromOther/Import';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 下载导入模板
   */
  static downloadTemplate(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CapitalIncomeRecordFromOther/DownloadTemplate';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static export(
    params: {
      /** requestBody */
      body?: CapitalIncomeRecordFromOtherPagedResultRequestDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CapitalIncomeRecordFromOther/Export';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 审核
   */
  static audit(
    params: {
      /** requestBody */
      body?: AuditUserLogProxy;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CapitalIncomeRecordFromOther/Audit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CapitalIncomeRecordFromOther/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static actualAudit(
    params: {
      /** requestBody */
      body?: AuditUserLog;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CapitalIncomeRecordFromOther/ActualAudit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getMyAll(
    params: {
      /**  */
      incomeDate?: string;
      /**  */
      incomeDateStart?: string;
      /**  */
      incomeDateEnd?: string;
      /**  */
      incomeType?: PayType;
      /**  */
      bankAccount?: string;
      /**  */
      totalIncomeMoney?: number;
      /**  */
      totalIncomeMoneyStart?: number;
      /**  */
      totalIncomeMoneyEnd?: number;
      /**  */
      incomeCategory?: IncomeCategory;
      /**  */
      currencyType?: CurrencyType;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CapitalIncomeRecordFromOtherDtoListResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CapitalIncomeRecordFromOther/GetMyAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        IncomeDate: params['incomeDate'],
        IncomeDateStart: params['incomeDateStart'],
        IncomeDateEnd: params['incomeDateEnd'],
        IncomeType: params['incomeType'],
        BankAccount: params['bankAccount'],
        TotalIncomeMoney: params['totalIncomeMoney'],
        TotalIncomeMoneyStart: params['totalIncomeMoneyStart'],
        TotalIncomeMoneyEnd: params['totalIncomeMoneyEnd'],
        IncomeCategory: params['incomeCategory'],
        CurrencyType: params['currencyType'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getLogs(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuditUserLogDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CapitalIncomeRecordFromOther/GetLogs';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getStatus(
    params: {
      /**  */
      audit?: number;
      /**  */
      auditStatus?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CapitalIncomeRecordFromOther/GetStatus';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { audit: params['audit'], auditStatus: params['auditStatus'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CapitalIncomeRecordFromOtherDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CapitalIncomeRecordFromOther/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /**  */
      incomeDate?: string;
      /**  */
      incomeDateStart?: string;
      /**  */
      incomeDateEnd?: string;
      /**  */
      incomeType?: PayType;
      /**  */
      bankAccount?: string;
      /**  */
      totalIncomeMoney?: number;
      /**  */
      totalIncomeMoneyStart?: number;
      /**  */
      totalIncomeMoneyEnd?: number;
      /**  */
      incomeCategory?: IncomeCategory;
      /**  */
      currencyType?: CurrencyType;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CapitalIncomeRecordFromOtherDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CapitalIncomeRecordFromOther/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        IncomeDate: params['incomeDate'],
        IncomeDateStart: params['incomeDateStart'],
        IncomeDateEnd: params['incomeDateEnd'],
        IncomeType: params['incomeType'],
        BankAccount: params['bankAccount'],
        TotalIncomeMoney: params['totalIncomeMoney'],
        TotalIncomeMoneyStart: params['totalIncomeMoneyStart'],
        TotalIncomeMoneyEnd: params['totalIncomeMoneyEnd'],
        IncomeCategory: params['incomeCategory'],
        CurrencyType: params['currencyType'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class CityService {
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CityCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CityDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/City/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: CityCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CityDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/City/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAllList(
    params: {
      /**  */
      provinceId?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CityDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/City/GetAllList';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { provinceId: params['provinceId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CityDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/City/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /**  */
      cityName?: string;
      /**  */
      shortCode?: string;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CityDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/City/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        CityName: params['cityName'],
        ShortCode: params['shortCode'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/City/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class CmsAnchorService {
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CmsAnchorCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CmsAnchorDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CmsAnchor/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: CmsAnchorCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CmsAnchorDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CmsAnchor/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CmsAnchor/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CmsAnchorDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CmsAnchor/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /**  */
      name?: string;
      /**  */
      displayName?: string;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CmsAnchorDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CmsAnchor/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Name: params['name'],
        DisplayName: params['displayName'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class CmsCategoryService {
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CmsCategoryCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CmsCategoryDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CmsCategory/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: CmsCategoryCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CmsCategoryDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CmsCategory/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CmsCategory/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static showIt(
    params: {
      /** requestBody */
      body?: Int32EntityDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CmsCategory/ShowIt';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static hiddenIt(
    params: {
      /** requestBody */
      body?: Int32EntityDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CmsCategory/HiddenIt';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getCmsCategoryList(
    params: {
      /**  */
      categoryCode?: string;
      /**  */
      isLeftJoin?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CmsCategoryDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CmsCategory/GetCmsCategoryList';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { categoryCode: params['categoryCode'], isLeftJoin: params['isLeftJoin'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getByCode(
    params: {
      /**  */
      categoryCode?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CmsCategoryDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CmsCategory/GetByCode';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { categoryCode: params['categoryCode'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 修改栏目排序
   */
  static updateSort(
    params: {
      /** requestBody */
      body?: CmsCategoryUpdateSortDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CmsCategory/UpdateSort';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CmsCategoryDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CmsCategory/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /** 只和UseParentIdParameter为true时使用。 */
      parentId?: number;
      /**  */
      parentCode?: string;
      /**  */
      useParentIdParameter?: boolean;
      /**  */
      isHidden?: boolean;
      /**  */
      enableDataPermissionLimit?: boolean;
      /**  */
      needShowContentCategory?: boolean;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CmsCategoryDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CmsCategory/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        ParentId: params['parentId'],
        ParentCode: params['parentCode'],
        UseParentIdParameter: params['useParentIdParameter'],
        IsHidden: params['isHidden'],
        EnableDataPermissionLimit: params['enableDataPermissionLimit'],
        NeedShowContentCategory: params['needShowContentCategory'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class CmsContentService {
  /**
   * 获取文章详情，包含明细
   */
  static getDetail(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CmsContentDetailDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CmsContent/GetDetail';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static publish(
    params: {
      /** requestBody */
      body?: Int32EntityDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CmsContent/Publish';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static cancelPublish(
    params: {
      /** requestBody */
      body?: Int32EntityDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CmsContent/CancelPublish';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 置顶
   */
  static stickyPost(
    params: {
      /** requestBody */
      body?: Int32EntityDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CmsContent/StickyPost';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 取消置顶
   */
  static cancelStickyPost(
    params: {
      /** requestBody */
      body?: Int32EntityDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CmsContent/CancelStickyPost';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static moveToTrash(
    params: {
      /** requestBody */
      body?: Int32EntityDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CmsContent/MoveToTrash';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static restoreFromTrash(
    params: {
      /** requestBody */
      body?: Int32EntityDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CmsContent/RestoreFromTrash';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CmsContentCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CmsContentDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CmsContent/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CmsContent/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: CmsContentCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CmsContentDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CmsContent/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 点赞
   */
  static praise(
    params: {
      /** requestBody */
      body?: Int32EntityDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CmsContent/Praise';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static searchPublishedContent(
    params: {
      /**  */
      title?: string;
      /**  */
      categoryId?: number;
      /**  */
      categoryCode?: string;
      /**  */
      publishYear?: number;
      /**  */
      status?: CmsContentStatus;
      /**  */
      enableDataPermissionLimit?: boolean;
      /** 指定要不包含的文章ID */
      noContainsId?: number;
      /** 排序方式.1=>默认方式,2=>lastest(最新) */
      sorting?: string;
      /** 基金Id */
      fundId?: number;
      /** 基金项目Id */
      fundProjectId?: number;
      /**  */
      hasCategory?: boolean;
      /** 是否加载子栏目的文章列表 */
      isLoadChildrenCategoryArticles?: boolean;
      /** 首页滚动 */
      isHomeScrolling?: boolean;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CmsContentDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CmsContent/SearchPublishedContent';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Title: params['title'],
        CategoryId: params['categoryId'],
        CategoryCode: params['categoryCode'],
        PublishYear: params['publishYear'],
        Status: params['status'],
        EnableDataPermissionLimit: params['enableDataPermissionLimit'],
        NoContainsId: params['noContainsId'],
        Sorting: params['sorting'],
        FundID: params['fundId'],
        FundProjectID: params['fundProjectId'],
        HasCategory: params['hasCategory'],
        IsLoadChildrenCategoryArticles: params['isLoadChildrenCategoryArticles'],
        IsHomeScrolling: params['isHomeScrolling'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 批量更新文章栏目
   */
  static batchChangeCategory(
    params: {
      /**  */
      contentIds?: string;
      /**  */
      categoryId?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CmsContent/BatchChangeCategory';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { contentIds: params['contentIds'], categoryId: params['categoryId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static syncWechatNews(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CmsContent/SyncWechatNews';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 首页滚动
   */
  static homeScrolling(
    params: {
      /** requestBody */
      body?: Int32EntityDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CmsContent/HomeScrolling';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CmsContentDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CmsContent/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /**  */
      title?: string;
      /**  */
      categoryId?: number;
      /**  */
      categoryCode?: string;
      /**  */
      publishYear?: number;
      /**  */
      status?: CmsContentStatus;
      /**  */
      enableDataPermissionLimit?: boolean;
      /** 指定要不包含的文章ID */
      noContainsId?: number;
      /** 排序方式.1=>默认方式,2=>lastest(最新) */
      sorting?: string;
      /** 基金Id */
      fundId?: number;
      /** 基金项目Id */
      fundProjectId?: number;
      /**  */
      hasCategory?: boolean;
      /** 是否加载子栏目的文章列表 */
      isLoadChildrenCategoryArticles?: boolean;
      /** 首页滚动 */
      isHomeScrolling?: boolean;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CmsContentDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CmsContent/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Title: params['title'],
        CategoryId: params['categoryId'],
        CategoryCode: params['categoryCode'],
        PublishYear: params['publishYear'],
        Status: params['status'],
        EnableDataPermissionLimit: params['enableDataPermissionLimit'],
        NoContainsId: params['noContainsId'],
        Sorting: params['sorting'],
        FundID: params['fundId'],
        FundProjectID: params['fundProjectId'],
        HasCategory: params['hasCategory'],
        IsLoadChildrenCategoryArticles: params['isLoadChildrenCategoryArticles'],
        IsHomeScrolling: params['isHomeScrolling'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class CmsFriendLinkService {
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CmsFriendLinkCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CmsFriendLinkDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CmsFriendLink/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: CmsFriendLinkCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CmsFriendLinkDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CmsFriendLink/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CmsFriendLink/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CmsFriendLinkDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CmsFriendLink/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /**  */
      name?: string;
      /**  */
      link?: string;
      /**  */
      displayOrder?: number;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CmsFriendLinkDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CmsFriendLink/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Name: params['name'],
        Link: params['link'],
        DisplayOrder: params['displayOrder'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class CollectWaterService {
  /**
   * 同步NC收款流水
   */
  static syncCollectWater(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CollectWater/SyncCollectWater';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getDetailForConfirm(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundIncomeRecordDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CollectWater/GetDetailForConfirm';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static createByConfirm(
    params: {
      /** requestBody */
      body?: FundIncomeRecordCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundIncomeRecordDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CollectWater/CreateByConfirm';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CollectWaterDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CollectWater/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /** 单据编号 */
      billNo?: string;
      /**  */
      startDate?: string;
      /**  */
      endDate?: string;
      /** 收支项目 */
      donateProject?: string;
      /** 摘要 */
      summary?: string;
      /** 收款银行账户 */
      receivingBankAccount?: string;
      /** 确认状态 */
      status?: CollectWaterStatus;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CollectWaterDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CollectWater/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        BillNo: params['billNo'],
        StartDate: params['startDate'],
        EndDate: params['endDate'],
        DonateProject: params['donateProject'],
        Summary: params['summary'],
        ReceivingBankAccount: params['receivingBankAccount'],
        Status: params['status'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CollectWaterCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CollectWaterDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CollectWater/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: CollectWaterCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CollectWaterDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CollectWater/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CollectWater/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class ConfigurationService {
  /**
   *
   */
  static changeUiTheme(
    params: {
      /** requestBody */
      body?: ChangeUiThemeInput;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Configuration/ChangeUiTheme';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class CustomFormService {
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CustomFormCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CustomFormDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CustomForm/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: CustomFormCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CustomFormDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CustomForm/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static copyExistForm(
    params: {
      /** requestBody */
      body?: CustomFormCopyInput;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CustomFormDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CustomForm/CopyExistForm';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取表单的ID
   */
  static getCustomFormId(
    params: {
      /**  */
      hostType?: CustomFormType;
      /**  */
      hostId?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CustomForm/GetCustomFormId';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { HostType: params['hostType'], HostId: params['hostId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 根据类名获取默认的固定字段表单定义
   */
  static getDefaultFields(
    params: {
      /**  */
      formType?: CustomFormType;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CustomFormFieldDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CustomForm/GetDefaultFields';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { formType: params['formType'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 拷贝
   */
  static copy(
    params: {
      /** requestBody */
      body?: CustomFormCopyInput;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CustomFormDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CustomForm/Copy';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CustomFormDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CustomForm/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /**  */
      hostType?: CustomFormType;
      /**  */
      hostId?: string;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CustomFormDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CustomForm/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        HostType: params['hostType'],
        HostId: params['hostId'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CustomForm/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class CycleDonateConfigService {
  /**
   *
   */
  static getAll(
    params: {
      /** 捐助人姓名 */
      displayName?: string;
      /** 手机号 */
      mobileTelephone?: string;
      /** 定时捐类型 */
      donationType?: DonationType;
      /** 是否开启 */
      isOpen?: boolean;
      /** 捐助人身份 */
      userType?: UserType;
      /** 捐赠类型 */
      donorType?: DonorType;
      /** Id */
      id?: number;
      /** 订单Id */
      contractOrderId?: string;
      /** 用户Id */
      userId?: number;
      /** 捐贈意向类型 */
      donorItemType?: DonorItemType;
      /** 捐赠意向Id */
      donorItemId?: number;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CycleDonateConfigDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CycleDonateConfig/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        DisplayName: params['displayName'],
        MobileTelephone: params['mobileTelephone'],
        DonationType: params['donationType'],
        IsOpen: params['isOpen'],
        UserType: params['userType'],
        DonorType: params['donorType'],
        Id: params['id'],
        ContractOrderId: params['contractOrderId'],
        UserId: params['userId'],
        DonorItemType: params['donorItemType'],
        DonorItemId: params['donorItemId'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getDetail(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CycleDonateConfigDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CycleDonateConfig/GetDetail';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getDetailByUser(
    params: {
      /** Id */
      id?: number;
      /** 捐贈意向类型 */
      donorItemType?: DonorItemType;
      /** 捐赠意向Id */
      donorItemId?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CycleDonateConfigDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CycleDonateConfig/GetDetailByUser';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'], DonorItemType: params['donorItemType'], DonorItemId: params['donorItemId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getDetailByOrder(
    params: {
      /**  */
      id?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CycleDonateConfigDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CycleDonateConfig/GetDetailByOrder';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static changeStatus(
    params: {
      /** requestBody */
      body?: CycleDonateChangeStatusInput;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CycleDonateConfigDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CycleDonateConfig/ChangeStatus';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static changeCycle(
    params: {
      /** requestBody */
      body?: CycleDonateChangeCycleInput;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CycleDonateConfigDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CycleDonateConfig/ChangeCycle';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class DashbordService {
  /**
   * 获取每月发布普通活动数量、志愿者活动数量
   */
  static getActivityCountMonthly(
    params: {
      /**  */
      year: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ActivityReportDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Dashbord/GetActivityCountMonthly';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { year: params['year'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取发布文章总数、发布活动总数
   */
  static getPublishedCount(options: IRequestOptions = {}): Promise<DashbordPublishedCount> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Dashbord/GetPublishedCount';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取每月总志愿者数量、每月新增志愿者数量
   */
  static getVolunteerCountMonthly(
    params: {
      /**  */
      year: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<VolunteerReportDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Dashbord/GetVolunteerCountMonthly';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { year: params['year'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取站点访问记录(参数必填，否则报错)
   */
  static getAccessRecord(
    params: {
      /**  */
      start: string;
      /**  */
      end: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TotalTenantAccessRecordReportDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Dashbord/GetAccessRecord';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { start: params['start'], end: params['end'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 专项基金收入排行
   */
  static getFundIncomeRecordRank(
    params: {
      /**  */
      start: string;
      /**  */
      end?: string;
      /**  */
      fundType?: string;
      /**  */
      isLimitTop10?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundRankDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Dashbord/GetFundIncomeRecordRank';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        start: params['start'],
        end: params['end'],
        fundType: params['fundType'],
        isLimitTop10: params['isLimitTop10']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 专项基金支出排行
   */
  static getFundAppropriateRecordRank(
    params: {
      /**  */
      start: string;
      /**  */
      end?: string;
      /**  */
      fundType?: string;
      /**  */
      isLimitTop10?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundRankDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Dashbord/GetFundAppropriateRecordRank';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        start: params['start'],
        end: params['end'],
        fundType: params['fundType'],
        isLimitTop10: params['isLimitTop10']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 基金账户余额排行
   */
  static getFundBalanceRecordRank(
    params: {
      /**  */
      start: string;
      /**  */
      end?: string;
      /**  */
      fundType?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundRankDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Dashbord/GetFundBalanceRecordRank';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { start: params['start'], end: params['end'], fundType: params['fundType'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 各项目当月筹款排行
   */
  static getFundProjectIncomeRank(options: IRequestOptions = {}): Promise<FundProjectRankDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Dashbord/GetFundProjectIncomeRank';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 项目领域占比表
   */
  static getProjectCategoryChart(options: IRequestOptions = {}): Promise<ProjectCategoryChartDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Dashbord/GetProjectCategoryChart';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 年度筹款额
   */
  static getTotalIncomeByYear(
    params: {
      /**  */
      year: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<number> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Dashbord/GetTotalIncomeByYear';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { year: params['year'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 年度新增基金总数
   */
  static getNewFundByYear(
    params: {
      /**  */
      year: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<number> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Dashbord/GetNewFundByYear';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { year: params['year'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 年度新增基金项目总数
   */
  static getNewFundProjectByYear(
    params: {
      /**  */
      year: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<number> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Dashbord/GetNewFundProjectByYear';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { year: params['year'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 年度新增志愿者总数
   */
  static getNewVolunteerByYear(
    params: {
      /**  */
      year: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<number> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Dashbord/GetNewVolunteerByYear';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { year: params['year'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 当月新增志愿者总数
   */
  static getNewVolunteerByCurrentMonth(options: IRequestOptions = {}): Promise<number> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Dashbord/GetNewVolunteerByCurrentMonth';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 当月志愿者活动签到次数
   */
  static getActivitySignInCountByCurrentMonth(options: IRequestOptions = {}): Promise<number> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Dashbord/GetActivitySignInCountByCurrentMonth';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 当月志愿者活动报名次数
   */
  static getActivityApplyCountByCurrentMonth(options: IRequestOptions = {}): Promise<number> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Dashbord/GetActivityApplyCountByCurrentMonth';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 当月新发布志愿者活动数量
   */
  static getNewPublishedActivityCountByCurrentMonth(options: IRequestOptions = {}): Promise<number> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Dashbord/GetNewPublishedActivityCountByCurrentMonth';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class DataDictionaryService {
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: DataDictionaryCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<DataDictionaryDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/DataDictionary/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: DataDictionaryCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<DataDictionaryDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/DataDictionary/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/DataDictionary/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static syncToTenant(
    params: {
      /** requestBody */
      body?: DataDictionarySyncInput;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/DataDictionary/SyncToTenant';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 分页查询
   */
  static getAll(
    params: {
      /**  */
      parentId?: number;
      /**  */
      isParent?: boolean;
      /** 键名 */
      key?: string;
      /** 显示的名称 */
      displayName?: string;
      /** 显示顺序 */
      displayOrder?: number;
      /**  */
      parentKey?: string;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<DataDictionaryDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/DataDictionary/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        ParentId: params['parentId'],
        IsParent: params['isParent'],
        Key: params['key'],
        DisplayName: params['displayName'],
        DisplayOrder: params['displayOrder'],
        ParentKey: params['parentKey'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 根据parentID获取子字典数据
   */
  static getListByParentId(
    params: {
      /**  */
      parentId?: number;
      /**  */
      isParent?: boolean;
      /** 键名 */
      key?: string;
      /** 显示的名称 */
      displayName?: string;
      /** 显示顺序 */
      displayOrder?: number;
      /**  */
      parentKey?: string;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<DataDictionaryDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/DataDictionary/GetListByParentId';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        ParentId: params['parentId'],
        IsParent: params['isParent'],
        Key: params['key'],
        DisplayName: params['displayName'],
        DisplayOrder: params['displayOrder'],
        ParentKey: params['parentKey'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 根据Key获取子字典数据
   */
  static getDataDictionaryListByKey(
    params: {
      /**  */
      parentId?: number;
      /**  */
      isParent?: boolean;
      /** 键名 */
      key?: string;
      /** 显示的名称 */
      displayName?: string;
      /** 显示顺序 */
      displayOrder?: number;
      /**  */
      parentKey?: string;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<DataDictionaryDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/DataDictionary/GetDataDictionaryListByKey';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        ParentId: params['parentId'],
        IsParent: params['isParent'],
        Key: params['key'],
        DisplayName: params['displayName'],
        DisplayOrder: params['displayOrder'],
        ParentKey: params['parentKey'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 根据Key获取不分页的字典项
   */
  static getDataDictionaryByKey(
    params: {
      /**  */
      key?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<DataDictionaryDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/DataDictionary/GetDataDictionaryByKey';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { key: params['key'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取所有的一级字典项
   */
  static getAllRoot(options: IRequestOptions = {}): Promise<DataDictionaryDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/DataDictionary/GetAllRoot';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<DataDictionaryDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/DataDictionary/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class DataPermissionLimitService {
  /**
   * 获取数据
   */
  static getAll(
    params: {
      /**  */
      hostId?: string;
      /**  */
      hostType?: DataPermissionLimitHostType;
      /**  */
      targetType?: DataPermissionLimitTargetType;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<DataPermissionLimitDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/DataPermissionLimit/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { HostId: params['hostId'], HostType: params['hostType'], TargetType: params['targetType'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: DataPermissionLimitUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/DataPermissionLimit/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static reset(
    params: {
      /** requestBody */
      body?: DataPermissionLimitHostType;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/DataPermissionLimit/Reset';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/DataPermissionLimit/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class DepartmentService {
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: DepartmentCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<DepartmentDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Department/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Department/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: DepartmentCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<DepartmentDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Department/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<DepartmentDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Department/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<DepartmentDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Department/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class DonatedAmountConfigService {
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: DonatedAmountConfigCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<DonatedAmountConfigDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/DonatedAmountConfig/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static search(
    params: {
      /** 名称 */
      name?: string;
      /**  */
      sourceType?: DonatedAmountConfigSourceType;
      /**  */
      sourceId?: string;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<DonatedAmountConfigDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/DonatedAmountConfig/Search';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Name: params['name'],
        SourceType: params['sourceType'],
        SourceId: params['sourceId'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: DonatedAmountConfigCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<DonatedAmountConfigDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/DonatedAmountConfig/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<DonatedAmountConfigDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/DonatedAmountConfig/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /** 名称 */
      name?: string;
      /**  */
      sourceType?: DonatedAmountConfigSourceType;
      /**  */
      sourceId?: string;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<DonatedAmountConfigDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/DonatedAmountConfig/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Name: params['name'],
        SourceType: params['sourceType'],
        SourceId: params['sourceId'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/DonatedAmountConfig/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class DownloadService {
  /**
   *
   */
  static attachment(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Download/Attachment';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static batchDownload(
    params: {
      /**  */
      id?: string;
      /**  */
      zipFileName?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Download/BatchDownload';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { id: params['id'], zipFileName: params['zipFileName'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class ElectronicInvoiceService {
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: ElectronicInvoiceCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ElectronicInvoiceDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ElectronicInvoice/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static createByPaySuccess(
    params: {
      /**  */
      invoiceAmount?: number;
      /** requestBody */
      body?: ElectronicInvoiceCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ElectronicInvoiceDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ElectronicInvoice/CreateByPaySuccess';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { invoiceAmount: params['invoiceAmount'] };
      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: ElectronicInvoiceCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ElectronicInvoiceDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ElectronicInvoice/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ElectronicInvoiceDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ElectronicInvoice/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getSelectFundIncomeRecord(
    params: {
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundIncomeRecordMiniDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ElectronicInvoice/GetSelectFundIncomeRecord';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getUserElectronicInvoice(
    params: {
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UserElectronicInvoiceDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ElectronicInvoice/GetUserElectronicInvoice';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取发票数据
   */
  static getInvoiceCount(options: IRequestOptions = {}): Promise<ElectronicInvoiceCountGetDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ElectronicInvoice/GetInvoiceCount';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 设置发票数量
   */
  static setInvoiceCount(
    params: {
      /** requestBody */
      body?: ElectronicInvoiceCountPutDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ElectronicInvoice/SetInvoiceCount';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 确认
   */
  static confirm(
    params: {
      /** requestBody */
      body?: ElectronicInvoiceConfirmPutDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ElectronicInvoice/Confirm';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 冲红
   */
  static creditNote(
    params: {
      /** requestBody */
      body?: Int64EntityDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ElectronicInvoice/CreditNote';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 导出电子发票
   */
  static exportExcel(
    params: {
      /** requestBody */
      body?: ElectronicInvoicePagedResultRequestDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ElectronicInvoice/ExportExcel';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /** 捐赠票据抬头 */
      donationNoteTitle?: string;
      /** 电子发票状态 */
      status?: ElectronicInvoiceStatus;
      /** 手机号 */
      mobilePhone?: string;
      /** 邮箱 */
      email?: string;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ElectronicInvoiceDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ElectronicInvoice/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        DonationNoteTitle: params['donationNoteTitle'],
        Status: params['status'],
        MobilePhone: params['mobilePhone'],
        Email: params['email'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ElectronicInvoice/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class EnumService {
  /**
   * 获取枚举选项列表
   */
  static getValues(
    params: {
      /** 枚举名称，如：NotifyTemplateType */
      typeName?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SelectListItem[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Enum/GetValues';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { typeName: params['typeName'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAllEnums(
    params: {
      /**  */
      filter?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Enum/GetAllEnums';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { filter: params['filter'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAppEnums(options: IRequestOptions = {}): Promise<SelectListItem[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Enum/GetAppEnums';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAppEnumNames(options: IRequestOptions = {}): Promise<string[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Enum/GetAppEnumNames';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class ExternalDueDiligenceRecordService {
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: ExternalDueDiligenceRecordCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ExternalDueDiligenceRecordDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalDueDiligenceRecord/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /** 尽调形式 */
      dueDiligenceTypeId?: number;
      /** 开始时间 */
      startDate?: string;
      /** 结束时间 */
      endDate?: string;
      /**  */
      startDateStart?: string;
      /**  */
      startDateEnd?: string;
      /**  */
      endDateStart?: string;
      /**  */
      endDateEnd?: string;
      /**  */
      place?: string;
      /**  */
      members?: string;
      /**  */
      visitObjectJson?: string;
      /**  */
      orgInfo?: string;
      /**  */
      projectInfo?: string;
      /**  */
      omnibusOpinion?: string;
      /**  */
      organizationUnitName?: string;
      /**  */
      projectName?: string;
      /**  */
      organizationUnitId?: number;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ExternalDueDiligenceRecordDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalDueDiligenceRecord/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        DueDiligenceTypeId: params['dueDiligenceTypeId'],
        StartDate: params['startDate'],
        EndDate: params['endDate'],
        StartDateStart: params['startDateStart'],
        StartDateEnd: params['startDateEnd'],
        EndDateStart: params['endDateStart'],
        EndDateEnd: params['endDateEnd'],
        Place: params['place'],
        Members: params['members'],
        VisitObjectJson: params['visitObjectJson'],
        OrgInfo: params['orgInfo'],
        ProjectInfo: params['projectInfo'],
        OmnibusOpinion: params['omnibusOpinion'],
        OrganizationUnitName: params['organizationUnitName'],
        ProjectName: params['projectName'],
        OrganizationUnitId: params['organizationUnitId'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getDetail(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ExternalDueDiligenceRecordDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalDueDiligenceRecord/GetDetail';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 审核
   */
  static audit(
    params: {
      /** requestBody */
      body?: AuditUserLogProxy;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalDueDiligenceRecord/Audit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: ExternalDueDiligenceRecordCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ExternalDueDiligenceRecordDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalDueDiligenceRecord/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalDueDiligenceRecord/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static actualAudit(
    params: {
      /** requestBody */
      body?: AuditUserLog;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalDueDiligenceRecord/ActualAudit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getMyAll(
    params: {
      /** 尽调形式 */
      dueDiligenceTypeId?: number;
      /** 开始时间 */
      startDate?: string;
      /** 结束时间 */
      endDate?: string;
      /**  */
      startDateStart?: string;
      /**  */
      startDateEnd?: string;
      /**  */
      endDateStart?: string;
      /**  */
      endDateEnd?: string;
      /**  */
      place?: string;
      /**  */
      members?: string;
      /**  */
      visitObjectJson?: string;
      /**  */
      orgInfo?: string;
      /**  */
      projectInfo?: string;
      /**  */
      omnibusOpinion?: string;
      /**  */
      organizationUnitName?: string;
      /**  */
      projectName?: string;
      /**  */
      organizationUnitId?: number;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ExternalDueDiligenceRecordDtoListResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalDueDiligenceRecord/GetMyAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        DueDiligenceTypeId: params['dueDiligenceTypeId'],
        StartDate: params['startDate'],
        EndDate: params['endDate'],
        StartDateStart: params['startDateStart'],
        StartDateEnd: params['startDateEnd'],
        EndDateStart: params['endDateStart'],
        EndDateEnd: params['endDateEnd'],
        Place: params['place'],
        Members: params['members'],
        VisitObjectJson: params['visitObjectJson'],
        OrgInfo: params['orgInfo'],
        ProjectInfo: params['projectInfo'],
        OmnibusOpinion: params['omnibusOpinion'],
        OrganizationUnitName: params['organizationUnitName'],
        ProjectName: params['projectName'],
        OrganizationUnitId: params['organizationUnitId'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getLogs(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuditUserLogDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalDueDiligenceRecord/GetLogs';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getStatus(
    params: {
      /**  */
      audit?: number;
      /**  */
      auditStatus?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalDueDiligenceRecord/GetStatus';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { audit: params['audit'], auditStatus: params['auditStatus'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ExternalDueDiligenceRecordDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalDueDiligenceRecord/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class ExternalMonthlyPlanService {
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: ExternalMonthlyPlanCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ExternalMonthlyPlanDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalMonthlyPlan/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: ExternalMonthlyPlanCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ExternalMonthlyPlanDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalMonthlyPlan/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ExternalMonthlyPlanDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalMonthlyPlan/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取我的未填写总结的月活动计划列表
   */
  static getMyExternalMonthlyPlanList(
    params: {
      /**  */
      projectId?: number;
      /**  */
      date?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ExternalMonthlyPlanDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalMonthlyPlan/GetMyExternalMonthlyPlanList';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { ProjectId: params['projectId'], Date: params['date'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 根据年月获取有月计划的项目id
   */
  static getExternalProjectIdListByDate(
    params: {
      /**  */
      date?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<number[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalMonthlyPlan/GetExternalProjectIdListByDate';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { date: params['date'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 审核
   */
  static audit(
    params: {
      /** requestBody */
      body?: AuditUserLogProxy;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalMonthlyPlan/Audit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalMonthlyPlan/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static actualAudit(
    params: {
      /** requestBody */
      body?: AuditUserLog;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalMonthlyPlan/ActualAudit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getMyAll(
    params: {
      /** 年月 */
      date?: string;
      /** 项目名称 */
      displayName?: string;
      /** 所属项目ID */
      projectId?: number;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ExternalMonthlyPlanDtoListResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalMonthlyPlan/GetMyAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Date: params['date'],
        DisplayName: params['displayName'],
        ProjectId: params['projectId'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getLogs(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuditUserLogDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalMonthlyPlan/GetLogs';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getStatus(
    params: {
      /**  */
      audit?: number;
      /**  */
      auditStatus?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalMonthlyPlan/GetStatus';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { audit: params['audit'], auditStatus: params['auditStatus'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /** 年月 */
      date?: string;
      /** 项目名称 */
      displayName?: string;
      /** 所属项目ID */
      projectId?: number;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ExternalMonthlyPlanDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalMonthlyPlan/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Date: params['date'],
        DisplayName: params['displayName'],
        ProjectId: params['projectId'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class ExternalMonthlySummarizeService {
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ExternalMonthlySummarizeDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalMonthlySummarize/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: ExternalMonthlySummarizeCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ExternalMonthlySummarizeDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalMonthlySummarize/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: ExternalMonthlySummarizeCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ExternalMonthlySummarizeDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalMonthlySummarize/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 审核
   */
  static audit(
    params: {
      /** requestBody */
      body?: AuditUserLogProxy;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalMonthlySummarize/Audit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalMonthlySummarize/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static actualAudit(
    params: {
      /** requestBody */
      body?: AuditUserLog;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalMonthlySummarize/ActualAudit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getMyAll(
    params: {
      /** 年月 */
      date?: string;
      /** 项目名称 */
      displayName?: string;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ExternalMonthlySummarizeDtoListResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalMonthlySummarize/GetMyAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Date: params['date'],
        DisplayName: params['displayName'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getLogs(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuditUserLogDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalMonthlySummarize/GetLogs';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getStatus(
    params: {
      /**  */
      audit?: number;
      /**  */
      auditStatus?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalMonthlySummarize/GetStatus';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { audit: params['audit'], auditStatus: params['auditStatus'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /** 年月 */
      date?: string;
      /** 项目名称 */
      displayName?: string;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ExternalMonthlySummarizeDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalMonthlySummarize/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Date: params['date'],
        DisplayName: params['displayName'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class ExternalProjectService {
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: ExternalProjectCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ExternalProjectDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProject/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 复制新增
   */
  static copyCreate(
    params: {
      /** requestBody */
      body?: ExternalProjectCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<number> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProject/CopyCreate';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取外部项目计划书详情
   */
  static getDetail(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ExternalProjectDetailDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProject/GetDetail';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 根据ProjectId获取外部项目计划书详情
   */
  static getDetailByProjectId(
    params: {
      /**  */
      projectId?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ExternalProjectDetailDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProject/GetDetailByProjectId';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { projectId: params['projectId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getProjectMonthlySummaizeDetailsByProjectId(
    params: {
      /**  */
      projectId?: number;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ProjectMonthlySummaizeDetailsDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProject/GetProjectMonthlySummaizeDetailsByProjectId';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        ProjectId: params['projectId'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 更新外部项目预算表
   */
  static updateBudgetItem(
    params: {
      /** requestBody */
      body?: UpdateExternalProjectBudgetItemsDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProject/UpdateBudgetItem';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取外部项目已立项列表
   */
  static getExternalProjectList(options: IRequestOptions = {}): Promise<ExternalProjectDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProject/GetExternalProjectList';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 根据年月获取有月计划的外部项目列表
   */
  static getExternalProjectListByDate(
    params: {
      /**  */
      date?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ExternalProjectDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProject/GetExternalProjectListByDate';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { date: params['date'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 审核
   */
  static audit(
    params: {
      /** requestBody */
      body?: AuditUserLogProxy;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProject/Audit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: ExternalProjectCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ExternalProjectDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProject/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProject/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static actualAudit(
    params: {
      /** requestBody */
      body?: AuditUserLog;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProject/ActualAudit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getMyAll(
    params: {
      /**  */
      displayName?: string;
      /**  */
      orgName?: string;
      /**  */
      projectId?: number;
      /**  */
      year?: number;
      /**  */
      isPhase?: boolean;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ExternalProjectDtoListResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProject/GetMyAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        DisplayName: params['displayName'],
        OrgName: params['orgName'],
        ProjectId: params['projectId'],
        Year: params['year'],
        IsPhase: params['isPhase'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getLogs(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuditUserLogDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProject/GetLogs';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getStatus(
    params: {
      /**  */
      audit?: number;
      /**  */
      auditStatus?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProject/GetStatus';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { audit: params['audit'], auditStatus: params['auditStatus'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ExternalProjectDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProject/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /**  */
      displayName?: string;
      /**  */
      orgName?: string;
      /**  */
      projectId?: number;
      /**  */
      year?: number;
      /**  */
      isPhase?: boolean;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ExternalProjectDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProject/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        DisplayName: params['displayName'],
        OrgName: params['orgName'],
        ProjectId: params['projectId'],
        Year: params['year'],
        IsPhase: params['isPhase'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class ExternalProjectChangeApplyService {
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: ExternalProjectChangeApplyCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ExternalProjectChangeApplyDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectChangeApply/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: ExternalProjectChangeApplyCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ExternalProjectChangeApplyDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectChangeApply/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ExternalProjectChangeApplyDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectChangeApply/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 审核
   */
  static audit(
    params: {
      /** requestBody */
      body?: AuditUserLogProxy;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectChangeApply/Audit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectChangeApply/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static actualAudit(
    params: {
      /** requestBody */
      body?: AuditUserLog;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectChangeApply/ActualAudit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getMyAll(
    params: {
      /** 项目名称 */
      displayName?: string;
      /** 变更时间 */
      changeDate?: string;
      /**  */
      changeTypes?: string;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ExternalProjectChangeApplyDtoListResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectChangeApply/GetMyAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        DisplayName: params['displayName'],
        ChangeDate: params['changeDate'],
        ChangeTypes: params['changeTypes'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getLogs(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuditUserLogDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectChangeApply/GetLogs';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getStatus(
    params: {
      /**  */
      audit?: number;
      /**  */
      auditStatus?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectChangeApply/GetStatus';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { audit: params['audit'], auditStatus: params['auditStatus'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /** 项目名称 */
      displayName?: string;
      /** 变更时间 */
      changeDate?: string;
      /**  */
      changeTypes?: string;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ExternalProjectChangeApplyDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectChangeApply/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        DisplayName: params['displayName'],
        ChangeDate: params['changeDate'],
        ChangeTypes: params['changeTypes'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class ExternalProjectCloseReportService {
  /**
   *
   */
  static getDetail(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CloseReportDetailDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectCloseReport/GetDetail';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CloseReportCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CloseReportDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectCloseReport/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: CloseReportCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CloseReportDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectCloseReport/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 发送评估总结报告填写通知
   */
  static sendNotify(
    params: {
      /**  */
      projectId?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectCloseReport/SendNotify';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { projectId: params['projectId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 审核
   */
  static audit(
    params: {
      /** requestBody */
      body?: AuditUserLogProxy;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectCloseReport/Audit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectCloseReport/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static actualAudit(
    params: {
      /** requestBody */
      body?: AuditUserLog;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectCloseReport/ActualAudit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getMyAll(
    params: {
      /** 项目名称 */
      projectName?: string;
      /** 机构名称 */
      orgName?: string;
      /** 开始时间 */
      startDate?: string;
      /** 截止时间 */
      endDate?: string;
      /**  */
      projectId?: number;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CloseReportDtoListResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectCloseReport/GetMyAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        ProjectName: params['projectName'],
        OrgName: params['orgName'],
        StartDate: params['startDate'],
        EndDate: params['endDate'],
        ProjectId: params['projectId'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getLogs(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuditUserLogDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectCloseReport/GetLogs';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getStatus(
    params: {
      /**  */
      audit?: number;
      /**  */
      auditStatus?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectCloseReport/GetStatus';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { audit: params['audit'], auditStatus: params['auditStatus'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CloseReportDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectCloseReport/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /** 项目名称 */
      projectName?: string;
      /** 机构名称 */
      orgName?: string;
      /** 开始时间 */
      startDate?: string;
      /** 截止时间 */
      endDate?: string;
      /**  */
      projectId?: number;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CloseReportDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectCloseReport/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        ProjectName: params['projectName'],
        OrgName: params['orgName'],
        StartDate: params['startDate'],
        EndDate: params['endDate'],
        ProjectId: params['projectId'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class ExternalProjectIntentionService {
  /**
   * 获取项目意向书详情
   */
  static getDetail(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ExternalProjectIntentionCreateOrUpdateDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectIntention/GetDetail';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: ExternalProjectIntentionCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ExternalProjectIntentionDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectIntention/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 审核
   */
  static audit(
    params: {
      /** requestBody */
      body?: AuditUserLogProxy;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectIntention/Audit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: ExternalProjectIntentionCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ExternalProjectIntentionDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectIntention/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectIntention/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static actualAudit(
    params: {
      /** requestBody */
      body?: AuditUserLog;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectIntention/ActualAudit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getMyAll(
    params: {
      /** 项目名称 */
      displayName?: string;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ExternalProjectIntentionDtoListResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectIntention/GetMyAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        DisplayName: params['displayName'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getLogs(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuditUserLogDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectIntention/GetLogs';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getStatus(
    params: {
      /**  */
      audit?: number;
      /**  */
      auditStatus?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectIntention/GetStatus';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { audit: params['audit'], auditStatus: params['auditStatus'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ExternalProjectIntentionDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectIntention/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /** 项目名称 */
      displayName?: string;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ExternalProjectIntentionDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectIntention/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        DisplayName: params['displayName'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class ExternalProjectPhaseService {
  /**
   *
   */
  static getProjectPhasesList(
    params: {
      /**  */
      projectId?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ExternalProjectPhaseItemDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectPhase/GetProjectPhasesList';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { projectId: params['projectId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getProjectMonthList(
    params: {
      /**  */
      projectId?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ProjectMonthItemDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectPhase/GetProjectMonthList';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { projectId: params['projectId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getProjectAttachmentListByPhase(
    params: {
      /** 项目ID */
      projectId?: number;
      /** 节点枚举 */
      stage?: WorkflowOfProjectByExternal;
      /** 年份 */
      year?: number;
      /** 月份 */
      month?: number;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AttachmentDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectPhase/GetProjectAttachmentListByPhase';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        ProjectId: params['projectId'],
        Stage: params['stage'],
        Year: params['year'],
        Month: params['month'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getProjectAttachmentListByMonth(
    params: {
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
      /** 项目ID */
      projectId?: number;
      /** 年份 */
      year?: number;
      /** 月份 */
      month?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AttachmentDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectPhase/GetProjectAttachmentListByMonth';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount'],
        ProjectId: params['projectId'],
        Year: params['year'],
        Month: params['month']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static batchDownloadProjectPhasesAttachment(
    params: {
      /**  */
      projectId?: number;
      /**  */
      stage?: WorkflowOfProjectByExternal;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectPhase/BatchDownloadProjectPhasesAttachment';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { projectId: params['projectId'], stage: params['stage'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static batchDownloadProjectMonthAttachment(
    params: {
      /**  */
      projectId?: number;
      /**  */
      year?: number;
      /**  */
      month?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectPhase/BatchDownloadProjectMonthAttachment';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { projectId: params['projectId'], year: params['year'], month: params['month'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class ExternalProjectProcessMonitoringService {
  /**
   * 获取监测记录详情
   */
  static getDetail(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ExternalProjectProcessMonitoringCreateOrUpdateDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectProcessMonitoring/GetDetail';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: ExternalProjectProcessMonitoringCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ExternalProjectProcessMonitoringDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectProcessMonitoring/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: ExternalProjectProcessMonitoringCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ExternalProjectProcessMonitoringDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectProcessMonitoring/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 发送监测记录填写通知
   */
  static sendNotify(
    params: {
      /**  */
      projectId?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectProcessMonitoring/SendNotify';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { projectId: params['projectId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 审核
   */
  static audit(
    params: {
      /** requestBody */
      body?: AuditUserLogProxy;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectProcessMonitoring/Audit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectProcessMonitoring/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static actualAudit(
    params: {
      /** requestBody */
      body?: AuditUserLog;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectProcessMonitoring/ActualAudit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getMyAll(
    params: {
      /** 项目名称 */
      displayName?: string;
      /** 监测主题 */
      title?: string;
      /** 监测方式 */
      monitoringType?: string;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ExternalProjectProcessMonitoringDtoListResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectProcessMonitoring/GetMyAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        DisplayName: params['displayName'],
        Title: params['title'],
        MonitoringType: params['monitoringType'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getLogs(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuditUserLogDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectProcessMonitoring/GetLogs';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getStatus(
    params: {
      /**  */
      audit?: number;
      /**  */
      auditStatus?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectProcessMonitoring/GetStatus';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { audit: params['audit'], auditStatus: params['auditStatus'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ExternalProjectProcessMonitoringDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectProcessMonitoring/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /** 项目名称 */
      displayName?: string;
      /** 监测主题 */
      title?: string;
      /** 监测方式 */
      monitoringType?: string;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ExternalProjectProcessMonitoringDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectProcessMonitoring/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        DisplayName: params['displayName'],
        Title: params['title'],
        MonitoringType: params['monitoringType'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class ExternalProjectProgressReportService {
  /**
   * 获取中期报告详情
   */
  static getDetail(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ProgressReportDetailDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectProgressReport/GetDetail';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: ProgressReportCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ProgressReportDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectProgressReport/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: ProgressReportCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ProgressReportDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectProgressReport/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 发送中期报告填写通知
   */
  static sendNotify(
    params: {
      /**  */
      projectId?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectProgressReport/SendNotify';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { projectId: params['projectId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 审核
   */
  static audit(
    params: {
      /** requestBody */
      body?: AuditUserLogProxy;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectProgressReport/Audit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectProgressReport/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static actualAudit(
    params: {
      /** requestBody */
      body?: AuditUserLog;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectProgressReport/ActualAudit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getMyAll(
    params: {
      /** 项目名称 */
      projectName?: string;
      /** 机构名称 */
      orgName?: string;
      /** 开始时间 */
      startDate?: string;
      /** 截止时间 */
      endDate?: string;
      /**  */
      projectId?: number;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ProgressReportDtoListResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectProgressReport/GetMyAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        ProjectName: params['projectName'],
        OrgName: params['orgName'],
        StartDate: params['startDate'],
        EndDate: params['endDate'],
        ProjectId: params['projectId'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getLogs(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuditUserLogDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectProgressReport/GetLogs';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getStatus(
    params: {
      /**  */
      audit?: number;
      /**  */
      auditStatus?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectProgressReport/GetStatus';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { audit: params['audit'], auditStatus: params['auditStatus'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ProgressReportDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectProgressReport/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /** 项目名称 */
      projectName?: string;
      /** 机构名称 */
      orgName?: string;
      /** 开始时间 */
      startDate?: string;
      /** 截止时间 */
      endDate?: string;
      /**  */
      projectId?: number;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ProgressReportDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectProgressReport/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        ProjectName: params['projectName'],
        OrgName: params['orgName'],
        StartDate: params['startDate'],
        EndDate: params['endDate'],
        ProjectId: params['projectId'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class ExternalProjectReportService {
  /**
   * 外部项目宏观展示
   */
  static getMacroscopic(options: IRequestOptions = {}): Promise<LineChartDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectReport/GetMacroscopic';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 外部项目微观展示
   */
  static getMicrocosmics(
    params: {
      /** 项目年份 */
      year?: number;
      /** 项目类型 */
      projectType?: number;
      /** 项目状态 */
      status?: WorkflowOfProjectByExternal;
      /**  */
      skipCount?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ExternalMicrocosmicDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectReport/GetMicrocosmics';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Year: params['year'],
        ProjectType: params['projectType'],
        Status: params['status'],
        SkipCount: params['skipCount'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取未完成月总结的项目
   */
  static getNotCompleteMonthlySummaryProjects(
    params: {
      /**  */
      year?: number;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ProjectOfNotCompleteDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectReport/GetNotCompleteMonthlySummaryProjects';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Year: params['year'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取未正常关项的项目
   */
  static getNotClosingNormallyProjects(
    params: {
      /**  */
      year?: number;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ProjectOfNotCompleteDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectReport/GetNotClosingNormallyProjects';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Year: params['year'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 没有交付中期报告的项目列表
   */
  static getNotCompleteProgressReportProjects(
    params: {
      /**  */
      year?: number;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ProjectOfNotCompleteDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectReport/GetNotCompleteProgressReportProjects';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Year: params['year'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 没有交付结项自评报告的项目列表
   */
  static getNotCompleteSummaryReportProjects(
    params: {
      /**  */
      year?: number;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ProjectOfNotCompleteDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectReport/GetNotCompleteSummaryReportProjects';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Year: params['year'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class ExternalProjectSummaryReportService {
  /**
   * 获取结项自评报告详情
   */
  static getDetail(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SummaryReportDetailDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectSummaryReport/GetDetail';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 根据项目Id获取结项自评报告详情
   */
  static getDetailByProjectId(
    params: {
      /**  */
      projectId?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SummaryReportDetailDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectSummaryReport/GetDetailByProjectId';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { projectId: params['projectId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: SummaryReportCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SummaryReportDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectSummaryReport/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: SummaryReportCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SummaryReportDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectSummaryReport/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 发送结项自评报告填写通知
   */
  static sendNotify(
    params: {
      /**  */
      projectId?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectSummaryReport/SendNotify';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { projectId: params['projectId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 审核
   */
  static audit(
    params: {
      /** requestBody */
      body?: AuditUserLogProxy;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectSummaryReport/Audit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectSummaryReport/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static actualAudit(
    params: {
      /** requestBody */
      body?: AuditUserLog;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectSummaryReport/ActualAudit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getMyAll(
    params: {
      /** 项目名称 */
      projectName?: string;
      /** 机构名称 */
      orgName?: string;
      /** 开始时间 */
      startDate?: string;
      /** 截止时间 */
      endDate?: string;
      /**  */
      projectId?: number;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SummaryReportDtoListResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectSummaryReport/GetMyAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        ProjectName: params['projectName'],
        OrgName: params['orgName'],
        StartDate: params['startDate'],
        EndDate: params['endDate'],
        ProjectId: params['projectId'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getLogs(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuditUserLogDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectSummaryReport/GetLogs';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getStatus(
    params: {
      /**  */
      audit?: number;
      /**  */
      auditStatus?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectSummaryReport/GetStatus';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { audit: params['audit'], auditStatus: params['auditStatus'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SummaryReportDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectSummaryReport/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /** 项目名称 */
      projectName?: string;
      /** 机构名称 */
      orgName?: string;
      /** 开始时间 */
      startDate?: string;
      /** 截止时间 */
      endDate?: string;
      /**  */
      projectId?: number;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SummaryReportDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ExternalProjectSummaryReport/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        ProjectName: params['projectName'],
        OrgName: params['orgName'],
        StartDate: params['startDate'],
        EndDate: params['endDate'],
        ProjectId: params['projectId'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class FeedbackService {
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: FeedbackCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FeedbackDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Feedback/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static submit(
    params: {
      /** requestBody */
      body?: FeedbackCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FeedbackDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Feedback/Submit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FeedbackDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Feedback/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 我的在线留言
   */
  static getMy(
    params: {
      /** 标题 */
      title?: string;
      /** 内容 */
      content?: string;
      /** 联系方式 */
      contactType?: string;
      /** 反馈类型Id */
      typeCodeId?: number;
      /** 反馈来源 */
      sourceType?: FeedbackSourceType;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FeedbackDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Feedback/GetMy';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Title: params['title'],
        Content: params['content'],
        ContactType: params['contactType'],
        TypeCodeId: params['typeCodeId'],
        SourceType: params['sourceType'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: FeedbackCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FeedbackDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Feedback/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Feedback/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static replySave(
    params: {
      /** requestBody */
      body?: FeedbackCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FeedbackDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Feedback/ReplySave';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /** 标题 */
      title?: string;
      /** 内容 */
      content?: string;
      /** 联系方式 */
      contactType?: string;
      /** 反馈类型Id */
      typeCodeId?: number;
      /** 反馈来源 */
      sourceType?: FeedbackSourceType;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FeedbackDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Feedback/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Title: params['title'],
        Content: params['content'],
        ContactType: params['contactType'],
        TypeCodeId: params['typeCodeId'],
        SourceType: params['sourceType'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class FeedbackReplyService {
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: FeedbackReplyCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FeedbackReplyDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FeedbackReply/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FeedbackReplyDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FeedbackReply/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: FeedbackReplyCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FeedbackReplyDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FeedbackReply/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FeedbackReply/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 显示记录
   */
  static show(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FeedbackReply/Show';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 隐藏记录
   */
  static hidden(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FeedbackReply/Hidden';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /** 反馈信息Id */
      feedbackId?: number;
      /** 内容 */
      content?: string;
      /** 是否隐藏 */
      isHide?: boolean;
      /** 用户Id */
      userId?: number;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FeedbackReplyDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FeedbackReply/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        FeedbackId: params['feedbackId'],
        Content: params['content'],
        IsHide: params['isHide'],
        UserId: params['userId'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class FundService {
  /**
   * 开启筹款
   */
  static enableFundRaising(
    params: {
      /**  */
      fundId?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Fund/EnableFundRaising';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { fundId: params['fundId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 关闭筹款
   */
  static disableFundRaising(
    params: {
      /**  */
      fundId?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Fund/DisableFundRaising';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { fundId: params['fundId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 全部发送基金消息
   */
  static sendAllMessage(
    params: {
      /**  */
      messageId?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Fund/SendAllMessage';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { messageId: params['messageId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 选择发送基金消息
   */
  static sendMessage(
    params: {
      /** requestBody */
      body?: FundSendMessageInput;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Fund/SendMessage';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取二维码
   */
  static downQrCode(
    params: {
      /**  */
      fundId?: number;
      /**  */
      donateType?: DonateType;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Fund/DownQrCode';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { fundId: params['fundId'], donateType: params['donateType'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: FundCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Fund/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: FundCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Fund/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Fund/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /** 基金名称 */
      name?: string;
      /** 基金类型 */
      type?: FundType;
      /**  */
      isAudited?: boolean;
      /** 细分类别 */
      fundCategory?: string;
      /** 是否在网站上显示 */
      isPublished?: boolean;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Fund/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Name: params['name'],
        Type: params['type'],
        IsAudited: params['isAudited'],
        FundCategory: params['fundCategory'],
        IsPublished: params['isPublished'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getList(
    params: {
      /** 基金名称 */
      name?: string;
      /** 基金类型 */
      type?: FundType;
      /**  */
      isAudited?: boolean;
      /** 细分类别 */
      fundCategory?: string;
      /** 是否在网站上显示 */
      isPublished?: boolean;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Fund/GetList';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Name: params['name'],
        Type: params['type'],
        IsAudited: params['isAudited'],
        FundCategory: params['fundCategory'],
        IsPublished: params['isPublished'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取基金消息
   */
  static getFundMessage(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundMessageDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Fund/GetFundMessage';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取基金消息
   */
  static getFundMessageAll(
    params: {
      /** 基金Id */
      fundId?: number;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundMessageDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Fund/GetFundMessageAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        FundId: params['fundId'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取基金消息的未读数量
   */
  static getFundMessageUnReadCount(
    params: {
      /**  */
      fundId?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<number> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Fund/GetFundMessageUnReadCount';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { fundId: params['fundId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 更新基金消息的阅读信息
   */
  static updateFundMessageRead(
    params: {
      /** requestBody */
      body?: Int32EntityDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Fund/UpdateFundMessageRead';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Fund/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 开始公示
   */
  static enablePublishShow(
    params: {
      /**  */
      fundId?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Fund/EnablePublishShow';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { fundId: params['fundId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 关闭公示
   */
  static disablePublishShow(
    params: {
      /**  */
      fundId?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Fund/DisablePublishShow';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { fundId: params['fundId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class FundAccountService {
  /**
   *
   */
  static getAll(
    params: {
      /** 基金类型 */
      type?: FundType;
      /** 基金Id */
      fundId?: number;
      /** 起始日期 */
      startDate?: string;
      /** 截止日期 */
      endDate?: string;
      /** 是否前端 */
      isFront?: boolean;
      /** 记录类型 */
      operationType?: FundAccountRecordOperationType;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundAccountDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundAccount/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Type: params['type'],
        FundID: params['fundId'],
        StartDate: params['startDate'],
        EndDate: params['endDate'],
        IsFront: params['isFront'],
        OperationType: params['operationType'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static export(
    params: {
      /** requestBody */
      body?: FundAccountPagedResultRequestDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundAccount/Export';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static queryIncomeAndAppropriateFundRecord(
    params: {
      /** 基金类型 */
      type?: FundType;
      /** 基金Id */
      fundId?: number;
      /** 起始日期 */
      startDate?: string;
      /** 截止日期 */
      endDate?: string;
      /** 是否前端 */
      isFront?: boolean;
      /** 记录类型 */
      operationType?: FundAccountRecordOperationType;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundAccountRecordDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundAccount/QueryIncomeAndAppropriateFundRecord';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Type: params['type'],
        FundID: params['fundId'],
        StartDate: params['startDate'],
        EndDate: params['endDate'],
        IsFront: params['isFront'],
        OperationType: params['operationType'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class FundApplyService {
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: FundApplyCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundApplyDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundApply/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: FundApplyCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundApplyDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundApply/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取用户最近一次申请的记录
   */
  static getLatestAudit(
    params: {
      /**  */
      fundType?: FundType;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundApplyDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundApply/GetLatestAudit';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { fundType: params['fundType'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static audit(
    params: {
      /** requestBody */
      body?: AuditUserLogProxy;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundApply/Audit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getLogs(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuditUserLogDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundApply/GetLogs';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundApply/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static actualAudit(
    params: {
      /** requestBody */
      body?: AuditUserLog;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundApply/ActualAudit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getMyAll(
    params: {
      /** 基金名称 */
      fundName?: string;
      /**  */
      isAudited?: boolean;
      /** 基金类型 */
      type?: FundType;
      /** 细分类别 */
      fundCategory?: string;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundApplyDtoListResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundApply/GetMyAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        FundName: params['fundName'],
        IsAudited: params['isAudited'],
        Type: params['type'],
        FundCategory: params['fundCategory'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getStatus(
    params: {
      /**  */
      audit?: number;
      /**  */
      auditStatus?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundApply/GetStatus';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { audit: params['audit'], auditStatus: params['auditStatus'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundApplyDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundApply/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /** 基金名称 */
      fundName?: string;
      /**  */
      isAudited?: boolean;
      /** 基金类型 */
      type?: FundType;
      /** 细分类别 */
      fundCategory?: string;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundApplyDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundApply/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        FundName: params['fundName'],
        IsAudited: params['isAudited'],
        Type: params['type'],
        FundCategory: params['fundCategory'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class FundAppropriateApplyService {
  /**
   *
   */
  static audit(
    params: {
      /** requestBody */
      body?: AuditUserLogProxy;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundAppropriateApply/Audit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: FundAppropriateApplyCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundAppropriateApplyDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundAppropriateApply/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundAppropriateApply/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static actualAudit(
    params: {
      /** requestBody */
      body?: AuditUserLog;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundAppropriateApply/ActualAudit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getMyAll(
    params: {
      /**  */
      fundName?: string;
      /**  */
      projectName?: string;
      /**  */
      fundId?: number;
      /**  */
      isAudited?: boolean;
      /**  */
      projectId?: number;
      /**  */
      title?: string;
      /** 拨付金额 */
      moneyAmount?: number;
      /**  */
      moneyAmountStart?: number;
      /**  */
      moneyAmountEnd?: number;
      /** 拨付理由 */
      appropriateReason?: string;
      /** 收款银行账号 */
      bankAccountCode?: string;
      /** 开户行名称 */
      bankName?: string;
      /** 户名 */
      bankAccountName?: string;
      /** 收款人姓名 */
      receiverName?: string;
      /** 收款人电话 */
      receiverTelephone?: string;
      /** 拨付类型 */
      appropriateType?: FundAppropriateType;
      /** 其他项目名称 */
      otherProjectName?: string;
      /**  */
      endDate?: string;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundAppropriateApplyDtoListResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundAppropriateApply/GetMyAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        FundName: params['fundName'],
        ProjectName: params['projectName'],
        FundId: params['fundId'],
        IsAudited: params['isAudited'],
        ProjectId: params['projectId'],
        Title: params['title'],
        MoneyAmount: params['moneyAmount'],
        MoneyAmountStart: params['moneyAmountStart'],
        MoneyAmountEnd: params['moneyAmountEnd'],
        AppropriateReason: params['appropriateReason'],
        BankAccountCode: params['bankAccountCode'],
        BankName: params['bankName'],
        BankAccountName: params['bankAccountName'],
        ReceiverName: params['receiverName'],
        ReceiverTelephone: params['receiverTelephone'],
        AppropriateType: params['appropriateType'],
        OtherProjectName: params['otherProjectName'],
        EndDate: params['endDate'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getLogs(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuditUserLogDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundAppropriateApply/GetLogs';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getStatus(
    params: {
      /**  */
      audit?: number;
      /**  */
      auditStatus?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundAppropriateApply/GetStatus';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { audit: params['audit'], auditStatus: params['auditStatus'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundAppropriateApplyDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundAppropriateApply/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /**  */
      fundName?: string;
      /**  */
      projectName?: string;
      /**  */
      fundId?: number;
      /**  */
      isAudited?: boolean;
      /**  */
      projectId?: number;
      /**  */
      title?: string;
      /** 拨付金额 */
      moneyAmount?: number;
      /**  */
      moneyAmountStart?: number;
      /**  */
      moneyAmountEnd?: number;
      /** 拨付理由 */
      appropriateReason?: string;
      /** 收款银行账号 */
      bankAccountCode?: string;
      /** 开户行名称 */
      bankName?: string;
      /** 户名 */
      bankAccountName?: string;
      /** 收款人姓名 */
      receiverName?: string;
      /** 收款人电话 */
      receiverTelephone?: string;
      /** 拨付类型 */
      appropriateType?: FundAppropriateType;
      /** 其他项目名称 */
      otherProjectName?: string;
      /**  */
      endDate?: string;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundAppropriateApplyDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundAppropriateApply/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        FundName: params['fundName'],
        ProjectName: params['projectName'],
        FundId: params['fundId'],
        IsAudited: params['isAudited'],
        ProjectId: params['projectId'],
        Title: params['title'],
        MoneyAmount: params['moneyAmount'],
        MoneyAmountStart: params['moneyAmountStart'],
        MoneyAmountEnd: params['moneyAmountEnd'],
        AppropriateReason: params['appropriateReason'],
        BankAccountCode: params['bankAccountCode'],
        BankName: params['bankName'],
        BankAccountName: params['bankAccountName'],
        ReceiverName: params['receiverName'],
        ReceiverTelephone: params['receiverTelephone'],
        AppropriateType: params['appropriateType'],
        OtherProjectName: params['otherProjectName'],
        EndDate: params['endDate'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class FundAppropriateRecordService {
  /**
   * 获取拨付统计
   */
  static statisticsTotalAmountByFundId(
    params: {
      /**  */
      fundId?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<number> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundAppropriateRecord/StatisticsTotalAmountByFundID';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { fundId: params['fundId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取拨付统计
   */
  static statisticsTotalAmount(
    params: {
      /**  */
      fundName?: string;
      /**  */
      fundId?: number;
      /**  */
      projectId?: number;
      /**  */
      projectName?: string;
      /**  */
      title?: string;
      /** 拨付金额 */
      moneyAmount?: number;
      /** 拨付金额 */
      moneyAmountStart?: number;
      /** 拨付金额 */
      moneyAmountEnd?: number;
      /** 拨付理由 */
      appropriateReason?: string;
      /** 拨付时间 */
      appropriateTimeStart?: string;
      /**  */
      appropriateTimeEnd?: string;
      /** 收款银行账号 */
      bankAccountCode?: string;
      /** 开户行名称 */
      bankName?: string;
      /** 户名 */
      bankAccountName?: string;
      /** 收款人姓名 */
      receiverName?: string;
      /** 收款人电话 */
      receiverTelephone?: string;
      /** 状态 */
      status?: ValidStatus;
      /** 拨付类型 */
      appropriateType?: FundAppropriateType;
      /** 其他项目名称 */
      otherProjectName?: string;
      /**  */
      year?: string;
      /**  */
      month?: string;
      /**  */
      day?: string;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<number> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundAppropriateRecord/StatisticsTotalAmount';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        FundName: params['fundName'],
        FundId: params['fundId'],
        ProjectId: params['projectId'],
        ProjectName: params['projectName'],
        Title: params['title'],
        MoneyAmount: params['moneyAmount'],
        MoneyAmountStart: params['moneyAmountStart'],
        MoneyAmountEnd: params['moneyAmountEnd'],
        AppropriateReason: params['appropriateReason'],
        AppropriateTimeStart: params['appropriateTimeStart'],
        AppropriateTimeEnd: params['appropriateTimeEnd'],
        BankAccountCode: params['bankAccountCode'],
        BankName: params['bankName'],
        BankAccountName: params['bankAccountName'],
        ReceiverName: params['receiverName'],
        ReceiverTelephone: params['receiverTelephone'],
        Status: params['status'],
        AppropriateType: params['appropriateType'],
        OtherProjectName: params['otherProjectName'],
        Year: params['year'],
        Month: params['month'],
        Day: params['day'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /**  */
      fundName?: string;
      /**  */
      fundId?: number;
      /**  */
      projectId?: number;
      /**  */
      projectName?: string;
      /**  */
      title?: string;
      /** 拨付金额 */
      moneyAmount?: number;
      /** 拨付金额 */
      moneyAmountStart?: number;
      /** 拨付金额 */
      moneyAmountEnd?: number;
      /** 拨付理由 */
      appropriateReason?: string;
      /** 拨付时间 */
      appropriateTimeStart?: string;
      /**  */
      appropriateTimeEnd?: string;
      /** 收款银行账号 */
      bankAccountCode?: string;
      /** 开户行名称 */
      bankName?: string;
      /** 户名 */
      bankAccountName?: string;
      /** 收款人姓名 */
      receiverName?: string;
      /** 收款人电话 */
      receiverTelephone?: string;
      /** 状态 */
      status?: ValidStatus;
      /** 拨付类型 */
      appropriateType?: FundAppropriateType;
      /** 其他项目名称 */
      otherProjectName?: string;
      /**  */
      year?: string;
      /**  */
      month?: string;
      /**  */
      day?: string;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundAppropriateRecordDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundAppropriateRecord/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        FundName: params['fundName'],
        FundId: params['fundId'],
        ProjectId: params['projectId'],
        ProjectName: params['projectName'],
        Title: params['title'],
        MoneyAmount: params['moneyAmount'],
        MoneyAmountStart: params['moneyAmountStart'],
        MoneyAmountEnd: params['moneyAmountEnd'],
        AppropriateReason: params['appropriateReason'],
        AppropriateTimeStart: params['appropriateTimeStart'],
        AppropriateTimeEnd: params['appropriateTimeEnd'],
        BankAccountCode: params['bankAccountCode'],
        BankName: params['bankName'],
        BankAccountName: params['bankAccountName'],
        ReceiverName: params['receiverName'],
        ReceiverTelephone: params['receiverTelephone'],
        Status: params['status'],
        AppropriateType: params['appropriateType'],
        OtherProjectName: params['otherProjectName'],
        Year: params['year'],
        Month: params['month'],
        Day: params['day'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 修改拨付时间
   */
  static changeAppropriateTime(
    params: {
      /** requestBody */
      body?: FundAppropriateRecordChangeAppropriateTimeInput;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundAppropriateRecord/ChangeAppropriateTime';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundAppropriateRecordDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundAppropriateRecord/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class FundBankInfoService {
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: FundBankInfoCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundBankInfoDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundBankInfo/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: FundBankInfoCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundBankInfoDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundBankInfo/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundBankInfoDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundBankInfo/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundBankInfoDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundBankInfo/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundBankInfo/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class FundDonationMonthlyConfigService {
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundDonationMonthlyConfigDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundDonationMonthlyConfig/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /** 捐赠项目类型 */
      donorItemType?: number;
      /** 捐赠项目编号 */
      donorItemId?: number;
      /** 捐赠协议序列号(签约银行返回) */
      donorSignSn?: string;
      /** 捐赠方类型(个人，团体，企业) */
      donorType?: DonorType;
      /** 固定捐助天 */
      donorDay?: number;
      /** 捐赠金额,单位：分 */
      donationAmount?: number;
      /**  */
      donationAmountStart?: number;
      /**  */
      donationAmountEnd?: number;
      /** 发票Id */
      invoiceId?: number;
      /** 捐赠留言 */
      leaveMessage?: string;
      /** 捐赠人联系号码 */
      mobileTelephone?: string;
      /** 发票附件编号，多个使用英文","隔开 */
      attachments?: string;
      /** 捐赠人名称(匿名使用“爱心人士”) */
      displayName?: string;
      /** 平台与天付宝确认签约订单号，关联发票订单Id */
      spBillNo?: string;
      /** 天付宝确认签约订单号，关联发票订单Id */
      listId?: string;
      /** 月捐状态(1：开启，0：停止月捐) */
      isOpen?: boolean;
      /** 是否已确认 */
      isConfirmed?: boolean;
      /** 推荐人 */
      referrer?: string;
      /** 停止月捐时间 */
      stoppedTimeStart?: string;
      /**  */
      stoppedTimeEnd?: string;
      /** 月捐类型（1天付宝，2微信） */
      configType?: number;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundDonationMonthlyConfigDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundDonationMonthlyConfig/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        DonorItemType: params['donorItemType'],
        DonorItemId: params['donorItemId'],
        DonorSignSn: params['donorSignSn'],
        DonorType: params['donorType'],
        DonorDay: params['donorDay'],
        DonationAmount: params['donationAmount'],
        DonationAmountStart: params['donationAmountStart'],
        DonationAmountEnd: params['donationAmountEnd'],
        InvoiceId: params['invoiceId'],
        LeaveMessage: params['leaveMessage'],
        MobileTelephone: params['mobileTelephone'],
        Attachments: params['attachments'],
        DisplayName: params['displayName'],
        SpBillNo: params['spBillNo'],
        ListId: params['listId'],
        IsOpen: params['isOpen'],
        IsConfirmed: params['isConfirmed'],
        Referrer: params['referrer'],
        StoppedTimeStart: params['stoppedTimeStart'],
        StoppedTimeEnd: params['stoppedTimeEnd'],
        ConfigType: params['configType'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 停止月捐
   */
  static stop(
    params: {
      /** requestBody */
      body?: EntityDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundDonationMonthlyConfig/Stop';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class FundDonationOrderService {
  /**
   * 创建基金捐助订单
   */
  static create(
    params: {
      /** requestBody */
      body?: FundDonationOrderCreateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundDonationOrderDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundDonationOrder/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 创建自动扣款订单
   */
  static createAutoDeductionOrder(
    params: {
      /** requestBody */
      body?: FundAutoDeductionOrderCreateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundDonationOrderDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundDonationOrder/CreateAutoDeductionOrder';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 处理支付回调
   */
  static processOrderResponse(
    params: {
      /** requestBody */
      body?: PaymentReponseInputDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundDonationOrder/ProcessOrderResponse';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getById(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundDonationOrderDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundDonationOrder/GetById';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getByOrderId(
    params: {
      /**  */
      orderId?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundDonationOrderDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundDonationOrder/GetByOrderId';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { orderId: params['orderId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /**  */
      fundName?: string;
      /**  */
      fundProjectName?: string;
      /** 订单号 */
      orderId?: string;
      /** 捐赠基金Id */
      fundId?: number;
      /** 捐赠项目ID */
      fundProjectId?: number;
      /** 捐赠金额 */
      donationAmount?: number;
      /**  */
      donationAmountStart?: number;
      /**  */
      donationAmountEnd?: number;
      /** 是否为手动新增订单 */
      isManualCreate?: boolean;
      /** 用户Id */
      userId?: number;
      /** 捐赠人手机号码 */
      mobileTelephone?: string;
      /** 捐赠人类型 */
      donorType?: DonorType;
      /** 捐赠人姓名 */
      donorName?: string;
      /** 留言 */
      leaveMessage?: string;
      /** 是否支付成功 */
      isPayed?: boolean;
      /** 支付成功时间 */
      payedTime?: string;
      /**  */
      payedTimeStart?: string;
      /**  */
      payedTimeEnd?: string;
      /** 支付类型 */
      paymentType?: string;
      /** 支付平台是否响应 */
      isResponsed?: boolean;
      /** 支付平台响应时间 */
      responseTime?: string;
      /** 支付平台返回消息 */
      resultMessage?: string;
      /** 显示的名称 */
      displayName?: string;
      /** 支付交易号 */
      tradeNo?: string;
      /** 捐赠者账号 */
      donorAccount?: string;
      /** 捐赠类型 */
      donationType?: IncomeType;
      /** 是否需要发票 */
      needInvoice?: boolean;
      /** 订单交易流水号(天付宝用) */
      orderSerialNo?: string;
      /** 推荐人 */
      referrer?: string;
      /** 月捐日期 */
      monthDonorDay?: number;
      /** 捐赠意向Id */
      donorItemId?: number;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundDonationOrderDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundDonationOrder/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        FundName: params['fundName'],
        FundProjectName: params['fundProjectName'],
        OrderId: params['orderId'],
        FundID: params['fundId'],
        FundProjectID: params['fundProjectId'],
        DonationAmount: params['donationAmount'],
        DonationAmountStart: params['donationAmountStart'],
        DonationAmountEnd: params['donationAmountEnd'],
        IsManualCreate: params['isManualCreate'],
        UserId: params['userId'],
        MobileTelephone: params['mobileTelephone'],
        DonorType: params['donorType'],
        DonorName: params['donorName'],
        LeaveMessage: params['leaveMessage'],
        IsPayed: params['isPayed'],
        PayedTime: params['payedTime'],
        PayedTimeStart: params['payedTimeStart'],
        PayedTimeEnd: params['payedTimeEnd'],
        PaymentType: params['paymentType'],
        IsResponsed: params['isResponsed'],
        ResponseTime: params['responseTime'],
        ResultMessage: params['resultMessage'],
        DisplayName: params['displayName'],
        TradeNo: params['tradeNo'],
        DonorAccount: params['donorAccount'],
        DonationType: params['donationType'],
        NeedInvoice: params['needInvoice'],
        OrderSerialNo: params['orderSerialNo'],
        Referrer: params['referrer'],
        MonthDonorDay: params['monthDonorDay'],
        DonorItemId: params['donorItemId'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class FundIncomeRecordService {
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: FundIncomeRecordCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundIncomeRecordDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundIncomeRecord/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundIncomeRecordDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundIncomeRecord/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /** 关键词 */
      keyword?: string;
      /** 捐赠者名称 */
      donorName?: string;
      /** 开始时间 */
      startDate?: string;
      /** 结束时间 */
      endDate?: string;
      /** 捐赠者类型 */
      donorType?: DonorType;
      /** 捐赠意向 */
      incomeType?: IncomeType;
      /** 基金Id */
      fundId?: number;
      /** 基金项目Id */
      projectId?: number;
      /** 支付方式 */
      paymentType?: string;
      /** 捐助方式 */
      isMonthDonor?: boolean;
      /** 用户Id */
      userId?: number;
      /**  */
      weixinTradeNo?: string;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundIncomeRecordDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundIncomeRecord/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Keyword: params['keyword'],
        DonorName: params['donorName'],
        StartDate: params['startDate'],
        EndDate: params['endDate'],
        DonorType: params['donorType'],
        IncomeType: params['incomeType'],
        FundId: params['fundId'],
        ProjectId: params['projectId'],
        PaymentType: params['paymentType'],
        IsMonthDonor: params['isMonthDonor'],
        UserId: params['userId'],
        WeixinTradeNo: params['weixinTradeNo'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: FundIncomeRecordCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundIncomeRecordDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundIncomeRecord/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundIncomeRecord/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAllByPortal(
    params: {
      /** 关键词 */
      keyword?: string;
      /** 捐赠者名称 */
      donorName?: string;
      /** 开始时间 */
      startDate?: string;
      /** 结束时间 */
      endDate?: string;
      /** 捐赠者类型 */
      donorType?: DonorType;
      /** 捐赠意向 */
      incomeType?: IncomeType;
      /** 基金Id */
      fundId?: number;
      /** 基金项目Id */
      projectId?: number;
      /** 支付方式 */
      paymentType?: string;
      /** 捐助方式 */
      isMonthDonor?: boolean;
      /** 用户Id */
      userId?: number;
      /**  */
      weixinTradeNo?: string;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundIncomeRecordDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundIncomeRecord/GetAllByPortal';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Keyword: params['keyword'],
        DonorName: params['donorName'],
        StartDate: params['startDate'],
        EndDate: params['endDate'],
        DonorType: params['donorType'],
        IncomeType: params['incomeType'],
        FundId: params['fundId'],
        ProjectId: params['projectId'],
        PaymentType: params['paymentType'],
        IsMonthDonor: params['isMonthDonor'],
        UserId: params['userId'],
        WeixinTradeNo: params['weixinTradeNo'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getTotalMoney(
    params: {
      /** 关键词 */
      keyword?: string;
      /** 捐赠者名称 */
      donorName?: string;
      /** 开始时间 */
      startDate?: string;
      /** 结束时间 */
      endDate?: string;
      /** 捐赠者类型 */
      donorType?: DonorType;
      /** 捐赠意向 */
      incomeType?: IncomeType;
      /** 基金Id */
      fundId?: number;
      /** 基金项目Id */
      projectId?: number;
      /** 支付方式 */
      paymentType?: string;
      /** 捐助方式 */
      isMonthDonor?: boolean;
      /** 用户Id */
      userId?: number;
      /**  */
      weixinTradeNo?: string;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundIncomeRecordTotalDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundIncomeRecord/GetTotalMoney';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Keyword: params['keyword'],
        DonorName: params['donorName'],
        StartDate: params['startDate'],
        EndDate: params['endDate'],
        DonorType: params['donorType'],
        IncomeType: params['incomeType'],
        FundId: params['fundId'],
        ProjectId: params['projectId'],
        PaymentType: params['paymentType'],
        IsMonthDonor: params['isMonthDonor'],
        UserId: params['userId'],
        WeixinTradeNo: params['weixinTradeNo'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getTotalByProtal(options: IRequestOptions = {}): Promise<FundIncomeRecordTotalByPortalDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundIncomeRecord/GetTotalByProtal';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 下载导入模板
   */
  static downloadTemplate(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundIncomeRecord/DownloadTemplate';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 导入资金捐赠
   */
  static import(options: IRequestOptions = {}): Promise<ImportResult> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundIncomeRecord/Import';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 导出捐赠明细
   */
  static exportFundIncomeRecord(
    params: {
      /** requestBody */
      body?: FundIncomeRecordPagedResultRequestDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundIncomeRecord/ExportFundIncomeRecord';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 导出捐赠明细总表
   */
  static exportFundIncomeRecordTotal(
    params: {
      /** requestBody */
      body?: FundIncomeRecordPagedResultRequestDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundIncomeRecord/ExportFundIncomeRecordTotal';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取用户捐赠数据
   */
  static getUserDonateInfo(
    params: {
      /**  */
      userId?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UserDonateInfoDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundIncomeRecord/GetUserDonateInfo';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { userId: params['userId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getDonationIntentById(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundIncomeRecordDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundIncomeRecord/GetDonationIntentById';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class FundManageFeeRecordService {
  /**
   *
   */
  static getAll(
    params: {
      /**  */
      fundId?: number;
      /**  */
      amount?: number;
      /**  */
      amountStart?: number;
      /**  */
      amountEnd?: number;
      /**  */
      content?: string;
      /**  */
      ration?: number;
      /**  */
      rationStart?: number;
      /**  */
      rationEnd?: number;
      /**  */
      remark?: string;
      /** 基金名称 */
      fundName?: string;
      /**  */
      startDate?: string;
      /**  */
      endDate?: string;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundManageFeeRecordDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundManageFeeRecord/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        FundId: params['fundId'],
        Amount: params['amount'],
        AmountStart: params['amountStart'],
        AmountEnd: params['amountEnd'],
        Content: params['content'],
        Ration: params['ration'],
        RationStart: params['rationStart'],
        RationEnd: params['rationEnd'],
        Remark: params['remark'],
        FundName: params['fundName'],
        StartDate: params['startDate'],
        EndDate: params['endDate'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundManageFeeFeeRecordDetailDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundManageFeeRecord/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 变更管理费
   */
  static change(
    params: {
      /** requestBody */
      body?: FundManageFeeRecordChangeRequestInput;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundManageFeeRecord/Change';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class FundModifyApplyService {
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: FundModifyApplyCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundModifyApplyDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundModifyApply/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: FundModifyApplyCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundModifyApplyDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundModifyApply/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static audit(
    params: {
      /** requestBody */
      body?: AuditUserLogProxy;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundModifyApply/Audit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getLogs(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuditUserLogDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundModifyApply/GetLogs';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundModifyApplyDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundModifyApply/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundModifyApply/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static actualAudit(
    params: {
      /** requestBody */
      body?: AuditUserLog;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundModifyApply/ActualAudit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getMyAll(
    params: {
      /** 基金名称 */
      name?: string;
      /** 基金类型 */
      type?: FundType;
      /**  */
      isAudited?: boolean;
      /** 细分类别 */
      fundCategory?: string;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundModifyApplyDtoListResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundModifyApply/GetMyAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Name: params['name'],
        Type: params['type'],
        IsAudited: params['isAudited'],
        FundCategory: params['fundCategory'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getStatus(
    params: {
      /**  */
      audit?: number;
      /**  */
      auditStatus?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundModifyApply/GetStatus';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { audit: params['audit'], auditStatus: params['auditStatus'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /** 基金名称 */
      name?: string;
      /** 基金类型 */
      type?: FundType;
      /**  */
      isAudited?: boolean;
      /** 细分类别 */
      fundCategory?: string;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundModifyApplyDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundModifyApply/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Name: params['name'],
        Type: params['type'],
        IsAudited: params['isAudited'],
        FundCategory: params['fundCategory'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class FundNonCashDonationService {
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: FundNonCashDonationRecordCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundNonCashDonationRecordDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundNonCashDonation/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static audit(
    params: {
      /** requestBody */
      body?: AuditUserLogProxy;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundNonCashDonation/Audit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /**  */
      name?: string;
      /**  */
      company?: string;
      /**  */
      address?: string;
      /**  */
      homeTelephone?: string;
      /** 手机号码 */
      telephone?: string;
      /** 期望联系方式（1手机 2邮箱 3两种皆可） */
      contactType?: number;
      /** 捐赠类型（1物品捐赠，2场地/其他捐赠） */
      donationType?: number;
      /**  */
      isAudited?: boolean;
      /** 关键词 */
      keyword?: string;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundNonCashDonationRecordDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundNonCashDonation/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Name: params['name'],
        Company: params['company'],
        Address: params['address'],
        HomeTelephone: params['homeTelephone'],
        Telephone: params['telephone'],
        ContactType: params['contactType'],
        DonationType: params['donationType'],
        IsAudited: params['isAudited'],
        Keyword: params['keyword'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取用户实物捐赠次数
   */
  static getUserNonCashDonationCount(
    params: {
      /**  */
      userId?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UserNonCashDonationInfoDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundNonCashDonation/GetUserNonCashDonationCount';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { userId: params['userId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: FundNonCashDonationRecordCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundNonCashDonationRecordDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundNonCashDonation/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundNonCashDonation/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static actualAudit(
    params: {
      /** requestBody */
      body?: AuditUserLog;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundNonCashDonation/ActualAudit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getMyAll(
    params: {
      /**  */
      name?: string;
      /**  */
      company?: string;
      /**  */
      address?: string;
      /**  */
      homeTelephone?: string;
      /** 手机号码 */
      telephone?: string;
      /** 期望联系方式（1手机 2邮箱 3两种皆可） */
      contactType?: number;
      /** 捐赠类型（1物品捐赠，2场地/其他捐赠） */
      donationType?: number;
      /**  */
      isAudited?: boolean;
      /** 关键词 */
      keyword?: string;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundNonCashDonationRecordDtoListResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundNonCashDonation/GetMyAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Name: params['name'],
        Company: params['company'],
        Address: params['address'],
        HomeTelephone: params['homeTelephone'],
        Telephone: params['telephone'],
        ContactType: params['contactType'],
        DonationType: params['donationType'],
        IsAudited: params['isAudited'],
        Keyword: params['keyword'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getLogs(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuditUserLogDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundNonCashDonation/GetLogs';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getStatus(
    params: {
      /**  */
      audit?: number;
      /**  */
      auditStatus?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundNonCashDonation/GetStatus';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { audit: params['audit'], auditStatus: params['auditStatus'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundNonCashDonationRecordDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundNonCashDonation/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class FundProjectService {
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: FundProjectCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundProjectDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundProject/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: FundProjectCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundProjectDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundProject/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundProject/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getByPortal(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundProjectDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundProject/GetByPortal';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAllByPortal(
    params: {
      /** 基金名称 */
      fundName?: string;
      /** 基金项目名称 */
      fundProjectName?: string;
      /** 基金项目状态 */
      status?: FundProjectStatus;
      /** 基金项目类型 */
      projectType?: FundProjectType;
      /**  */
      categoryName?: string;
      /**  */
      isNeedAll?: boolean;
      /**  */
      isBrand?: boolean;
      /** 基金Id */
      fundId?: number;
      /** 是否过滤OrgId */
      isFilterOrgId?: boolean;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundProjectDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundProject/GetAllByPortal';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        FundName: params['fundName'],
        FundProjectName: params['fundProjectName'],
        Status: params['status'],
        ProjectType: params['projectType'],
        CategoryName: params['categoryName'],
        IsNeedAll: params['isNeedAll'],
        IsBrand: params['isBrand'],
        FundId: params['fundId'],
        IsFilterOrgId: params['isFilterOrgId'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getList(
    params: {
      /** 基金Id */
      fundId?: number;
      /** 基金名称 */
      fundName?: string;
      /** 基金项目名称 */
      name?: string;
      /** 项目范围 */
      categoryName?: string;
      /** 基金项目类型 */
      projectType?: FundProjectType;
      /** 基金项目状态 */
      projectStatus?: FundProjectStatus;
      /** 是否品牌项目 */
      isBrand?: boolean;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundProjectDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundProject/GetList';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        FundId: params['fundId'],
        FundName: params['fundName'],
        Name: params['name'],
        CategoryName: params['categoryName'],
        ProjectType: params['projectType'],
        ProjectStatus: params['projectStatus'],
        IsBrand: params['isBrand'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getSummarization(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundProjectSummarizationDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundProject/GetSummarization';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 手动创建订单记录
   */
  static manualCreateDonateOrder(
    params: {
      /** requestBody */
      body?: FundProjectManualCreateDonateOrderInput;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundProject/ManualCreateDonateOrder';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 项目结项
   */
  static close(
    params: {
      /** requestBody */
      body?: FundProjectCloseInput;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundProject/Close';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 结束项目
   */
  static endProject(
    params: {
      /** requestBody */
      body?: Int32EntityDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundProject/EndProject';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 开始项目
   */
  static openProject(
    params: {
      /** requestBody */
      body?: Int32EntityDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundProject/OpenProject';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 下载二维码
   */
  static downloadQrCode(
    params: {
      /**  */
      id?: number;
      /**  */
      donateType?: DonateType;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundProject/DownloadQrCode';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { id: params['id'], donateType: params['donateType'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 开启筹款
   */
  static enableFundRaising(
    params: {
      /**  */
      fundId?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundProject/EnableFundRaising';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { fundId: params['fundId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 关闭筹款
   */
  static disableFundRaising(
    params: {
      /**  */
      fundId?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundProject/DisableFundRaising';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { fundId: params['fundId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 开启公示
   */
  static disableFundSpecial(
    params: {
      /**  */
      fundId?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundProject/DisableFundSpecial';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { fundId: params['fundId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 关闭公示
   */
  static enableFundSpecial(
    params: {
      /**  */
      fundId?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundProject/EnableFundSpecial';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { fundId: params['fundId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 置顶
   */
  static stickyPost(
    params: {
      /**  */
      fundId?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundProject/StickyPost';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { fundId: params['fundId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 取消置顶
   */
  static cancelStickyPost(
    params: {
      /**  */
      fundId?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundProject/CancelStickyPost';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { fundId: params['fundId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundProjectDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundProject/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /** 基金Id */
      fundId?: number;
      /** 基金名称 */
      fundName?: string;
      /** 基金项目名称 */
      name?: string;
      /** 项目范围 */
      categoryName?: string;
      /** 基金项目类型 */
      projectType?: FundProjectType;
      /** 基金项目状态 */
      projectStatus?: FundProjectStatus;
      /** 是否品牌项目 */
      isBrand?: boolean;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundProjectDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundProject/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        FundId: params['fundId'],
        FundName: params['fundName'],
        Name: params['name'],
        CategoryName: params['categoryName'],
        ProjectType: params['projectType'],
        ProjectStatus: params['projectStatus'],
        IsBrand: params['isBrand'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class FundProjectApplyService {
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: FundProjectApplyCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundProjectApplyDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundProjectApply/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAllByPortal(
    params: {
      /**  */
      fundId?: number;
      /**  */
      name?: string;
      /**  */
      projectType?: FundProjectType;
      /**  */
      isAudited?: boolean;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundProjectApplyDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundProjectApply/GetAllByPortal';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        FundId: params['fundId'],
        Name: params['name'],
        ProjectType: params['projectType'],
        IsAudited: params['isAudited'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: FundProjectApplyCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundProjectApplyDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundProjectApply/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static audit(
    params: {
      /** requestBody */
      body?: AuditUserLogProxy;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundProjectApply/Audit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getLogs(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuditUserLogDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundProjectApply/GetLogs';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundProjectApply/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static actualAudit(
    params: {
      /** requestBody */
      body?: AuditUserLog;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundProjectApply/ActualAudit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getMyAll(
    params: {
      /**  */
      fundId?: number;
      /**  */
      name?: string;
      /**  */
      projectType?: FundProjectType;
      /**  */
      isAudited?: boolean;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundProjectApplyDtoListResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundProjectApply/GetMyAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        FundId: params['fundId'],
        Name: params['name'],
        ProjectType: params['projectType'],
        IsAudited: params['isAudited'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getStatus(
    params: {
      /**  */
      audit?: number;
      /**  */
      auditStatus?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundProjectApply/GetStatus';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { audit: params['audit'], auditStatus: params['auditStatus'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundProjectApplyDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundProjectApply/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /**  */
      fundId?: number;
      /**  */
      name?: string;
      /**  */
      projectType?: FundProjectType;
      /**  */
      isAudited?: boolean;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundProjectApplyDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundProjectApply/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        FundId: params['fundId'],
        Name: params['name'],
        ProjectType: params['projectType'],
        IsAudited: params['isAudited'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class FundProjectContentService {
  /**
   * 创建基金项目的文章。请先保存文章，在获取得到文章的ID后，再调用此接口
   */
  static create(
    params: {
      /** requestBody */
      body?: FundProjectCmsContentCreateInput;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundProjectContent/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 删除基金项目的文章关联，并下架该文章
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundProjectContent/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /**  */
      projectId?: number;
      /**  */
      projectName?: string;
      /**  */
      title?: string;
      /**  */
      sorting?: string;
      /**  */
      skipCount?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundProjectCmsContentDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundProjectContent/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        ProjectId: params['projectId'],
        ProjectName: params['projectName'],
        Title: params['title'],
        Sorting: params['sorting'],
        SkipCount: params['skipCount'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class FundProjectDonationRecordService {
  /**
   *
   */
  static getAll(
    params: {
      /**  */
      projectId?: number;
      /**  */
      projectName?: string;
      /**  */
      fundId?: number;
      /**  */
      fundName?: string;
      /**  */
      donorType?: number;
      /**  */
      displayName?: string;
      /**  */
      donateTimeStart?: string;
      /**  */
      donateTimeEnd?: string;
      /**  */
      donateMoney?: number;
      /**  */
      donateMoneyStart?: number;
      /**  */
      donateMoneyEnd?: number;
      /**  */
      content?: string;
      /**  */
      leaveMessage?: string;
      /**  */
      recordSource?: number;
      /**  */
      donorMobilePhone?: string;
      /** 捐赠类型（1为线上捐款，2为线下捐款) */
      paymentType?: number;
      /** 捐赠类型（1为捐给项目，2为捐给基金) */
      donationType?: number;
      /** 是否月捐 */
      isMonthDonor?: boolean;
      /** 推荐人 */
      referrer?: string;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundProjectDonationRecordDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundProjectDonationRecord/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        ProjectId: params['projectId'],
        ProjectName: params['projectName'],
        FundId: params['fundId'],
        FundName: params['fundName'],
        DonorType: params['donorType'],
        DisplayName: params['displayName'],
        DonateTimeStart: params['donateTimeStart'],
        DonateTimeEnd: params['donateTimeEnd'],
        DonateMoney: params['donateMoney'],
        DonateMoneyStart: params['donateMoneyStart'],
        DonateMoneyEnd: params['donateMoneyEnd'],
        Content: params['content'],
        LeaveMessage: params['leaveMessage'],
        RecordSource: params['recordSource'],
        DonorMobilePhone: params['donorMobilePhone'],
        PaymentType: params['paymentType'],
        DonationType: params['donationType'],
        IsMonthDonor: params['isMonthDonor'],
        Referrer: params['referrer'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class FundProjectModifyApplyService {
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: FundProjectModifyApplyCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundProjectModifyApplyDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundProjectModifyApply/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /**  */
      projectId?: number;
      /**  */
      fundId?: number;
      /**  */
      name?: string;
      /**  */
      isAudited?: boolean;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundProjectModifyApplyDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundProjectModifyApply/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        ProjectId: params['projectId'],
        FundId: params['fundId'],
        Name: params['name'],
        IsAudited: params['isAudited'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static audit(
    params: {
      /** requestBody */
      body?: AuditUserLogProxy;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundProjectModifyApply/Audit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getLogs(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuditUserLogDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundProjectModifyApply/GetLogs';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: FundProjectModifyApplyCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundProjectModifyApplyDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundProjectModifyApply/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundProjectModifyApply/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static actualAudit(
    params: {
      /** requestBody */
      body?: AuditUserLog;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundProjectModifyApply/ActualAudit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getMyAll(
    params: {
      /**  */
      projectId?: number;
      /**  */
      fundId?: number;
      /**  */
      name?: string;
      /**  */
      isAudited?: boolean;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundProjectModifyApplyDtoListResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundProjectModifyApply/GetMyAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        ProjectId: params['projectId'],
        FundId: params['fundId'],
        Name: params['name'],
        IsAudited: params['isAudited'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getStatus(
    params: {
      /**  */
      audit?: number;
      /**  */
      auditStatus?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundProjectModifyApply/GetStatus';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { audit: params['audit'], auditStatus: params['auditStatus'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundProjectModifyApplyDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundProjectModifyApply/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class FundProjectProgressService {
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: FundProjectProgressCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundProjectProgressDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundProjectProgress/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: FundProjectProgressCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundProjectProgressDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundProjectProgress/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundProjectProgress/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 发布
   */
  static publish(
    params: {
      /** requestBody */
      body?: EntityDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundProjectProgress/Publish';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 取消发布
   */
  static cancelPublish(
    params: {
      /** requestBody */
      body?: EntityDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundProjectProgress/CancelPublish';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getByPortal(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundProjectProgressDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundProjectProgress/GetByPortal';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAllByPortal(
    params: {
      /**  */
      projectId?: number;
      /**  */
      summary?: string;
      /**  */
      title?: string;
      /**  */
      isPublish?: boolean;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundProjectProgressDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundProjectProgress/GetAllByPortal';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        ProjectId: params['projectId'],
        Summary: params['summary'],
        Title: params['title'],
        IsPublish: params['isPublish'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundProjectProgressDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundProjectProgress/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /**  */
      projectId?: number;
      /**  */
      summary?: string;
      /**  */
      title?: string;
      /**  */
      isPublish?: boolean;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundProjectProgressDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundProjectProgress/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        ProjectId: params['projectId'],
        Summary: params['summary'],
        Title: params['title'],
        IsPublish: params['isPublish'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class FundProjectYearSummaryService {
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundProjectYearSummaryDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundProjectYearSummary/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 基金会点评
   */
  static appraise(
    params: {
      /** requestBody */
      body?: FundProjectYearSummaryAppraiseInput;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundProjectYearSummary/Appraise';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: FundProjectYearSummaryCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundProjectYearSummaryDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundProjectYearSummary/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: FundProjectYearSummaryCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundProjectYearSummaryDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundProjectYearSummary/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundProjectYearSummary/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /**  */
      projectId?: number;
      /**  */
      projectName?: string;
      /**  */
      year?: number;
      /**  */
      serviceArea?: string;
      /**  */
      sorting?: string;
      /**  */
      skipCount?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundProjectYearSummaryDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundProjectYearSummary/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        ProjectId: params['projectId'],
        ProjectName: params['projectName'],
        Year: params['year'],
        ServiceArea: params['serviceArea'],
        Sorting: params['sorting'],
        SkipCount: params['skipCount'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class FundUserService {
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: FundUserCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundUserDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundUser/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundUserDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundUser/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getList(
    params: {
      /**  */
      fundId?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundUserDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundUser/GetList';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { fundId: params['fundId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /** 基金Id */
      fundId?: number;
      /** 基金名称 */
      fundName?: string;
      /** 姓名 */
      surname?: string;
      /** 账号 */
      userName?: string;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundUserDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundUser/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        FundId: params['fundId'],
        FundName: params['fundName'],
        Surname: params['surname'],
        UserName: params['userName'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getFundUserList(options: IRequestOptions = {}): Promise<SelectListItem[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundUser/GetFundUserList';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: FundUserCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FundUserDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundUser/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FundUser/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class InternalMonthlyPlanService {
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: InternalMonthlyPlanCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<InternalMonthlyPlanDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/InternalMonthlyPlan/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: InternalMonthlyPlanCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<InternalMonthlyPlanDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/InternalMonthlyPlan/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 分页查询
   */
  static getAll(
    params: {
      /** 年 */
      date?: string;
      /** 项目名称 */
      displayName?: string;
      /** 所属项目ID */
      projectId?: number;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<InternalMonthlyPlanDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/InternalMonthlyPlan/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Date: params['date'],
        DisplayName: params['displayName'],
        ProjectId: params['projectId'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<InternalMonthlyPlanDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/InternalMonthlyPlan/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取我的月活动计划列表
   */
  static getMyInternalMonthlyPlanList(
    params: {
      /**  */
      projectId?: number;
      /**  */
      date?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<InternalMonthlyPlanDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/InternalMonthlyPlan/GetMyInternalMonthlyPlanList';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { ProjectId: params['projectId'], Date: params['date'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 根据年月获取有月计划的项目id
   */
  static getInternalProjectIdListByDate(
    params: {
      /**  */
      date?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<number[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/InternalMonthlyPlan/GetInternalProjectIdListByDate';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { date: params['date'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 审核
   */
  static audit(
    params: {
      /** requestBody */
      body?: AuditUserLogProxy;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/InternalMonthlyPlan/Audit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/InternalMonthlyPlan/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static actualAudit(
    params: {
      /** requestBody */
      body?: AuditUserLog;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/InternalMonthlyPlan/ActualAudit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getMyAll(
    params: {
      /** 年 */
      date?: string;
      /** 项目名称 */
      displayName?: string;
      /** 所属项目ID */
      projectId?: number;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<InternalMonthlyPlanDtoListResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/InternalMonthlyPlan/GetMyAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Date: params['date'],
        DisplayName: params['displayName'],
        ProjectId: params['projectId'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getLogs(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuditUserLogDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/InternalMonthlyPlan/GetLogs';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getStatus(
    params: {
      /**  */
      audit?: number;
      /**  */
      auditStatus?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/InternalMonthlyPlan/GetStatus';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { audit: params['audit'], auditStatus: params['auditStatus'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class InternalMonthlySummarizeService {
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: InternalMonthlySummarizeCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<InternalMonthlySummarizeDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/InternalMonthlySummarize/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: InternalMonthlySummarizeCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<InternalMonthlySummarizeDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/InternalMonthlySummarize/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<InternalMonthlySummarizeDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/InternalMonthlySummarize/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 审核
   */
  static audit(
    params: {
      /** requestBody */
      body?: AuditUserLogProxy;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/InternalMonthlySummarize/Audit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/InternalMonthlySummarize/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static actualAudit(
    params: {
      /** requestBody */
      body?: AuditUserLog;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/InternalMonthlySummarize/ActualAudit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getMyAll(
    params: {
      /** 年 */
      date?: string;
      /** 项目名称 */
      displayName?: string;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<InternalMonthlySummarizeDtoListResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/InternalMonthlySummarize/GetMyAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Date: params['date'],
        DisplayName: params['displayName'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getLogs(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuditUserLogDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/InternalMonthlySummarize/GetLogs';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getStatus(
    params: {
      /**  */
      audit?: number;
      /**  */
      auditStatus?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/InternalMonthlySummarize/GetStatus';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { audit: params['audit'], auditStatus: params['auditStatus'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /** 年 */
      date?: string;
      /** 项目名称 */
      displayName?: string;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<InternalMonthlySummarizeDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/InternalMonthlySummarize/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Date: params['date'],
        DisplayName: params['displayName'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class InternalPersonalYearEndSummaryService {
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: InternalPersonalYearEndSummaryCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<InternalPersonalYearEndSummaryDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/InternalPersonalYearEndSummary/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: InternalPersonalYearEndSummaryCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<InternalPersonalYearEndSummaryDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/InternalPersonalYearEndSummary/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /** 年 */
      year?: number;
      /**  */
      userName?: string;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<InternalPersonalYearEndSummaryDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/InternalPersonalYearEndSummary/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Year: params['year'],
        UserName: params['userName'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 审核
   */
  static audit(
    params: {
      /** requestBody */
      body?: AuditUserLogProxy;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/InternalPersonalYearEndSummary/Audit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/InternalPersonalYearEndSummary/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static actualAudit(
    params: {
      /** requestBody */
      body?: AuditUserLog;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/InternalPersonalYearEndSummary/ActualAudit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getMyAll(
    params: {
      /** 年 */
      year?: number;
      /**  */
      userName?: string;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<InternalPersonalYearEndSummaryDtoListResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/InternalPersonalYearEndSummary/GetMyAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Year: params['year'],
        UserName: params['userName'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getLogs(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuditUserLogDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/InternalPersonalYearEndSummary/GetLogs';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getStatus(
    params: {
      /**  */
      audit?: number;
      /**  */
      auditStatus?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/InternalPersonalYearEndSummary/GetStatus';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { audit: params['audit'], auditStatus: params['auditStatus'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<InternalPersonalYearEndSummaryDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/InternalPersonalYearEndSummary/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class InternalProjectService {
  /**
   *
   */
  static getAll(
    params: {
      /** 项目名称 */
      displayName?: string;
      /**  */
      projectId?: number;
      /**  */
      year?: number;
      /**  */
      isPhase?: boolean;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<InternalProjectDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/InternalProject/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        DisplayName: params['displayName'],
        ProjectId: params['projectId'],
        Year: params['year'],
        IsPhase: params['isPhase'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取内部项目已立项列表
   */
  static getInternalProjectList(options: IRequestOptions = {}): Promise<InternalProjectDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/InternalProject/GetInternalProjectList';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 根据年月获取有月计划的内部项目列表
   */
  static getInternalProjectListByDate(
    params: {
      /**  */
      date?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<InternalProjectDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/InternalProject/GetInternalProjectListByDate';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { date: params['date'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: InternalProjectCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<InternalProjectDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/InternalProject/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: InternalProjectCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<InternalProjectDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/InternalProject/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取内部项目立项书详情
   */
  static getDetail(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<InternalProjectDetailDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/InternalProject/GetDetail';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 根据项目Id获取内部项目立项书详情
   */
  static getDetailByProjectId(
    params: {
      /**  */
      projectId?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<InternalProjectDetailDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/InternalProject/GetDetailByProjectId';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { projectId: params['projectId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getProjectMonthlySummaizeDetailsByProjectId(
    params: {
      /**  */
      projectId?: number;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ProjectMonthlySummaizeDetailsDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/InternalProject/GetProjectMonthlySummaizeDetailsByProjectId';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        ProjectId: params['projectId'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getProjectBudgetItemListByProjectId(
    params: {
      /**  */
      projectId?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<InternalProjectBudgetItemDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/InternalProject/GetProjectBudgetItemListByProjectId';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { projectId: params['projectId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 更新内部项目预算表
   */
  static updateBudgetItem(
    params: {
      /** requestBody */
      body?: UpdateInternalProjectBudgetItemDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/InternalProject/UpdateBudgetItem';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 复制内部项目
   */
  static copy(
    params: {
      /**  */
      projectId?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/InternalProject/Copy';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { projectId: params['projectId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 审核
   */
  static audit(
    params: {
      /** requestBody */
      body?: AuditUserLogProxy;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/InternalProject/Audit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/InternalProject/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static actualAudit(
    params: {
      /** requestBody */
      body?: AuditUserLog;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/InternalProject/ActualAudit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getMyAll(
    params: {
      /** 项目名称 */
      displayName?: string;
      /**  */
      projectId?: number;
      /**  */
      year?: number;
      /**  */
      isPhase?: boolean;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<InternalProjectDtoListResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/InternalProject/GetMyAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        DisplayName: params['displayName'],
        ProjectId: params['projectId'],
        Year: params['year'],
        IsPhase: params['isPhase'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getLogs(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuditUserLogDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/InternalProject/GetLogs';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getStatus(
    params: {
      /**  */
      audit?: number;
      /**  */
      auditStatus?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/InternalProject/GetStatus';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { audit: params['audit'], auditStatus: params['auditStatus'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<InternalProjectDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/InternalProject/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class InternalProjectPhaseService {
  /**
   * 获取项目节点列表
   */
  static getProjectPhasesList(
    params: {
      /**  */
      projectId?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<InternalProjectPhasesItemDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/InternalProjectPhase/GetProjectPhasesList';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { projectId: params['projectId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取项目月份列表
   */
  static getProjectMonthList(
    params: {
      /**  */
      projectId?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ProjectMonthItemDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/InternalProjectPhase/GetProjectMonthList';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { projectId: params['projectId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 分页获取项目节点附件列表，全部时Stage传null
   */
  static getProjectAttachmentListByPhase(
    params: {
      /** 项目ID */
      projectId?: number;
      /** 节点枚举 */
      stage?: WorkflowOfProjectByInternal;
      /** 年份 */
      year?: number;
      /** 月份 */
      month?: number;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AttachmentDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/InternalProjectPhase/GetProjectAttachmentListByPhase';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        ProjectId: params['projectId'],
        Stage: params['stage'],
        Year: params['year'],
        Month: params['month'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 分页获取项目月度附件列表，全部时Year和Month传0
   */
  static getProjectAttachmentListByMonth(
    params: {
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
      /** 项目ID */
      projectId?: number;
      /** 年份 */
      year?: number;
      /** 月份 */
      month?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AttachmentDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/InternalProjectPhase/GetProjectAttachmentListByMonth';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount'],
        ProjectId: params['projectId'],
        Year: params['year'],
        Month: params['month']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 项目节点附件全部下载
   */
  static batchDownloadProjectPhasesAttachment(
    params: {
      /**  */
      projectId?: number;
      /**  */
      stage?: WorkflowOfProjectByInternal;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/InternalProjectPhase/BatchDownloadProjectPhasesAttachment';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { projectId: params['projectId'], stage: params['stage'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 项目月度附件全部下载
   */
  static batchDownloadProjectMonthAttachment(
    params: {
      /**  */
      projectId?: number;
      /**  */
      year?: number;
      /**  */
      month?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/InternalProjectPhase/BatchDownloadProjectMonthAttachment';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { projectId: params['projectId'], year: params['year'], month: params['month'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class InternalProjectReportService {
  /**
   * 内部项目宏观展示
   */
  static getMacroscopic(options: IRequestOptions = {}): Promise<LineChartDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/InternalProjectReport/GetMacroscopic';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 内部项目的微观展示
   */
  static getMicrocosmics(
    params: {
      /** 项目年份 */
      year?: number;
      /** 项目类型 */
      projectType?: number;
      /** 项目状态 */
      status?: WorkflowOfProjectByInternal;
      /**  */
      skipCount?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<InternalMicrocosmicDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/InternalProjectReport/GetMicrocosmics';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Year: params['year'],
        ProjectType: params['projectType'],
        Status: params['status'],
        SkipCount: params['skipCount'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取未完成月总结的项目
   */
  static getNotCompleteMonthlySummaryProjects(
    params: {
      /**  */
      year?: number;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ProjectOfNotCompleteDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/InternalProjectReport/GetNotCompleteMonthlySummaryProjects';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Year: params['year'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取未正常关项的项目
   */
  static getNotClosingNormallyProjects(
    params: {
      /**  */
      year?: number;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ProjectOfNotCompleteDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/InternalProjectReport/GetNotClosingNormallyProjects';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Year: params['year'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class InternalProjectSummaryReportsService {
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: InternalProjectSummaryReportCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<InternalProjectSummaryReportDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/InternalProjectSummaryReports/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: InternalProjectSummaryReportCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<InternalProjectSummaryReportDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/InternalProjectSummaryReports/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<InternalProjectSummaryReportDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/InternalProjectSummaryReports/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 发送总结报告填写通知
   */
  static sendNotify(
    params: {
      /**  */
      projectId?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/InternalProjectSummaryReports/SendNotify';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { projectId: params['projectId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 审核
   */
  static audit(
    params: {
      /** requestBody */
      body?: AuditUserLogProxy;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/InternalProjectSummaryReports/Audit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/InternalProjectSummaryReports/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static actualAudit(
    params: {
      /** requestBody */
      body?: AuditUserLog;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/InternalProjectSummaryReports/ActualAudit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getMyAll(
    params: {
      /** 年 */
      year?: number;
      /** 项目名称 */
      displayName?: string;
      /** 填写人 */
      userName?: string;
      /**  */
      projectId?: number;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<InternalProjectSummaryReportDtoListResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/InternalProjectSummaryReports/GetMyAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Year: params['year'],
        DisplayName: params['displayName'],
        UserName: params['userName'],
        ProjectId: params['projectId'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getLogs(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuditUserLogDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/InternalProjectSummaryReports/GetLogs';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getStatus(
    params: {
      /**  */
      audit?: number;
      /**  */
      auditStatus?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/InternalProjectSummaryReports/GetStatus';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { audit: params['audit'], auditStatus: params['auditStatus'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /** 年 */
      year?: number;
      /** 项目名称 */
      displayName?: string;
      /** 填写人 */
      userName?: string;
      /**  */
      projectId?: number;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<InternalProjectSummaryReportDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/InternalProjectSummaryReports/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Year: params['year'],
        DisplayName: params['displayName'],
        UserName: params['userName'],
        ProjectId: params['projectId'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class JobService {
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: JobCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<JobDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Job/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: JobCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<JobDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Job/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Job/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /** 信息标题 */
      title?: string;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<JobDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Job/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Title: params['title'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<JobDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Job/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class MerchantService {
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: MerchantCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<MerchantDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Merchant/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: MerchantCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<MerchantDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Merchant/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<MerchantDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Merchant/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Merchant/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static enableOrDisable(
    params: {
      /** requestBody */
      body?: Int64EntityDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Merchant/EnableOrDisable';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 推送至用友
   */
  static syncSupplierToNc(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Merchant/SyncSupplierToNC';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /** 单位名称 */
      unitName?: string;
      /** 单位地址 */
      unitAddress?: string;
      /** 负责人姓名 */
      principalName?: string;
      /** 负责人手机号 */
      principalMobilePhone?: string;
      /** 负责人邮箱 */
      principalEmailAddress?: string;
      /** 联系人姓名 */
      contactName?: string;
      /** 联系人手机号 */
      contactMobilePhone?: string;
      /** 联系人邮箱 */
      contactEmailAddress?: string;
      /** 所属基金 */
      fundName?: string;
      /** 是否已推送至用友 */
      isSynced?: boolean;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<MerchantDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Merchant/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        UnitName: params['unitName'],
        UnitAddress: params['unitAddress'],
        PrincipalName: params['principalName'],
        PrincipalMobilePhone: params['principalMobilePhone'],
        PrincipalEmailAddress: params['principalEmailAddress'],
        ContactName: params['contactName'],
        ContactMobilePhone: params['contactMobilePhone'],
        ContactEmailAddress: params['contactEmailAddress'],
        FundName: params['fundName'],
        IsSynced: params['isSynced'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class MerchantBankAccountService {
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: MerchantBankAccountCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<MerchantBankAccountDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/MerchantBankAccount/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/MerchantBankAccount/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: MerchantBankAccountCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<MerchantBankAccountDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/MerchantBankAccount/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static enableOrDisable(
    params: {
      /** requestBody */
      body?: Int64EntityDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/MerchantBankAccount/EnableOrDisable';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 推送至用友
   */
  static syncBankAccountToNc(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/MerchantBankAccount/SyncBankAccountToNC';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<MerchantBankAccountDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/MerchantBankAccount/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /** 客商主表Id */
      merchantId?: number;
      /** 银行账号 */
      bankAccountCode?: string;
      /** 银行名称 */
      bankName?: string;
      /** 户名 */
      bankAccountName?: string;
      /**  */
      isOnlyMine?: boolean;
      /**  */
      isSynced?: boolean;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<MerchantBankAccountDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/MerchantBankAccount/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        MerchantId: params['merchantId'],
        BankAccountCode: params['bankAccountCode'],
        BankName: params['bankName'],
        BankAccountName: params['bankAccountName'],
        IsOnlyMine: params['isOnlyMine'],
        IsSynced: params['isSynced'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class MessageService {
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: MessageCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<MessageDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Message/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: MessageCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<MessageDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Message/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Message/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<MessageDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Message/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /** 消息标题 */
      title?: string;
      /** 起始日期 */
      startDate?: string;
      /** 截止日期 */
      endDate?: string;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<MessageDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Message/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Title: params['title'],
        StartDate: params['startDate'],
        EndDate: params['endDate'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class NotifyRecordService {
  /**
   * 获取通知发送记录详情
   */
  static getDetail(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<NotifyRecordDetailDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/NotifyRecord/GetDetail';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: NotifyRecordCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<NotifyRecordDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/NotifyRecord/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: NotifyRecordCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<NotifyRecordDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/NotifyRecord/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<NotifyRecordDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/NotifyRecord/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /** 通知标题 */
      title?: string;
      /** 通知类型 */
      notifyType?: NotifyTemplateType;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<NotifyRecordDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/NotifyRecord/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Title: params['title'],
        NotifyType: params['notifyType'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/NotifyRecord/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class NotifyTemplateService {
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<NotifyTemplateDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/NotifyTemplate/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /** 通知模板标题 */
      title?: string;
      /** 通知模板类型 */
      notifyTemplateType?: NotifyTemplateType;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<NotifyTemplateDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/NotifyTemplate/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Title: params['title'],
        NotifyTemplateType: params['notifyTemplateType'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: NotifyTemplateCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<NotifyTemplateDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/NotifyTemplate/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: NotifyTemplateCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<NotifyTemplateDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/NotifyTemplate/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/NotifyTemplate/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class OrderService {
  /**
   *
   */
  static getForEdit(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<OrderCreateOrUpdateDtoGetForEditOutput> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Order/GetForEdit';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<OrderDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Order/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /** 订单类型 */
      type?: OrderType;
      /** 关联表Id */
      applyId?: number;
      /**  */
      userName?: string;
      /**  */
      title?: string;
      /** 订单状态 */
      status?: OrderStatus;
      /**  */
      onlyMine?: boolean;
      /**  */
      sorting?: string;
      /**  */
      skipCount?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<OrderDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Order/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Type: params['type'],
        ApplyId: params['applyId'],
        UserName: params['userName'],
        Title: params['title'],
        Status: params['status'],
        OnlyMine: params['onlyMine'],
        Sorting: params['sorting'],
        SkipCount: params['skipCount'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: OrderCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<OrderDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Order/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: OrderCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<OrderDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Order/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Order/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class OrganizationUnitService {
  /**
   * 导出合作方
   */
  static export(
    params: {
      /** requestBody */
      body?: OrganizationUnitPagedResultRequestDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/OrganizationUnit/Export';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 申请入驻(首次申请)
   */
  static apply(
    params: {
      /** requestBody */
      body?: OrganizationUnitCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/OrganizationUnit/Apply';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 根据Code获取邀约详情
   */
  static getInviteByCode(
    params: {
      /**  */
      inviteCode?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PartnerInviteDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/OrganizationUnit/GetInviteByCode';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { inviteCode: params['inviteCode'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 重新申请
   */
  static reapply(
    params: {
      /** requestBody */
      body?: OrganizationUnitCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/OrganizationUnit/Reapply';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: OrganizationUnitCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<OrganizationUnitDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/OrganizationUnit/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: OrganizationUnitCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<OrganizationUnitDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/OrganizationUnit/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static createLoginAccount(
    params: {
      /** requestBody */
      body?: AgileOrganizationUnit;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<OrganizationUnitLoginAccountResult> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/OrganizationUnit/CreateLoginAccount';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static import(options: IRequestOptions = {}): Promise<ImportResult> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/OrganizationUnit/Import';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 下载导入模板
   */
  static downloadTemplate(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/OrganizationUnit/DownloadTemplate';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 审核
   */
  static audit(
    params: {
      /** requestBody */
      body?: AuditUserLogProxy;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/OrganizationUnit/Audit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/OrganizationUnit/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static actualAudit(
    params: {
      /** requestBody */
      body?: AuditUserLog;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/OrganizationUnit/ActualAudit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getMyAll(
    params: {
      /**  */
      displayName?: string;
      /** 机构的类型(数据字典的ID） */
      organizationType?: number;
      /**  */
      isApply?: boolean;
      /**  */
      status?: OrganizationStatus;
      /**  */
      principalName?: string;
      /**  */
      mobilePhone?: string;
      /**  */
      emailAddress?: string;
      /** 联系人姓名 */
      contactName?: string;
      /** 联系人手机号 */
      contactMobilePhone?: string;
      /** 联系人邮箱 */
      contactEmailAddress?: string;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<OrganizationUnitDtoListResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/OrganizationUnit/GetMyAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        DisplayName: params['displayName'],
        OrganizationType: params['organizationType'],
        IsApply: params['isApply'],
        Status: params['status'],
        PrincipalName: params['principalName'],
        MobilePhone: params['mobilePhone'],
        EmailAddress: params['emailAddress'],
        ContactName: params['contactName'],
        ContactMobilePhone: params['contactMobilePhone'],
        ContactEmailAddress: params['contactEmailAddress'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getLogs(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuditUserLogDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/OrganizationUnit/GetLogs';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getStatus(
    params: {
      /**  */
      audit?: number;
      /**  */
      auditStatus?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/OrganizationUnit/GetStatus';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { audit: params['audit'], auditStatus: params['auditStatus'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<OrganizationUnitDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/OrganizationUnit/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /**  */
      displayName?: string;
      /** 机构的类型(数据字典的ID） */
      organizationType?: number;
      /**  */
      isApply?: boolean;
      /**  */
      status?: OrganizationStatus;
      /**  */
      principalName?: string;
      /**  */
      mobilePhone?: string;
      /**  */
      emailAddress?: string;
      /** 联系人姓名 */
      contactName?: string;
      /** 联系人手机号 */
      contactMobilePhone?: string;
      /** 联系人邮箱 */
      contactEmailAddress?: string;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<OrganizationUnitDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/OrganizationUnit/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        DisplayName: params['displayName'],
        OrganizationType: params['organizationType'],
        IsApply: params['isApply'],
        Status: params['status'],
        PrincipalName: params['principalName'],
        MobilePhone: params['mobilePhone'],
        EmailAddress: params['emailAddress'],
        ContactName: params['contactName'],
        ContactMobilePhone: params['contactMobilePhone'],
        ContactEmailAddress: params['contactEmailAddress'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class PartnerCapitalApplyService {
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: PartnerCapitalApplyCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PartnerCapitalApplyDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PartnerCapitalApply/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: PartnerCapitalApplyCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PartnerCapitalApplyDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PartnerCapitalApply/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /** 是否内部项目 */
      isInternal?: boolean;
      /** 项目名称 */
      displayName?: string;
      /** 机构名称 */
      orgName?: string;
      /** 开始时间 */
      startDate?: string;
      /** 截止时间 */
      endDate?: string;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PartnerCapitalApplyDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PartnerCapitalApply/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        IsInternal: params['isInternal'],
        DisplayName: params['displayName'],
        OrgName: params['orgName'],
        StartDate: params['startDate'],
        EndDate: params['endDate'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 审核
   */
  static audit(
    params: {
      /** requestBody */
      body?: AuditUserLogProxy;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PartnerCapitalApply/Audit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PartnerCapitalApply/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static actualAudit(
    params: {
      /** requestBody */
      body?: AuditUserLog;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PartnerCapitalApply/ActualAudit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getMyAll(
    params: {
      /** 是否内部项目 */
      isInternal?: boolean;
      /** 项目名称 */
      displayName?: string;
      /** 机构名称 */
      orgName?: string;
      /** 开始时间 */
      startDate?: string;
      /** 截止时间 */
      endDate?: string;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PartnerCapitalApplyDtoListResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PartnerCapitalApply/GetMyAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        IsInternal: params['isInternal'],
        DisplayName: params['displayName'],
        OrgName: params['orgName'],
        StartDate: params['startDate'],
        EndDate: params['endDate'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getLogs(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuditUserLogDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PartnerCapitalApply/GetLogs';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getStatus(
    params: {
      /**  */
      audit?: number;
      /**  */
      auditStatus?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PartnerCapitalApply/GetStatus';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { audit: params['audit'], auditStatus: params['auditStatus'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PartnerCapitalApplyDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PartnerCapitalApply/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class PartnerInviteService {
  /**
   *
   */
  static testEasyNetQ(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PartnerInvite/TestEasyNetQ';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: PartnerInviteCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PartnerInviteDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PartnerInvite/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static import(options: IRequestOptions = {}): Promise<ImportResult> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PartnerInvite/Import';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 下载导入模板
   */
  static downloadTemplate(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PartnerInvite/DownloadTemplate';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PartnerInviteDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PartnerInvite/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /** 邀约机构名称 */
      organizationName?: string;
      /** 机构类型 */
      organizationType?: number;
      /**  */
      emailAddress?: string;
      /**  */
      mobile?: string;
      /**  */
      content?: string;
      /**  */
      hasUsed?: boolean;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PartnerInviteDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PartnerInvite/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        OrganizationName: params['organizationName'],
        OrganizationType: params['organizationType'],
        EmailAddress: params['emailAddress'],
        Mobile: params['mobile'],
        Content: params['content'],
        HasUsed: params['hasUsed'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: PartnerInviteCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PartnerInviteDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PartnerInvite/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PartnerInvite/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class PayService {
  /**
   * JS-SDK支付回调地址（在统一下单接口中设置notify_url）
   */
  static payNotifyUrl(
    params: {
      /** requestBody */
      body?: TenPayNotifyXml;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Pay/PayNotifyUrl';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class PcHomeService {
  /**
   *
   */
  static getSummary(options: IRequestOptions = {}): Promise<SummaryDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PCHome/GetSummary';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class PermissionDefinitionService {
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: PermissionDefinitionCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PermissionDefinitionDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PermissionDefinition/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: PermissionDefinitionCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PermissionDefinitionDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PermissionDefinition/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PermissionDefinition/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAllCreatedNames(options: IRequestOptions = {}): Promise<string[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PermissionDefinition/GetAllCreatedNames';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAllPermissionNames(options: IRequestOptions = {}): Promise<StringStringKeyValuePair[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PermissionDefinition/GetAllPermissionNames';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PermissionDefinitionDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PermissionDefinition/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PermissionDefinitionDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PermissionDefinition/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class ProjectService {
  /**
   *
   */
  static getAll(
    params: {
      /**  */
      year?: number;
      /**  */
      projectSeriesId?: number;
      /**  */
      projectTypes?: string;
      /**  */
      sorting?: string;
      /**  */
      noContainsId?: number;
      /** �Ƿ����IsPublicShow��ѯ�������ж� */
      isIgnorePublicShow?: boolean;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ProjectFullInfoDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Project/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Year: params['year'],
        ProjectSeriesId: params['projectSeriesId'],
        ProjectTypes: params['projectTypes'],
        Sorting: params['sorting'],
        NoContainsId: params['noContainsId'],
        IsIgnorePublicShow: params['isIgnorePublicShow'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取项目基本信息详情
   */
  static getProjectBasicDetail(
    params: {
      /**  */
      projectId?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ProjectBasicDetailUpdateDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Project/GetProjectBasicDetail';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { projectId: params['projectId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 更新项目基本信息
   */
  static updateProjectBasicDetail(
    params: {
      /** requestBody */
      body?: ProjectBasicDetailUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Project/UpdateProjectBasicDetail';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 设置是否公开显示
   */
  static changePublicShow(
    params: {
      /**  */
      projectId?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Project/ChangePublicShow';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { projectId: params['projectId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 终止项目
   */
  static terminate(
    params: {
      /**  */
      projectId?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Project/Terminate';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { projectId: params['projectId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取项目合作机构Id
   */
  static getProjectMappings(
    params: {
      /**  */
      projectId?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ProjectOrganizationUnitMappingDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Project/GetProjectMappings';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { projectId: params['projectId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 更新项目合作机构
   */
  static updateMapping(
    params: {
      /** requestBody */
      body?: ProjectOrganizationUnitMappingDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Project/UpdateMapping';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ProjectFullInfoDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Project/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: ProjectCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ProjectFullInfoDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Project/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: ProjectCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ProjectFullInfoDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Project/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Project/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class ProjectBeneficiaryMappingService {
  /**
   *
   */
  static getAll(
    params: {
      /**  */
      beneficiaryName?: string;
      /**  */
      projectId?: number;
      /** 性别 */
      sex?: string;
      /** 最小年龄 */
      minAge?: number;
      /** 最大年龄 */
      maxAge?: number;
      /** 民族 */
      nation?: string;
      /** 省份Id */
      provinceId?: number;
      /** 城市Id */
      cityId?: number;
      /** 区域Id */
      areaId?: number;
      /** 街道Id */
      townId?: number;
      /** 是否享受低保政策 */
      isEnjoyTheSubsistenceAllowancePolicy?: boolean;
      /** 是否为建档立卡户 */
      isEnjoyOtherSalvation?: boolean;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ProjectBeneficiaryMappingDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ProjectBeneficiaryMapping/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        BeneficiaryName: params['beneficiaryName'],
        ProjectId: params['projectId'],
        Sex: params['sex'],
        MinAge: params['minAge'],
        MaxAge: params['maxAge'],
        Nation: params['nation'],
        ProvinceId: params['provinceId'],
        CityId: params['cityId'],
        AreaId: params['areaId'],
        TownId: params['townId'],
        IsEnjoyTheSubsistenceAllowancePolicy: params['isEnjoyTheSubsistenceAllowancePolicy'],
        IsEnjoyOtherSalvation: params['isEnjoyOtherSalvation'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getMyAll(
    params: {
      /**  */
      beneficiaryName?: string;
      /**  */
      projectId?: number;
      /** 性别 */
      sex?: string;
      /** 最小年龄 */
      minAge?: number;
      /** 最大年龄 */
      maxAge?: number;
      /** 民族 */
      nation?: string;
      /** 省份Id */
      provinceId?: number;
      /** 城市Id */
      cityId?: number;
      /** 区域Id */
      areaId?: number;
      /** 街道Id */
      townId?: number;
      /** 是否享受低保政策 */
      isEnjoyTheSubsistenceAllowancePolicy?: boolean;
      /** 是否为建档立卡户 */
      isEnjoyOtherSalvation?: boolean;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ProjectBeneficiaryMappingDtoListResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ProjectBeneficiaryMapping/GetMyAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        BeneficiaryName: params['beneficiaryName'],
        ProjectId: params['projectId'],
        Sex: params['sex'],
        MinAge: params['minAge'],
        MaxAge: params['maxAge'],
        Nation: params['nation'],
        ProvinceId: params['provinceId'],
        CityId: params['cityId'],
        AreaId: params['areaId'],
        TownId: params['townId'],
        IsEnjoyTheSubsistenceAllowancePolicy: params['isEnjoyTheSubsistenceAllowancePolicy'],
        IsEnjoyOtherSalvation: params['isEnjoyOtherSalvation'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: ProjectBeneficiaryMappingCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ProjectBeneficiaryMappingDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ProjectBeneficiaryMapping/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: ProjectBeneficiaryMappingCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ProjectBeneficiaryMappingDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ProjectBeneficiaryMapping/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ProjectBeneficiaryMappingDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ProjectBeneficiaryMapping/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static import(
    params: {
      /**  */
      projectId?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ImportResult> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ProjectBeneficiaryMapping/Import';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { projectId: params['projectId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 下载导入模板
   */
  static downloadTemplate(
    params: {
      /**  */
      projectId?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ProjectBeneficiaryMapping/DownloadTemplate';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { projectId: params['projectId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 审核
   */
  static audit(
    params: {
      /** requestBody */
      body?: AuditUserLogProxy;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ProjectBeneficiaryMapping/Audit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ProjectBeneficiaryMapping/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static actualAudit(
    params: {
      /** requestBody */
      body?: AuditUserLog;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ProjectBeneficiaryMapping/ActualAudit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getLogs(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuditUserLogDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ProjectBeneficiaryMapping/GetLogs';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getStatus(
    params: {
      /**  */
      audit?: number;
      /**  */
      auditStatus?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ProjectBeneficiaryMapping/GetStatus';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { audit: params['audit'], auditStatus: params['auditStatus'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class ProjectInviteService {
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: ProjectInviteCreateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ProjectInviteDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ProjectInvite/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ProjectInvite/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: ProjectInviteCreateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ProjectInviteDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ProjectInvite/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ProjectInviteDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ProjectInvite/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /**  */
      isInternal?: boolean;
      /** 项目名称 */
      displayName?: string;
      /** 机构名称 */
      orgName?: string;
      /** 年份 */
      year?: number;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ProjectInviteDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ProjectInvite/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        IsInternal: params['isInternal'],
        DisplayName: params['displayName'],
        OrgName: params['orgName'],
        Year: params['year'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class ProjectSeriesService {
  /**
   * 根据Sequence升序获取列表
   */
  static getProjectSeriesList(options: IRequestOptions = {}): Promise<ProjectSeries[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ProjectSeries/GetProjectSeriesList';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ProjectSeriesDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ProjectSeries/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /** 系列名称 */
      title?: string;
      /** 是否公开显示 */
      isPublicShow?: boolean;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ProjectSeriesDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ProjectSeries/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Title: params['title'],
        IsPublicShow: params['isPublicShow'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: ProjectSeriesCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ProjectSeriesDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ProjectSeries/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: ProjectSeriesCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ProjectSeriesDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ProjectSeries/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ProjectSeries/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class ProvinceService {
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: ProvinceCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ProvinceDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Province/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: ProvinceCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ProvinceDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Province/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAllList(options: IRequestOptions = {}): Promise<ProvinceDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Province/GetAllList';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ProvinceDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Province/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /**  */
      provinceName?: string;
      /**  */
      shortName?: string;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ProvinceDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Province/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        ProvinceName: params['provinceName'],
        ShortName: params['shortName'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Province/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class RoleService {
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: RoleCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<RoleDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Role/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getRoles(
    params: {
      /**  */
      permission?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<RoleListDtoListResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Role/GetRoles';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Permission: params['permission'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: RoleCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<RoleDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Role/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Role/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取所有可分配的权限信息
   */
  static getAllPermissions(options: IRequestOptions = {}): Promise<PermissionDtoListResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Role/GetAllPermissions';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取分配给角色的权限数据权限分配
   */
  static getGrantedDataPermissionSettings(
    params: {
      /**  */
      roleId?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<DataPermissionSettingDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Role/GetGrantedDataPermissionSettings';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { roleId: params['roleId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取已分配的权限信息
   */
  static getGrantedPermissionNames(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Role/GetGrantedPermissionNames';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getRoleForEdit(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GetRoleForEditOutput> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Role/GetRoleForEdit';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<RoleDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Role/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /**  */
      keyword?: string;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<RoleDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Role/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Keyword: params['keyword'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class ScopeDataSourceService {
  /**
   * 获取数据源内容
   */
  static getItems(
    params: {
      /**  */
      providerName?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<DisplayItem[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ScopeDataSource/GetItems';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { providerName: params['providerName'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取所有的数据源提供者
   */
  static getProviders(
    params: {
      /**  */
      permissionCode?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<DisplayItem[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ScopeDataSource/GetProviders';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { permissionCode: params['permissionCode'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取所有的支持数据权限控制的过滤器
   */
  static getAllSupportProviders(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ScopeDataSource/GetAllSupportProviders';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class SessionService {
  /**
   *
   */
  static getBasicInfo(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Session/GetBasicInfo';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getCurrentLoginInformations(options: IRequestOptions = {}): Promise<GetCurrentLoginInformationsOutput> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Session/GetCurrentLoginInformations';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class SettingManagerService {
  /**
   *
   */
  static getValue(
    params: {
      /**  */
      key?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/SettingManager/GetValue';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { key: params['key'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class SwiperService {
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: SwiperCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SwiperDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Swiper/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: SwiperCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SwiperDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Swiper/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Swiper/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 根据锚点编号获取轮播图列表
   */
  static getSwiperListByAnchor(
    params: {
      /**  */
      anchorName?: string;
      /**  */
      isMustImg?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SwiperDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Swiper/GetSwiperListByAnchor';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { anchorName: params['anchorName'], isMustImg: params['isMustImg'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SwiperDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Swiper/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /**  */
      displayName?: string;
      /**  */
      cmsAnchorId?: number;
      /**  */
      anchorName?: string;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SwiperDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Swiper/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        DisplayName: params['displayName'],
        CmsAnchorId: params['cmsAnchorId'],
        AnchorName: params['anchorName'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class TenantService {
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CreateTenantDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TenantDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Tenant/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Tenant/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TenantDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Tenant/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /**  */
      keyword?: string;
      /**  */
      isActive?: boolean;
      /**  */
      skipCount?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TenantDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Tenant/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Keyword: params['keyword'],
        IsActive: params['isActive'],
        SkipCount: params['skipCount'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: TenantDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TenantDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Tenant/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class TenantAccessRecordService {
  /**
   *
   */
  static updateAccessRecord(
    params: {
      /** requestBody */
      body?: TenantAccessRecordCreateDto[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/TenantAccessRecord/UpdateAccessRecord';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class TenantAccountRecordService {
  /**
   *
   */
  static getAll(
    params: {
      /** 租户账户记录类型 */
      recordType?: TenantAccountRecordType;
      /** 项目/基金名称 */
      projectName?: string;
      /** 捐赠者名称 */
      donorName?: string;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TenantAccountRecordDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/TenantAccountRecord/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        RecordType: params['recordType'],
        ProjectName: params['projectName'],
        DonorName: params['donorName'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getTenantAccountByPortal(options: IRequestOptions = {}): Promise<TenantAccountDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/TenantAccountRecord/GetTenantAccountByPortal';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class TenantBankAccountService {
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: TenantBankAccountCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TenantBankAccountDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/TenantBankAccount/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: TenantBankAccountCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TenantBankAccountDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/TenantBankAccount/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/TenantBankAccount/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getList(
    params: {
      /** 银行账号 */
      bankAccountCode?: string;
      /** 银行名称 */
      bankName?: string;
      /** 户名 */
      bankAccountName?: string;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TenantBankAccountDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/TenantBankAccount/GetList';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        BankAccountCode: params['bankAccountCode'],
        BankName: params['bankName'],
        BankAccountName: params['bankAccountName'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TenantBankAccountDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/TenantBankAccount/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /** 银行账号 */
      bankAccountCode?: string;
      /** 银行名称 */
      bankName?: string;
      /** 户名 */
      bankAccountName?: string;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TenantBankAccountDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/TenantBankAccount/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        BankAccountCode: params['bankAccountCode'],
        BankName: params['bankName'],
        BankAccountName: params['bankAccountName'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class TestEntityService {
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: TestMainCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TestMainDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/TestEntity/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TestMainDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/TestEntity/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TestMainDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/TestEntity/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: TestMainCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TestMainDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/TestEntity/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/TestEntity/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class TokenAuthService {
  /**
   *
   */
  static authenticate(
    params: {
      /** requestBody */
      body?: AuthenticateModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuthenticateResultModel> {
    return new Promise((resolve, reject) => {
      let url = '/api/TokenAuth/Authenticate';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getExternalAuthenticateResult(
    params: {
      /**  */
      cacheKey?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ExternalAuthenticateResultModel> {
    return new Promise((resolve, reject) => {
      let url = '/api/TokenAuth/GetExternalAuthenticateResult';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { cacheKey: params['cacheKey'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getExternalAuthenticationProviders(options: IRequestOptions = {}): Promise<ExternalLoginProviderInfoModel[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/TokenAuth/GetExternalAuthenticationProviders';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static externalAuthenticate(
    params: {
      /** requestBody */
      body?: ExternalAuthenticateModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ExternalAuthenticateResultModel> {
    return new Promise((resolve, reject) => {
      let url = '/api/TokenAuth/ExternalAuthenticate';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static weiXinLoginCallback(
    params: {
      /**  */
      weiXinUser?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuthenticateResultModel> {
    return new Promise((resolve, reject) => {
      let url = '/api/TokenAuth/WeiXinLoginCallback';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { weiXinUser: params['weiXinUser'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class TownService {
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: TownCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TownDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Town/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: TownCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TownDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Town/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAllList(
    params: {
      /**  */
      areaId?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TownDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Town/GetAllList';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { areaId: params['areaId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TownDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Town/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /**  */
      townName?: string;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TownDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Town/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        TownName: params['townName'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Town/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class UEditorHandlerService {
  /**
   *
   */
  static uEditorUpload(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/UEditorHandler/UEditorUpload';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static uEditorUpload1(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/UEditorHandler/UEditorUpload';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static uEditorUpload2(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/UEditorHandler/UEditorUpload';

      const configs: IRequestConfig = getConfigs('options', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class UserService {
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CreateUserDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UserDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/User/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: UserDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UserDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/User/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/User/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /**  */
      keyword?: string;
      /**  */
      isActive?: boolean;
      /**  */
      organizationUnitId?: number;
      /**  */
      departmentId?: number;
      /**  */
      departments?: string;
      /** 用户查询模式: foundation | organizationUnit */
      mode?: string;
      /** 角色Id */
      roleId?: number;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UserDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/User/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Keyword: params['keyword'],
        IsActive: params['isActive'],
        OrganizationUnitId: params['organizationUnitId'],
        DepartmentId: params['departmentId'],
        Departments: params['departments'],
        Mode: params['mode'],
        RoleId: params['roleId'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UserDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/User/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getByMobilePhone(
    params: {
      /**  */
      mobilePhone?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UserDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/User/GetByMobilePhone';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { mobilePhone: params['mobilePhone'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getRoles(options: IRequestOptions = {}): Promise<RoleDtoListResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/User/GetRoles';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static changeLanguage(
    params: {
      /** requestBody */
      body?: ChangeUserLanguageDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/User/ChangeLanguage';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取当前租户下的所有用户
   */
  static getAllUsers(options: IRequestOptions = {}): Promise<UserDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/User/GetAllUsers';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取机构的所有用户
   */
  static getOrganizationUnitUsers(
    params: {
      /**  */
      keyword?: string;
      /**  */
      isActive?: boolean;
      /**  */
      organizationUnitId?: number;
      /**  */
      departmentId?: number;
      /**  */
      departments?: string;
      /** 用户查询模式: foundation | organizationUnit */
      mode?: string;
      /** 角色Id */
      roleId?: number;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UserOrganizationUnitDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/User/GetOrganizationUnitUsers';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Keyword: params['keyword'],
        IsActive: params['isActive'],
        OrganizationUnitId: params['organizationUnitId'],
        DepartmentId: params['departmentId'],
        Departments: params['departments'],
        Mode: params['mode'],
        RoleId: params['roleId'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 根据角色编号获取用户
   */
  static getUserListByRoleName(
    params: {
      /**  */
      roleName?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UserDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/User/GetUserListByRoleName';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { roleName: params['roleName'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取用户个人信息
   */
  static getUserProfileForEdit(options: IRequestOptions = {}): Promise<UserProfileUpdateDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/User/GetUserProfileForEdit';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static updateUserProfile(
    params: {
      /** requestBody */
      body?: UserProfileUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UserProfileUpdateDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/User/UpdateUserProfile';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 更新用户头像
   */
  static updateUserHeadImageUrl(
    params: {
      /**  */
      url?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/User/UpdateUserHeadImageUrl';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);
      configs.params = { url: params['url'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static changePassword(
    params: {
      /** requestBody */
      body?: ChangePasswordDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<boolean> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/User/ChangePassword';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static resetPassword(
    params: {
      /** requestBody */
      body?: ResetPasswordDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<boolean> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/User/ResetPassword';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static resetPassword4Portal(
    params: {
      /** requestBody */
      body?: ResetPassword4PortalDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/User/ResetPassword4Portal';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class UserTaskService {
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: UserTaskCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UserTaskDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/UserTask/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UserTaskDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/UserTask/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 任务管理
   */
  static getAll(
    params: {
      /** 任务名称 */
      title?: string;
      /** 任务状态 */
      status?: TaskStatus;
      /** 紧急程度Id */
      importantLevelId?: number;
      /** 开始时间 */
      startTime?: string;
      /** 截止时间 */
      endTime?: string;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UserTaskDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/UserTask/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Title: params['title'],
        Status: params['status'],
        ImportantLevelId: params['importantLevelId'],
        StartTime: params['startTime'],
        EndTime: params['endTime'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: UserTaskCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UserTaskDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/UserTask/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 我的任务
   */
  static getMyTask(
    params: {
      /** 任务名称 */
      title?: string;
      /** 任务状态 */
      status?: TaskStatus;
      /** 紧急程度Id */
      importantLevelId?: number;
      /** 开始时间 */
      startTime?: string;
      /** 截止时间 */
      endTime?: string;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UserTaskDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/UserTask/GetMyTask';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Title: params['title'],
        Status: params['status'],
        ImportantLevelId: params['importantLevelId'],
        StartTime: params['startTime'],
        EndTime: params['endTime'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 认领任务
   */
  static claim(
    params: {
      /** requestBody */
      body?: Int64EntityDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/UserTask/Claim';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 提交审核
   */
  static submit(
    params: {
      /** requestBody */
      body?: Int64EntityDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/UserTask/Submit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 审核
   */
  static audit(
    params: {
      /** requestBody */
      body?: AuditUserLogProxy;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/UserTask/Audit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/UserTask/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static actualAudit(
    params: {
      /** requestBody */
      body?: AuditUserLog;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/UserTask/ActualAudit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getMyAll(
    params: {
      /** 任务名称 */
      title?: string;
      /** 任务状态 */
      status?: TaskStatus;
      /** 紧急程度Id */
      importantLevelId?: number;
      /** 开始时间 */
      startTime?: string;
      /** 截止时间 */
      endTime?: string;
      /** 每页记录数，用作替换MaxResultCount */
      pageSize?: number;
      /**  */
      skipCount?: number;
      /** 页码，用来替换SkipCount */
      pageIndex?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UserTaskDtoListResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/UserTask/GetMyAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Title: params['title'],
        Status: params['status'],
        ImportantLevelId: params['importantLevelId'],
        StartTime: params['startTime'],
        EndTime: params['endTime'],
        PageSize: params['pageSize'],
        SkipCount: params['skipCount'],
        PageIndex: params['pageIndex'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getLogs(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuditUserLogDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/UserTask/GetLogs';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getStatus(
    params: {
      /**  */
      audit?: number;
      /**  */
      auditStatus?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/UserTask/GetStatus';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { audit: params['audit'], auditStatus: params['auditStatus'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class VolunteerService {
  /**
   *
   */
  static audit(
    params: {
      /** requestBody */
      body?: AuditUserLogProxy;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Volunteer/Audit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<VolunteerDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Volunteer/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /** 志愿者姓名 */
      volunteerName?: string;
      /** 志愿者手机号 */
      volunteerPhone?: string;
      /**  */
      volunteerId?: number;
      /** 志愿者编号 */
      volunteerCode?: string;
      /**  */
      includeUserExtend?: boolean;
      /** 状态 */
      status?: VolunteerStatus;
      /**  */
      sorting?: string;
      /**  */
      skipCount?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<VolunteerDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Volunteer/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        VolunteerName: params['volunteerName'],
        VolunteerPhone: params['volunteerPhone'],
        VolunteerId: params['volunteerId'],
        VolunteerCode: params['volunteerCode'],
        IncludeUserExtend: params['includeUserExtend'],
        Status: params['status'],
        Sorting: params['sorting'],
        SkipCount: params['skipCount'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: VolunteerCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<VolunteerDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Volunteer/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: VolunteerCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<VolunteerDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Volunteer/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 导出活动名单
   */
  static exportExcel(
    params: {
      /** requestBody */
      body?: VolunteerPagedResultRequestDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Volunteer/ExportExcel';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static batchAudit(
    params: {
      /** requestBody */
      body?: BatchAuditDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Volunteer/BatchAudit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 提交审核
   */
  static postToAudit(
    params: {
      /** requestBody */
      body?: Int64EntityDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Volunteer/PostToAudit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 提交审核
   */
  static postTorReAudit(
    params: {
      /** requestBody */
      body?: Int64EntityDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Volunteer/PostTorReAudit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 下载导入模板
   */
  static downloadTemplate(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Volunteer/DownloadTemplate';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static import(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ImportResult> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Volunteer/Import';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 禁用
   */
  static ban(
    params: {
      /** requestBody */
      body?: Int64EntityDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Volunteer/Ban';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 取消禁用
   */
  static cancelBan(
    params: {
      /** requestBody */
      body?: Int64EntityDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Volunteer/CancelBan';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static createByPortal(
    params: {
      /** requestBody */
      body?: VolunteerCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<VolunteerDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Volunteer/CreateByPortal';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getByPortal(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<VolunteerDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Volunteer/GetByPortal';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static updateByPortal(
    params: {
      /** requestBody */
      body?: VolunteerCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<VolunteerDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Volunteer/UpdateByPortal';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getCurrentUserByPortal(options: IRequestOptions = {}): Promise<VolunteerDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Volunteer/GetCurrentUserByPortal';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Volunteer/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static actualAudit(
    params: {
      /** requestBody */
      body?: AuditUserLog;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Volunteer/ActualAudit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getMyAll(
    params: {
      /** 志愿者姓名 */
      volunteerName?: string;
      /** 志愿者手机号 */
      volunteerPhone?: string;
      /**  */
      volunteerId?: number;
      /** 志愿者编号 */
      volunteerCode?: string;
      /**  */
      includeUserExtend?: boolean;
      /** 状态 */
      status?: VolunteerStatus;
      /**  */
      sorting?: string;
      /**  */
      skipCount?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<VolunteerDtoListResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Volunteer/GetMyAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        VolunteerName: params['volunteerName'],
        VolunteerPhone: params['volunteerPhone'],
        VolunteerId: params['volunteerId'],
        VolunteerCode: params['volunteerCode'],
        IncludeUserExtend: params['includeUserExtend'],
        Status: params['status'],
        Sorting: params['sorting'],
        SkipCount: params['skipCount'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getLogs(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuditUserLogDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Volunteer/GetLogs';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getStatus(
    params: {
      /**  */
      audit?: number;
      /**  */
      auditStatus?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Volunteer/GetStatus';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { audit: params['audit'], auditStatus: params['auditStatus'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class VolunteerServiceHistoryService {
  /**
   * 获取服务记录统计
   */
  static getTotalDetails(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/VolunteerServiceHistory/GetTotalDetails';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: VolunteerServiceHistoryCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<VolunteerServiceHistoryDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/VolunteerServiceHistory/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取用户志愿者信息
   */
  static getUserVolunteerInfo(
    params: {
      /**  */
      userId?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UserVolunteerInfo> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/VolunteerServiceHistory/GetUserVolunteerInfo';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { userId: params['userId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getForEdit(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<VolunteerServiceHistoryCreateOrUpdateDtoGetForEditOutput> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/VolunteerServiceHistory/GetForEdit';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<VolunteerServiceHistoryDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/VolunteerServiceHistory/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /** 志愿者姓名 */
      volunteerName?: string;
      /** 志愿者手机号 */
      volunteerPhone?: string;
      /**  */
      volunteerId?: number;
      /** 志愿者编号 */
      volunteerCode?: string;
      /**  */
      includeUserExtend?: boolean;
      /** 状态 */
      status?: VolunteerStatus;
      /**  */
      sorting?: string;
      /**  */
      skipCount?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<VolunteerServiceHistoryDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/VolunteerServiceHistory/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        VolunteerName: params['volunteerName'],
        VolunteerPhone: params['volunteerPhone'],
        VolunteerId: params['volunteerId'],
        VolunteerCode: params['volunteerCode'],
        IncludeUserExtend: params['includeUserExtend'],
        Status: params['status'],
        Sorting: params['sorting'],
        SkipCount: params['skipCount'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: VolunteerServiceHistoryCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<VolunteerServiceHistoryDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/VolunteerServiceHistory/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/VolunteerServiceHistory/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export interface QyWeiXinLoginPostModel {
  /**  */
  userName?: string;

  /**  */
  password?: string;

  /**  */
  qyWeiXinUserId?: string;
}

export interface ExternalAuthenticateResultModel {
  /**  */
  accessToken?: string;

  /**  */
  encryptedAccessToken?: string;

  /**  */
  expireInSeconds?: number;

  /**  */
  waitingForActivation?: boolean;
}

export interface IsTenantAvailableInput {
  /**  */
  tenancyName?: string;
}

export interface IsTenantAvailableOutput {
  /**  */
  state?: TenantAvailabilityState;

  /**  */
  tenantId?: number;
}

export interface LoginPostRespDto {
  /**  */
  errorInfo?: string;

  /**  */
  accessToken?: string;

  /**  */
  identityToken?: string;

  /**  */
  expiresIn?: number;

  /** 租户Id */
  tenantId?: number;

  /** 机构Id */
  organizationUnitId?: number;

  /** 用户Id */
  userId?: number;

  /** 企业微信Id */
  workWeiXinId?: string;
}

export interface RegisterInput {
  /**  */
  name?: string;

  /**  */
  surname?: string;

  /**  */
  userName?: string;

  /**  */
  emailAddress?: string;

  /**  */
  password?: string;

  /**  */
  captchaResponse?: string;
}

export interface RegisterOutput {
  /**  */
  userId?: number;

  /**  */
  canLogin?: boolean;
}

export interface LoginPostReqDto {
  /** 用户名 */
  username?: string;

  /** 密码 */
  password?: string;

  /** 是否记住我 */
  rememberMe?: boolean;

  /** 租户 */
  tenancyName?: string;
}

export interface AbpInvokeReturn {
  /**  */
  hasError?: boolean;

  /**  */
  errorCode?: string;

  /**  */
  errorMessage?: string;

  /**  */
  data?: object;
}

export interface AttachmentDto {
  /**  */
  fileName?: string;

  /** 文件的扩展名 */
  extension?: string;

  /** 是否为临时文件 */
  isTemp?: boolean;

  /**  */
  url?: string;

  /** 附件的宿主ID */
  hostId?: string;

  /**  */
  hostType?: AttachmentHostType;

  /** 文件的长度大小(单位：字节） */
  contentLength?: number;

  /** 文件的大小(自动计算的属性) */
  fileSize?: string;

  /**  */
  id?: number;
}

export interface ActivityDto {
  /**  */
  title?: string;

  /**  */
  content?: string;

  /**  */
  provinceId?: number;

  /**  */
  cityId?: number;

  /**  */
  areaId?: number;

  /**  */
  place?: string;

  /**  */
  placeCoordinate?: string;

  /**  */
  summary?: string;

  /**  */
  aimAmount?: number;

  /**  */
  price?: number;

  /**  */
  signUpCount?: number;

  /**  */
  activityStartTime?: Date;

  /**  */
  activityEndTime?: Date;

  /**  */
  applyEndTime?: Date;

  /**  */
  status?: ActivityStatus;

  /**  */
  titleImagePath?: string;

  /**  */
  host?: string;

  /**  */
  coOrganizer?: string;

  /**  */
  typeID?: ActivityTypeEnum;

  /**  */
  readCount?: number;

  /**  */
  thumbsUpCount?: number;

  /**  */
  isVolunteerActivity?: boolean;

  /**  */
  totalMinutes?: number;

  /** 活动时长(小时) */
  totalHours?: number;

  /**  */
  point?: number;

  /**  */
  attachments?: AttachmentDto[];

  /**  */
  checkInCount?: number;

  /**  */
  cancelCount?: number;

  /**  */
  isDeleted?: boolean;

  /**  */
  deleterUserId?: number;

  /**  */
  deletionTime?: Date;

  /**  */
  lastModificationTime?: Date;

  /**  */
  lastModifierUserId?: number;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  id?: number;
}

export interface ActivityDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: ActivityDto[];
}

export interface Int64EntityDto {
  /**  */
  id?: number;
}

export interface ActivityCreateOrUpdateDto {
  /**  */
  status?: ActivityApplyStatus;

  /**  */
  title?: string;

  /**  */
  content?: string;

  /**  */
  provinceId?: number;

  /**  */
  cityId?: number;

  /**  */
  areaId?: number;

  /**  */
  place?: string;

  /**  */
  placeCoordinate?: string;

  /**  */
  summary?: string;

  /**  */
  aimAmount?: number;

  /**  */
  price?: number;

  /**  */
  signUpCount?: number;

  /**  */
  activityStartTime?: Date;

  /**  */
  activityEndTime?: Date;

  /**  */
  applyTimeType?: number;

  /**  */
  applyEndTime?: Date;

  /**  */
  titleImagePath?: string;

  /**  */
  host?: string;

  /**  */
  coOrganizer?: string;

  /**  */
  typeID?: number;

  /**  */
  isVolunteerActivity?: boolean;

  /**  */
  point?: number;

  /** 活动时长(小时) */
  totalHours?: number;

  /** 限制报名人数 */
  isLimitAim?: boolean;

  /** 活动是否收费 */
  isNotFree?: boolean;

  /** 是否发布 */
  isPublish?: boolean;

  /**  */
  id?: number;
}

export interface ActivityCreateOrUpdateDtoGetForEditOutput {
  /**  */
  data?: ActivityCreateOrUpdateDto;

  /**  */
  schema?: any | null;

  /**  */
  uiSchema?: any | null;

  /**  */
  errorSchema?: any | null;
}

export interface OrganizationUnitShortDto {
  /**  */
  displayName?: string;

  /**  */
  id?: number;
}

export interface UserDto {
  /**  */
  userName?: string;

  /**  */
  name?: string;

  /**  */
  surname?: string;

  /**  */
  emailAddress?: string;

  /**  */
  isActive?: boolean;

  /**  */
  fullName?: string;

  /**  */
  lastLoginTime?: Date;

  /**  */
  creationTime?: Date;

  /**  */
  departmentId?: number;

  /**  */
  departmentName?: string;

  /**  */
  roleNames?: string[];

  /**  */
  organizationUnit?: OrganizationUnitShortDto;

  /**  */
  organizationUnitId?: number;

  /**  */
  phoneNumber?: string;

  /**  */
  userType?: UserType;

  /**  */
  fundId?: number;

  /** 成员图片\/用户头像 */
  headImgUrl?: string;

  /** 公众号openId */
  openId?: string;

  /**  */
  id?: number;
}

export interface AuditNodeDto {
  /**  */
  desc?: string;

  /**  */
  roleName?: string;

  /**  */
  roleId?: number;

  /**  */
  userName?: string;

  /**  */
  userId?: number;

  /**  */
  index?: number;

  /**  */
  auditFlowId?: string;

  /**  */
  tenantId?: number;

  /**  */
  iCanAudit?: boolean;

  /**  */
  id?: string;
}

export interface AuditFlowDto {
  /**  */
  title?: string;

  /**  */
  desc?: string;

  /**  */
  status?: AuditFLowStatus;

  /**  */
  scope?: number;

  /**  */
  type?: AuditFlowType;

  /**  */
  nodesMaxIndex?: number;

  /**  */
  auditNodes?: AuditNodeDto[];

  /**  */
  id?: string;
}

export interface ActivityApplyDto {
  /**  */
  id?: number;

  /** 报名姓名 */
  surname?: string;

  /** 报名手机 */
  phoneNumber?: string;

  /**  */
  organizationUnitId?: number;

  /** 对应的活动Id */
  activityId?: number;

  /**  */
  activity?: ActivityDto;

  /** 报名用户ID
存在导入或 */
  userId?: number;

  /**  */
  applyUser?: UserDto;

  /** 审核通过时更新 */
  approvedTime?: Date;

  /** 用户在前端或管理员在后台取消时更新 */
  cancelTime?: Date;

  /** 审核不通过时更新 */
  sendbackTime?: Date;

  /** 活动报名被退回原因 */
  applyReturnReason?: string;

  /**  */
  status?: ActivityApplyStatus;

  /** 报名时间 */
  applyTime?: Date;

  /** 签到时间 */
  checkInTime?: Date;

  /** 签到次数 */
  checkInTimes?: number;

  /** 总价 */
  totalPrice?: number;

  /** 已支付 */
  totalPaid?: number;

  /** 订单号 */
  billNo?: string;

  /**  */
  auditFlowId?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /**  */
  isAudited?: boolean;

  /**  */
  auditFlow?: AuditFlowDto;

  /**  */
  currentAuditNodes?: AuditNodeDto[];

  /** 订单号 */
  orderId?: number;
}

export interface ActivityApplyCreateOrUpdateDto {
  /** 报名姓名 */
  surname?: string;

  /** 报名手机 */
  phoneNumber?: string;

  /**  */
  status?: ApplyStatus;

  /**  */
  organizationUnitId?: number;

  /**  */
  auditFlowId?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /** 对应的活动Id */
  activityId?: number;

  /**  */
  activity?: ActivityDto;

  /** 报名用户ID
存在导入或 */
  userId?: number;

  /**  */
  applyUser?: UserDto;

  /** 审核通过时更新 */
  approvedTime?: Date;

  /** 用户在前端或管理员在后台取消时更新 */
  cancelTime?: Date;

  /** 审核不通过时更新 */
  sendbackTime?: Date;

  /** 活动报名被退回原因 */
  applyReturnReason?: string;

  /** 报名时间 */
  applyTime?: Date;

  /** 总价 */
  totalPrice?: number;

  /**  */
  clientType?: ClientType;

  /**  */
  id?: number;
}

export interface ActivityApplyDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: ActivityApplyDto[];
}

export interface ExcelRowImportError {
  /**  */
  errorMessage?: string;

  /**  */
  details?: string[];
}

export interface ExcelRowImportResult {
  /**  */
  model?: object;

  /**  */
  success?: boolean;

  /**  */
  error?: ExcelRowImportError;

  /**  */
  rowNumber?: number;

  /**  */
  resultType?: ImportResultType;
}

export interface ImportResult {
  /**  */
  excelFileName?: string;

  /**  */
  importResults?: ExcelRowImportResult[];
}

export interface ActivityApplyPagedResultRequestDto {
  /**  */
  activityId?: number;

  /**  */
  activityTitle?: string;

  /**  */
  applyUserPhone?: string;

  /**  */
  applyUserName?: string;

  /**  */
  isPay?: boolean;

  /**  */
  isPriced?: boolean;

  /**  */
  isOnlyMine?: boolean;

  /** 1:已付款；2:未付款；3:已关闭 */
  specialType?: number;

  /**  */
  status?: ActivityApplyStatus;

  /** 每页记录数，用作替换MaxResultCount */
  pageSize?: number;

  /**  */
  skipCount?: number;

  /** 页码，用来替换SkipCount */
  pageIndex?: number;

  /**  */
  sorting?: string;

  /**  */
  maxResultCount?: number;
}

export interface ActivityApplyCreateOrUpdateDtoGetForEditOutput {
  /**  */
  data?: ActivityApplyCreateOrUpdateDto;

  /**  */
  schema?: any | null;

  /**  */
  uiSchema?: any | null;

  /**  */
  errorSchema?: any | null;
}

export interface UserMiniDto {
  /**  */
  userName?: string;

  /**  */
  name?: string;

  /**  */
  surname?: string;

  /**  */
  phoneNumber?: string;

  /**  */
  id?: number;
}

export interface OrderDto {
  /** 订单号 */
  orderNo?: string;

  /** 关联表Id */
  applyId?: number;

  /** 标题 */
  title?: string;

  /** 图片 */
  titleImagePath?: string;

  /**  */
  type?: OrderType;

  /** 订单金额 */
  priceTotal?: number;

  /** 付款金额 */
  payedMoney?: number;

  /** 是否在线支付 */
  isOnlinePayed?: boolean;

  /** 备注 */
  remark?: string;

  /**  */
  status?: OrderStatus;

  /** 支付时间 */
  payedTime?: Date;

  /** 交易号 */
  tradeNo?: string;

  /** 是否回调 */
  isResponse?: boolean;

  /** 回调时间 */
  responseTime?: Date;

  /** 回调结果 */
  resultMessage?: string;

  /** 取消时间 */
  cancelTime?: Date;

  /** 取消原因 */
  cancelReason?: string;

  /**  */
  creatorUser?: UserMiniDto;

  /**  */
  id?: number;
}

export interface PaymentReponseInputDto {
  /**  */
  sign_Type?: string;

  /**  */
  payment_Type?: string;

  /**  */
  buyer_Account?: string;

  /**  */
  trade_Status?: string;

  /**  */
  trade_No?: string;

  /**  */
  total_Fee?: number;

  /**  */
  order_No?: string;

  /**  */
  notify_Type?: string;

  /**  */
  notify_Id?: string;

  /**  */
  notify_Time?: string;

  /**  */
  sign?: string;

  /**  */
  sortDict?: object;
}

export interface UserActivityApplyInfoDto {
  /** 报名成功次数 */
  signUpCount?: number;
}

export interface AbpBoolDto {
  /** 结果 */
  result?: boolean;
}

export interface UserToken {
  /**  */
  tenantId?: number;

  /**  */
  userId?: number;

  /**  */
  loginProvider?: string;

  /**  */
  name?: string;

  /**  */
  value?: string;

  /**  */
  expireDate?: Date;

  /**  */
  id?: number;
}

export interface UserLogin {
  /**  */
  tenantId?: number;

  /**  */
  userId?: number;

  /**  */
  loginProvider?: string;

  /**  */
  providerKey?: string;

  /**  */
  id?: number;
}

export interface UserRole {
  /**  */
  tenantId?: number;

  /**  */
  userId?: number;

  /**  */
  roleId?: number;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  id?: number;
}

export interface UserClaim {
  /**  */
  tenantId?: number;

  /**  */
  userId?: number;

  /**  */
  claimType?: string;

  /**  */
  claimValue?: string;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  id?: number;
}

export interface UserPermissionSetting {
  /**  */
  userId?: number;

  /**  */
  tenantId?: number;

  /**  */
  name?: string;

  /**  */
  isGranted?: boolean;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  id?: number;
}

export interface Setting {
  /**  */
  tenantId?: number;

  /**  */
  userId?: number;

  /**  */
  name?: string;

  /**  */
  value?: string;

  /**  */
  lastModificationTime?: Date;

  /**  */
  lastModifierUserId?: number;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  id?: number;
}

export interface User {
  /**  */
  departmentId?: number;

  /**  */
  normalizedUserName?: string;

  /**  */
  normalizedEmailAddress?: string;

  /**  */
  concurrencyStamp?: string;

  /**  */
  tokens?: UserToken[];

  /**  */
  deleterUser?: User;

  /**  */
  creatorUser?: User;

  /**  */
  lastModifierUser?: User;

  /**  */
  authenticationSource?: string;

  /**  */
  userName?: string;

  /**  */
  tenantId?: number;

  /**  */
  emailAddress?: string;

  /**  */
  name?: string;

  /**  */
  surname?: string;

  /**  */
  fullName?: string;

  /**  */
  password?: string;

  /**  */
  emailConfirmationCode?: string;

  /**  */
  passwordResetCode?: string;

  /**  */
  lockoutEndDateUtc?: Date;

  /**  */
  accessFailedCount?: number;

  /**  */
  isLockoutEnabled?: boolean;

  /**  */
  phoneNumber?: string;

  /**  */
  isPhoneNumberConfirmed?: boolean;

  /**  */
  securityStamp?: string;

  /**  */
  isTwoFactorEnabled?: boolean;

  /**  */
  logins?: UserLogin[];

  /**  */
  roles?: UserRole[];

  /**  */
  claims?: UserClaim[];

  /**  */
  permissions?: UserPermissionSetting[];

  /**  */
  settings?: Setting[];

  /**  */
  isEmailConfirmed?: boolean;

  /**  */
  isActive?: boolean;

  /**  */
  isDeleted?: boolean;

  /**  */
  deleterUserId?: number;

  /**  */
  deletionTime?: Date;

  /**  */
  lastModificationTime?: Date;

  /**  */
  lastModifierUserId?: number;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  id?: number;
}

export interface AuditUserLogProxy {
  /**  */
  hostId?: string;

  /**  */
  hostType?: AuditFlowScope;

  /**  */
  auditFlowId?: string;

  /**  */
  auditNodeId?: string;

  /**  */
  status?: AuditUserLogStatus;

  /**  */
  desc?: string;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  creatorUser?: User;

  /**  */
  tenantId?: number;

  /**  */
  auditStatus?: number;

  /**  */
  expired?: boolean;
}

export interface AuditUserLog {
  /**  */
  hostId?: string;

  /**  */
  hostType?: number;

  /**  */
  auditFlowId?: string;

  /**  */
  auditNodeId?: string;

  /**  */
  status?: AuditUserLogStatus;

  /**  */
  desc?: string;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  creatorUser?: User;

  /**  */
  tenantId?: number;

  /**  */
  auditStatus?: number;

  /**  */
  expired?: boolean;

  /**  */
  id?: number;
}

export interface ActivityApplyDtoListResultDto {
  /**  */
  items?: ActivityApplyDto[];
}

export interface AuditUserLogDto {
  /**  */
  hostType?: number;

  /**  */
  status?: AuditUserLogStatus;

  /**  */
  desc?: string;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUser?: UserMiniDto;

  /**  */
  expired?: boolean;

  /**  */
  auditNodeId?: string;

  /**  */
  id?: number;
}

export interface ActivitySignInRecordDto {
  /**  */
  id?: number;
}

export interface ActivitySignInRecordDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: ActivitySignInRecordDto[];
}

export interface ActivitySignInRecordCreateOrUpdateDto {
  /**  */
  id?: number;
}

export interface AlbumDto {
  /** 相册名称 */
  name?: string;

  /** 相册描述 */
  summary?: string;

  /** 封面地址 */
  cover?: string;

  /**  */
  tenantId?: number;

  /**  */
  isDeleted?: boolean;

  /**  */
  deleterUserId?: number;

  /**  */
  deletionTime?: Date;

  /**  */
  lastModificationTime?: Date;

  /**  */
  lastModifierUserId?: number;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  id?: number;
}

export interface AlbumCreateUpdateDto {
  /** 相册名称 */
  name?: string;

  /** 相册描述 */
  summary?: string;

  /** 封面地址 */
  cover?: string;

  /**  */
  id?: number;
}

export interface AlbumDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: AlbumDto[];
}

export interface AlbumPhotoDto {
  /**  */
  id?: number;

  /** 照片名称 */
  name?: string;

  /** 照片大小(byte) */
  photoSize?: number;

  /**  */
  size?: string;

  /** 照片路径 */
  photoPath?: string;
}

export interface AlbumPhotoDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: AlbumPhotoDto[];
}

export interface AlbumPhotoMoveInput {
  /** 目标相册 */
  albumId?: number;

  /**  */
  id?: number;
}

export interface RenameAlbumPhotoInput {
  /** 照片名称 */
  name?: string;

  /**  */
  id?: number;
}

export interface ApplicationPaymentCreateOrUpdateDto {
  /**  */
  auditFlowId?: string;

  /**  */
  savedAttachments?: number[];

  /** 客商主表Id */
  merchantId?: number;

  /** 客商银行账号表Id */
  merchantBankAccountId?: number;

  /** 标题 */
  title?: string;

  /**  */
  approvalCategory?: ApprovalCategory;

  /** 项目类别 */
  projectCategoryId?: number;

  /** 项目领域 */
  projectDomainId?: number;

  /** 活动分类 */
  activityClassId?: number;

  /** 基金Id */
  fundId?: number;

  /** 基金项目Id */
  fundProjectId?: number;

  /** 请款理由 */
  payReason?: string;

  /**  */
  payCurrencyType?: CurrencyType;

  /** 支付金额 */
  payMoney?: number;

  /** 备注 */
  remark?: string;

  /** 其他项目名称 */
  otherProjectName?: string;

  /** 拟办意见 */
  appropriateReason?: string;

  /**  */
  attachmentStr?: string;

  /**  */
  applyTime?: Date;

  /**  */
  id?: number;
}

export interface TenantBankAccountDto {
  /**  */
  creatorUser?: UserMiniDto;

  /** 银行账号 */
  bankAccountCode?: string;

  /** 银行名称 */
  bankName?: string;

  /** 户名 */
  bankAccountName?: string;

  /**  */
  id?: number;
}

export interface MerchantDto {
  /**  */
  creatorUser?: UserMiniDto;

  /**  */
  organizationUnitId?: number;

  /**  */
  organizationUnit?: OrganizationUnitShortDto;

  /** 单位名称 */
  unitName?: string;

  /** 单位地址 */
  unitAddress?: string;

  /** 负责人姓名 */
  principalName?: string;

  /** 负责人手机号 */
  principalMobilePhone?: string;

  /** 负责人邮箱 */
  principalEmailAddress?: string;

  /** 联系人姓名 */
  contactName?: string;

  /** 联系人手机号 */
  contactMobilePhone?: string;

  /** 联系人邮箱 */
  contactEmailAddress?: string;

  /**  */
  fundId?: number;

  /** 是否推送至NC系统 */
  isSynced?: boolean;

  /** 是否已启用 */
  isEnabled?: boolean;

  /** 用友系统中的供应商主键 */
  ncSupplierPK?: string;

  /**  */
  id?: number;
}

export interface MerchantBankAccountDto {
  /**  */
  creatorUser?: UserMiniDto;

  /** 客商主表Id */
  merchantId?: number;

  /**  */
  merchant?: MerchantDto;

  /** 银行账号 */
  bankAccountCode?: string;

  /** 银行类型 */
  bankType?: string;

  /**  */
  bankTypePK?: string;

  /** 银行名称 */
  bankName?: string;

  /**  */
  bankNamePK?: string;

  /** 户名 */
  bankAccountName?: string;

  /** 是否推送至NC系统 */
  isSynced?: boolean;

  /** 是否已启用 */
  isEnabled?: boolean;

  /**  */
  id?: number;
}

export interface FundMiniDto {
  /**  */
  name?: string;

  /**  */
  id?: number;
}

export interface FundProjectMiniDto {
  /** 项目标题 */
  name?: string;

  /**  */
  projectType?: FundProjectType;

  /**  */
  id?: number;
}

export interface DataDictionaryDto {
  /** 租户。 */
  tenantId?: number;

  /** 键名 */
  key?: string;

  /** 显示的名称 */
  displayName?: string;

  /** 显示顺序 */
  displayOrder?: number;

  /**  */
  parentId?: number;

  /**  */
  id?: number;
}

export interface ApplicationPaymentDto {
  /** 审核流程Id */
  auditFlowId?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /**  */
  auditFlow?: AuditFlowDto;

  /**  */
  creatorUser?: UserMiniDto;

  /** 基金银行账号表Id */
  tenantBankAccountId?: number;

  /**  */
  tenantBankAccount?: TenantBankAccountDto;

  /** 客商主表Id */
  merchantId?: number;

  /**  */
  merchant?: MerchantDto;

  /** 客商银行账号表Id */
  merchantBankAccountId?: number;

  /**  */
  merchantBankAccount?: MerchantBankAccountDto;

  /** 申请人Id */
  applicantId?: number;

  /**  */
  applicant?: UserMiniDto;

  /** 资料提交人Id */
  operatorId?: number;

  /**  */
  operator?: UserMiniDto;

  /** 基金Id */
  fundId?: number;

  /**  */
  fund?: FundMiniDto;

  /** 基金项目Id */
  fundProjectId?: number;

  /**  */
  fundProject?: FundProjectMiniDto;

  /** 审批编号 */
  approvalNumber?: string;

  /** 提交时间 */
  submitTime?: Date;

  /** 申请人部门Id */
  applicantDeptId?: number;

  /** 标题 */
  title?: string;

  /**  */
  approvalCategory?: ApprovalCategory;

  /** 审批类别 */
  approvalCategoryName?: string;

  /** 项目类别 */
  projectCategoryId?: number;

  /**  */
  projectCategory?: DataDictionaryDto;

  /** 项目领域 */
  projectDomainId?: number;

  /**  */
  projectDomain?: DataDictionaryDto;

  /** 活动分类 */
  activityClassId?: number;

  /**  */
  activityClass?: DataDictionaryDto;

  /** 请款理由 */
  payReason?: string;

  /**  */
  payCurrencyType?: CurrencyType;

  /** 支付金额 */
  payMoney?: number;

  /** 备注 */
  remark?: string;

  /** 发票号码 */
  invoiceNumber?: string;

  /** 发票是否匹配 */
  isInvoiceMatched?: boolean;

  /** 第三方Id */
  thirdPartyId?: string;

  /** 第三方状态 */
  thirdPartyStatus?: string;

  /** 发票数量 */
  invoiceCount?: number;

  /** 已验证的发票数量 */
  verifiedInvoiceCount?: number;

  /**  */
  auditFlowScope?: AuditFlowScope;

  /** 其他项目名称 */
  otherProjectName?: string;

  /** 原因 */
  reason?: string;

  /**  */
  validationStatus?: ApplicationPaymentValidationStatus;

  /** 拟办意见 */
  appropriateReason?: string;

  /** 部门名称 */
  deptName?: string;

  /**  */
  applyTime?: Date;

  /**  */
  isDeleted?: boolean;

  /**  */
  deleterUserId?: number;

  /**  */
  deletionTime?: Date;

  /**  */
  lastModificationTime?: Date;

  /**  */
  lastModifierUserId?: number;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  id?: number;
}

export interface ApplicationPaymentDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: ApplicationPaymentDto[];
}

export interface ApplicationPaymentInvoiceNumberInput {
  /** 用款申请Id */
  id?: number;

  /** 发票号码 */
  invoiceNumbers?: string[];
}

export interface Int32EntityDto {
  /**  */
  id?: number;
}

export interface ConfirmFundingInput {
  /**  */
  id?: number;

  /**  */
  tenantBankAccountId?: number;
}

export interface ApplicationPaymentDtoListResultDto {
  /**  */
  items?: ApplicationPaymentDto[];
}

export interface AreaCreateOrUpdateDto {
  /**  */
  cityId?: number;

  /**  */
  areaName?: string;

  /**  */
  id?: number;
}

export interface AreaDto {
  /**  */
  cityId?: number;

  /**  */
  areaName?: string;

  /**  */
  id?: number;
}

export interface AreaDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: AreaDto[];
}

export interface UploadResult {
  /**  */
  hostType?: AttachmentHostType;

  /**  */
  attachmentId?: number;

  /**  */
  fileName?: string;

  /**  */
  url?: string;
}

export interface AuditNodeCreateOrEditDto {
  /**  */
  desc?: string;

  /**  */
  roleName?: string;

  /**  */
  roleId?: number;

  /**  */
  userName?: string;

  /**  */
  userId?: number;

  /**  */
  index?: number;

  /**  */
  auditFlowId?: string;

  /**  */
  tenantId?: number;

  /**  */
  id?: string;
}

export interface AuditFlowCreateOrEditDto {
  /**  */
  title?: string;

  /**  */
  desc?: string;

  /**  */
  nodesMaxIndex?: number;

  /**  */
  status?: AuditFLowStatus;

  /**  */
  type?: AuditFlowType;

  /**  */
  scope?: number;

  /**  */
  auditNodes?: AuditNodeCreateOrEditDto[];

  /**  */
  id?: string;
}

export interface AuditFlowCreateOrEditDtoGetForEditOutput {
  /**  */
  data?: AuditFlowCreateOrEditDto;

  /**  */
  schema?: any | null;

  /**  */
  uiSchema?: any | null;

  /**  */
  errorSchema?: any | null;
}

export interface GuidEntityDto {
  /**  */
  id?: string;
}

export interface CanAuditRequestDto {
  /**  */
  auditFlowId?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;
}

export interface AuditFlowDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: AuditFlowDto[];
}

export interface AuditFlowCreateOrEditProxyDto {
  /** 标题 */
  title?: string;

  /** 描述 */
  desc?: string;

  /**  */
  nodesMaxIndex?: number;

  /**  */
  status?: AuditFLowStatus;

  /**  */
  type?: AuditFlowType;

  /**  */
  scope?: AuditFlowScope;

  /** 节点 */
  auditNodes?: AuditNodeCreateOrEditDto[];

  /**  */
  id?: string;
}

export interface AuditFlowCreateOrEditProxyDtoGetForEditOutput {
  /**  */
  data?: AuditFlowCreateOrEditProxyDto;

  /**  */
  schema?: any | null;

  /**  */
  uiSchema?: any | null;

  /**  */
  errorSchema?: any | null;
}

export interface AuditNodePreDefineCreateOrEditDto {
  /**  */
  desc?: string;

  /**  */
  roleName?: string;

  /**  */
  roleId?: number;

  /**  */
  userName?: string;

  /**  */
  userId?: number;

  /**  */
  organizationUnitId?: number;

  /**  */
  id?: string;
}

export interface AuditNodePreDefineCreateOrEditDtoGetForEditOutput {
  /**  */
  data?: AuditNodePreDefineCreateOrEditDto;

  /**  */
  schema?: any | null;

  /**  */
  uiSchema?: any | null;

  /**  */
  errorSchema?: any | null;
}

export interface RoleMiniDto {
  /**  */
  name?: string;

  /**  */
  displayName?: string;

  /**  */
  id?: number;
}

export interface AuditNodePreDefineDto {
  /**  */
  desc?: string;

  /**  */
  roleName?: string;

  /**  */
  roleId?: number;

  /**  */
  userName?: string;

  /**  */
  userId?: number;

  /**  */
  organizationUnitId?: number;

  /**  */
  userMini?: UserMiniDto;

  /**  */
  role?: RoleMiniDto;

  /**  */
  id?: string;
}

export interface AuditNodePreDefineDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: AuditNodePreDefineDto[];
}

export interface InvoiceDto {
  /** 交款人 */
  donorName?: string;

  /** 交款人类型 */
  donorType?: string;

  /** 收款方式 */
  donateType?: string;

  /** 统一社会信用代码 */
  creditCode?: string;

  /** 备注 */
  remark?: string;

  /** 项目名称 */
  projectName?: string;

  /** 数量 */
  number?: number;

  /** 金额 */
  money?: number;

  /** 创建时间 */
  creationTime?: string;

  /** 创建人Id */
  creatorUserId?: number;

  /** 创建人 */
  creatorUserName?: string;

  /**  */
  id?: number;
}

export interface BankNameDto {
  /**  */
  name?: string;

  /**  */
  bankNameCode?: string;

  /**  */
  bankNamePK?: string;

  /**  */
  id?: number;
}

export interface BankNameDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: BankNameDto[];
}

export interface BankNameCreateOrUpdateDto {
  /**  */
  name?: string;

  /**  */
  bankNameCode?: string;

  /**  */
  bankNamePK?: string;

  /**  */
  id?: number;
}

export interface DecimalMonthlyItem {
  /**  */
  date?: string;

  /**  */
  value?: number;
}

export interface BankTypeDto {
  /**  */
  name?: string;

  /**  */
  bankTypeCode?: string;

  /**  */
  bankTypePK?: string;

  /**  */
  id?: number;
}

export interface BankTypeDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: BankTypeDto[];
}

export interface BankTypeCreateOrUpdateDto {
  /**  */
  name?: string;

  /**  */
  bankTypeCode?: string;

  /**  */
  bankTypePK?: string;

  /**  */
  id?: number;
}

export interface AreaSelectDto {
  /**  */
  provinceId?: number;

  /**  */
  cityId?: number;

  /**  */
  areaId?: number;

  /**  */
  townId?: number;
}

export interface FamilyMembersInfoDto {
  /** 姓名 */
  name?: string;

  /** 称谓 */
  appellation?: string;

  /** 出生年月 */
  birthDate?: Date;

  /** 健康情况 */
  health?: string;

  /** 职业 */
  occupation?: string;

  /** 年收入 */
  annualIncome?: number;

  /**  */
  id?: string;
}

export interface BeneficiaryDto {
  /** 个案编号 */
  code?: string;

  /** 负责人 */
  principalName?: string;

  /** 负责人电话 */
  principalPhone?: string;

  /** 姓名 */
  realName?: string;

  /** 性别(男,女) */
  sex?: string;

  /** 出生日期 */
  birthday?: Date;

  /** 民族 */
  nation?: string;

  /** 联系电话 */
  phone?: string;

  /** 身份证号 */
  idNo?: string;

  /**  */
  provinceId?: number;

  /**  */
  provinceName?: string;

  /**  */
  cityId?: number;

  /**  */
  cityName?: string;

  /**  */
  areaId?: number;

  /**  */
  areaName?: string;

  /**  */
  townId?: number;

  /**  */
  townName?: string;

  /** 详细地址 */
  homeAddress?: string;

  /** 是否为建档立卡户 */
  isEnjoyOtherSalvation?: boolean;

  /** 建档立卡金额(元\/月) */
  otherSalvationAmount?: number;

  /** 是否享受低保政策 */
  isEnjoyTheSubsistenceAllowancePolicy?: boolean;

  /** 低保金额(元\/月) */
  subsistenceAllowanceAmount?: number;

  /**  */
  auditFlowId?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /**  */
  areaSelect?: AreaSelectDto;

  /** 家庭成员情况 */
  familyMembersInfoList?: FamilyMembersInfoDto[];

  /**  */
  id?: number;
}

export interface BeneficiaryCreateOrUpdateDto {
  /** 个案编号 */
  code?: string;

  /** 负责人 */
  principalName?: string;

  /** 负责人电话 */
  principalPhone?: string;

  /** 姓名 */
  realName?: string;

  /** 性别(男,女) */
  sex?: string;

  /** 出生日期 */
  birthday?: Date;

  /** 民族 */
  nation?: string;

  /** 联系电话 */
  phone?: string;

  /** 身份证号 */
  idNo?: string;

  /**  */
  provinceId?: number;

  /**  */
  provinceName?: string;

  /**  */
  cityId?: number;

  /**  */
  cityName?: string;

  /**  */
  areaId?: number;

  /**  */
  areaName?: string;

  /**  */
  townId?: number;

  /**  */
  townName?: string;

  /**  */
  areaSelect?: AreaSelectDto;

  /** 详细地址 */
  homeAddress?: string;

  /** 是否为建档立卡户 */
  isEnjoyOtherSalvation?: boolean;

  /** 建档立卡金额(元\/月) */
  otherSalvationAmount?: number;

  /** 是否享受低保政策 */
  isEnjoyTheSubsistenceAllowancePolicy?: boolean;

  /** 低保金额(元\/月) */
  subsistenceAllowanceAmount?: number;

  /**  */
  savedAttachments?: number[];

  /**  */
  auditFlowId?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /** 家庭成员情况 */
  familyMembersInfoList?: FamilyMembersInfoDto[];

  /**  */
  id?: number;
}

export interface BeneficiaryDtoListResultDto {
  /**  */
  items?: BeneficiaryDto[];
}

export interface BeneficiaryDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: BeneficiaryDto[];
}

export interface ProjectDto {
  /**  */
  organizationUnitId?: number;

  /**  */
  organizationUnit?: OrganizationUnitShortDto;

  /**  */
  displayName?: string;

  /**  */
  isPublicShow?: boolean;

  /**  */
  titleImagePath?: string;

  /**  */
  workflowStep?: WorkflowOfProjectByExternal;

  /**  */
  id?: number;
}

export interface ProvinceDto {
  /**  */
  provinceName?: string;

  /**  */
  shortName?: string;

  /**  */
  id?: number;
}

export interface CityDto {
  /**  */
  cityName?: string;

  /**  */
  provinceId?: number;

  /**  */
  shortCode?: string;

  /**  */
  id?: number;
}

export interface TownDto {
  /**  */
  areaId?: number;

  /**  */
  townName?: string;

  /**  */
  id?: number;
}

export interface OrganizationUnitDto {
  /** 机构logo */
  logoImageUrl?: string;

  /** 机构名称 */
  displayName?: string;

  /** 机构类型,数据字典Id */
  organizationType?: number;

  /**  */
  areaSelect?: AreaSelectDto;

  /**  */
  provinceId?: number;

  /**  */
  province?: ProvinceDto;

  /**  */
  cityId?: number;

  /**  */
  city?: CityDto;

  /**  */
  areaId?: number;

  /**  */
  area?: AreaDto;

  /**  */
  townId?: number;

  /**  */
  town?: TownDto;

  /** 地点 */
  place?: string;

  /** 负责人姓名 */
  principalName?: string;

  /** 主要负责人的手机号 */
  mobilePhone?: string;

  /** 主要负责人的邮箱 */
  emailAddress?: string;

  /** 联系人姓名 */
  contactName?: string;

  /** 联系人手机号 */
  contactMobilePhone?: string;

  /** 联系人邮箱 */
  contactEmailAddress?: string;

  /** 统一社会信用代码 */
  creditCode?: string;

  /** 合作方银行账号名称 */
  bankAccountName?: string;

  /** 开户行信息 */
  bankName?: string;

  /** 开户账号 */
  bankAccount?: string;

  /** 收件人 */
  receiverName?: string;

  /** 收件地址 */
  receiverAddress?: string;

  /** 收件电话 */
  receiverMobile?: string;

  /** 法人登记证书复印件 */
  certificateImagePath?: string;

  /**  */
  extensionData?: string;

  /**  */
  registerTime?: Date;

  /**  */
  extensionObject?: object;

  /**  */
  auditFlowId?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /**  */
  isDeleted?: boolean;

  /**  */
  deleterUserId?: number;

  /**  */
  deletionTime?: Date;

  /**  */
  lastModificationTime?: Date;

  /**  */
  lastModifierUserId?: number;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  id?: number;
}

export interface ProjectServiceItemDto {
  /**  */
  sequence?: number;

  /**  */
  serviceTime?: Date;

  /**  */
  serviceMethod?: string;

  /**  */
  serviceContent?: string;

  /**  */
  target?: string;

  /**  */
  completeStatus?: ProjectServiceRecordCompleteStatus;

  /**  */
  remark?: string;

  /**  */
  tenantId?: number;

  /**  */
  organizationUnitId?: number;

  /**  */
  serviceMethods?: string[];

  /**  */
  id?: number;
}

export interface ServiceRecordDto {
  /**  */
  projectId?: number;

  /**  */
  project?: ProjectDto;

  /**  */
  serviceRecordType?: ServiceRecordType;

  /**  */
  beneficiaryId?: number;

  /**  */
  beneficiary?: BeneficiaryDto;

  /**  */
  organizationUnitId?: number;

  /**  */
  schoolId?: number;

  /**  */
  school?: OrganizationUnitDto;

  /**  */
  extensionData?: string;

  /**  */
  projectBeneficiaryMappingId?: number;

  /**  */
  simpleDetail?: ProjectServiceItemDto;

  /**  */
  serviceItems?: ProjectServiceItemDto[];

  /**  */
  auditFlowId?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /**  */
  extensionObject?: object;

  /**  */
  id?: number;
}

export interface ServiceRecordDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: ServiceRecordDto[];
}

export interface ProjectServiceItemCreateOrUpdateDto {
  /**  */
  organizationUnitId?: number;

  /**  */
  id?: number;

  /**  */
  sequence?: number;

  /**  */
  auditFlowId?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /**  */
  tenantId?: number;

  /**  */
  serviceTime?: Date;

  /**  */
  serviceMethod?: string;

  /**  */
  serviceMethods?: string[];

  /**  */
  serviceContent?: string;

  /**  */
  target?: string;

  /**  */
  completeStatus?: ProjectServiceRecordCompleteStatus;

  /**  */
  remark?: string;

  /**  */
  savedAttachments?: number[];
}

export interface ServiceRecordCreateOrUpdateDto {
  /**  */
  projectId?: number;

  /**  */
  serviceRecordType?: ServiceRecordType;

  /**  */
  beneficiaryId?: number;

  /**  */
  schoolId?: number;

  /**  */
  organizationUnitId?: number;

  /**  */
  extensionData?: string;

  /**  */
  savedAttachments?: number[];

  /**  */
  auditFlowId?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /**  */
  projectBeneficiaryMappingId?: number;

  /**  */
  serviceItems?: ProjectServiceItemCreateOrUpdateDto[];

  /**  */
  extensionObject?: object;

  /**  */
  formId?: number;

  /**  */
  id?: number;
}

export interface ServiceRecordPagedResultRequestDto {
  /**  */
  serviceRecordType?: ServiceRecordType;

  /**  */
  beneficiaryName?: string;

  /**  */
  schoolName?: string;

  /**  */
  projectName?: string;

  /**  */
  projectId?: number;

  /** 每页记录数，用作替换MaxResultCount */
  pageSize?: number;

  /**  */
  skipCount?: number;

  /** 页码，用来替换SkipCount */
  pageIndex?: number;

  /**  */
  sorting?: string;

  /**  */
  maxResultCount?: number;
}

export interface ServiceRecordDtoListResultDto {
  /**  */
  items?: ServiceRecordDto[];
}

export interface CapitalExpenseRecordDetailCreateOrUpdateDto {
  /**  */
  sequence?: number;

  /** 项目类型 */
  projectType?: string;

  /** 项目类型名称 */
  projectTypeName?: string;

  /** 项目Id（-1为待分摊） */
  projectId?: number;

  /** 内部项目预算子项目内容 */
  internalProjectBudgetItemId?: string;

  /** 三级科目 */
  itemName?: string;

  /** 摘要 */
  summary?: string;

  /** 本次支付金额（元） */
  money?: number;

  /** 备注 */
  remark?: string;

  /** 是否超出预算(该项目该三级科目已支付金额加本次支付金额是否超出预算金额) */
  isOver?: boolean;

  /**  */
  id?: string;
}

export interface CapitalExpenseRecordCreateOrUpdateDto {
  /** 收款单位 */
  payeeName?: string;

  /** 开户银行 */
  payeeBankName?: string;

  /** 开户账号 */
  payeeBankAccount?: string;

  /**  */
  payType?: PayType;

  /** 付款账号（数据字典，多选一） */
  payBankAccount?: string;

  /** 合同编号 */
  contractNo?: string;

  /** 合同总金额（元） */
  contractTotalMoney?: number;

  /** 累计已支付金额（元） */
  paidTotalMoney?: number;

  /** 本次支付合计金额（元） */
  totalMoney?: number;

  /** 剩余待分摊总金额（元） */
  nonApportionTotalMoney?: number;

  /**  */
  details?: CapitalExpenseRecordDetailCreateOrUpdateDto[];

  /**  */
  auditFlowId?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /**  */
  id?: number;
}

export interface ProjectFullInfoDto {
  /**  */
  organizationUnitId?: number;

  /**  */
  displayName?: string;

  /**  */
  year?: number;

  /**  */
  description?: string;

  /**  */
  projectTypes?: string;

  /**  */
  isPublicShow?: boolean;

  /**  */
  projectSeriesId?: number;

  /**  */
  titleImagePath?: string;

  /**  */
  isInternal?: boolean;

  /**  */
  progressReportDate?: Date;

  /**  */
  summaryReportDate?: Date;

  /**  */
  workflowStep?: number;

  /**  */
  projectResult?: string;

  /** 项目开始日期 */
  startDate?: Date;

  /** 项目结束日期 */
  endDate?: Date;

  /**  */
  id?: number;
}

export interface CapitalExpenseRecordDetailDto {
  /**  */
  sequence?: number;

  /**  */
  capitalExpenseRecordId?: number;

  /** 项目类型 */
  projectType?: string;

  /** 项目类型名称 */
  projectTypeName?: string;

  /** 项目Id（-1为待分摊） */
  projectId?: number;

  /**  */
  project?: ProjectFullInfoDto;

  /** 内部项目预算子项目内容 */
  internalProjectBudgetItemId?: string;

  /** 三级科目 */
  itemName?: string;

  /** 摘要 */
  summary?: string;

  /** 本次支付金额（元） */
  money?: number;

  /** 备注 */
  remark?: string;

  /** 是否超出预算(该项目该三级科目已支付金额加本次支付金额是否超出预算金额) */
  isOver?: boolean;

  /**  */
  totalAmount?: number;

  /**  */
  id?: string;
}

export interface CapitalExpenseRecordDto {
  /** 收款单位 */
  payeeName?: string;

  /** 开户银行 */
  payeeBankName?: string;

  /** 开户账号 */
  payeeBankAccount?: string;

  /**  */
  payType?: PayType;

  /** 付款账号（数据字典，多选一） */
  payBankAccount?: string;

  /** 合同编号 */
  contractNo?: string;

  /** 合同总金额（元） */
  contractTotalMoney?: number;

  /** 累计已支付金额（元） */
  paidTotalMoney?: number;

  /** 本次支付合计金额（元） */
  totalMoney?: number;

  /** 剩余待分摊总金额（元） */
  nonApportionTotalMoney?: number;

  /**  */
  details?: CapitalExpenseRecordDetailDto[];

  /**  */
  payDate?: Date;

  /**  */
  simpleDetail?: CapitalExpenseRecordDetailDto;

  /**  */
  auditFlowId?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /**  */
  version?: number;

  /**  */
  preVersionId?: number;

  /**  */
  changeState?: ChangeState;

  /**  */
  id?: number;
}

export interface ContractNoInformationDto {
  /**  */
  contractTotalMoney?: number;

  /**  */
  paidTotalMoney?: number;
}

export interface InternalBudgetItemAndUseRecordDto {
  /**  */
  projectId?: number;

  /** 序列(显示顺序） */
  sequence?: number;

  /**  */
  projectBudgetCategory?: ProjectBudgetCategory;

  /**  */
  projectBudgetType?: ProjectBudgetType;

  /** 子项目内容（三级科目） */
  itemName?: string;

  /** 具体内容 */
  content?: string;

  /** 单价（元） */
  unitPrice?: number;

  /** 数量 */
  number?: number;

  /** 单位 */
  unit?: string;

  /** 预算报价 */
  budgetQuotation?: number;

  /**  */
  projectBudgetCapitalSource?: ProjectBudgetCapitalSource;

  /**  */
  actualMoney?: number;

  /**  */
  id?: string;
}

export interface CapitalExpenseRecordPagedResultRequestDto {
  /** 收款单位 */
  payeeName?: string;

  /** 开户银行 */
  payeeBankAccount?: string;

  /**  */
  payType?: PayType;

  /** 合同编号 */
  contractNo?: string;

  /** 开始日期 */
  startDate?: Date;

  /** 截止日期 */
  endDate?: Date;

  /**  */
  projectName?: string;

  /** 每页记录数，用作替换MaxResultCount */
  pageSize?: number;

  /**  */
  skipCount?: number;

  /** 页码，用来替换SkipCount */
  pageIndex?: number;

  /**  */
  sorting?: string;

  /**  */
  maxResultCount?: number;
}

export interface ProjectReportDto {
  /**  */
  totalAmount?: number;

  /**  */
  projectName?: string;

  /**  */
  year?: number;

  /**  */
  projectSeries?: string;

  /**  */
  projectType?: string;

  /**  */
  projectTypeName?: string;

  /**  */
  projectId?: number;
}

export interface ProjectReportDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: ProjectReportDto[];
}

export interface ProjectDetailReprotDto {
  /**  */
  money?: number;

  /**  */
  itemName?: string;

  /**  */
  remark?: string;

  /**  */
  summary?: string;

  /**  */
  payeeName?: string;

  /**  */
  payeeBankName?: string;

  /**  */
  payeeBankAccount?: string;

  /**  */
  contractNo?: string;

  /**  */
  payDate?: Date;

  /**  */
  totalAmount?: number;

  /**  */
  projectName?: string;

  /**  */
  year?: number;

  /**  */
  projectSeries?: string;

  /**  */
  projectType?: string;

  /**  */
  projectTypeName?: string;

  /**  */
  projectId?: number;
}

export interface ProjectDetailReprotDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: ProjectDetailReprotDto[];
}

export interface CapitalExpenseRecord {
  /**  */
  tenantId?: number;

  /**  */
  payeeName?: string;

  /**  */
  payeeBankName?: string;

  /**  */
  payeeBankAccount?: string;

  /**  */
  payType?: PayType;

  /**  */
  payBankAccount?: string;

  /**  */
  contractNo?: string;

  /**  */
  contractTotalMoney?: number;

  /**  */
  paidTotalMoney?: number;

  /**  */
  payDate?: Date;

  /**  */
  totalMoney?: number;

  /**  */
  nonApportionTotalMoney?: number;

  /**  */
  details?: CapitalExpenseRecordDetail[];

  /**  */
  auditFlowId?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /**  */
  enableRestartAudit?: boolean;

  /**  */
  creatorUser?: User;

  /**  */
  version?: number;

  /**  */
  preVersionId?: number;

  /**  */
  changeState?: ChangeState;

  /**  */
  isDeleted?: boolean;

  /**  */
  deleterUserId?: number;

  /**  */
  deletionTime?: Date;

  /**  */
  lastModificationTime?: Date;

  /**  */
  lastModifierUserId?: number;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  id?: number;
}

export interface ProjectSeries {
  /**  */
  tenantId?: number;

  /**  */
  title?: string;

  /**  */
  titleImagePath?: string;

  /**  */
  isPublicShow?: boolean;

  /**  */
  sequence?: number;

  /**  */
  isDefault?: boolean;

  /**  */
  ignored?: boolean;

  /**  */
  isDeleted?: boolean;

  /**  */
  deleterUserId?: number;

  /**  */
  deletionTime?: Date;

  /**  */
  lastModificationTime?: Date;

  /**  */
  lastModifierUserId?: number;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  id?: number;
}

export interface Province {
  /**  */
  provinceName?: string;

  /**  */
  shortName?: string;

  /**  */
  id?: number;
}

export interface City {
  /**  */
  cityName?: string;

  /**  */
  provinceId?: number;

  /**  */
  province?: Province;

  /**  */
  shortCode?: string;

  /**  */
  id?: number;
}

export interface Area {
  /**  */
  cityId?: number;

  /**  */
  city?: City;

  /**  */
  areaName?: string;

  /**  */
  id?: number;
}

export interface Town {
  /**  */
  areaId?: number;

  /**  */
  area?: Area;

  /**  */
  townName?: string;

  /**  */
  id?: number;
}

export interface OrganizationUnit {
  /**  */
  tenantId?: number;

  /**  */
  parent?: OrganizationUnit;

  /**  */
  parentId?: number;

  /**  */
  code?: string;

  /**  */
  displayName?: string;

  /**  */
  children?: OrganizationUnit[];

  /**  */
  isDeleted?: boolean;

  /**  */
  deleterUserId?: number;

  /**  */
  deletionTime?: Date;

  /**  */
  lastModificationTime?: Date;

  /**  */
  lastModifierUserId?: number;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  id?: number;
}

export interface AgileOrganizationUnit {
  /**  */
  organizationType?: number;

  /**  */
  logoImageUrl?: string;

  /**  */
  provinceId?: number;

  /**  */
  province?: Province;

  /**  */
  cityId?: number;

  /**  */
  city?: City;

  /**  */
  areaId?: number;

  /**  */
  area?: Area;

  /**  */
  townId?: number;

  /**  */
  town?: Town;

  /**  */
  place?: string;

  /**  */
  principalName?: string;

  /**  */
  mobilePhone?: string;

  /**  */
  emailAddress?: string;

  /**  */
  contactName?: string;

  /**  */
  contactMobilePhone?: string;

  /**  */
  contactEmailAddress?: string;

  /**  */
  creditCode?: string;

  /**  */
  bankAccountName?: string;

  /**  */
  bankName?: string;

  /**  */
  bankAccount?: string;

  /**  */
  receiverName?: string;

  /**  */
  receiverAddress?: string;

  /**  */
  receiverMobile?: string;

  /**  */
  certificateImagePath?: string;

  /**  */
  extensionData?: string;

  /**  */
  registerTime?: Date;

  /**  */
  extensionObject?: object;

  /**  */
  creatorUser?: User;

  /**  */
  auditFlowId?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /**  */
  enableRestartAudit?: boolean;

  /**  */
  partnerInviteId?: number;

  /**  */
  tenantId?: number;

  /**  */
  parent?: OrganizationUnit;

  /**  */
  parentId?: number;

  /**  */
  code?: string;

  /**  */
  displayName?: string;

  /**  */
  children?: OrganizationUnit[];

  /**  */
  isDeleted?: boolean;

  /**  */
  deleterUserId?: number;

  /**  */
  deletionTime?: Date;

  /**  */
  lastModificationTime?: Date;

  /**  */
  lastModifierUserId?: number;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  id?: number;
}

export interface Project {
  /**  */
  displayName?: string;

  /**  */
  startDate?: Date;

  /**  */
  endDate?: Date;

  /**  */
  year?: number;

  /**  */
  description?: string;

  /**  */
  projectTypes?: string;

  /**  */
  titleImagePath?: string;

  /**  */
  isPublicShow?: boolean;

  /**  */
  projectSeriesId?: number;

  /**  */
  projectSeries?: ProjectSeries;

  /**  */
  isInternal?: boolean;

  /**  */
  workflowStep?: number;

  /**  */
  tenantId?: number;

  /**  */
  organizationUnitId?: number;

  /**  */
  organizationUnit?: AgileOrganizationUnit;

  /**  */
  progressReportDate?: Date;

  /**  */
  summaryReportDate?: Date;

  /**  */
  ignored?: boolean;

  /**  */
  projectResult?: string;

  /**  */
  isDeleted?: boolean;

  /**  */
  deleterUserId?: number;

  /**  */
  deletionTime?: Date;

  /**  */
  lastModificationTime?: Date;

  /**  */
  lastModifierUserId?: number;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  id?: number;
}

export interface CapitalExpenseRecordDetail {
  /**  */
  capitalExpenseRecordId?: number;

  /**  */
  capitalExpenseRecord?: CapitalExpenseRecord;

  /**  */
  sequence?: number;

  /**  */
  projectType?: string;

  /**  */
  projectTypeName?: string;

  /**  */
  projectId?: number;

  /**  */
  project?: Project;

  /**  */
  internalProjectBudgetItemId?: string;

  /**  */
  itemName?: string;

  /**  */
  summary?: string;

  /**  */
  money?: number;

  /**  */
  remark?: string;

  /**  */
  isOver?: boolean;

  /**  */
  isDeleted?: boolean;

  /**  */
  deleterUserId?: number;

  /**  */
  deletionTime?: Date;

  /**  */
  lastModificationTime?: Date;

  /**  */
  lastModifierUserId?: number;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  id?: string;
}

export interface CapitalExpenseRecordDtoListResultDto {
  /**  */
  items?: CapitalExpenseRecordDto[];
}

export interface CapitalExpenseRecordDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: CapitalExpenseRecordDto[];
}

export interface CapitalIncomeRecordFromDonationDetailCreateOrUpdateDto {
  /**  */
  id?: string;

  /**  */
  sequence?: number;

  /**  */
  capitalProperty?: CapitalProperty;

  /** 项目Id */
  projectId?: number;

  /**  */
  currencyType?: CurrencyType;

  /** 金额 */
  money?: number;

  /** 备注 */
  remark?: string;
}

export interface CapitalIncomeRecordFromDonationCreateOrUpdateDto {
  /** 捐赠时间 */
  incomeDate?: Date;

  /** 捐赠方名称 */
  donatorName?: string;

  /**  */
  incomeType?: PayType;

  /** 付款账号 */
  payBankAccount?: string;

  /** 收款账号 */
  bankAccount?: string;

  /** 合计收入金额（元） */
  totalIncomeMoney?: number;

  /**  */
  auditFlowId?: string;

  /**  */
  details?: CapitalIncomeRecordFromDonationDetailCreateOrUpdateDto[];

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /**  */
  id?: number;
}

export interface CapitalIncomeRecordFromDonationDetailDto {
  /**  */
  sequence?: number;

  /**  */
  capitalProperty?: CapitalProperty;

  /** 项目Id */
  projectId?: number;

  /**  */
  project?: ProjectDto;

  /**  */
  currencyType?: CurrencyType;

  /** 金额 */
  money?: number;

  /** 备注 */
  remark?: string;

  /**  */
  id?: string;
}

export interface CapitalIncomeRecordFromDonationDto {
  /**  */
  auditFlowId?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /** 捐赠时间 */
  incomeDate?: Date;

  /** 捐赠方名称 */
  donatorName?: string;

  /**  */
  incomeType?: PayType;

  /** 付款账号 */
  payBankAccount?: string;

  /** 收款账号 */
  bankAccount?: string;

  /** 合计收入金额（元） */
  totalIncomeMoney?: number;

  /**  */
  simpleDetail?: CapitalIncomeRecordFromDonationDetailDto;

  /**  */
  details?: CapitalIncomeRecordFromDonationDetailDto[];

  /**  */
  id?: number;
}

export interface CapitalIncomeRecordFromDonationPagedResultRequestDto {
  /**  */
  incomeDate?: Date;

  /**  */
  incomeDateStart?: Date;

  /**  */
  incomeDateEnd?: Date;

  /**  */
  donatorName?: string;

  /**  */
  incomeType?: PayType;

  /**  */
  bankAccount?: string;

  /**  */
  totalIncomeMoney?: number;

  /**  */
  totalIncomeMoneyStart?: number;

  /**  */
  totalIncomeMoneyEnd?: number;

  /**  */
  capitalProperty?: CapitalProperty;

  /**  */
  currencyType?: CurrencyType;

  /** 每页记录数，用作替换MaxResultCount */
  pageSize?: number;

  /**  */
  skipCount?: number;

  /** 页码，用来替换SkipCount */
  pageIndex?: number;

  /**  */
  sorting?: string;

  /**  */
  maxResultCount?: number;
}

export interface CapitalIncomeRecordFromDonationDtoListResultDto {
  /**  */
  items?: CapitalIncomeRecordFromDonationDto[];
}

export interface CapitalIncomeRecordFromDonationDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: CapitalIncomeRecordFromDonationDto[];
}

export interface CapitalIncomeRecordFromOtherDetailCreateOrUpdateDto {
  /**  */
  id?: string;

  /**  */
  sequence?: number;

  /**  */
  capitalProperty?: CapitalProperty;

  /**  */
  incomeCategory?: IncomeCategory;

  /**  */
  currencyType?: CurrencyType;

  /** 金额 */
  money?: number;

  /** 摘要 */
  remark?: string;
}

export interface CapitalIncomeRecordFromOtherCreateOrUpdateDto {
  /** 收入时间 */
  incomeDate?: Date;

  /**  */
  incomeType?: PayType;

  /** 付款账号 */
  payBankAccount?: string;

  /** 收款账号 */
  bankAccount?: string;

  /** 合计收入金额（元） */
  totalIncomeMoney?: number;

  /**  */
  auditFlowId?: string;

  /**  */
  details?: CapitalIncomeRecordFromOtherDetailCreateOrUpdateDto[];

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /**  */
  id?: number;
}

export interface CapitalIncomeRecordFromOtherDetailDto {
  /**  */
  sequence?: number;

  /**  */
  capitalProperty?: CapitalProperty;

  /**  */
  incomeCategory?: IncomeCategory;

  /**  */
  currencyType?: CurrencyType;

  /** 金额 */
  money?: number;

  /** 摘要 */
  remark?: string;

  /**  */
  id?: string;
}

export interface CapitalIncomeRecordFromOtherDto {
  /**  */
  auditFlowId?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /** 收入时间 */
  incomeDate?: Date;

  /**  */
  incomeType?: PayType;

  /** 付款账号 */
  payBankAccount?: string;

  /** 收款账号 */
  bankAccount?: string;

  /** 合计收入金额（元） */
  totalIncomeMoney?: number;

  /**  */
  simpleDetail?: CapitalIncomeRecordFromOtherDetailDto;

  /**  */
  details?: CapitalIncomeRecordFromOtherDetailDto[];

  /**  */
  id?: number;
}

export interface CapitalIncomeRecordFromOtherPagedResultRequestDto {
  /**  */
  incomeDate?: Date;

  /**  */
  incomeDateStart?: Date;

  /**  */
  incomeDateEnd?: Date;

  /**  */
  incomeType?: PayType;

  /**  */
  bankAccount?: string;

  /**  */
  totalIncomeMoney?: number;

  /**  */
  totalIncomeMoneyStart?: number;

  /**  */
  totalIncomeMoneyEnd?: number;

  /**  */
  incomeCategory?: IncomeCategory;

  /**  */
  currencyType?: CurrencyType;

  /** 每页记录数，用作替换MaxResultCount */
  pageSize?: number;

  /**  */
  skipCount?: number;

  /** 页码，用来替换SkipCount */
  pageIndex?: number;

  /**  */
  sorting?: string;

  /**  */
  maxResultCount?: number;
}

export interface CapitalIncomeRecordFromOtherDtoListResultDto {
  /**  */
  items?: CapitalIncomeRecordFromOtherDto[];
}

export interface CapitalIncomeRecordFromOtherDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: CapitalIncomeRecordFromOtherDto[];
}

export interface CityCreateOrUpdateDto {
  /**  */
  cityName?: string;

  /**  */
  provinceId?: number;

  /**  */
  shortCode?: string;

  /**  */
  id?: number;
}

export interface CityDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: CityDto[];
}

export interface CmsAnchorCreateOrUpdateDto {
  /**  */
  name?: string;

  /**  */
  displayName?: string;

  /** 锚点内容的建议宽度 */
  width?: number;

  /** 锚点内容的建议高度 */
  height?: number;

  /**  */
  id?: number;
}

export interface CmsAnchorDto {
  /**  */
  name?: string;

  /**  */
  displayName?: string;

  /** 锚点内容的建议宽度 */
  width?: number;

  /** 锚点内容的建议高度 */
  height?: number;

  /**  */
  id?: number;
}

export interface CmsAnchorDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: CmsAnchorDto[];
}

export interface CmsCategoryCreateOrUpdateDto {
  /**  */
  categoryCode?: string;

  /**  */
  displayName?: string;

  /**  */
  description?: string;

  /**  */
  parentId?: number;

  /**  */
  displayOrder?: number;

  /**  */
  titleImagePath?: string;

  /**  */
  mobileTitleImagePath?: string;

  /**  */
  type?: CmsCategoryType;

  /**  */
  redirectUrl?: string;

  /**  */
  redirectUrlForWeixinMiniProgram?: string;

  /** 破格图片 */
  unconventionalImagePath?: string;

  /** 副标题 */
  contentAlias?: string;

  /** 栏目简介 */
  shortDesc?: string;

  /**  */
  id?: number;
}

export interface CmsCategoryDto {
  /**  */
  categoryCode?: string;

  /**  */
  displayName?: string;

  /**  */
  description?: string;

  /**  */
  parentId?: number;

  /**  */
  displayOrder?: number;

  /**  */
  titleImagePath?: string;

  /**  */
  mobileTitleImagePath?: string;

  /**  */
  type?: CmsCategoryType;

  /**  */
  redirectUrl?: string;

  /**  */
  redirectUrlForWeixinMiniProgram?: string;

  /** 破格图片 */
  unconventionalImagePath?: string;

  /** 副标题 */
  contentAlias?: string;

  /**  */
  shortDesc?: string;

  /**  */
  isDeleted?: boolean;

  /**  */
  deleterUserId?: number;

  /**  */
  deletionTime?: Date;

  /**  */
  lastModificationTime?: Date;

  /**  */
  lastModifierUserId?: number;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  id?: number;
}

export interface CmsCategoryUpdateSortDto {
  /** Id */
  ids?: number[];
}

export interface CmsCategoryDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: CmsCategoryDto[];
}

export interface CmsContentDetailDto {
  /** 文章内容 */
  description?: string;

  /**  */
  savedAttachments?: number[];

  /**  */
  status?: CmsContentStatus;

  /**  */
  title?: string;

  /**  */
  isTop?: boolean;

  /** 当被设置置顶后，呈现的显示顺序 */
  topDisplayOrder?: number;

  /**  */
  titleImageUrl?: string;

  /**  */
  cmsCategory?: CmsCategoryDto;

  /**  */
  cmsCategoryId?: number;

  /**  */
  author?: string;

  /** 发布时间 */
  publishTime?: Date;

  /**  */
  source?: string;

  /**  */
  summary?: string;

  /** 阅读数量 */
  readCount?: number;

  /** 点赞数量 */
  praisedCount?: number;

  /**  */
  customlinks?: string;

  /** 首页滚动 */
  isHomeScrolling?: boolean;

  /**  */
  attachments?: AttachmentDto[];

  /**  */
  isDeleted?: boolean;

  /**  */
  deleterUserId?: number;

  /**  */
  deletionTime?: Date;

  /**  */
  lastModificationTime?: Date;

  /**  */
  lastModifierUserId?: number;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  id?: number;
}

export interface CmsContentCreateOrUpdateDto {
  /**  */
  title?: string;

  /**  */
  summary?: string;

  /**  */
  titleImageUrl?: string;

  /**  */
  cmsCategoryId?: number;

  /**  */
  author?: string;

  /** 发布时间 */
  publishTime?: Date;

  /** 是否直接发布 */
  isPublish?: boolean;

  /** 内容来源 */
  source?: string;

  /**  */
  description?: string;

  /**  */
  savedAttachments?: number[];

  /** 阅读数量 */
  readCount?: number;

  /** 点赞数量 */
  praisedCount?: number;

  /** 基金Id */
  fundID?: number;

  /** 基金项目Id */
  fundProjectID?: number;

  /**  */
  customlinks?: string;

  /**  */
  id?: number;
}

export interface CmsContentDto {
  /**  */
  status?: CmsContentStatus;

  /**  */
  title?: string;

  /**  */
  isTop?: boolean;

  /** 当被设置置顶后，呈现的显示顺序 */
  topDisplayOrder?: number;

  /**  */
  titleImageUrl?: string;

  /**  */
  cmsCategory?: CmsCategoryDto;

  /**  */
  cmsCategoryId?: number;

  /**  */
  author?: string;

  /** 发布时间 */
  publishTime?: Date;

  /**  */
  source?: string;

  /**  */
  summary?: string;

  /** 阅读数量 */
  readCount?: number;

  /** 点赞数量 */
  praisedCount?: number;

  /**  */
  customlinks?: string;

  /** 首页滚动 */
  isHomeScrolling?: boolean;

  /**  */
  attachments?: AttachmentDto[];

  /**  */
  isDeleted?: boolean;

  /**  */
  deleterUserId?: number;

  /**  */
  deletionTime?: Date;

  /**  */
  lastModificationTime?: Date;

  /**  */
  lastModifierUserId?: number;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  id?: number;
}

export interface CmsContentDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: CmsContentDto[];
}

export interface CmsFriendLinkCreateOrUpdateDto {
  /**  */
  name?: string;

  /**  */
  link?: string;

  /** 显示顺序 */
  displayOrder?: number;

  /**  */
  logo?: string;

  /**  */
  id?: number;
}

export interface CmsFriendLinkDto {
  /**  */
  name?: string;

  /**  */
  link?: string;

  /** 显示顺序 */
  displayOrder?: number;

  /**  */
  logo?: string;

  /**  */
  id?: number;
}

export interface CmsFriendLinkDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: CmsFriendLinkDto[];
}

export interface InvoiceInformationDto {
  /** 订单ID */
  orderID?: string;

  /** 付款成功后创建的记录ID或手动新增的收入记录ID */
  recordID?: number;

  /** 抬头 */
  title?: string;

  /** 收件人姓名 */
  name?: string;

  /** 收件人电话 */
  telephone?: string;

  /** 收件人地址 */
  address?: string;

  /**  */
  status?: ValidStatus;

  /** 税号 */
  taxNum?: string;

  /** 发票内容 */
  detailInfo?: string;

  /** 发票金额 */
  taxAmount?: number;

  /**  */
  type?: ElectronicInvoiceType;

  /** 统一社会信用代码 */
  creditCode?: string;

  /** 身份证号码 */
  idNo?: string;

  /** 邮箱 */
  email?: string;

  /**  */
  id?: number;
}

export interface FundIncomeRecordDto {
  /**  */
  organizationUnitId?: number;

  /** 捐赠基金Id */
  fundID?: number;

  /**  */
  fund?: FundMiniDto;

  /** 捐赠项目Id */
  fundProjectID?: number;

  /**  */
  fundProject?: FundProjectMiniDto;

  /** 捐赠产品Id */
  fundProductID?: number;

  /** 捐赠金额 */
  moneyAmount?: number;

  /** 捐赠描述 */
  content?: string;

  /** 捐赠时间 */
  incomeTime?: Date;

  /** 捐赠人姓名 */
  donorName?: string;

  /**  */
  donorType?: DonorType;

  /** 捐赠人电话 */
  donorTelephone?: string;

  /** 捐赠人邮箱 */
  donorEmail?: string;

  /** 捐赠人地址 */
  donorAddress?: string;

  /** 邮政编码 */
  donorPostCode?: string;

  /** 是否需要发票 */
  isNeedInVoice?: boolean;

  /**  */
  incomeType?: IncomeType;

  /** 付款类型(数据字典) */
  paymentType?: string;

  /** 是否线上支付 */
  isOnLinePayment?: boolean;

  /**  */
  currencyType?: CurrencyType;

  /**  */
  status?: ValidStatus;

  /** 留言 */
  leaveMessage?: string;

  /** 已打印次数 */
  printCount?: number;

  /** 是否来自境外 */
  isAbroad?: boolean;

  /** 是否月捐 */
  isMonthDonor?: boolean;

  /** 推荐人 */
  referrer?: string;

  /** 订单号 */
  orderID?: string;

  /** 捐赠意向 */
  donationIntent?: string;

  /**  */
  invoiceInformation?: InvoiceInformationDto;

  /** 创建时间 */
  creationTime?: Date;

  /** 基金名称 */
  fundName?: string;

  /** 基金项目名称 */
  projectName?: string;

  /** 标题图片 */
  titleImagePath?: string;

  /**  */
  donateYear?: string;

  /**  */
  donateMonthAndDay?: string;

  /**  */
  weixinTradeNo?: string;

  /**  */
  isDeleted?: boolean;

  /**  */
  deleterUserId?: number;

  /**  */
  deletionTime?: Date;

  /**  */
  lastModificationTime?: Date;

  /**  */
  lastModifierUserId?: number;

  /**  */
  creatorUserId?: number;

  /**  */
  id?: number;
}

export interface FundIncomeRecordCreateOrUpdateDto {
  /**  */
  savedAttachments?: number[];

  /** 捐赠基金Id */
  fundID?: number;

  /** 捐赠项目Id */
  fundProjectID?: number;

  /** 捐赠产品Id */
  fundProductID?: number;

  /** 捐赠金额 */
  moneyAmount?: number;

  /** 捐赠描述 */
  content?: string;

  /** 捐赠时间 */
  incomeTime?: Date;

  /** 捐赠人姓名 */
  donorName?: string;

  /**  */
  donorType?: DonorType;

  /** 捐赠人电话 */
  donorTelephone?: string;

  /** 捐赠人邮箱 */
  donorEmail?: string;

  /** 捐赠人地址 */
  donorAddress?: string;

  /** 邮政编码 */
  donorPostCode?: string;

  /** 是否需要发票 */
  isNeedInVoice?: boolean;

  /**  */
  incomeType?: IncomeType;

  /** 付款类型(数据字典) */
  paymentType?: string;

  /** 是否线上支付 */
  isOnLinePayment?: boolean;

  /**  */
  currencyType?: CurrencyType;

  /**  */
  status?: ValidStatus;

  /** 留言 */
  leaveMessage?: string;

  /** 已打印次数 */
  printCount?: number;

  /** 是否来自境外 */
  isAbroad?: boolean;

  /** 是否月捐 */
  isMonthDonor?: boolean;

  /** 推荐人 */
  referrer?: string;

  /** 订单号 */
  orderID?: string;

  /** 发票Id */
  invoiceId?: number;

  /** 发票抬头 */
  invoiceTitle?: string;

  /** 发票收件人姓名 */
  invoiceName?: string;

  /** 发票收件人电话 */
  invoiceTelephone?: string;

  /** 发票收件人地址 */
  invoiceAddress?: string;

  /**  */
  type?: ElectronicInvoiceType;

  /** 统一社会信用代码 */
  creditCode?: string;

  /** 身份证号码 */
  idNo?: string;

  /** 邮箱 */
  email?: string;

  /** 线下转账记录ID */
  collectWaterId?: number;

  /**  */
  id?: number;
}

export interface CollectWaterDto {
  /** 单据编号 */
  billNo?: string;

  /** 单据日期 */
  billDate?: Date;

  /** 生效状态 */
  validStatus?: string;

  /** 交易对象类型 */
  tradeObjectType?: string;

  /** 收款交易类型 */
  collectionTradeType?: string;

  /** 付款银行账号 */
  paymentBankAccount?: string;

  /** 收支项目 */
  donateProject?: string;

  /** 结算方式 */
  paymentType?: string;

  /** 摘要 */
  summary?: string;

  /** 组织本币 */
  organizeLocalMoney?: number;

  /** 客户 */
  customer?: string;

  /** 收款原币金额 */
  originalMoney?: number;

  /** 币种 */
  currency?: string;

  /** 单据状态 */
  billStatus?: string;

  /** 收款银行账户 */
  receivingBankAccount?: string;

  /** 组织本币汇率 */
  organizeLocalExchangeRate?: number;

  /**  */
  status?: CollectWaterStatus;

  /** 关联捐赠记录Id */
  fundIncomeRecordId?: number;

  /**  */
  creationTime?: Date;

  /**  */
  id?: number;
}

export interface CollectWaterDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: CollectWaterDto[];
}

export interface CollectWaterCreateOrUpdateDto {
  /** 单据编号 */
  billNo?: string;

  /** 单据日期 */
  billDate?: Date;

  /** 生效状态 */
  validStatus?: string;

  /** 交易对象类型 */
  tradeObjectType?: string;

  /** 收款交易类型 */
  collectionTradeType?: string;

  /** 付款银行账号 */
  paymentBankAccount?: string;

  /** 收支项目 */
  donateProject?: string;

  /** 结算方式 */
  paymentType?: string;

  /** 摘要 */
  summary?: string;

  /** 组织本币 */
  organizeLocalMoney?: number;

  /** 客户 */
  customer?: string;

  /** 收款原币金额 */
  originalMoney?: number;

  /** 币种 */
  currency?: string;

  /** 单据状态 */
  billStatus?: string;

  /** 收款银行账户 */
  receivingBankAccount?: string;

  /** 组织本币汇率 */
  organizeLocalExchangeRate?: number;

  /**  */
  id?: number;
}

export interface ChangeUiThemeInput {
  /**  */
  theme?: string;
}

export interface CustomFormLayoutDetailCreateOrUpdateDto {
  /** 显示顺序 */
  sequence?: number;

  /**  */
  parentId?: string;

  /**  */
  elementName?: string;

  /**  */
  elementContent?: string;

  /**  */
  textAlign?: string;

  /**  */
  elementAttributes?: object;

  /**  */
  id?: string;
}

export interface CustomFieldDataSourceCreateOrUpdateDto {
  /** 绑定的要显示的名称 */
  bindDisplayName?: string;

  /** 绑定的值 */
  bindValue?: string;

  /**  */
  dataSourceType?: CustomFormDataSourceType;

  /**  */
  fieldId?: string;

  /**  */
  dataSource?: string;

  /**  */
  id?: string;
}

export interface CustomFormFieldChooseValueCreateOrUpdateDto {
  /**  */
  displayName?: string;

  /**  */
  id?: string;
}

export interface CustomFormFieldCreateOrUpdateDto {
  /** 是否为动态字段 */
  isDynamic?: boolean;

  /**  */
  fieldName?: string;

  /**  */
  fieldDisplayName?: string;

  /**  */
  placeholder?: string;

  /**  */
  elementType?: string;

  /** 是否必填项 */
  required?: boolean;

  /**  */
  fieldValidators?: string[];

  /** 所在的布局 */
  layoutId?: string;

  /**  */
  dataSource?: CustomFieldDataSourceCreateOrUpdateDto;

  /** 可用来选择的自定义的列表值(仅当DataSource是CustomValues时，才有值) */
  chooseValues?: CustomFormFieldChooseValueCreateOrUpdateDto[];

  /**  */
  id?: string;
}

export interface CustomFormCreateOrUpdateDto {
  /**  */
  hostType?: CustomFormType;

  /** 宿主ID，可为空。当为空时，表示针对某类通用的。 */
  hostId?: string;

  /**  */
  title?: string;

  /**  */
  layout?: CustomFormLayoutDetailCreateOrUpdateDto[];

  /**  */
  fields?: CustomFormFieldCreateOrUpdateDto[];

  /**  */
  id?: number;
}

export interface CustomFormLayoutDetailDto {
  /**  */
  customFormId?: number;

  /** 显示顺序 */
  sequence?: number;

  /**  */
  parentId?: string;

  /**  */
  elementName?: string;

  /**  */
  elementContent?: string;

  /**  */
  textAlign?: string;

  /**  */
  elementAttributes?: object;

  /**  */
  id?: string;
}

export interface CustomFieldDataSourceDto {
  /**  */
  fieldId?: string;

  /** 绑定的要显示的名称 */
  bindDisplayName?: string;

  /** 绑定的值 */
  bindValue?: string;

  /**  */
  dataSourceType?: CustomFormDataSourceType;

  /**  */
  dataSource?: string;

  /**  */
  id?: string;
}

export interface CustomFormFieldChooseValueDto {
  /**  */
  displayName?: string;

  /**  */
  id?: string;
}

export interface CustomFormFieldDto {
  /**  */
  customFormId?: number;

  /** 是否为动态字段 */
  isDynamic?: boolean;

  /**  */
  fieldName?: string;

  /**  */
  fieldDisplayName?: string;

  /**  */
  placeholder?: string;

  /**  */
  elementType?: string;

  /** 是否必填项 */
  required?: boolean;

  /**  */
  fieldValidators?: string[];

  /** 所在的布局 */
  layoutId?: string;

  /**  */
  dataSource?: CustomFieldDataSourceDto;

  /** 可用来选择的自定义的列表值(仅当DataSource是CustomValues时，才有值) */
  chooseValues?: CustomFormFieldChooseValueDto[];

  /**  */
  id?: string;
}

export interface CustomFormDto {
  /**  */
  hostType?: CustomFormType;

  /** 宿主ID，可为空。当为空时，表示针对某类通用的。 */
  hostId?: string;

  /**  */
  title?: string;

  /**  */
  layout?: CustomFormLayoutDetailDto[];

  /**  */
  fields?: CustomFormFieldDto[];

  /**  */
  id?: number;
}

export interface CustomFormCopyInput {
  /** 宿主ID，可为空。当为空时，表示针对某类通用的。 */
  hostId?: string;

  /**  */
  id?: number;
}

export interface CustomFormDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: CustomFormDto[];
}

export interface CycleDonateConfigDto {
  /**  */
  tenantId?: number;

  /**  */
  user?: UserMiniDto;

  /**  */
  invoice?: InvoiceInformationDto;

  /** 用户Id */
  userId?: number;

  /**  */
  donationType?: DonationType;

  /**  */
  donationCycle?: DonationCycle;

  /** 捐赠时间 */
  donationTime?: Date;

  /** 固定捐助天 */
  donorDay?: number;

  /** 捐赠人 */
  displayName?: string;

  /** 推荐人 */
  referrer?: string;

  /**  */
  donorType?: DonorType;

  /** 联系电话 */
  mobileTelephone?: string;

  /** 捐赠金额 */
  donationAmount?: number;

  /** 捐赠留言 */
  leaveMessage?: string;

  /** 订单Id */
  contractOrderId?: string;

  /** 发票Id */
  invoiceId?: number;

  /**  */
  donorItemType?: DonorItemType;

  /** 捐赠意向Id */
  donorItemId?: number;

  /** 捐赠协议序列号(签约银行返回) */
  donorSignSn?: string;

  /** 平台与天付宝确认签约订单号，关联发票订单Id */
  spBillNo?: string;

  /** 国采订单号 */
  listId?: string;

  /** 是否开启 */
  isOpen?: boolean;

  /** 是否已确认 */
  isConfirmed?: boolean;

  /** 是否为临时 */
  isTemp?: boolean;

  /**  */
  userType?: UserType;

  /** 累计次数 */
  cumulativeTimes?: number;

  /** 累计捐款金额 */
  accumulatedDonationAmount?: number;

  /** 捐赠类型 */
  donationTypeName?: string;

  /** 捐赠周期 */
  donationCycleName?: string;

  /**  */
  isDeleted?: boolean;

  /**  */
  deleterUserId?: number;

  /**  */
  deletionTime?: Date;

  /**  */
  lastModificationTime?: Date;

  /**  */
  lastModifierUserId?: number;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  id?: number;
}

export interface CycleDonateConfigDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: CycleDonateConfigDto[];
}

export interface CycleDonateChangeStatusInput {
  /** Id */
  id?: number;

  /**  */
  donorItemType?: DonorItemType;

  /** 捐赠意向Id */
  donorItemId?: number;
}

export interface CycleDonateChangeCycleInput {
  /** Id */
  id?: number;

  /**  */
  donationCycle?: DonationCycle;

  /** 捐赠时间 */
  donationTime?: Date;

  /** 固定捐助天 */
  donorDay?: number;

  /** 捐赠金额 */
  donationAmount?: number;
}

export interface ActivityReportDto {
  /** 月份 */
  months?: number[];

  /** 普通活动 */
  generalActivity?: number[];

  /** 志愿者活动 */
  volunteerActivity?: number[];
}

export interface DashbordPublishedCount {
  /** 发布文章总数 */
  articlePublishedCount?: number;

  /** 发布活动总数 */
  activityPublishedCount?: number;
}

export interface VolunteerReportDto {
  /** 月份 */
  months?: number[];

  /** 总的数量 */
  total?: number[];

  /** 新增的数量 */
  new?: number[];
}

export interface AccessRecordReportDto {
  /**  */
  dateArray?: string[];

  /**  */
  countArray?: number[];
}

export interface TotalTenantAccessRecordReportDto {
  /**  */
  pcData?: AccessRecordReportDto;

  /**  */
  mobileData?: AccessRecordReportDto;

  /**  */
  wechatData?: AccessRecordReportDto;
}

export interface FundRankDto {
  /**  */
  fundName?: string;

  /**  */
  moneyTotal?: number;

  /**  */
  fundID?: number;
}

export interface FundProjectRankDto {
  /**  */
  projectName?: string;

  /**  */
  moneyTotal?: number;

  /**  */
  projectID?: number;
}

export interface ProjectCategoryChartDto {
  /**  */
  name?: string;

  /**  */
  value?: number;
}

export interface DataDictionaryCreateOrUpdateDto {
  /** 租户。 */
  tenantId?: number;

  /** 键名 */
  key?: string;

  /** 显示的名称 */
  displayName?: string;

  /**  */
  parentId?: number;

  /** 显示顺序 */
  displayOrder?: number;

  /**  */
  id?: number;
}

export interface DataDictionarySyncInput {
  /**  */
  id?: number;

  /**  */
  syncMode?: DataDictionarySyncMode;
}

export interface DataDictionaryDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: DataDictionaryDto[];
}

export interface DataPermissionLimitDto {
  /** 宿主ID，可以是具体的id,也可以是`all`这个关键字 */
  hostId?: string;

  /**  */
  hostType?: DataPermissionLimitHostType;

  /**  */
  targetType?: DataPermissionLimitTargetType;

  /** 被授权的对象 */
  targetId?: string;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  id?: string;
}

export interface DataPermissionLimitUpdateDto {
  /** 宿主ID，可以是具体的id,也可以是`all`这个关键字 */
  hostId?: string[];

  /**  */
  targetType?: DataPermissionLimitTargetType;

  /**  */
  hostType?: DataPermissionLimitHostType;

  /**  */
  targetId?: string[];

  /**  */
  id?: string;
}

export interface DepartmentCreateOrUpdateDto {
  /**  */
  name?: string;

  /**  */
  displayName?: string;

  /**  */
  parentId?: number;

  /**  */
  displayOrder?: number;

  /**  */
  id?: number;
}

export interface DepartmentDto {
  /**  */
  name?: string;

  /**  */
  displayName?: string;

  /**  */
  parentId?: number;

  /**  */
  displayOrder?: number;

  /**  */
  organizationUnitId?: number;

  /**  */
  isDeleted?: boolean;

  /**  */
  deleterUserId?: number;

  /**  */
  deletionTime?: Date;

  /**  */
  lastModificationTime?: Date;

  /**  */
  lastModifierUserId?: number;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  id?: number;
}

export interface DepartmentDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: DepartmentDto[];
}

export interface DonatedAmountConfigCreateOrUpdateDto {
  /** 名称 */
  name?: string;

  /** 金额 */
  amount?: number;

  /** 图片地址 */
  imageUrl?: string;

  /**  */
  sourceType?: DonatedAmountConfigSourceType;

  /**  */
  sourceId?: string;

  /**  */
  id?: number;
}

export interface DonatedAmountConfigDto {
  /**  */
  tenantId?: number;

  /** 名称 */
  name?: string;

  /** 金额 */
  amount?: number;

  /** 图片地址 */
  imageUrl?: string;

  /**  */
  sourceType?: DonatedAmountConfigSourceType;

  /** 来源Id */
  sourceId?: string;

  /**  */
  isDeleted?: boolean;

  /**  */
  deleterUserId?: number;

  /**  */
  deletionTime?: Date;

  /**  */
  lastModificationTime?: Date;

  /**  */
  lastModifierUserId?: number;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  id?: number;
}

export interface DonatedAmountConfigDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: DonatedAmountConfigDto[];
}

export interface ElectronicInvoiceCreateOrUpdateDto {
  /**  */
  type?: ElectronicInvoiceType;

  /** 捐赠票据抬头 */
  donationNoteTitle?: string;

  /** 统一社会信用代码 */
  creditCode?: string;

  /** 身份证号码 */
  idNo?: string;

  /** 手机号 */
  mobilePhone?: string;

  /** 邮箱 */
  email?: string;

  /** 善款捐赠明细Id */
  fundIncomeRecordIds?: number[];

  /**  */
  userId?: number;

  /**  */
  id?: number;
}

export interface ElectronicInvoiceDto {
  /**  */
  creatorUser?: UserMiniDto;

  /** 冲红发票Id */
  creditNoteInvoiceId?: number;

  /**  */
  creditNoteInvoice?: ElectronicInvoiceDto;

  /**  */
  type?: ElectronicInvoiceType;

  /** 捐赠票据抬头 */
  donationNoteTitle?: string;

  /** 统一社会信用代码 */
  creditCode?: string;

  /** 身份证号码 */
  idNo?: string;

  /** 手机号 */
  mobilePhone?: string;

  /** 邮箱 */
  email?: string;

  /** 开票金额 */
  invoiceAmount?: number;

  /**  */
  status?: ElectronicInvoiceStatus;

  /** 图片地址 */
  imageUrl?: string;

  /** 是否冲红发票 */
  isCreditNoteInvoice?: boolean;

  /**  */
  isDeleted?: boolean;

  /**  */
  deleterUserId?: number;

  /**  */
  deletionTime?: Date;

  /**  */
  lastModificationTime?: Date;

  /**  */
  lastModifierUserId?: number;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  id?: number;
}

export interface FundIncomeRecordMiniDto {
  /** Id */
  id?: number;

  /** 捐赠意向 */
  donationIntent?: string;

  /** 捐赠金额 */
  moneyAmount?: number;

  /** 捐赠时间 */
  incomeTime?: Date;
}

export interface FundIncomeRecordMiniDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: FundIncomeRecordMiniDto[];
}

export interface UserElectronicInvoiceDto {
  /**  */
  status?: ElectronicInvoiceStatus;

  /** 图片地址 */
  imageUrl?: string;

  /**  */
  fundIncomeRecords?: FundIncomeRecordMiniDto[];

  /**  */
  id?: number;
}

export interface UserElectronicInvoiceDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: UserElectronicInvoiceDto[];
}

export interface ElectronicInvoiceCountGetDto {
  /** 发票总张数 */
  totalNumber?: number;

  /** 已开发票数量 */
  invoicedQuantity?: number;

  /** 可开发票数量 */
  canInvoiceQuantity?: number;
}

export interface ElectronicInvoiceCountPutDto {
  /** 新增发票张数 */
  totalNumber?: number;
}

export interface ElectronicInvoiceConfirmPutDto {
  /** 电子发票Id */
  ids?: number[];
}

export interface ElectronicInvoicePagedResultRequestDto {
  /** 捐赠票据抬头 */
  donationNoteTitle?: string;

  /**  */
  status?: ElectronicInvoiceStatus;

  /** 手机号 */
  mobilePhone?: string;

  /** 邮箱 */
  email?: string;

  /** 每页记录数，用作替换MaxResultCount */
  pageSize?: number;

  /**  */
  skipCount?: number;

  /** 页码，用来替换SkipCount */
  pageIndex?: number;

  /**  */
  sorting?: string;

  /**  */
  maxResultCount?: number;
}

export interface ElectronicInvoiceDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: ElectronicInvoiceDto[];
}

export interface SelectListGroup {
  /**  */
  disabled?: boolean;

  /**  */
  name?: string;
}

export interface SelectListItem {
  /**  */
  disabled?: boolean;

  /**  */
  group?: SelectListGroup;

  /**  */
  selected?: boolean;

  /**  */
  text?: string;

  /**  */
  value?: string;
}

export interface ExternalDueDiligenceRecordCreateOrUpdateDto {
  /**  */
  auditFlowId?: string;

  /**  */
  organizationUnitId?: number;

  /**  */
  projectId?: number;

  /**  */
  dueDiligenceTypeId?: number;

  /**  */
  startDate?: Date;

  /**  */
  endDate?: Date;

  /**  */
  place?: string;

  /**  */
  members?: string;

  /**  */
  visitObjectJson?: string;

  /**  */
  orgInfo?: string;

  /**  */
  projectInfo?: string;

  /**  */
  omnibusOpinion?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /**  */
  cancelRestartAudit?: boolean;

  /**  */
  id?: number;
}

export interface ExternalDueDiligenceRecordDto {
  /**  */
  organizationUnitId?: number;

  /**  */
  projectId?: number;

  /**  */
  dueDiligenceTypeId?: number;

  /**  */
  startDate?: Date;

  /**  */
  endDate?: Date;

  /**  */
  place?: string;

  /**  */
  members?: string;

  /**  */
  visitObjectJson?: string;

  /**  */
  orgInfo?: string;

  /**  */
  projectInfo?: string;

  /**  */
  omnibusOpinion?: string;

  /**  */
  dueDiligenceType?: DataDictionaryDto;

  /**  */
  project?: ProjectDto;

  /**  */
  organizationUnit?: OrganizationUnitShortDto;

  /**  */
  auditFlowId?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /**  */
  cancelRestartAudit?: boolean;

  /**  */
  isDeleted?: boolean;

  /**  */
  deleterUserId?: number;

  /**  */
  deletionTime?: Date;

  /**  */
  lastModificationTime?: Date;

  /**  */
  lastModifierUserId?: number;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  id?: number;
}

export interface ExternalDueDiligenceRecordDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: ExternalDueDiligenceRecordDto[];
}

export interface ExternalDueDiligenceRecordDtoListResultDto {
  /**  */
  items?: ExternalDueDiligenceRecordDto[];
}

export interface ExternalMonthlyPlanDetailCreateOrUpdateDto {
  /**  */
  sequence?: number;

  /** 具体计划Id */
  projectSpecificPlanId?: string;

  /** 具体目标Id */
  projectSpecificGoalId?: string;

  /** 标题 */
  title?: string;

  /** 内容概述 */
  summary?: string;

  /** 开始日期 */
  startDate?: Date;

  /** 结束日期 */
  endDate?: Date;

  /**  */
  provinceId?: number;

  /**  */
  province?: ProvinceDto;

  /**  */
  cityId?: number;

  /**  */
  city?: CityDto;

  /**  */
  areaId?: number;

  /**  */
  area?: AreaDto;

  /**  */
  townId?: number;

  /**  */
  town?: TownDto;

  /** 详细地址 */
  place?: string;

  /** 预计人数 */
  peopleCount?: number;

  /**  */
  id?: number;
}

export interface ExternalMonthlyPlanCreateOrUpdateDto {
  /** 日期 */
  date?: Date;

  /**  */
  projectId?: number;

  /**  */
  details?: ExternalMonthlyPlanDetailCreateOrUpdateDto[];

  /**  */
  auditFlowId?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /**  */
  id?: number;
}

export interface ExternalMonthlyPlanDetailDto {
  /**  */
  sequence?: number;

  /** 具体计划Id */
  projectSpecificPlanId?: string;

  /** 具体目标Id */
  projectSpecificGoalId?: string;

  /** 标题 */
  title?: string;

  /** 内容概述 */
  summary?: string;

  /** 开始日期 */
  startDate?: Date;

  /** 结束日期 */
  endDate?: Date;

  /**  */
  provinceId?: number;

  /**  */
  province?: ProvinceDto;

  /**  */
  cityId?: number;

  /**  */
  city?: CityDto;

  /**  */
  areaId?: number;

  /**  */
  area?: AreaDto;

  /**  */
  townId?: number;

  /**  */
  town?: TownDto;

  /** 详细地址 */
  place?: string;

  /** 预计人数 */
  peopleCount?: number;

  /**  */
  id?: number;
}

export interface ExternalMonthlyPlanDto {
  /** 日期 */
  date?: Date;

  /**  */
  year?: number;

  /**  */
  month?: number;

  /**  */
  details?: ExternalMonthlyPlanDetailDto[];

  /**  */
  project?: ProjectDto;

  /**  */
  auditFlowId?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /**  */
  id?: number;
}

export interface ExternalMonthlyPlanDtoListResultDto {
  /**  */
  items?: ExternalMonthlyPlanDto[];
}

export interface ExternalMonthlyPlanDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: ExternalMonthlyPlanDto[];
}

export interface ExternalMonthlySummarizeDetailDto {
  /**  */
  sequence?: number;

  /** 具体计划Id */
  projectSpecificPlanId?: string;

  /** 具体目标Id */
  projectSpecificGoalId?: string;

  /** 标题 */
  title?: string;

  /** 开始日期 */
  startDate?: Date;

  /** 结束日期 */
  endDate?: Date;

  /**  */
  completeStatus?: ProjectMonthlyPlanCompleteStatus;

  /** 内容概述 */
  summary?: string;

  /**  */
  provinceId?: number;

  /**  */
  province?: ProvinceDto;

  /**  */
  cityId?: number;

  /**  */
  city?: CityDto;

  /**  */
  areaId?: number;

  /**  */
  area?: AreaDto;

  /**  */
  townId?: number;

  /**  */
  town?: TownDto;

  /** 地点 */
  place?: string;

  /** 实到人数 */
  peopleCount?: number;

  /** 原因\/问题 */
  reason?: string;

  /** 对应策略 */
  tactics?: string;

  /**  */
  savedAttachments?: number[];

  /**  */
  externalMonthlyPlanDetailId?: number;

  /**  */
  id?: number;
}

export interface ExternalMonthlySummarizeDto {
  /** 日期 */
  date?: Date;

  /**  */
  year?: number;

  /**  */
  month?: number;

  /**  */
  details?: ExternalMonthlySummarizeDetailDto[];

  /** 面临的问题 */
  problem?: string;

  /** 所需资源 */
  needsResource?: string;

  /**  */
  project?: ProjectDto;

  /** 对应月计划Id */
  externalMonthlyPlanId?: number;

  /**  */
  externalMonthlyPlan?: ExternalMonthlyPlanDto;

  /**  */
  auditFlowId?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /**  */
  id?: number;
}

export interface ExternalMonthlySummarizeDetailCreateOrUpdateDto {
  /**  */
  sequence?: number;

  /** 具体计划Id */
  projectSpecificPlanId?: string;

  /** 具体目标Id */
  projectSpecificGoalId?: string;

  /** 标题 */
  title?: string;

  /** 开始日期 */
  startDate?: Date;

  /** 结束日期 */
  endDate?: Date;

  /**  */
  completeStatus?: ProjectMonthlyPlanCompleteStatus;

  /** 内容概述 */
  summary?: string;

  /**  */
  provinceId?: number;

  /**  */
  cityId?: number;

  /**  */
  areaId?: number;

  /**  */
  townId?: number;

  /** 地点 */
  place?: string;

  /** 实到人数 */
  peopleCount?: number;

  /** 原因\/问题 */
  reason?: string;

  /** 对应策略 */
  tactics?: string;

  /**  */
  projectId?: number;

  /**  */
  savedAttachments?: number[];

  /**  */
  externalMonthlyPlanDetailId?: number;

  /**  */
  id?: number;
}

export interface ExternalMonthlySummarizeCreateOrUpdateDto {
  /**  */
  projectId?: number;

  /** 日期 */
  date?: Date;

  /**  */
  details?: ExternalMonthlySummarizeDetailCreateOrUpdateDto[];

  /**  */
  externalMonthlyPlanId?: number;

  /** 面临的问题 */
  problem?: string;

  /** 所需资源 */
  needsResource?: string;

  /**  */
  savedAttachments?: number[];

  /**  */
  auditFlowId?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /**  */
  id?: number;
}

export interface ExternalMonthlySummarizeDtoListResultDto {
  /**  */
  items?: ExternalMonthlySummarizeDto[];
}

export interface ExternalMonthlySummarizeDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: ExternalMonthlySummarizeDto[];
}

export interface ProjectSpecificGoalDto {
  /** 序列（顺序） */
  sequence?: number;

  /**  */
  projectId?: number;

  /** 项目成效（具体目标） */
  effect?: string;

  /** 具体指标（具体目标描述） */
  norm?: string;

  /** 验证条件 */
  validateCondition?: string;

  /**  */
  id?: string;
}

export interface ExternalProjectSpecificPlanDto {
  /** 序列（顺序） */
  sequence?: number;

  /**  */
  projectId?: number;

  /**  */
  projectSpecificGoalId?: string;

  /** 标题 */
  title?: string;

  /** 具体内容 */
  summary?: string;

  /** 开始年月 */
  startDate?: Date;

  /** 结束年月 */
  endDate?: Date;

  /** 活动频次 */
  activityCount?: number;

  /** 参与人数 */
  peopleCount?: number;

  /** 预计产出 */
  output?: string;

  /**  */
  id?: string;
}

export interface ProjectRiskPlanDto {
  /** 序列（顺序） */
  sequence?: number;

  /**  */
  projectId?: number;

  /** 潜在风险 */
  risk?: string;

  /** 应对策略 */
  copingStrategy?: string;

  /**  */
  id?: string;
}

export interface ProjectMemberItemDto {
  /** 序列（顺序） */
  sequence?: number;

  /**  */
  projectId?: number;

  /** 姓名 */
  name?: string;

  /** 性别 */
  sex?: string;

  /** 年龄 */
  age?: number;

  /** 学历 */
  educationTypeId?: number;

  /**  */
  educationType?: DataDictionaryDto;

  /** 所学专业 */
  major?: string;

  /** 职业资质 */
  qualifications?: string;

  /** 团队分工 */
  projectRole?: string;

  /** 投入的时间精力比（%） */
  inputPercent?: number;

  /**  */
  id?: string;
}

export interface ExternalProjectBudgetItemDto {
  /**  */
  projectId?: number;

  /** 序列(显示顺序） */
  sequence?: number;

  /**  */
  projectBudgetCategory?: ProjectBudgetCategory;

  /**  */
  projectBudgetType?: ProjectBudgetType;

  /** 子项目内容（三级科目） */
  itemName?: string;

  /** 具体计划Id */
  projectSpecificPlanId?: string;

  /** 具体目标Id */
  projectSpecificGoalId?: string;

  /** 具体内容 */
  content?: string;

  /** 单价（元） */
  unitPrice?: number;

  /** 数量 */
  number?: number;

  /** 单位 */
  unit?: string;

  /** 预算报价 */
  budgetQuotation?: number;

  /**  */
  projectBudgetCapitalSource?: ProjectBudgetCapitalSource;

  /**  */
  id?: string;
}

export interface ExternalProjectCreateOrUpdateDto {
  /** 项目名称 */
  displayName?: string;

  /** 项目概述 */
  summary?: string;

  /** 项目关注的问题描述，以及对问题原因的分析 */
  problemDescription?: string;

  /** 项目实施地域的情况及服务对象的总体情况 */
  areaDescription?: string;

  /** 针对该问题，其他机构或政府已经采取的服务、政策及经验 */
  otherExperience?: string;

  /** 实施地点 */
  place?: string;

  /** 项目开始日期 */
  startDate?: Date;

  /** 项目结束日期 */
  endDate?: Date;

  /** 直接受益对象 */
  benefitObjectOfDirect?: string;

  /** 间接受益对象 */
  benefitObjectOfIndirect?: string;

  /** 总目标 */
  objectiveOfMain?: string;

  /** 项目成效及成功指标 */
  effects?: ProjectSpecificGoalDto[];

  /** 具体计划 */
  specificPlans?: ExternalProjectSpecificPlanDto[];

  /** 项目风险预案 */
  riskPlans?: ProjectRiskPlanDto[];

  /** 项目团队信息 */
  projectMemberItems?: ProjectMemberItemDto[];

  /** 项目负责人简介 */
  projectMangerInfo?: string;

  /** 项目预算明细 */
  budgetItems?: ExternalProjectBudgetItemDto[];

  /** 向基金会申请资金 */
  applyMoney?: number;

  /** 自筹资金 */
  selfMoney?: number;

  /** 其他来源资金 */
  otherMoney?: number;

  /** 总预算 = 向基金会申请资金+自筹资金+其他来源资金 */
  totalMoney?: number;

  /**  */
  savedAttachments?: number[];

  /**  */
  auditFlowId?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /**  */
  id?: number;
}

export interface ExternalProjectDto {
  /**  */
  projectId?: number;

  /**  */
  project?: ProjectDto;

  /** 项目开始日期 */
  startDate?: Date;

  /** 项目结束日期 */
  endDate?: Date;

  /** 实施地点 */
  place?: string;

  /** 总预算 */
  totalMoney?: number;

  /**  */
  auditFlowId?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /**  */
  id?: number;
}

export interface ExternalProjectDetailDto {
  /**  */
  organizationUnitId?: number;

  /**  */
  organizationUnit?: OrganizationUnitShortDto;

  /**  */
  projectId?: number;

  /**  */
  project?: ProjectDto;

  /**  */
  projectTypes?: string;

  /** 项目名称 */
  displayName?: string;

  /** 项目概述 */
  summary?: string;

  /** 项目关注的问题描述，以及对问题原因的分析 */
  problemDescription?: string;

  /** 项目实施地域的情况及服务对象的总体情况 */
  areaDescription?: string;

  /** 针对该问题，其他机构或政府已经采取的服务、政策及经验 */
  otherExperience?: string;

  /** 实施地点 */
  place?: string;

  /** 项目开始日期 */
  startDate?: Date;

  /** 项目结束日期 */
  endDate?: Date;

  /** 直接受益对象 */
  benefitObjectOfDirect?: string;

  /** 间接受益对象 */
  benefitObjectOfIndirect?: string;

  /** 总目标 */
  objectiveOfMain?: string;

  /** 项目成效及成功指标 */
  effects?: ProjectSpecificGoalDto[];

  /** 具体计划 */
  specificPlans?: ExternalProjectSpecificPlanDto[];

  /** 项目风险预案 */
  riskPlans?: ProjectRiskPlanDto[];

  /** 项目团队信息 */
  projectMemberItems?: ProjectMemberItemDto[];

  /** 项目负责人简介 */
  projectMangerInfo?: string;

  /** 项目预算明细 */
  budgetItems?: ExternalProjectBudgetItemDto[];

  /** 向基金会申请资金 */
  applyMoney?: number;

  /** 自筹资金 */
  selfMoney?: number;

  /** 其他来源资金 */
  otherMoney?: number;

  /** 总预算 = 向基金会申请资金+自筹资金+其他来源资金 */
  totalMoney?: number;

  /**  */
  savedAttachments?: number[];

  /**  */
  auditFlowId?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /**  */
  id?: number;
}

export interface ProjectMonthlySummaizeDetailsDto {
  /** 活动照片 */
  attachment?: AttachmentDto[];

  /** 活动标题 */
  title?: string;

  /** 开始日期 */
  startDate?: Date;

  /** 结束日期 */
  endDate?: Date;

  /** 执行概述 */
  summary?: string;
}

export interface ProjectMonthlySummaizeDetailsDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: ProjectMonthlySummaizeDetailsDto[];
}

export interface UpdateExternalProjectBudgetItemsDto {
  /** 项目预算明细 */
  budgetItems?: ExternalProjectBudgetItemDto[];

  /**  */
  id?: number;
}

export interface ExternalProjectDtoListResultDto {
  /**  */
  items?: ExternalProjectDto[];
}

export interface ExternalProjectDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: ExternalProjectDto[];
}

export interface ExternalProjectChangeApplyCreateOrUpdateDto {
  /**  */
  projectId?: number;

  /**  */
  sourceExternalProjectId?: number;

  /**  */
  targetExternalProjectId?: number;

  /** 变更类别,多选，数据字典(经费变更\/项目延期\/内容变更\/目标人群变更\/其他变) */
  changeTypes?: string;

  /**  */
  savedChangeTypes?: string[];

  /** 变更时间 */
  changeDate?: Date;

  /** 变更原因 */
  changeReason?: string;

  /** 变更内容 */
  changeContent?: string;

  /**  */
  auditFlowId?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /**  */
  id?: number;
}

export interface ExternalProjectChangeApplyDto {
  /**  */
  projectId?: number;

  /**  */
  project?: ProjectDto;

  /**  */
  sourceExternalProjectId?: number;

  /**  */
  sourceExternalProject?: ExternalProjectDto;

  /**  */
  targetExternalProjectId?: number;

  /**  */
  targetExternalProject?: ExternalProjectDto;

  /** 变更类别,多选，数据字典(经费变更\/项目延期\/内容变更\/目标人群变更\/其他变) */
  changeTypes?: string;

  /**  */
  savedChangeTypes?: string[];

  /** 变更时间 */
  changeDate?: Date;

  /** 变更原因 */
  changeReason?: string;

  /** 变更内容 */
  changeContent?: string;

  /**  */
  organizationUnit?: OrganizationUnit;

  /**  */
  auditFlowId?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /**  */
  id?: number;
}

export interface ExternalProjectChangeApplyDtoListResultDto {
  /**  */
  items?: ExternalProjectChangeApplyDto[];
}

export interface ExternalProjectChangeApplyDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: ExternalProjectChangeApplyDto[];
}

export interface ExternalProjectActualBudgetItemDto {
  /**  */
  projectId?: number;

  /**  */
  sequence?: number;

  /**  */
  projectBudgetCategory?: ProjectBudgetCategory;

  /**  */
  projectBudgetType?: ProjectBudgetType;

  /** 子项目内容（三级科目） */
  itemName?: string;

  /** 具体计划Id */
  projectSpecificPlanId?: string;

  /** 具体目标Id */
  projectSpecificGoalId?: string;

  /** 具体内容 */
  content?: string;

  /** 单价（元） */
  unitPrice?: number;

  /** 数量 */
  number?: number;

  /** 单位 */
  unit?: string;

  /** 预算报价 */
  budgetQuotation?: number;

  /**  */
  projectBudgetCapitalSource?: ProjectBudgetCapitalSource;

  /** 计划预算明细项Id */
  budgetItemId?: number;

  /** 实际开支 */
  actualBudget?: number;

  /** 差额 */
  balance?: number;

  /** 实际占预算比例 */
  actualPercent?: number;

  /** 差异原因说明 */
  reason?: string;

  /**  */
  id?: string;
}

export interface CloseReportDetailDto {
  /**  */
  project?: ProjectDto;

  /**  */
  organizationUnit?: OrganizationUnitShortDto;

  /**  */
  externalProjectActualBudgetItems?: ExternalProjectActualBudgetItemDto[];

  /**  */
  projectId?: number;

  /** 项目经费 */
  totalBudget?: number;

  /** 项目负责人 */
  projectManager?: string;

  /** 评估日期 */
  assessmentDate?: Date;

  /** 评估地点 */
  place?: string;

  /** 主要负责人员 */
  projectTeams?: string;

  /** 项目开始日期 */
  startDate?: Date;

  /** 项目结束日期 */
  endDate?: Date;

  /** 服务对象 */
  serviceObjects?: string;

  /** 服务区域 */
  serviceArea?: string;

  /** 评估形式 */
  assessmentType?: string;

  /** 1.	项目提出的问题，以及对问题真实性的验证 */
  problemsCheck?: string;

  /** 2.	回顾项目目标和执行计划 */
  implementReview?: string;

  /** 3.	初期该领域\/人群的状况，以及目前的状况 */
  situationCheck?: string;

  /** 4.	资助行为如何回应了差距\/问题 */
  subsidize?: string;

  /** 5.	被资助方、受益人和其他参与方的访谈情况 */
  interviewCheck?: string;

  /** 1.	总结的成功经验和模式 */
  experience?: string;

  /** 2.	出现的问题及解决策略 */
  problemsSolution?: string;

  /** 3.	成功\/典型案例 */
  successfulCase?: string;

  /** 1.	项目资金使用基本情况 */
  fundsUsage?: string;

  /** 2.	问题及建议 */
  financeProblems?: string;

  /**  */
  savedAttachments?: number[];

  /**  */
  auditFlowId?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /**  */
  id?: number;
}

export interface CloseReportCreateOrUpdateDto {
  /**  */
  projectId?: number;

  /** 项目经费 */
  totalBudget?: number;

  /** 项目负责人 */
  projectManager?: string;

  /** 评估日期 */
  assessmentDate?: Date;

  /** 评估地点 */
  place?: string;

  /** 主要负责人员 */
  projectTeams?: string;

  /** 项目开始日期 */
  startDate?: Date;

  /** 项目结束日期 */
  endDate?: Date;

  /** 服务对象 */
  serviceObjects?: string;

  /** 服务区域 */
  serviceArea?: string;

  /** 评估形式 */
  assessmentType?: string;

  /** 1.	项目提出的问题，以及对问题真实性的验证 */
  problemsCheck?: string;

  /** 2.	回顾项目目标和执行计划 */
  implementReview?: string;

  /** 3.	初期该领域\/人群的状况，以及目前的状况 */
  situationCheck?: string;

  /** 4.	资助行为如何回应了差距\/问题 */
  subsidize?: string;

  /** 5.	被资助方、受益人和其他参与方的访谈情况 */
  interviewCheck?: string;

  /** 1.	总结的成功经验和模式 */
  experience?: string;

  /** 2.	出现的问题及解决策略 */
  problemsSolution?: string;

  /** 3.	成功\/典型案例 */
  successfulCase?: string;

  /** 1.	项目资金使用基本情况 */
  fundsUsage?: string;

  /** 2.	问题及建议 */
  financeProblems?: string;

  /**  */
  savedAttachments?: number[];

  /**  */
  auditFlowId?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /**  */
  id?: number;
}

export interface CloseReportDto {
  /**  */
  project?: ProjectDto;

  /**  */
  organizationUnit?: OrganizationUnitShortDto;

  /** 项目经费 */
  totalBudget?: number;

  /** 项目负责人 */
  projectManager?: string;

  /** 评估日期 */
  assessmentDate?: Date;

  /** 评估地点 */
  place?: string;

  /** 主要负责人员 */
  projectTeams?: string;

  /** 项目开始日期 */
  startDate?: Date;

  /** 项目结束日期 */
  endDate?: Date;

  /** 服务对象 */
  serviceObjects?: string;

  /** 服务区域 */
  serviceArea?: string;

  /** 评估形式 */
  assessmentType?: string;

  /** 1.	项目提出的问题，以及对问题真实性的验证 */
  problemsCheck?: string;

  /** 2.	回顾项目目标和执行计划 */
  implementReview?: string;

  /** 3.	初期该领域\/人群的状况，以及目前的状况 */
  situationCheck?: string;

  /** 4.	资助行为如何回应了差距\/问题 */
  subsidize?: string;

  /** 5.	被资助方、受益人和其他参与方的访谈情况 */
  interviewCheck?: string;

  /** 1.	总结的成功经验和模式 */
  experience?: string;

  /** 2.	出现的问题及解决策略 */
  problemsSolution?: string;

  /** 3.	成功\/典型案例 */
  successfulCase?: string;

  /** 1.	项目资金使用基本情况 */
  fundsUsage?: string;

  /** 2.	问题及建议 */
  financeProblems?: string;

  /**  */
  auditFlowId?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /**  */
  id?: number;
}

export interface CloseReportDtoListResultDto {
  /**  */
  items?: CloseReportDto[];
}

export interface CloseReportDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: CloseReportDto[];
}

export interface ExternalProjectIntentionCreateOrUpdateDto {
  /**  */
  projectId?: number;

  /**  */
  displayName?: string;

  /** 项目开始日期 */
  startDate?: Date;

  /** 项目结束日期 */
  endDate?: Date;

  /** 拟落地的区域 */
  place?: string;

  /** 受益人群 */
  benefitObject?: string;

  /** 拟申请项目概述 */
  summary?: string;

  /** 拟解决的问题与拟达到的目标 */
  solvedProblem?: string;

  /** 拟采取的策略\/开展的活动 */
  activityPlan?: string;

  /** 项目初步预算 */
  budgetPlan?: string;

  /** 执行机构过往经验 */
  executeExperience?: string;

  /**  */
  savedAttachments?: number[];

  /**  */
  auditFlowId?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /**  */
  id?: number;
}

export interface ExternalProjectIntentionDto {
  /**  */
  projectId?: number;

  /**  */
  project?: ProjectDto;

  /**  */
  organizationUnit?: OrganizationUnitShortDto;

  /** 项目开始日期 */
  startDate?: Date;

  /** 项目结束日期 */
  endDate?: Date;

  /** 拟落地的区域 */
  place?: string;

  /**  */
  auditFlowId?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /**  */
  id?: number;
}

export interface ExternalProjectIntentionDtoListResultDto {
  /**  */
  items?: ExternalProjectIntentionDto[];
}

export interface ExternalProjectIntentionDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: ExternalProjectIntentionDto[];
}

export interface ExternalProjectPhaseItemDto {
  /**  */
  stage?: WorkflowOfProjectByExternal;

  /** 节点名称 */
  name?: string;

  /**  */
  status?: ProjectPhaseStatus;

  /** 跳转链接 */
  redirectUrl?: string[];
}

export interface ProjectMonthItemDto {
  /** 年份 */
  year?: number;

  /** 月份 */
  month?: number;

  /**  */
  status?: ProjectPhaseStatus;
}

export interface AttachmentDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: AttachmentDto[];
}

export interface ExternalProjectProcessMonitoringCreateOrUpdateDto {
  /**  */
  projectId?: number;

  /** 开始日期 */
  startDate?: Date;

  /** 结束日期 */
  endDate?: Date;

  /**  */
  provinceId?: number;

  /**  */
  provinceName?: string;

  /**  */
  cityId?: number;

  /**  */
  cityName?: string;

  /**  */
  areaId?: number;

  /**  */
  areaName?: string;

  /**  */
  townId?: number;

  /**  */
  townName?: string;

  /** 仅展示 */
  projectName?: string;

  /** 地点 */
  place?: string;

  /** 监测方式 */
  monitoringType?: string;

  /** 监测主题 */
  title?: string;

  /** 监测过程 */
  monitoringProcess?: string;

  /** 观察发现 */
  observe?: string;

  /** 给对方的反馈 */
  feedback?: string;

  /**  */
  savedAttachments?: number[];

  /**  */
  auditFlowId?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /**  */
  id?: number;
}

export interface ExternalProjectProcessMonitoringDto {
  /**  */
  projectId?: number;

  /**  */
  project?: ProjectDto;

  /** 开始日期 */
  startDate?: Date;

  /** 结束日期 */
  endDate?: Date;

  /**  */
  provinceId?: number;

  /**  */
  province?: ProvinceDto;

  /**  */
  cityId?: number;

  /**  */
  city?: CityDto;

  /**  */
  areaId?: number;

  /**  */
  area?: AreaDto;

  /**  */
  townId?: number;

  /**  */
  town?: TownDto;

  /** 地点 */
  place?: string;

  /** 监测方式 */
  monitoringType?: string;

  /** 监测主题 */
  title?: string;

  /**  */
  monitoringProcess?: string;

  /**  */
  observe?: string;

  /**  */
  feedback?: string;

  /**  */
  auditFlowId?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /**  */
  id?: number;
}

export interface ExternalProjectProcessMonitoringDtoListResultDto {
  /**  */
  items?: ExternalProjectProcessMonitoringDto[];
}

export interface ExternalProjectProcessMonitoringDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: ExternalProjectProcessMonitoringDto[];
}

export interface ProgressReportDetailDto {
  /**  */
  project?: ProjectDto;

  /**  */
  organizationUnit?: OrganizationUnitShortDto;

  /**  */
  projectId?: number;

  /** 提交报告日期 */
  reportDate?: Date;

  /** 项目执行团队及人员分工Json */
  projectMemberJson?: string;

  /** 指标完成情况Json */
  projectSpecificGoalJson?: string;

  /** 介入方式 */
  interventions?: string;

  /** 项目开展情况 */
  implementStatus?: string;

  /** 项目实施效果 */
  implementEffect?: string;

  /** 项目宣传情况 */
  publicityStatus?: string;

  /** 项目实施对组织自身的影响 */
  selfInfluence?: string;

  /** 项目创新性及可推广性 */
  innovation?: string;

  /** 项目经费使用情况 */
  budgetUsedJson?: string;

  /** 项目执行中的问题和建议 */
  problemsJson?: string;

  /** 下半年计划 */
  nextPlan?: string;

  /**  */
  savedAttachments?: number[];

  /**  */
  auditFlowId?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /**  */
  id?: number;
}

export interface ProgressReportCreateOrUpdateDto {
  /**  */
  projectId?: number;

  /** 提交报告日期 */
  reportDate?: Date;

  /** 项目执行团队及人员分工Json */
  projectMemberJson?: string;

  /** 指标完成情况Json */
  projectSpecificGoalJson?: string;

  /** 介入方式 */
  interventions?: string;

  /** 项目开展情况 */
  implementStatus?: string;

  /** 项目实施效果 */
  implementEffect?: string;

  /** 项目宣传情况 */
  publicityStatus?: string;

  /** 项目实施对组织自身的影响 */
  selfInfluence?: string;

  /** 项目创新性及可推广性 */
  innovation?: string;

  /** 项目经费使用情况 */
  budgetUsedJson?: string;

  /** 项目执行中的问题和建议 */
  problemsJson?: string;

  /** 下半年计划 */
  nextPlan?: string;

  /**  */
  savedAttachments?: number[];

  /**  */
  auditFlowId?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /**  */
  id?: number;
}

export interface ProgressReportDto {
  /**  */
  projectId?: number;

  /**  */
  project?: ProjectDto;

  /**  */
  organizationUnitId?: number;

  /**  */
  organizationUnit?: OrganizationUnitShortDto;

  /** 提交报告日期 */
  reportDate?: Date;

  /**  */
  auditFlowId?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /**  */
  id?: number;
}

export interface ProgressReportDtoListResultDto {
  /**  */
  items?: ProgressReportDto[];
}

export interface ProgressReportDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: ProgressReportDto[];
}

export interface LineChartDto {
  /** 年份 */
  years?: number[];

  /** 项目数量 */
  projectCounts?: number[];

  /** 预算金额 */
  totalBudgets?: number[];

  /** 实际支出 */
  actualExpenses?: number[];

  /** 受益人次 */
  actualBeneficiaryCounts?: number[];

  /** 活动场次 */
  activityCounts?: number[];

  /** 覆盖区域数量 */
  townCounts?: number[];
}

export interface ExternalMicrocosmicDto {
  /** 项目名称 */
  projectName?: string;

  /** 开始时间 */
  startDate?: string;

  /** 结束时间 */
  endDate?: string;

  /**  */
  status?: WorkflowOfProjectByExternal;

  /** 活动场次 */
  activityCount?: number;

  /** 受益人次 */
  actualBeneficiaryCount?: number;

  /** 覆盖区域数量 */
  townCount?: number;

  /** 预算金额 */
  budget?: number;

  /** 实际支出 */
  actualExpenses?: number;
}

export interface ExternalMicrocosmicDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: ExternalMicrocosmicDto[];
}

export interface ProjectOfNotCompleteDto {
  /**  */
  startDate?: string;

  /**  */
  endDate?: string;

  /**  */
  projectName?: string;

  /** 姓名 */
  name?: string;

  /**  */
  mobilePhone?: string;

  /**  */
  email?: string;

  /**  */
  projectId?: number;

  /** 内部或外部的对应ID */
  hostId?: number;

  /**  */
  user?: User;
}

export interface ProjectOfNotCompleteDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: ProjectOfNotCompleteDto[];
}

export interface SummaryReportDetailDto {
  /**  */
  project?: ProjectDto;

  /**  */
  organizationUnit?: OrganizationUnitShortDto;

  /**  */
  projectId?: number;

  /** 提交报告日期 */
  reportDate?: Date;

  /** 项目执行团队及人员分工Json */
  projectMemberJson?: string;

  /** 机构内部的决策机制 */
  decisionMechanism?: string;

  /** 合作机构Json */
  partnersJson?: string;

  /** 指标完成情况Json */
  projectSpecificGoalJson?: string;

  /** 介入方式 */
  interventions?: string;

  /** 活动开展情况 */
  implementStatus?: string;

  /** 项目活动完成情况对照表 */
  implementStatusJson?: string;

  /** 项目经费使用情况 */
  budgetUsedJson?: string;

  /** 服务对象反馈 */
  serviceObjectsFeedback?: string;

  /** 相关方反馈 */
  partnersFeedback?: string;

  /** 社会影响 */
  socialImpact?: string;

  /** 项目成果\/产出 */
  output?: string;

  /** 对执行机构的作用 */
  effectForSelf?: string;

  /** 对领域\/行业的作用 */
  effectForIndustry?: string;

  /** 项目执行中的问题和建议 */
  problemsJson?: string;

  /** 整个项目执行的反思 */
  executeIntrospection?: string;

  /** 对基金会的建议和反馈 */
  feedbackForFoundation?: string;

  /**  */
  externalProjectActualBudgetItems?: ExternalProjectActualBudgetItemDto[];

  /** 实际开支 */
  actualBudget?: number;

  /** 差额 */
  balance?: number;

  /** 实际占预算比例 */
  actualPercent?: number;

  /**  */
  savedAttachments?: number[];

  /**  */
  auditFlowId?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /**  */
  id?: number;
}

export interface SummaryReportCreateOrUpdateDto {
  /**  */
  projectId?: number;

  /** 提交报告日期 */
  reportDate?: Date;

  /** 项目执行团队及人员分工Json */
  projectMemberJson?: string;

  /** 机构内部的决策机制 */
  decisionMechanism?: string;

  /** 合作机构Json */
  partnersJson?: string;

  /** 指标完成情况Json */
  projectSpecificGoalJson?: string;

  /** 介入方式 */
  interventions?: string;

  /** 活动开展情况 */
  implementStatus?: string;

  /** 项目活动完成情况对照表 */
  implementStatusJson?: string;

  /** 项目经费使用情况 */
  budgetUsedJson?: string;

  /** 服务对象反馈 */
  serviceObjectsFeedback?: string;

  /** 相关方反馈 */
  partnersFeedback?: string;

  /** 社会影响 */
  socialImpact?: string;

  /** 项目成果\/产出 */
  output?: string;

  /** 对执行机构的作用 */
  effectForSelf?: string;

  /** 对领域\/行业的作用 */
  effectForIndustry?: string;

  /** 项目执行中的问题和建议 */
  problemsJson?: string;

  /** 整个项目执行的反思 */
  executeIntrospection?: string;

  /** 对基金会的建议和反馈 */
  feedbackForFoundation?: string;

  /**  */
  externalProjectActualBudgetItems?: ExternalProjectActualBudgetItemDto[];

  /** 实际开支 */
  actualBudget?: number;

  /** 差额 */
  balance?: number;

  /** 实际占预算比例 */
  actualPercent?: number;

  /**  */
  savedAttachments?: number[];

  /**  */
  auditFlowId?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /**  */
  id?: number;
}

export interface SummaryReportDto {
  /**  */
  projectId?: number;

  /**  */
  project?: ProjectDto;

  /**  */
  organizationUnitId?: number;

  /**  */
  organizationUnit?: OrganizationUnitShortDto;

  /** 提交报告日期 */
  reportDate?: Date;

  /**  */
  auditFlowId?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /**  */
  id?: number;
}

export interface SummaryReportDtoListResultDto {
  /**  */
  items?: SummaryReportDto[];
}

export interface SummaryReportDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: SummaryReportDto[];
}

export interface FeedbackCreateOrUpdateDto {
  /** 标题 */
  title?: string;

  /** 内容 */
  content?: string;

  /** 联系方式 */
  contactType?: string;

  /** 反馈类型Id */
  typeCodeId?: number;

  /**  */
  sourceType?: FeedbackSourceType;

  /**  */
  id?: number;
}

export interface FeedbackDto {
  /**  */
  creatorUser?: UserMiniDto;

  /**  */
  typeCode?: DataDictionaryDto;

  /** 反馈类型Id */
  typeCodeId?: number;

  /** 标题 */
  title?: string;

  /** 内容 */
  content?: string;

  /** 联系方式 */
  contactType?: string;

  /**  */
  sourceType?: FeedbackSourceType;

  /** 用户Id */
  accountId?: number;

  /** 回复人员Id */
  replyUserId?: number;

  /** 回复内容 */
  replyContent?: string;

  /** 机构用户Id */
  orgAccountId?: number;

  /**  */
  feedbackTime?: Date;

  /** 回复时间 */
  replyTime?: Date;

  /**  */
  isDeleted?: boolean;

  /**  */
  deleterUserId?: number;

  /**  */
  deletionTime?: Date;

  /**  */
  lastModificationTime?: Date;

  /**  */
  lastModifierUserId?: number;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  id?: number;
}

export interface FeedbackDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: FeedbackDto[];
}

export interface FeedbackReplyCreateOrUpdateDto {
  /** 反馈信息Id */
  feedbackId?: number;

  /** 回复内容 */
  content?: string;

  /**  */
  id?: number;
}

export interface FeedbackReplyDto {
  /**  */
  creatorUser?: UserMiniDto;

  /** 反馈信息Id */
  feedbackId?: number;

  /** 回复内容 */
  content?: string;

  /** 是否隐藏 */
  isHide?: boolean;

  /**  */
  isDeleted?: boolean;

  /**  */
  deleterUserId?: number;

  /**  */
  deletionTime?: Date;

  /**  */
  lastModificationTime?: Date;

  /**  */
  lastModifierUserId?: number;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  id?: number;
}

export interface FeedbackReplyDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: FeedbackReplyDto[];
}

export interface FundSendMessageInput {
  /**  */
  messageId?: number;

  /**  */
  fundIds?: number[];
}

export interface FundCreateOrUpdateDto {
  /**  */
  savedAttachments?: number[];

  /**  */
  name?: string;

  /** 封面图片 */
  titleImage?: string;

  /** 创立人姓名 */
  founderName?: string;

  /**  */
  mobileTelephone?: string;

  /**  */
  fixTelephone?: string;

  /** 邮箱 */
  email?: string;

  /**  */
  qq?: string;

  /** 成立日期 */
  foundDate?: Date;

  /** 宗旨 */
  purpose?: string;

  /** 资金使用范围 */
  usageRange?: string;

  /** 管理费比例 */
  managementFeePercentage?: number;

  /** 起设金额 */
  intialCaptial?: number;

  /** 资金来源 */
  capitalSource?: string;

  /** 关注领域 */
  focusArea?: string;

  /**  */
  summary?: string;

  /**  */
  description?: string;

  /**  */
  viceChairman?: string;

  /**  */
  chairman?: string;

  /**  */
  member?: string;

  /** 联系人 */
  contacts?: string;

  /**  */
  type?: FundType;

  /**  */
  status?: ValidStatus;

  /** 类别（数据字典里获得，个冠的类别有关爱之星，荣誉理事，功勋理事） */
  honorType?: string;

  /** 是否在网站上显示 */
  isPublished?: boolean;

  /** 已经筹集捐款金额累计 */
  raisedAmountTotal?: number;

  /** 该基金累计捐款人数 */
  donatedPersonTotal?: number;

  /** 支出金额统计 */
  expenseAmountTotal?: number;

  /** 管委会主任ID */
  directorID?: number;

  /** 批示文件图片 */
  instructionsImage?: string;

  /** 牌匾图片 */
  plaqueImage?: string;

  /** 是否可以匿名捐赠 */
  canAnonymous?: boolean;

  /** 是否拥有自己的产品 */
  hasProducts?: boolean;

  /** 是否需要募捐 */
  isFundRaising?: boolean;

  /** 细分类别 */
  fundCategory?: string;

  /**  */
  id?: number;
}

export interface UserExtendMiniDto {
  /**  */
  user?: UserMiniDto;

  /** 企业职务 */
  companyDuty?: string;

  /** 职务 */
  duty?: string;

  /** 成员图片\/用户头像 */
  headImgUrl?: string;
}

export interface FundDto {
  /**  */
  organizationUnitId?: number;

  /**  */
  name?: string;

  /** 封面图片 */
  titleImage?: string;

  /** 创立人姓名 */
  founderName?: string;

  /**  */
  mobileTelephone?: string;

  /**  */
  fixTelephone?: string;

  /** 邮箱 */
  email?: string;

  /**  */
  qq?: string;

  /** 成立日期 */
  foundDate?: Date;

  /** 宗旨 */
  purpose?: string;

  /**  */
  usageRange?: string;

  /** 管理费比例 */
  managementFeePercentage?: number;

  /** 起设金额 */
  intialCaptial?: number;

  /** 资金来源 */
  capitalSource?: string;

  /**  */
  focusArea?: string;

  /**  */
  summary?: string;

  /**  */
  description?: string;

  /**  */
  viceChairman?: string;

  /**  */
  chairman?: string;

  /**  */
  member?: string;

  /** 联系人 */
  contacts?: string;

  /**  */
  type?: FundType;

  /**  */
  status?: ValidStatus;

  /** 类别（数据字典里获得，个冠的类别有关爱之星，荣誉理事，功勋理事） */
  honorType?: string;

  /** 是否在网站上显示 */
  isPublished?: boolean;

  /** 已经筹集捐款金额累计 */
  raisedAmountTotal?: number;

  /** 该基金累计捐款人数 */
  donatedPersonTotal?: number;

  /** 支出金额统计 */
  expenseAmountTotal?: number;

  /** 管委会主任ID */
  directorID?: number;

  /** 批示文件图片 */
  instructionsImage?: string;

  /** 牌匾图片 */
  plaqueImage?: string;

  /** 是否可以匿名捐赠 */
  canAnonymous?: boolean;

  /** 是否拥有自己的产品 */
  hasProducts?: boolean;

  /** 是否需要募捐 */
  isFundRaising?: boolean;

  /** 细分类别 */
  fundCategory?: string;

  /** 累计收入基金账户金额 */
  accumlativeMoney?: number;

  /** 当前基金账户金额 */
  availableMoney?: number;

  /** 基金成员 */
  users?: UserExtendMiniDto[];

  /**  */
  isDeleted?: boolean;

  /**  */
  deleterUserId?: number;

  /**  */
  deletionTime?: Date;

  /**  */
  lastModificationTime?: Date;

  /**  */
  lastModifierUserId?: number;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  id?: number;
}

export interface FundDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: FundDto[];
}

export interface MessageDto {
  /**  */
  organizationUnitId?: number;

  /** 消息标题 */
  title?: string;

  /** 消息内容 */
  content?: string;

  /**  */
  messageType?: MessageType;

  /**  */
  status?: ValidStatus;

  /**  */
  isDeleted?: boolean;

  /**  */
  deleterUserId?: number;

  /**  */
  deletionTime?: Date;

  /**  */
  lastModificationTime?: Date;

  /**  */
  lastModifierUserId?: number;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  id?: number;
}

export interface FundMessageDto {
  /**  */
  message?: MessageDto;

  /** 基金Id */
  fundID?: number;

  /** 消息Id */
  messageID?: number;

  /** 否是已经阅读 */
  isReaded?: boolean;

  /** 阅读时间 */
  readTime?: Date;

  /**  */
  attachments?: AttachmentDto[];

  /**  */
  savedAttachments?: number[];

  /**  */
  id?: number;
}

export interface FundMessageDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: FundMessageDto[];
}

export interface FundAccountDto {
  /** 基金Id */
  fundID?: number;

  /** 基金名称 */
  fundName?: string;

  /** 当前基金账户金额 */
  availableMoney?: number;

  /** 累计收入基金账户金额 */
  accumlativeMoney?: number;

  /** 累计支出金额 */
  appropriatedMoney?: number;

  /** 管理费 */
  manageFee?: number;
}

export interface FundAccountDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: FundAccountDto[];
}

export interface FundAccountPagedResultRequestDto {
  /**  */
  type?: FundType;

  /** 基金Id */
  fundID?: number;

  /** 起始日期 */
  startDate?: string;

  /** 截止日期 */
  endDate?: string;

  /** 是否前端 */
  isFront?: boolean;

  /**  */
  operationType?: FundAccountRecordOperationType;

  /** 每页记录数，用作替换MaxResultCount */
  pageSize?: number;

  /**  */
  skipCount?: number;

  /** 页码，用来替换SkipCount */
  pageIndex?: number;

  /**  */
  sorting?: string;

  /**  */
  maxResultCount?: number;
}

export interface FundAccountRecordDto {
  /** 操作金额 */
  moneyAmount?: number;

  /** 操作时间 */
  operationTime?: string;

  /** 内容 */
  content?: string;

  /** 操作类型 */
  operationType?: number;
}

export interface FundAccountRecordDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: FundAccountRecordDto[];
}

export interface FundApplyCreateOrUpdateDto {
  /**  */
  auditFlowId?: string;

  /**  */
  savedAttachments?: number[];

  /** 基金名称 */
  fundName?: string;

  /** 申请人姓名 */
  applicantName?: string;

  /** 联系电话 */
  applicantMobileTelephone?: string;

  /** 固定电话 */
  applicantFixTelephone?: string;

  /**  */
  applicantEmail?: string;

  /**  */
  applicantQQ?: string;

  /** 启动资金金额 */
  intialCaptial?: number;

  /** 简介 */
  summary?: string;

  /**  */
  type?: FundType;

  /**  */
  status?: ApplyStatus;

  /**  */
  applyTime?: Date;

  /** 管理费比例 */
  managementFeePercentage?: number;

  /** 细分类别 */
  fundCategory?: string;

  /** 是否可以匿名捐赠 */
  canAnonymous?: boolean;

  /**  */
  attachmentStr?: string;

  /** 资金使用范围 */
  usageRange?: string;

  /**  */
  id?: number;
}

export interface FundApplyDto {
  /**  */
  auditFlowId?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /** 基金名称 */
  fundName?: string;

  /** 申请人姓名 */
  applicantName?: string;

  /** 联系电话 */
  applicantMobileTelephone?: string;

  /** 固定电话 */
  applicantFixTelephone?: string;

  /**  */
  applicantEmail?: string;

  /**  */
  applicantQQ?: string;

  /** 启动资金金额 */
  intialCaptial?: number;

  /** 简介 */
  summary?: string;

  /**  */
  type?: FundType;

  /**  */
  status?: ApplyStatus;

  /**  */
  applyTime?: Date;

  /** 管理费比例 */
  managementFeePercentage?: number;

  /** 细分类别 */
  fundCategory?: string;

  /** 是否可以匿名捐赠 */
  canAnonymous?: boolean;

  /** 资金使用范围 */
  usageRange?: string;

  /**  */
  isDeleted?: boolean;

  /**  */
  deleterUserId?: number;

  /**  */
  deletionTime?: Date;

  /**  */
  lastModificationTime?: Date;

  /**  */
  lastModifierUserId?: number;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  id?: number;
}

export interface FundApplyDtoListResultDto {
  /**  */
  items?: FundApplyDto[];
}

export interface FundApplyDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: FundApplyDto[];
}

export interface FundAppropriateApplyCreateOrUpdateDto {
  /**  */
  fundId?: number;

  /**  */
  auditFlowId?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /**  */
  projectId?: number;

  /** 拨付标题 */
  title?: string;

  /** 拨付金额 */
  moneyAmount?: number;

  /** 拨付理由 */
  appropriateReason?: string;

  /** 收款银行账号 */
  bankAccountCode?: string;

  /** 开户行名称 */
  bankName?: string;

  /** 户名 */
  bankAccountName?: string;

  /** 收款人姓名 */
  receiverName?: string;

  /** 收款人电话 */
  receiverTelephone?: string;

  /**  */
  appropriateType?: FundAppropriateType;

  /**  */
  savedAttachments?: number[];

  /** 其他项目名称 */
  otherProjectName?: string;

  /**  */
  attachmentStr?: string;

  /**  */
  id?: number;
}

export interface FundAppropriateApplyDto {
  /**  */
  auditFlowId?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /**  */
  organizationUnitId?: number;

  /**  */
  fundId?: number;

  /**  */
  fund?: FundMiniDto;

  /**  */
  projectId?: number;

  /**  */
  fundProject?: FundProjectMiniDto;

  /** 拨付标题 */
  title?: string;

  /** 拨付金额 */
  moneyAmount?: number;

  /** 拨付理由 */
  appropriateReason?: string;

  /** 收款银行账号 */
  bankAccountCode?: string;

  /** 开户行名称 */
  bankName?: string;

  /** 户名 */
  bankAccountName?: string;

  /** 收款人姓名 */
  receiverName?: string;

  /** 收款人电话 */
  receiverTelephone?: string;

  /**  */
  appropriateType?: FundAppropriateType;

  /** 其他项目名称 */
  otherProjectName?: string;

  /**  */
  creatorUser?: UserMiniDto;

  /**  */
  isDeleted?: boolean;

  /**  */
  deleterUserId?: number;

  /**  */
  deletionTime?: Date;

  /**  */
  lastModificationTime?: Date;

  /**  */
  lastModifierUserId?: number;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  id?: number;
}

export interface FundAppropriateApplyDtoListResultDto {
  /**  */
  items?: FundAppropriateApplyDto[];
}

export interface FundAppropriateApplyDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: FundAppropriateApplyDto[];
}

export interface FundAppropriateRecordDto {
  /**  */
  fundID?: number;

  /**  */
  fund?: FundMiniDto;

  /**  */
  projectID?: number;

  /**  */
  fundProject?: FundProjectMiniDto;

  /**  */
  creatorUser?: UserMiniDto;

  /** 拨付标题 */
  title?: string;

  /** 拨付金额 */
  moneyAmount?: number;

  /** 拨付理由 */
  appropriateReason?: string;

  /** 拨付时间 */
  appropriateTime?: Date;

  /** 最终审核通过人 */
  operatorID?: number;

  /**  */
  operator?: UserMiniDto;

  /** 收款银行账号 */
  bankAccountCode?: string;

  /** 开户行名称 */
  bankName?: string;

  /** 户名 */
  bankAccountName?: string;

  /** 收款人姓名 */
  receiverName?: string;

  /** 收款人电话 */
  receiverTelephone?: string;

  /**  */
  status?: ValidStatus;

  /**  */
  appropriateType?: FundAppropriateType;

  /** 其他项目名称 */
  otherProjectName?: string;

  /** 用款申请Id */
  applicationPaymentId?: number;

  /**  */
  applicationPayment?: ApplicationPaymentDto;

  /**  */
  isDeleted?: boolean;

  /**  */
  deleterUserId?: number;

  /**  */
  deletionTime?: Date;

  /**  */
  lastModificationTime?: Date;

  /**  */
  lastModifierUserId?: number;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  id?: number;
}

export interface FundAppropriateRecordDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: FundAppropriateRecordDto[];
}

export interface FundAppropriateRecordChangeAppropriateTimeInput {
  /**  */
  newTime?: Date;

  /**  */
  id?: number;
}

export interface FundBankInfoCreateOrUpdateDto {
  /** 收款人姓名 */
  name?: string;

  /** 收款人电话 */
  telephone?: string;

  /** 户名 */
  accountName?: string;

  /** 银行账号 */
  accountCode?: string;

  /** 开户银行名称 */
  bankName?: string;

  /** 是否默认 */
  isDefault?: boolean;

  /**  */
  id?: number;
}

export interface FundBankInfoDto {
  /**  */
  fundID?: number;

  /**  */
  fund?: FundDto;

  /** 收款人姓名 */
  name?: string;

  /** 收款人电话 */
  telephone?: string;

  /** 户名 */
  accountName?: string;

  /** 银行账号 */
  accountCode?: string;

  /** 开户银行名称 */
  bankName?: string;

  /** 是否默认 */
  isDefault?: boolean;

  /**  */
  id?: number;
}

export interface FundBankInfoDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: FundBankInfoDto[];
}

export interface FundDonationMonthlyConfigDto {
  /** 会员Id */
  userId?: number;

  /**  */
  user?: UserMiniDto;

  /** 捐赠项目类型 */
  donorItemType?: number;

  /** 捐赠项目编号 */
  donorItemId?: number;

  /** 捐赠协议序列号(签约银行返回) */
  donorSignSn?: string;

  /**  */
  donorType?: DonorType;

  /** 固定捐助天 */
  donorDay?: number;

  /** 捐赠金额,单位：分 */
  donationAmount?: number;

  /** 发票Id */
  invoiceId?: number;

  /** 捐赠留言 */
  leaveMessage?: string;

  /** 捐赠人联系号码 */
  mobileTelephone?: string;

  /** 发票附件编号，多个使用英文","隔开 */
  attachments?: string;

  /** 捐赠人名称(匿名使用“爱心人士”) */
  displayName?: string;

  /** 平台与天付宝确认签约订单号，关联发票订单Id */
  spBillNo?: string;

  /** 天付宝确认签约订单号，关联发票订单Id */
  listId?: string;

  /** 月捐状态(1：开启，0：停止月捐) */
  isOpen?: boolean;

  /** 是否已确认 */
  isConfirmed?: boolean;

  /** 推荐人 */
  referrer?: string;

  /** 停止月捐时间 */
  stoppedTime?: Date;

  /** 月捐类型（1天付宝，2微信） */
  configType?: number;

  /** 捐赠项目名称 */
  donorItemProjectName?: string;

  /**  */
  isDeleted?: boolean;

  /**  */
  deleterUserId?: number;

  /**  */
  deletionTime?: Date;

  /**  */
  lastModificationTime?: Date;

  /**  */
  lastModifierUserId?: number;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  id?: number;
}

export interface FundDonationMonthlyConfigDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: FundDonationMonthlyConfigDto[];
}

export interface EntityDto {
  /**  */
  id?: number;
}

export interface FundDonationOrderCreateDto {
  /**  */
  orderID?: string;

  /** 基金ID */
  fundID?: number;

  /** 项目ID */
  projectID?: number;

  /** 捐款数额 */
  donationAmount?: number;

  /** 会员ID */
  memberID?: number;

  /** 手机号码 */
  mobileTelephone?: string;

  /** 捐助者姓名 */
  donorName?: string;

  /** 留言 */
  leaveMessage?: string;

  /** 发票抬头 */
  invoiceHeader?: string;

  /** 订单生产时间 */
  createdTime?: string;

  /** 是否支付成功 */
  isPayed?: boolean;

  /** 支付成功时间 */
  payedTime?: string;

  /** 支付类型ID */
  paymentType?: number;

  /** 支付平台是否响应 */
  isResponsed?: boolean;

  /** 支付平台响应时间 */
  responseTime?: string;

  /** 支付平台返回消息 */
  resultMessage?: string;

  /** 显示的名称 */
  displayName?: string;

  /** 支付交易号 */
  tadeNO?: string;

  /** 捐赠者账户 */
  donatorAccount?: string;

  /** 失效时间 */
  invalidTime?: string;

  /** 推荐人 */
  referrer?: string;

  /**  */
  name?: string;

  /**  */
  needInvoice?: boolean;

  /**  */
  isAnonymous?: boolean;

  /**  */
  donorType?: DonorType;

  /**  */
  inVoiceTitle?: string;

  /**  */
  inVoiceName?: string;

  /**  */
  inVoiceTelephone?: string;

  /**  */
  inVoiceAddress?: string;

  /**  */
  attachmentStr?: string;

  /**  */
  incomeType?: IncomeType;

  /** 月捐日期 */
  monthDonorDay?: number;

  /**  */
  donationType?: DonationType;

  /**  */
  donationCycle?: DonationCycle;

  /** 捐赠时间 */
  donationTime?: Date;

  /**  */
  donorItemType?: DonorItemType;

  /** 捐赠意向Id */
  donorItemId?: number;

  /**  */
  type?: ElectronicInvoiceType;

  /** 统一社会信用代码 */
  creditCode?: string;

  /** 身份证号码 */
  idNo?: string;

  /** 邮箱 */
  email?: string;
}

export interface FundDonationOrderDto {
  /**  */
  organizationUnitId?: number;

  /** 订单号 */
  orderID?: string;

  /** 捐赠基金Id */
  fundID?: number;

  /**  */
  fund?: FundMiniDto;

  /** 捐赠项目ID */
  fundProjectID?: number;

  /**  */
  fundProject?: FundProjectMiniDto;

  /** 捐赠金额 */
  donationAmount?: number;

  /** 是否为手动新增订单 */
  isManualCreate?: boolean;

  /** 用户Id */
  userId?: number;

  /** 捐赠人手机号码 */
  mobileTelephone?: string;

  /**  */
  donorType?: DonorType;

  /** 捐赠人姓名 */
  donorName?: string;

  /** 留言 */
  leaveMessage?: string;

  /** 是否支付成功 */
  isPayed?: boolean;

  /** 支付成功时间 */
  payedTime?: Date;

  /** 支付类型 */
  paymentType?: string;

  /** 支付平台是否响应 */
  isResponsed?: boolean;

  /** 支付平台响应时间 */
  responseTime?: Date;

  /** 支付平台返回消息 */
  resultMessage?: string;

  /** 显示的名称 */
  displayName?: string;

  /** 支付交易号 */
  tradeNo?: string;

  /** 捐赠者账号 */
  donorAccount?: string;

  /** 失效时间 */
  invalidTime?: Date;

  /**  */
  donationType?: IncomeType;

  /** 是否需要发票 */
  needInvoice?: boolean;

  /** 订单交易流水号(天付宝用) */
  orderSerialNo?: string;

  /** 推荐人 */
  referrer?: string;

  /** 月捐日期 */
  monthDonorDay?: number;

  /** 捐赠意向Id */
  donorItemId?: number;

  /**  */
  isDeleted?: boolean;

  /**  */
  deleterUserId?: number;

  /**  */
  deletionTime?: Date;

  /**  */
  lastModificationTime?: Date;

  /**  */
  lastModifierUserId?: number;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  id?: number;
}

export interface FundAutoDeductionOrderCreateDto {
  /**  */
  fromBmsOrderId?: string;

  /**  */
  newBmsOrderId?: string;

  /**  */
  newBmsOrderPrice?: number;
}

export interface FundDonationOrderDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: FundDonationOrderDto[];
}

export interface FundIncomeRecordDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: FundIncomeRecordDto[];
}

export interface FundIncomeRecordTotalDto {
  /**  */
  orgTotal?: number;

  /**  */
  fundProjectTotal?: number;

  /**  */
  fundTotal?: number;

  /**  */
  aidStudentTotal?: number;

  /**  */
  totalMoney?: number;
}

export interface FundIncomeRecordTotalByPortalDto {
  /** 捐赠总额 */
  totalMoney?: number;

  /** 捐赠基金数 */
  donateFundCount?: number;

  /** 捐赠项目数 */
  donateProjectCount?: number;
}

export interface FundIncomeRecordPagedResultRequestDto {
  /** 关键词 */
  keyword?: string;

  /** 捐赠者名称 */
  donorName?: string;

  /** 开始时间 */
  startDate?: string;

  /** 结束时间 */
  endDate?: string;

  /**  */
  donorType?: DonorType;

  /**  */
  incomeType?: IncomeType;

  /** 基金Id */
  fundId?: number;

  /** 基金项目Id */
  projectId?: number;

  /** 支付方式 */
  paymentType?: string;

  /** 捐助方式 */
  isMonthDonor?: boolean;

  /** 用户Id */
  userId?: number;

  /**  */
  weixinTradeNo?: string;

  /** 每页记录数，用作替换MaxResultCount */
  pageSize?: number;

  /**  */
  skipCount?: number;

  /** 页码，用来替换SkipCount */
  pageIndex?: number;

  /**  */
  sorting?: string;

  /**  */
  maxResultCount?: number;
}

export interface UserDonateInfoDto {
  /** 资金捐赠次数 */
  donateCount?: number;

  /** 资金捐赠总金额 */
  donateMoney?: number;
}

export interface FundManageFeeRecordDto {
  /**  */
  organizationUnitId?: number;

  /** 捐赠基金Id */
  fundId?: number;

  /**  */
  fund?: FundMiniDto;

  /** 管理费金额 */
  moneyAmount?: number;

  /** 捐赠描述 */
  content?: string;

  /** 管理费比例 */
  ration?: number;

  /** 源记录ID（由哪条原始数据产生） */
  sourceId?: number;

  /** 备注 */
  remark?: string;

  /** 捐赠记录ID */
  incomeRecordId?: number;

  /** 记录是否发生过变更 */
  hasChanged?: boolean;

  /**  */
  isDeleted?: boolean;

  /**  */
  deleterUserId?: number;

  /**  */
  deletionTime?: Date;

  /**  */
  lastModificationTime?: Date;

  /**  */
  lastModifierUserId?: number;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  id?: number;
}

export interface FundManageFeeRecordDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: FundManageFeeRecordDto[];
}

export interface FundManageFeeRecordChangeHistoryDto {
  /**  */
  recordId?: number;

  /** 变更前金额 */
  beforeAmount?: number;

  /** 变更后金额 */
  afterAmount?: number;

  /**  */
  type?: ManagerFeeChangeType;

  /**  */
  summary?: string;

  /**  */
  creatorUser?: UserMiniDto;

  /**  */
  creationTime?: Date;

  /**  */
  creationTimeText?: string;

  /**  */
  creatorUserId?: number;
}

export interface FundManageFeeFeeRecordDetailDto {
  /**  */
  changeHistories?: FundManageFeeRecordChangeHistoryDto[];

  /**  */
  organizationUnitId?: number;

  /** 捐赠基金Id */
  fundId?: number;

  /**  */
  fund?: FundMiniDto;

  /** 管理费金额 */
  moneyAmount?: number;

  /** 捐赠描述 */
  content?: string;

  /** 管理费比例 */
  ration?: number;

  /** 源记录ID（由哪条原始数据产生） */
  sourceId?: number;

  /** 备注 */
  remark?: string;

  /** 捐赠记录ID */
  incomeRecordId?: number;

  /** 记录是否发生过变更 */
  hasChanged?: boolean;

  /**  */
  isDeleted?: boolean;

  /**  */
  deleterUserId?: number;

  /**  */
  deletionTime?: Date;

  /**  */
  lastModificationTime?: Date;

  /**  */
  lastModifierUserId?: number;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  id?: number;
}

export interface FundManageFeeRecordChangeRequestInput {
  /** 变更原因说明 */
  sumamry?: string;

  /** 目标金额 */
  amount?: number;

  /**  */
  id?: number;
}

export interface FundModifyApplyCreateOrUpdateDto {
  /**  */
  auditFlowId?: string;

  /**  */
  savedAttachments?: number[];

  /**  */
  name?: string;

  /** 封面图片 */
  titleImage?: string;

  /** 创立人姓名 */
  founderName?: string;

  /**  */
  mobileTelephone?: string;

  /**  */
  fixTelephone?: string;

  /** 邮箱 */
  email?: string;

  /**  */
  qq?: string;

  /** 成立日期 */
  foundDate?: Date;

  /** 宗旨 */
  purpose?: string;

  /** 资金使用范围 */
  usageRange?: string;

  /** 管理费比例 */
  managementFeePercentage?: number;

  /** 起设金额 */
  intialCaptial?: number;

  /** 资金来源 */
  capitalSource?: string;

  /** 关注领域 */
  focusArea?: string;

  /**  */
  summary?: string;

  /**  */
  description?: string;

  /**  */
  viceChairman?: string;

  /**  */
  chairman?: string;

  /**  */
  member?: string;

  /** 联系人 */
  contacts?: string;

  /**  */
  type?: FundType;

  /**  */
  status?: ValidStatus;

  /** 类别（数据字典里获得，个冠的类别有关爱之星，荣誉理事，功勋理事） */
  honorType?: string;

  /** 是否在网站上显示 */
  isPublished?: boolean;

  /** 已经筹集捐款金额累计 */
  raisedAmountTotal?: number;

  /** 该基金累计捐款人数 */
  donatedPersonTotal?: number;

  /** 支出金额统计 */
  expenseAmountTotal?: number;

  /** 管委会主任ID */
  directorID?: number;

  /** 批示文件图片 */
  instructionsImage?: string;

  /** 牌匾图片 */
  plaqueImage?: string;

  /** 是否可以匿名捐赠 */
  canAnonymous?: boolean;

  /** 是否拥有自己的产品 */
  hasProducts?: boolean;

  /** 是否需要募捐 */
  isFundRaising?: boolean;

  /** 基金Id */
  fundID?: number;

  /** 细分类别 */
  fundCategory?: string;

  /**  */
  id?: number;
}

export interface FundModifyApplyDto {
  /**  */
  organizationUnitId?: number;

  /**  */
  auditFlowId?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /**  */
  name?: string;

  /** 封面图片 */
  titleImage?: string;

  /** 创立人姓名 */
  founderName?: string;

  /**  */
  mobileTelephone?: string;

  /**  */
  fixTelephone?: string;

  /** 邮箱 */
  email?: string;

  /**  */
  qq?: string;

  /** 成立日期 */
  foundDate?: Date;

  /** 宗旨 */
  purpose?: string;

  /**  */
  usageRange?: string;

  /** 管理费比例 */
  managementFeePercentage?: number;

  /** 起设金额 */
  intialCaptial?: number;

  /** 资金来源 */
  capitalSource?: string;

  /**  */
  focusArea?: string;

  /**  */
  summary?: string;

  /**  */
  description?: string;

  /**  */
  viceChairman?: string;

  /**  */
  chairman?: string;

  /**  */
  member?: string;

  /** 联系人 */
  contacts?: string;

  /**  */
  type?: FundType;

  /**  */
  status?: ValidStatus;

  /** 类别（数据字典里获得，个冠的类别有关爱之星，荣誉理事，功勋理事） */
  honorType?: string;

  /** 是否在网站上显示 */
  isPublished?: boolean;

  /** 已经筹集捐款金额累计 */
  raisedAmountTotal?: number;

  /** 该基金累计捐款人数 */
  donatedPersonTotal?: number;

  /** 支出金额统计 */
  expenseAmountTotal?: number;

  /** 管委会主任ID */
  directorID?: number;

  /** 批示文件图片 */
  instructionsImage?: string;

  /** 牌匾图片 */
  plaqueImage?: string;

  /** 是否可以匿名捐赠 */
  canAnonymous?: boolean;

  /** 是否拥有自己的产品 */
  hasProducts?: boolean;

  /** 是否需要募捐 */
  isFundRaising?: boolean;

  /**  */
  applyStatus?: ApplyStatus;

  /** 基金Id */
  fundID?: number;

  /** 细分类别 */
  fundCategory?: string;

  /** 拒绝原因 */
  rejectReason?: string;

  /** 基金成员 */
  users?: UserExtendMiniDto[];

  /**  */
  isDeleted?: boolean;

  /**  */
  deleterUserId?: number;

  /**  */
  deletionTime?: Date;

  /**  */
  lastModificationTime?: Date;

  /**  */
  lastModifierUserId?: number;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  id?: number;
}

export interface FundModifyApplyDtoListResultDto {
  /**  */
  items?: FundModifyApplyDto[];
}

export interface FundModifyApplyDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: FundModifyApplyDto[];
}

export interface FundNonCashDonationRecordCreateOrUpdateDto {
  /**  */
  auditFlowId?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /** 姓名 */
  name?: string;

  /** 公司 */
  company?: string;

  /** 地址 */
  address?: string;

  /** 邮箱 */
  email?: string;

  /** 家庭电话 */
  homeTelephone?: string;

  /** 手机号码 */
  telephone?: string;

  /** 期望联系方式（1手机 2邮箱 3两种皆可） */
  contactType?: number;

  /** 捐赠类型（1物品捐赠，2场地\/其他捐赠） */
  donationType?: number;

  /**  */
  nonCashDonationItemJson?: string;

  /**  */
  id?: number;
}

export interface FundNonCashDonationRecordDto {
  /**  */
  tenantId?: number;

  /**  */
  auditFlowId?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /** 姓名 */
  name?: string;

  /** 公司 */
  company?: string;

  /** 地址 */
  address?: string;

  /** 邮箱 */
  email?: string;

  /** 家庭电话 */
  homeTelephone?: string;

  /** 手机号码 */
  telephone?: string;

  /** 期望联系方式（1手机 2邮箱 3两种皆可） */
  contactType?: number;

  /** 捐赠类型（1物品捐赠，2场地\/其他捐赠） */
  donationType?: number;

  /** 捐赠人ID */
  donorId?: number;

  /**  */
  nonCashDonationItemJson?: string;

  /**  */
  status?: ApplyStatus;

  /** 拒绝原因 */
  rejectReason?: string;

  /**  */
  isDeleted?: boolean;

  /**  */
  deleterUserId?: number;

  /**  */
  deletionTime?: Date;

  /**  */
  lastModificationTime?: Date;

  /**  */
  lastModifierUserId?: number;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  id?: number;
}

export interface FundNonCashDonationRecordDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: FundNonCashDonationRecordDto[];
}

export interface UserNonCashDonationInfoDto {
  /** 实物捐赠审核通过次数 */
  nonCashDonationCount?: number;
}

export interface FundNonCashDonationRecordDtoListResultDto {
  /**  */
  items?: FundNonCashDonationRecordDto[];
}

export interface FundProjectCreateOrUpdateDto {
  /**  */
  savedAttachments?: number[];

  /** 项目标题 */
  name?: string;

  /** 所属基金ID */
  fundID?: number;

  /**  */
  projectType?: FundProjectType;

  /** 标题图片 */
  titleImagePath?: string;

  /** 项目预算 */
  budget?: number;

  /** 项目预算说明 */
  budgetDescription?: string;

  /** 项目执行计划 */
  executionPlan?: string;

  /** 项目周期（月） */
  period?: number;

  /** 服务地区 */
  serviceArea?: string;

  /** 服务领域 */
  serviceField?: string;

  /** 项目目标 */
  projectGoal?: string;

  /** 项目简介 */
  summary?: string;

  /** 项目详细描述 */
  description?: string;

  /** 联系人姓名 */
  contactsName?: string;

  /** 联系人手机号码 */
  contactsMobileTelephone?: string;

  /** 联系人地址 */
  contactsAddress?: string;

  /** 联系人邮箱 */
  contactsEmail?: string;

  /** 已经筹集捐款金额累计 */
  raisedAmountTotal?: number;

  /** 该项目累计捐款人数 */
  donatedPersonTotal?: number;

  /** 支出金额统计 */
  expenseAmountTotal?: number;

  /**  */
  startTime?: Date;

  /**  */
  endTime?: Date;

  /**  */
  status?: FundProjectStatus;

  /** 项目编号（唯一） */
  code?: string;

  /** 是否专题项目 */
  isSpecial?: boolean;

  /** 是否需要筹款 */
  isFundRaising?: boolean;

  /** 项目范围 */
  categoryName?: string;

  /** 是否品牌项目 */
  isBrand?: boolean;

  /** 目标筹款金额 */
  targetAmountTotal?: number;

  /** 结项报告 */
  finalReport?: string;

  /** 项目可用余额 */
  availableMoney?: number;

  /** 是否可以匿名捐赠 */
  canAnonymous?: boolean;

  /**  */
  organizationUnitId?: number;

  /**  */
  id?: number;
}

export interface FundProjectDto {
  /**  */
  organizationUnitId?: number;

  /**  */
  auditFlowId?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /** 项目标题 */
  name?: string;

  /** 所属基金ID */
  fundID?: number;

  /**  */
  fund?: FundMiniDto;

  /**  */
  projectType?: FundProjectType;

  /** 标题图片 */
  titleImagePath?: string;

  /** 项目预算 */
  budget?: number;

  /** 项目预算说明 */
  budgetDescription?: string;

  /** 项目执行计划 */
  executionPlan?: string;

  /** 项目周期（月） */
  period?: number;

  /** 服务地区 */
  serviceArea?: string;

  /** 服务领域 */
  serviceField?: string;

  /** 项目目标 */
  projectGoal?: string;

  /** 项目简介 */
  summary?: string;

  /** 项目详细描述 */
  description?: string;

  /** 联系人姓名 */
  contactsName?: string;

  /** 联系人手机号码 */
  contactsMobileTelephone?: string;

  /** 联系人地址 */
  contactsAddress?: string;

  /** 联系人邮箱 */
  contactsEmail?: string;

  /** 已经筹集捐款金额累计 */
  raisedAmountTotal?: number;

  /** 该项目累计捐款人数 */
  donatedPersonTotal?: number;

  /** 支出金额统计 */
  expenseAmountTotal?: number;

  /**  */
  startTime?: Date;

  /**  */
  endTime?: Date;

  /**  */
  status?: FundProjectStatus;

  /** 是否已结项 */
  isEnd?: boolean;

  /** 项目编号（唯一） */
  code?: string;

  /** 是否专题项目 */
  isSpecial?: boolean;

  /** 是否需要筹款 */
  isFundRaising?: boolean;

  /** 项目范围 */
  categoryName?: string;

  /** 是否品牌项目 */
  isBrand?: boolean;

  /** 目标筹款金额 */
  targetAmountTotal?: number;

  /** 结项报告 */
  finalReport?: string;

  /** 项目可用余额 */
  availableMoney?: number;

  /** 是否可以匿名捐赠 */
  canAnonymous?: boolean;

  /** 是否置顶 */
  isTop?: boolean;

  /** 置顶顺序 */
  topDisplayOrder?: number;

  /**  */
  savedAttachments?: number[];

  /**  */
  isDeleted?: boolean;

  /**  */
  deleterUserId?: number;

  /**  */
  deletionTime?: Date;

  /**  */
  lastModificationTime?: Date;

  /**  */
  lastModifierUserId?: number;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  id?: number;
}

export interface FundProjectDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: FundProjectDto[];
}

export interface FundProjectSummarizationDto {
  /**  */
  organizationUnitId?: number;

  /** 结项标题 */
  title?: string;

  /** 简介 */
  summary?: string;

  /** 内容 */
  content?: string;

  /**  */
  isDeleted?: boolean;

  /**  */
  deleterUserId?: number;

  /**  */
  deletionTime?: Date;

  /**  */
  lastModificationTime?: Date;

  /**  */
  lastModifierUserId?: number;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  id?: number;
}

export interface FundProjectManualCreateDonateOrderInput {
  /**  */
  fundProjectId?: number;

  /** 捐赠金额 */
  donationAmount?: number;

  /**  */
  userId?: number;

  /** 付款时间 */
  payedTime?: Date;

  /** 付款方式 */
  paymentType?: string;

  /** 手机号码 */
  mobileTelephone?: string;

  /** 捐助者姓名 */
  donorName?: string;

  /** 留言 */
  leaveMessage?: string;

  /** 显示的名称 */
  displayName?: string;
}

export interface FundProjectCloseInput {
  /**  */
  projectId?: number;

  /**  */
  title?: string;

  /**  */
  summary?: string;

  /**  */
  content?: string;
}

export interface FundProjectApplyCreateOrUpdateDto {
  /**  */
  savedAttachments?: number[];

  /**  */
  auditFlowId?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /** 项目标题 */
  name?: string;

  /** 所属基金ID */
  fundID?: number;

  /**  */
  projectType?: FundProjectType;

  /** 标题图片 */
  titleImagePath?: string;

  /** 项目预算 */
  budget?: number;

  /** 项目预算说明 */
  budgetDescription?: string;

  /** 项目执行计划 */
  executionPlan?: string;

  /** 项目周期（月） */
  period?: number;

  /** 服务地区 */
  serviceArea?: string;

  /** 服务领域 */
  serviceField?: string;

  /** 项目目标 */
  projectGoal?: string;

  /** 项目简介 */
  summary?: string;

  /** 项目详细描述 */
  description?: string;

  /** 联系人姓名 */
  contactsName?: string;

  /** 联系人手机号码 */
  contactsMobileTelephone?: string;

  /** 联系人地址 */
  contactsAddress?: string;

  /** 联系人邮箱 */
  contactsEmail?: string;

  /** 已经筹集捐款金额累计 */
  raisedAmountTotal?: number;

  /** 该项目累计捐款人数 */
  donatedPersonTotal?: number;

  /** 支出金额统计 */
  expenseAmountTotal?: number;

  /**  */
  startTime?: Date;

  /**  */
  endTime?: Date;

  /**  */
  status?: FundProjectStatus;

  /** 项目编号（唯一） */
  code?: string;

  /** 是否专题项目 */
  isSpecial?: boolean;

  /** 是否需要筹款 */
  isFundRaising?: boolean;

  /** 项目范围 */
  categoryName?: string;

  /** 是否品牌项目 */
  isBrand?: boolean;

  /** 目标筹款金额 */
  targetAmountTotal?: number;

  /** 结项报告 */
  finalReport?: string;

  /** 项目可用余额 */
  availableMoney?: number;

  /** 是否可以匿名捐赠 */
  canAnonymous?: boolean;

  /**  */
  id?: number;
}

export interface FundProjectApplyDto {
  /**  */
  organizationUnitId?: number;

  /**  */
  auditFlowId?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /** 项目标题 */
  name?: string;

  /** 所属基金ID */
  fundID?: number;

  /**  */
  fund?: FundMiniDto;

  /**  */
  projectType?: FundProjectType;

  /** 标题图片 */
  titleImagePath?: string;

  /** 项目预算 */
  budget?: number;

  /** 项目预算说明 */
  budgetDescription?: string;

  /** 项目执行计划 */
  executionPlan?: string;

  /** 项目周期（月） */
  period?: number;

  /** 服务地区 */
  serviceArea?: string;

  /** 服务领域 */
  serviceField?: string;

  /** 项目目标 */
  projectGoal?: string;

  /** 项目简介 */
  summary?: string;

  /** 项目详细描述 */
  description?: string;

  /** 联系人姓名 */
  contactsName?: string;

  /** 联系人手机号码 */
  contactsMobileTelephone?: string;

  /** 联系人地址 */
  contactsAddress?: string;

  /** 联系人邮箱 */
  contactsEmail?: string;

  /** 已经筹集捐款金额累计 */
  raisedAmountTotal?: number;

  /** 该项目累计捐款人数 */
  donatedPersonTotal?: number;

  /** 支出金额统计 */
  expenseAmountTotal?: number;

  /**  */
  startTime?: Date;

  /**  */
  endTime?: Date;

  /**  */
  status?: FundProjectStatus;

  /** 项目编号（唯一） */
  code?: string;

  /** 是否专题项目 */
  isSpecial?: boolean;

  /** 是否需要筹款 */
  isFundRaising?: boolean;

  /** 项目范围 */
  categoryName?: string;

  /** 是否品牌项目 */
  isBrand?: boolean;

  /** 目标筹款金额 */
  targetAmountTotal?: number;

  /** 结项报告 */
  finalReport?: string;

  /** 项目可用余额 */
  availableMoney?: number;

  /** 是否可以匿名捐赠 */
  canAnonymous?: boolean;

  /**  */
  creationTime?: Date;

  /**  */
  id?: number;
}

export interface FundProjectApplyDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: FundProjectApplyDto[];
}

export interface FundProjectApplyDtoListResultDto {
  /**  */
  items?: FundProjectApplyDto[];
}

export interface FundProjectCmsContentCreateInput {
  /**  */
  projectId?: number;

  /**  */
  cmsContentId?: number;
}

export interface CmsContentMiniDto {
  /**  */
  status?: CmsContentStatus;

  /**  */
  title?: string;

  /**  */
  summary?: string;

  /**  */
  author?: string;

  /** 发布时间 */
  publishTime?: Date;

  /** 内容来源 */
  source?: string;

  /**  */
  id?: number;
}

export interface FundProjectCmsContentDto {
  /**  */
  projectId?: number;

  /**  */
  project?: FundProjectMiniDto;

  /**  */
  cmsContentId?: number;

  /**  */
  content?: CmsContentMiniDto;

  /**  */
  id?: number;
}

export interface FundProjectCmsContentDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: FundProjectCmsContentDto[];
}

export interface FundProjectDonationRecordDto {
  /**  */
  projectId?: number;

  /**  */
  project?: FundProjectMiniDto;

  /** 项目所属基金 */
  fundId?: number;

  /**  */
  fund?: FundMiniDto;

  /**  */
  fundProductId?: number;

  /** 捐助者类型（1为个人，2为单位） */
  donorType?: number;

  /** 捐款人姓名 */
  displayName?: string;

  /** 捐款时间 */
  donateTime?: Date;

  /** 捐款金额 */
  donateMoney?: number;

  /** 捐助内容 */
  content?: string;

  /** 捐助者留言 */
  leaveMessage?: string;

  /** 记录来源:0,手动录入，1：用户捐款 */
  recordSource?: number;

  /** 捐助者手机号 */
  donorMobilePhone?: string;

  /** 线上捐款订单号 */
  orderNO?: string;

  /** 捐赠类型（1为线上捐款，2为线下捐款) */
  paymentType?: number;

  /** 捐赠人，未登录状态捐赠时可为空 */
  userId?: number;

  /** 捐赠类型（1为捐给项目，2为捐给基金) */
  donationType?: number;

  /** 是否月捐 */
  isMonthDonor?: boolean;

  /** 推荐人 */
  referrer?: string;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  id?: number;
}

export interface FundProjectDonationRecordDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: FundProjectDonationRecordDto[];
}

export interface FundProjectModifyApplyCreateOrUpdateDto {
  /**  */
  auditFlowId?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /**  */
  organizationUnitId?: number;

  /**  */
  savedAttachments?: number[];

  /** 项目标题 */
  name?: string;

  /**  */
  projectId?: number;

  /**  */
  projectType?: FundProjectType;

  /** 标题图片 */
  titleImagePath?: string;

  /** 项目预算 */
  budget?: number;

  /** 项目预算说明 */
  budgetDescription?: string;

  /** 项目执行计划 */
  executionPlan?: string;

  /** 项目周期（月） */
  period?: number;

  /** 服务地区 */
  serviceArea?: string;

  /** 服务领域 */
  serviceField?: string;

  /** 项目目标 */
  projectGoal?: string;

  /** 项目简介 */
  summary?: string;

  /** 项目详细描述 */
  description?: string;

  /** 联系人姓名 */
  contactsName?: string;

  /** 联系人手机号码 */
  contactsMobileTelephone?: string;

  /** 联系人地址 */
  contactsAddress?: string;

  /** 联系人邮箱 */
  contactsEmail?: string;

  /** 已经筹集捐款金额累计 */
  raisedAmountTotal?: number;

  /** 该项目累计捐款人数 */
  donatedPersonTotal?: number;

  /** 支出金额统计 */
  expenseAmountTotal?: number;

  /**  */
  startTime?: Date;

  /**  */
  endTime?: Date;

  /**  */
  status?: FundProjectStatus;

  /** 项目编号（唯一） */
  code?: string;

  /** 是否专题项目 */
  isSpecial?: boolean;

  /** 是否需要筹款 */
  isFundRaising?: boolean;

  /** 项目范围 */
  categoryName?: string;

  /** 是否品牌项目 */
  isBrand?: boolean;

  /** 目标筹款金额 */
  targetAmountTotal?: number;

  /** 结项报告 */
  finalReport?: string;

  /** 项目可用余额 */
  availableMoney?: number;

  /** 是否可以匿名捐赠 */
  canAnonymous?: boolean;

  /**  */
  id?: number;
}

export interface FundProjectModifyApplyDto {
  /**  */
  tenantId?: number;

  /**  */
  organizationUnitId?: number;

  /**  */
  auditFlowId?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /** 项目标题 */
  name?: string;

  /**  */
  projectId?: number;

  /**  */
  project?: FundProjectDto;

  /** 所属基金ID */
  fundID?: number;

  /**  */
  fund?: FundMiniDto;

  /**  */
  projectType?: FundProjectType;

  /** 标题图片 */
  titleImagePath?: string;

  /** 项目预算 */
  budget?: number;

  /** 项目预算说明 */
  budgetDescription?: string;

  /** 项目执行计划 */
  executionPlan?: string;

  /** 项目周期（月） */
  period?: number;

  /** 服务地区 */
  serviceArea?: string;

  /** 服务领域 */
  serviceField?: string;

  /** 项目目标 */
  projectGoal?: string;

  /** 项目简介 */
  summary?: string;

  /** 项目详细描述 */
  description?: string;

  /** 联系人姓名 */
  contactsName?: string;

  /** 联系人手机号码 */
  contactsMobileTelephone?: string;

  /** 联系人地址 */
  contactsAddress?: string;

  /** 联系人邮箱 */
  contactsEmail?: string;

  /** 已经筹集捐款金额累计 */
  raisedAmountTotal?: number;

  /** 该项目累计捐款人数 */
  donatedPersonTotal?: number;

  /** 支出金额统计 */
  expenseAmountTotal?: number;

  /**  */
  startTime?: Date;

  /**  */
  endTime?: Date;

  /**  */
  status?: FundProjectStatus;

  /** 项目编号（唯一） */
  code?: string;

  /** 是否专题项目 */
  isSpecial?: boolean;

  /** 是否需要筹款 */
  isFundRaising?: boolean;

  /** 项目范围 */
  categoryName?: string;

  /** 是否品牌项目 */
  isBrand?: boolean;

  /** 目标筹款金额 */
  targetAmountTotal?: number;

  /** 结项报告 */
  finalReport?: string;

  /** 项目可用余额 */
  availableMoney?: number;

  /** 是否可以匿名捐赠 */
  canAnonymous?: boolean;

  /**  */
  id?: number;
}

export interface FundProjectModifyApplyDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: FundProjectModifyApplyDto[];
}

export interface FundProjectModifyApplyDtoListResultDto {
  /**  */
  items?: FundProjectModifyApplyDto[];
}

export interface FundProjectProgressCreateOrUpdateDto {
  /**  */
  organizationUnitId?: number;

  /** 进展标题 */
  title?: string;

  /** 所属项目Id */
  projectId?: number;

  /** 简述 */
  summary?: string;

  /**  */
  remark?: string;

  /** 活动进展图片，以","分隔 */
  images?: string;

  /**  */
  publishedTime?: Date;

  /**  */
  status?: ValidStatus;

  /**  */
  id?: number;
}

export interface FundProjectProgressDto {
  /**  */
  organizationUnitId?: number;

  /** 进展标题 */
  title?: string;

  /** 所属项目Id */
  projectId?: number;

  /**  */
  fundProject?: FundProjectMiniDto;

  /** 简述 */
  summary?: string;

  /**  */
  status?: ValidStatus;

  /**  */
  publishedTime?: Date;

  /**  */
  publishUserId?: number;

  /**  */
  remark?: string;

  /** 活动进展图片，以","分隔 */
  images?: string;

  /**  */
  creatorUser?: UserMiniDto;

  /**  */
  isDeleted?: boolean;

  /**  */
  deleterUserId?: number;

  /**  */
  deletionTime?: Date;

  /**  */
  lastModificationTime?: Date;

  /**  */
  lastModifierUserId?: number;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  id?: number;
}

export interface FundProjectProgressDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: FundProjectProgressDto[];
}

export interface FundProjectMixtureMiniDto {
  /**  */
  fund?: FundMiniDto;

  /** 项目标题 */
  name?: string;

  /**  */
  projectType?: FundProjectType;

  /**  */
  id?: number;
}

export interface FundProjectYearSummaryDto {
  /**  */
  creatorUser?: UserMiniDto;

  /**  */
  fundProjectId?: number;

  /**  */
  organizationUnitId?: number;

  /**  */
  fundProject?: FundProjectMixtureMiniDto;

  /** 服务区域 */
  serviceArea?: string;

  /** 受益人数 */
  benefitNumber?: string;

  /** 活动效果 */
  activityEffect?: string;

  /**  */
  summarization?: string;

  /** 年份 */
  year?: number;

  /** 基金会点评 */
  appraise?: string;

  /** 点评时间 */
  appraisedTime?: Date;

  /** 点评人 */
  appraiseUserId?: number;

  /**  */
  appraiseUser?: UserMiniDto;

  /**  */
  isDeleted?: boolean;

  /**  */
  deleterUserId?: number;

  /**  */
  deletionTime?: Date;

  /**  */
  lastModificationTime?: Date;

  /**  */
  lastModifierUserId?: number;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  id?: number;
}

export interface FundProjectYearSummaryAppraiseInput {
  /**  */
  appraise?: string;

  /**  */
  id?: number;
}

export interface FundProjectYearSummaryCreateOrUpdateDto {
  /**  */
  fundProjectId?: number;

  /**  */
  organizationUnitId?: number;

  /** 服务区域 */
  serviceArea?: string;

  /** 受益人数 */
  benefitNumber?: string;

  /** 活动效果 */
  activityEffect?: string;

  /**  */
  summarization?: string;

  /** 年份 */
  year?: number;

  /**  */
  id?: number;
}

export interface FundProjectYearSummaryDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: FundProjectYearSummaryDto[];
}

export interface FundUserCreateOrUpdateDto {
  /** 账号 */
  userName?: string;

  /** 密码 */
  password?: string;

  /** 昵称 */
  name?: string;

  /** 邮箱 */
  emailAddress?: string;

  /** 姓名 */
  surname?: string;

  /** 手机号码 */
  phoneNumber?: string;

  /** 基金Id */
  fundId?: number;

  /** 性别 */
  sex?: string;

  /** 职务（数据字典且有对应枚举，所以value为1,2,3,4...） */
  duty?: string;

  /** 身份证号码 */
  idNo?: string;

  /** 所在企业 */
  company?: string;

  /** 企业职务 */
  companyDuty?: string;

  /** 成员图片\/用户头像 */
  headImgUrl?: string;

  /**  */
  id?: number;
}

export interface FundUserDto {
  /** 用户Id */
  userId?: number;

  /** 账号 */
  userName?: string;

  /** 昵称 */
  name?: string;

  /** 邮箱 */
  emailAddress?: string;

  /** 姓名 */
  surname?: string;

  /** 手机号码 */
  phoneNumber?: string;

  /** 基金Id */
  fundId?: number;

  /** 基金名称 */
  fundName?: string;

  /** 性别 */
  sex?: string;

  /** 职务（数据字典且有对应枚举，所以value为1,2,3,4...） */
  duty?: string;

  /** 身份证号码 */
  idNo?: string;

  /** 所在企业 */
  company?: string;

  /** 企业职务 */
  companyDuty?: string;

  /** 成员图片\/用户头像 */
  headImgUrl?: string;

  /**  */
  isDeleted?: boolean;

  /**  */
  deleterUserId?: number;

  /**  */
  deletionTime?: Date;

  /**  */
  lastModificationTime?: Date;

  /**  */
  lastModifierUserId?: number;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  id?: number;
}

export interface FundUserDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: FundUserDto[];
}

export interface InternalMonthlyPlanDetailCreateOrUpdateDto {
  /**  */
  id?: number;

  /**  */
  sequence?: number;

  /** 地点 */
  place?: string;

  /** 标题 */
  title?: string;

  /** 开始日期 */
  startDate?: Date;

  /** 结束日期 */
  endDate?: Date;

  /** 内容概述 */
  summary?: string;

  /** 合作方机构Id */
  partnerOrgId?: string;

  /**  */
  savedPartnerOrgIds?: number[];

  /** 所需支持 */
  needSupport?: string;

  /** 备注 */
  remark?: string;

  /**  */
  projectId?: number;

  /**  */
  auditFlowId?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /**  */
  enableRestartAudit?: boolean;
}

export interface InternalMonthlyPlanCreateOrUpdateDto {
  /** 日期 */
  date?: Date;

  /**  */
  auditFlowId?: string;

  /**  */
  projectId?: number;

  /**  */
  details?: InternalMonthlyPlanDetailCreateOrUpdateDto[];

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /**  */
  id?: number;
}

export interface InternalMonthlyPlanDetailDto {
  /**  */
  sequence?: number;

  /** 地点 */
  place?: string;

  /** 标题 */
  title?: string;

  /** 开始日期 */
  startDate?: Date;

  /** 结束日期 */
  endDate?: Date;

  /** 内容概述 */
  summary?: string;

  /** 合作方机构Id */
  partnerOrgId?: string;

  /**  */
  savedPartnerOrgIds?: number[];

  /** 所需支持 */
  needSupport?: string;

  /** 备注 */
  remark?: string;

  /**  */
  projectId?: number;

  /**  */
  internalMonthlyPlanId?: number;

  /**  */
  id?: number;
}

export interface InternalMonthlyPlanDto {
  /**  */
  auditFlowId?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /** 日期 */
  date?: Date;

  /** 年 */
  year?: number;

  /** 对应的月份 */
  month?: number;

  /**  */
  details?: InternalMonthlyPlanDetailDto[];

  /**  */
  project?: ProjectDto;

  /**  */
  id?: number;
}

export interface InternalMonthlyPlanDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: InternalMonthlyPlanDto[];
}

export interface InternalMonthlyPlanDtoListResultDto {
  /**  */
  items?: InternalMonthlyPlanDto[];
}

export interface InternalMonthlySummarizeDetailCreateOrUpdateDto {
  /**  */
  id?: number;

  /**  */
  sequence?: number;

  /** 地点 */
  place?: string;

  /** 标题 */
  title?: string;

  /** 开始日期 */
  startDate?: Date;

  /** 结束日期 */
  endDate?: Date;

  /** 原计划 */
  summary?: string;

  /** 合作方机构Id */
  partnerOrgId?: string;

  /**  */
  savedPartnerOrgIds?: number[];

  /** 执行概述 */
  executeSummary?: string;

  /** 受益人次 */
  benefitObjectCount?: number;

  /** 备注 */
  remark?: string;

  /**  */
  completeStatus?: ProjectMonthlyPlanCompleteStatus;

  /**  */
  savedAttachments?: number[];

  /**  */
  projectId?: number;

  /**  */
  internalMonthlyPlanDetailId?: number;
}

export interface InternalMonthlySummarizeCreateOrUpdateDto {
  /** 日期 */
  date?: Date;

  /**  */
  auditFlowId?: string;

  /** 对应月计划Id */
  internalMonthlyPlanId?: number;

  /**  */
  projectId?: number;

  /**  */
  details?: InternalMonthlySummarizeDetailCreateOrUpdateDto[];

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /**  */
  id?: number;
}

export interface InternalMonthlySummarizeDetailDto {
  /**  */
  sequence?: number;

  /** 地点 */
  place?: string;

  /** 标题 */
  title?: string;

  /** 开始日期 */
  startDate?: Date;

  /** 结束日期 */
  endDate?: Date;

  /** 原计划 */
  summary?: string;

  /** 合作方机构Id */
  partnerOrgId?: string;

  /** 执行概述 */
  executeSummary?: string;

  /** 受益人次 */
  benefitObjectCount?: number;

  /** 备注 */
  remark?: string;

  /**  */
  completeStatus?: ProjectMonthlyPlanCompleteStatus;

  /**  */
  internalMonthlySummarizeId?: number;

  /**  */
  savedAttachments?: number[];

  /**  */
  savedPartnerOrgIds?: number[];

  /**  */
  projectId?: number;

  /**  */
  internalMonthlyPlanDetailId?: number;

  /**  */
  id?: number;
}

export interface InternalMonthlySummarizeDto {
  /**  */
  auditFlowId?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /** 日期 */
  date?: Date;

  /**  */
  year?: number;

  /**  */
  month?: number;

  /** 对应月计划Id */
  internalMonthlyPlanId?: number;

  /**  */
  projectId?: number;

  /**  */
  project?: ProjectDto;

  /**  */
  details?: InternalMonthlySummarizeDetailDto[];

  /**  */
  id?: number;
}

export interface InternalMonthlySummarizeDtoListResultDto {
  /**  */
  items?: InternalMonthlySummarizeDto[];
}

export interface InternalMonthlySummarizeDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: InternalMonthlySummarizeDto[];
}

export interface InternalPersonalYearEndSummaryCreateOrUpdateDto {
  /** 年 */
  year?: number;

  /**  */
  role?: string;

  /**  */
  userName?: string;

  /**  */
  summary?: string;

  /**  */
  savedAttachments?: number[];

  /**  */
  auditFlowId?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /**  */
  id?: number;
}

export interface InternalPersonalYearEndSummaryDto {
  /** 年 */
  year?: number;

  /**  */
  role?: string;

  /**  */
  userName?: string;

  /**  */
  summary?: string;

  /**  */
  auditFlowId?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /**  */
  id?: number;
}

export interface InternalPersonalYearEndSummaryDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: InternalPersonalYearEndSummaryDto[];
}

export interface InternalPersonalYearEndSummaryDtoListResultDto {
  /**  */
  items?: InternalPersonalYearEndSummaryDto[];
}

export interface InternalProjectDto {
  /**  */
  projectId?: number;

  /**  */
  project?: ProjectDto;

  /** 项目概述 */
  summary?: string;

  /** 实施地点 */
  place?: string;

  /** 项目开始日期 */
  startDate?: Date;

  /** 项目结束日期 */
  endDate?: Date;

  /** 总预算 */
  totalMoney?: number;

  /**  */
  auditFlowId?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /**  */
  extensionData?: string;

  /**  */
  extensionObject?: object;

  /**  */
  id?: number;
}

export interface InternalProjectDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: InternalProjectDto[];
}

export interface InternalProjectBudgetItemDto {
  /**  */
  projectId?: number;

  /** 序列(显示顺序） */
  sequence?: number;

  /**  */
  projectBudgetCategory?: ProjectBudgetCategory;

  /**  */
  projectBudgetType?: ProjectBudgetType;

  /** 子项目内容（三级科目） */
  itemName?: string;

  /** 具体内容 */
  content?: string;

  /** 单价（元） */
  unitPrice?: number;

  /** 数量 */
  number?: number;

  /** 单位 */
  unit?: string;

  /** 预算报价 */
  budgetQuotation?: number;

  /**  */
  projectBudgetCapitalSource?: ProjectBudgetCapitalSource;

  /**  */
  id?: string;
}

export interface InternalProjectCreateOrUpdateDto {
  /** 项目名称 */
  displayName?: string;

  /** 项目类型，如：,1,11,111, */
  projectTypes?: string;

  /** 项目概述 */
  summary?: string;

  /** 实施地点 */
  place?: string;

  /** 项目开始日期 */
  startDate?: Date;

  /** 项目结束日期 */
  endDate?: Date;

  /** 项目预算明细 */
  budgetItems?: InternalProjectBudgetItemDto[];

  /** 向基金会申请资金 */
  applyMoney?: number;

  /** 自筹资金 */
  selfMoney?: number;

  /** 其他来源资金 */
  otherMoney?: number;

  /** 总预算 = 向基金会申请资金+自筹资金+其他来源资金 */
  totalMoney?: number;

  /**  */
  savedAttachments?: number[];

  /**  */
  auditFlowId?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /**  */
  formId?: number;

  /**  */
  extensionData?: string;

  /**  */
  extensionObject?: object;

  /**  */
  id?: number;
}

export interface InternalProjectDetailDto {
  /**  */
  projectId?: number;

  /**  */
  project?: ProjectDto;

  /** 项目名称 */
  displayName?: string;

  /** 项目类型，如：,1,11,111, */
  projectTypes?: string;

  /** 项目概述 */
  summary?: string;

  /** 实施地点 */
  place?: string;

  /** 项目开始日期 */
  startDate?: Date;

  /** 项目结束日期 */
  endDate?: Date;

  /** 项目预算明细 */
  budgetItems?: InternalProjectBudgetItemDto[];

  /** 向基金会申请资金 */
  applyMoney?: number;

  /** 自筹资金 */
  selfMoney?: number;

  /** 其他来源资金 */
  otherMoney?: number;

  /** 总预算 = 向基金会申请资金+自筹资金+其他来源资金 */
  totalMoney?: number;

  /**  */
  savedAttachments?: number[];

  /**  */
  auditFlowId?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /**  */
  formId?: number;

  /**  */
  extensionData?: string;

  /**  */
  extensionObject?: object;

  /**  */
  id?: number;
}

export interface UpdateInternalProjectBudgetItemDto {
  /** 项目预算明细 */
  budgetItems?: InternalProjectBudgetItemDto[];

  /**  */
  id?: number;
}

export interface InternalProjectDtoListResultDto {
  /**  */
  items?: InternalProjectDto[];
}

export interface InternalProjectPhasesItemDto {
  /**  */
  stage?: WorkflowOfProjectByInternal;

  /** 节点名称 */
  name?: string;

  /**  */
  status?: ProjectPhaseStatus;

  /** 跳转链接 */
  redirectUrl?: string[];
}

export interface InternalMicrocosmicDto {
  /**  */
  projectName?: string;

  /**  */
  startDate?: string;

  /**  */
  endDate?: string;

  /**  */
  status?: WorkflowOfProjectByInternal;

  /** 活动场次 */
  activityCount?: number;

  /** 受益人次 */
  actualBeneficiaryCount?: number;

  /** 受益人数 */
  beneficiaryCount?: number;

  /** 覆盖区域数量 */
  townCount?: number;

  /** 各类型合作方数量 */
  organizationUnitCount?: object;

  /** 预算金额 */
  budget?: number;

  /** 实际支出 */
  actualExpenses?: number;

  /** 服务次数 */
  serviceCount?: number;
}

export interface InternalMicrocosmicDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: InternalMicrocosmicDto[];
}

export interface InternalProjectSummaryReportCreateOrUpdateDto {
  /**  */
  projectId?: number;

  /** 年度 */
  year?: number;

  /** 填写人 */
  userName?: string;

  /** 项目总结内容 */
  summary?: string;

  /**  */
  savedAttachments?: number[];

  /**  */
  auditFlowId?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /**  */
  id?: number;
}

export interface InternalProjectSummaryReportDto {
  /**  */
  projectId?: number;

  /**  */
  project?: ProjectDto;

  /** 年度 */
  year?: number;

  /** 填写人 */
  userName?: string;

  /** 项目总结内容 */
  summary?: string;

  /**  */
  auditFlowId?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /**  */
  id?: number;
}

export interface InternalProjectSummaryReportDtoListResultDto {
  /**  */
  items?: InternalProjectSummaryReportDto[];
}

export interface InternalProjectSummaryReportDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: InternalProjectSummaryReportDto[];
}

export interface JobCreateOrUpdateDto {
  /** 信息标题 */
  title?: string;

  /** 封面图片 */
  titleImagePath?: string;

  /** 工作城市 */
  city?: string;

  /** 地址 */
  address?: string;

  /** 联系方式 */
  contact?: string;

  /** 薪资 */
  salary?: string;

  /** 招聘人数 */
  recruitNumber?: number;

  /**  */
  description?: string;

  /** 学历条件 */
  education?: string;

  /**  */
  id?: number;
}

export interface JobDto {
  /**  */
  creatorUser?: UserMiniDto;

  /** 信息标题 */
  title?: string;

  /** 封面图片 */
  titleImagePath?: string;

  /** 工作城市 */
  city?: string;

  /** 地址 */
  address?: string;

  /** 联系方式 */
  contact?: string;

  /** 薪资 */
  salary?: string;

  /** 招聘人数 */
  recruitNumber?: number;

  /**  */
  description?: string;

  /** 学历条件 */
  education?: string;

  /**  */
  status?: ValidStatus;

  /** 发布时间 */
  publishedTime?: Date;

  /**  */
  isDeleted?: boolean;

  /**  */
  deleterUserId?: number;

  /**  */
  deletionTime?: Date;

  /**  */
  lastModificationTime?: Date;

  /**  */
  lastModifierUserId?: number;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  id?: number;
}

export interface JobDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: JobDto[];
}

export interface MerchantCreateOrUpdateDto {
  /** 基金Id */
  fundId?: number;

  /** 单位名称 */
  unitName?: string;

  /** 单位地址 */
  unitAddress?: string;

  /** 负责人姓名 */
  principalName?: string;

  /** 负责人手机号 */
  principalMobilePhone?: string;

  /** 负责人邮箱 */
  principalEmailAddress?: string;

  /** 联系人姓名 */
  contactName?: string;

  /** 联系人手机号 */
  contactMobilePhone?: string;

  /** 联系人邮箱 */
  contactEmailAddress?: string;

  /**  */
  id?: number;
}

export interface MerchantDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: MerchantDto[];
}

export interface MerchantBankAccountCreateOrUpdateDto {
  /** 客商主表Id */
  merchantId?: number;

  /** 银行账号 */
  bankAccountCode?: string;

  /**  */
  bankTypePK?: string;

  /** 银行名称 */
  bankNamePK?: string;

  /** 户名 */
  bankAccountName?: string;

  /**  */
  id?: number;
}

export interface MerchantBankAccountDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: MerchantBankAccountDto[];
}

export interface MessageCreateOrUpdateDto {
  /**  */
  savedAttachments?: number[];

  /** 消息标题 */
  title?: string;

  /** 消息内容 */
  content?: string;

  /**  */
  messageType?: MessageType;

  /**  */
  status?: ValidStatus;

  /**  */
  id?: number;
}

export interface MessageDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: MessageDto[];
}

export interface NotifyTemplateDto {
  /**  */
  organizationUnitId?: number;

  /**  */
  organizationUnit?: OrganizationUnitShortDto;

  /** 评估计划模板名称 */
  title?: string;

  /** 评估计划模板内容（富文本） */
  content?: string;

  /**  */
  notifyTemplateType?: NotifyTemplateType;

  /**  */
  isDeleted?: boolean;

  /**  */
  deleterUserId?: number;

  /**  */
  deletionTime?: Date;

  /**  */
  lastModificationTime?: Date;

  /**  */
  lastModifierUserId?: number;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  id?: number;
}

export interface NotifyRecordDetailDto {
  /**  */
  organizationUnit?: OrganizationUnitShortDto;

  /**  */
  project?: ProjectDto;

  /**  */
  notifyTemplate?: NotifyTemplateDto;

  /** 项目Id */
  hostId?: number;

  /**  */
  notifyType?: NotifyTemplateType;

  /** 通知模板Id */
  notifyTemplateId?: number;

  /** 通知标题 */
  title?: string;

  /** 通知内容（富文本） */
  content?: string;

  /**  */
  id?: number;
}

export interface NotifyRecordCreateOrUpdateDto {
  /** 项目Id */
  hostId?: number;

  /**  */
  notifyType?: NotifyTemplateType;

  /** 通知模板Id */
  notifyTemplateId?: number;

  /** 通知标题 */
  title?: string;

  /** 通知内容（富文本） */
  content?: string;

  /**  */
  id?: number;
}

export interface NotifyRecordDto {
  /**  */
  organizationUnitId?: number;

  /**  */
  organizationUnit?: OrganizationUnitShortDto;

  /** 项目Id */
  hostId?: number;

  /**  */
  notifyType?: NotifyTemplateType;

  /** 通知模板Id */
  notifyTemplateId?: number;

  /** 通知标题 */
  title?: string;

  /** 通知内容（富文本） */
  content?: string;

  /** 发送时间 */
  creationTime?: Date;

  /**  */
  id?: number;
}

export interface NotifyRecordDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: NotifyRecordDto[];
}

export interface NotifyTemplateDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: NotifyTemplateDto[];
}

export interface NotifyTemplateCreateOrUpdateDto {
  /** 评估计划模板名称 */
  title?: string;

  /** 评估计划模板内容（富文本） */
  content?: string;

  /**  */
  notifyTemplateType?: NotifyTemplateType;

  /**  */
  id?: number;
}

export interface OrderCreateOrUpdateDto {
  /** 订单号 */
  orderNo?: string;

  /** 关联表Id */
  applyId?: number;

  /** 标题 */
  title?: string;

  /** 图片 */
  titleImagePath?: string;

  /**  */
  type?: OrderType;

  /** 订单金额 */
  priceTotal?: number;

  /** 付款金额 */
  payedMoney?: number;

  /** 是否在线支付 */
  isOnlinePayed?: boolean;

  /** 备注 */
  remark?: string;

  /**  */
  status?: OrderStatus;

  /** 支付时间 */
  payedTime?: Date;

  /** 交易号 */
  tradeNo?: string;

  /** 是否回调 */
  isResponse?: boolean;

  /** 回调时间 */
  responseTime?: Date;

  /** 回调结果 */
  resultMessage?: string;

  /** 取消时间 */
  cancelTime?: Date;

  /** 取消原因 */
  cancelReason?: string;

  /**  */
  id?: number;
}

export interface OrderCreateOrUpdateDtoGetForEditOutput {
  /**  */
  data?: OrderCreateOrUpdateDto;

  /**  */
  schema?: any | null;

  /**  */
  uiSchema?: any | null;

  /**  */
  errorSchema?: any | null;
}

export interface OrderDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: OrderDto[];
}

export interface OrganizationUnitPagedResultRequestDto {
  /**  */
  displayName?: string;

  /** 机构的类型(数据字典的ID） */
  organizationType?: number;

  /**  */
  isApply?: boolean;

  /**  */
  status?: OrganizationStatus;

  /**  */
  principalName?: string;

  /**  */
  mobilePhone?: string;

  /**  */
  emailAddress?: string;

  /** 联系人姓名 */
  contactName?: string;

  /** 联系人手机号 */
  contactMobilePhone?: string;

  /** 联系人邮箱 */
  contactEmailAddress?: string;

  /** 每页记录数，用作替换MaxResultCount */
  pageSize?: number;

  /**  */
  skipCount?: number;

  /** 页码，用来替换SkipCount */
  pageIndex?: number;

  /**  */
  sorting?: string;

  /**  */
  maxResultCount?: number;
}

export interface OrganizationUnitCreateOrUpdateDto {
  /**  */
  inviteCode?: string;

  /**  */
  logoImageUrl?: string;

  /**  */
  displayName?: string;

  /** 机构类型,数据字典Id */
  organizationType?: number;

  /**  */
  areaSelect?: AreaSelectDto;

  /** 地点 */
  place?: string;

  /** 负责人姓名 */
  principalName?: string;

  /** 主要负责人的手机号 */
  mobilePhone?: string;

  /** 主要负责人的邮箱 */
  emailAddress?: string;

  /** 联系人姓名 */
  contactName?: string;

  /** 联系人手机号 */
  contactMobilePhone?: string;

  /** 联系人邮箱 */
  contactEmailAddress?: string;

  /** 统一社会信用代码 */
  creditCode?: string;

  /** 合作方银行账号名称 */
  bankAccountName?: string;

  /** 开户行信息 */
  bankName?: string;

  /** 开户账号 */
  bankAccount?: string;

  /** 收件人 */
  receiverName?: string;

  /** 收件地址 */
  receiverAddress?: string;

  /** 收件电话 */
  receiverMobile?: string;

  /** 法人登记证书复印件 */
  certificateImagePath?: string;

  /**  */
  extensionData?: string;

  /**  */
  auditFlowId?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /**  */
  extensionObject?: object;

  /**  */
  formId?: number;

  /**  */
  id?: number;
}

export interface PartnerInviteDto {
  /** 被邀请的机构名称 */
  organizationName?: string;

  /**  */
  organizationType?: number;

  /**  */
  emailAddress?: string;

  /**  */
  mobile?: string;

  /** 邀约的说明内容 */
  content?: string;

  /**  */
  hasUsed?: boolean;

  /**  */
  isDeleted?: boolean;

  /**  */
  deleterUserId?: number;

  /**  */
  deletionTime?: Date;

  /**  */
  lastModificationTime?: Date;

  /**  */
  lastModifierUserId?: number;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  id?: number;
}

export interface OrganizationUnitLoginAccountResult {
  /**  */
  userId?: number;

  /**  */
  userName?: string;

  /**  */
  password?: string;
}

export interface OrganizationUnitDtoListResultDto {
  /**  */
  items?: OrganizationUnitDto[];
}

export interface OrganizationUnitDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: OrganizationUnitDto[];
}

export interface PartnerCapitalApplyDetailCreateOrUpdateDto {
  /**  */
  sequence?: number;

  /** 资金用途 */
  purpose?: string;

  /** 单价（元） */
  unitPrice?: number;

  /** 数量 */
  number?: number;

  /** 单位 */
  unit?: string;

  /** 预算（元） */
  budgetQuotation?: number;

  /** 配比资金（元） */
  otherFund?: number;

  /** 配比资金来源 */
  otherFundSource?: string;

  /**  */
  id?: string;
}

export interface PartnerCapitalApplyCreateOrUpdateDto {
  /** 项目Id */
  projectId?: number;

  /** 机构联系人 */
  contactName?: string;

  /** 申请理由 */
  applyReason?: string;

  /** 资金预算明细 */
  partnerCapitalApplyDetails?: PartnerCapitalApplyDetailCreateOrUpdateDto[];

  /** 合计申请资金（元） */
  totalApplyMoney?: number;

  /**  */
  auditFlowId?: string;

  /**  */
  id?: number;
}

export interface PartnerCapitalApplyDto {
  /** 项目Id */
  projectId?: number;

  /**  */
  project?: ProjectDto;

  /**  */
  organizationUnit?: OrganizationUnitShortDto;

  /** 机构联系人 */
  contactName?: string;

  /** 申请理由 */
  applyReason?: string;

  /** 资金预算明细 */
  partnerCapitalApplyDetails?: PartnerCapitalApplyDetailCreateOrUpdateDto[];

  /** 合计申请资金（元） */
  totalApplyMoney?: number;

  /**  */
  auditFlowId?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /**  */
  creationTime?: Date;

  /**  */
  id?: number;
}

export interface PartnerCapitalApplyDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: PartnerCapitalApplyDto[];
}

export interface PartnerCapitalApplyDtoListResultDto {
  /**  */
  items?: PartnerCapitalApplyDto[];
}

export interface PartnerInviteCreateOrUpdateDto {
  /** 被邀请的机构名称 */
  organizationName?: string;

  /** 机构类型,数据字典Id */
  organizationType?: number;

  /**  */
  emailAddress?: string;

  /**  */
  mobile?: string;

  /** 邀约的说明内容 */
  content?: string;

  /**  */
  id?: number;
}

export interface PartnerInviteDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: PartnerInviteDto[];
}

export interface TenPayNotifyXml {
  /**  */
  appid?: string;

  /**  */
  mch_id?: string;

  /**  */
  device_info?: string;

  /**  */
  nonce_str?: string;

  /**  */
  sign?: string;

  /**  */
  result_code?: string;

  /**  */
  err_code?: string;

  /**  */
  err_code_des?: string;

  /** 交易类型 */
  trade_type?: string;

  /** 付款银行 ,银行类型，采用字符串类型的银行标识，银行类型见银行列表 */
  bank_type?: string;

  /** is_subscribe 用户是否关注公众账号，Y-关注，N-未关注 */
  is_subscribe?: string;

  /**  */
  openid?: string;

  /**  */
  total_fee?: string;

  /**  */
  settlement_total_fee?: number;

  /**  */
  fee_type?: string;

  /**  */
  cash_fee?: string;

  /**  */
  cash_fee_type?: string;

  /** 微信支付订单号 */
  transaction_id?: string;

  /** 商户订单号 */
  out_trade_no?: string;

  /** 支付完成时间 */
  time_end?: string;

  /**  */
  return_code?: string;

  /**  */
  return_msg?: string;
}

export interface SummaryDto {
  /**  */
  totalBeneficiaries?: number;

  /**  */
  totalProjects?: number;

  /**  */
  totalAmount?: number;
}

export interface PermissionDefinitionCreateOrUpdateDto {
  /** 权限的键 */
  name?: string;

  /** 显示的名称 */
  displayName?: string;

  /**  */
  displayOrder?: number;

  /**  */
  url?: string;

  /** 是否不在菜单中显示 */
  isHiddenForMenu?: boolean;

  /**  */
  icon?: string;

  /**  */
  parentId?: number;

  /**  */
  permissionDefinitionScopes?: PermissionDefinitionScope[];

  /** 开启数据权限 */
  enableDataPermission?: boolean;

  /** 开启按创建人过滤，其中包括“仅自己、本部门、本部门及下属部门” */
  enableDataPermissionForCreator?: boolean;

  /** 开启数据范围过滤 */
  enableDataPermissionSpecifiedLimit?: boolean;

  /** 指定数据范围的数据源。 当开启数据范围过滤时，填写此值。 */
  dataPermissionSpecifiedDataSourceProvider?: string;

  /**  */
  id?: number;
}

export interface PermissionDefinitionDto {
  /** 权限的键 */
  name?: string;

  /** 显示的名称 */
  displayName?: string;

  /**  */
  displayOrder?: number;

  /**  */
  url?: string;

  /** 是否不在菜单中显示 */
  isHiddenForMenu?: boolean;

  /**  */
  icon?: string;

  /**  */
  parentId?: number;

  /**  */
  permissionDefinitionScopes?: PermissionDefinitionScope[];

  /** 开启数据权限 */
  enableDataPermission?: boolean;

  /** 开启按创建人过滤，其中包括“仅自己、本部门、本部门及下属部门” */
  enableDataPermissionForCreator?: boolean;

  /** 开启数据范围过滤 */
  enableDataPermissionSpecifiedLimit?: boolean;

  /** 指定数据范围的数据源。 当开启数据范围过滤时，填写此值。 */
  dataPermissionSpecifiedDataSourceProvider?: string;

  /**  */
  isDeleted?: boolean;

  /**  */
  deleterUserId?: number;

  /**  */
  deletionTime?: Date;

  /**  */
  lastModificationTime?: Date;

  /**  */
  lastModifierUserId?: number;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  id?: number;
}

export interface StringStringKeyValuePair {
  /**  */
  key?: string;

  /**  */
  value?: string;
}

export interface PermissionDefinitionDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: PermissionDefinitionDto[];
}

export interface ProjectFullInfoDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: ProjectFullInfoDto[];
}

export interface ProjectBasicDetailUpdateDto {
  /** 项目图片 */
  titleImagePath?: string;

  /** 项目成果 */
  projectResult?: string;

  /** 项目类型，这个不用传，传数组即可 */
  projectTypes?: string;

  /** 中期报告提交时间 */
  progressReportDate?: Date;

  /** 末期报告提交时间 */
  summaryReportDate?: Date;

  /** 项目人员Id */
  projectManagerIds?: number[];

  /**  */
  projectTypesArrary?: string[];

  /**  */
  id?: number;
}

export interface ProjectOrganizationUnitMappingDto {
  /**  */
  projectId?: number;

  /** 合作机构Id */
  organizationUnitIds?: number[];
}

export interface ProjectCreateOrUpdateDto {
  /**  */
  id?: number;
}

export interface ProjectBeneficiaryMappingDto {
  /**  */
  projectId?: number;

  /**  */
  project?: ProjectDto;

  /**  */
  beneficiaryId?: number;

  /**  */
  organizationUnitId?: number;

  /**  */
  organizationUnit?: OrganizationUnitShortDto;

  /**  */
  extensionData?: string;

  /**  */
  extensionObject?: object;

  /**  */
  auditFlowId?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /** 个案编号 */
  code?: string;

  /** 负责人 */
  principalName?: string;

  /** 负责人电话 */
  principalPhone?: string;

  /** 姓名 */
  realName?: string;

  /** 性别(男,女) */
  sex?: string;

  /** 出生日期 */
  birthday?: Date;

  /** 民族 */
  nation?: string;

  /** 联系电话 */
  phone?: string;

  /** 身份证号 */
  idNo?: string;

  /**  */
  provinceId?: number;

  /**  */
  provinceName?: string;

  /**  */
  cityId?: number;

  /**  */
  cityName?: string;

  /**  */
  areaId?: number;

  /**  */
  areaName?: string;

  /**  */
  townId?: number;

  /**  */
  townName?: string;

  /** 详细地址 */
  homeAddress?: string;

  /** 是否为建档立卡户 */
  isEnjoyOtherSalvation?: boolean;

  /** 建档立卡金额(元\/月) */
  otherSalvationAmount?: number;

  /** 是否享受低保政策 */
  isEnjoyTheSubsistenceAllowancePolicy?: boolean;

  /** 低保金额(元\/月) */
  subsistenceAllowanceAmount?: number;

  /**  */
  areaSelect?: AreaSelectDto;

  /** 家庭成员情况 */
  familyMembersInfoList?: FamilyMembersInfoDto[];

  /**  */
  id?: number;
}

export interface ProjectBeneficiaryMappingDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: ProjectBeneficiaryMappingDto[];
}

export interface ProjectBeneficiaryMappingDtoListResultDto {
  /**  */
  items?: ProjectBeneficiaryMappingDto[];
}

export interface ProjectBeneficiaryMappingCreateOrUpdateDto {
  /** 受益人ID */
  beneficiaryId?: number;

  /**  */
  projectId?: number;

  /**  */
  organizationUnitId?: number;

  /**  */
  extensionObject?: object;

  /**  */
  auditFlowId?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /**  */
  extensionData?: string;

  /**  */
  formId?: number;

  /** 个案编号 */
  code?: string;

  /** 负责人 */
  principalName?: string;

  /** 负责人电话 */
  principalPhone?: string;

  /** 姓名 */
  realName?: string;

  /** 性别(男,女) */
  sex?: string;

  /** 出生日期 */
  birthday?: Date;

  /** 民族 */
  nation?: string;

  /** 联系电话 */
  phone?: string;

  /** 身份证号 */
  idNo?: string;

  /**  */
  provinceId?: number;

  /**  */
  provinceName?: string;

  /**  */
  cityId?: number;

  /**  */
  cityName?: string;

  /**  */
  areaId?: number;

  /**  */
  areaName?: string;

  /**  */
  townId?: number;

  /**  */
  townName?: string;

  /**  */
  areaSelect?: AreaSelectDto;

  /** 详细地址 */
  homeAddress?: string;

  /** 是否为建档立卡户 */
  isEnjoyOtherSalvation?: boolean;

  /** 建档立卡金额(元\/月) */
  otherSalvationAmount?: number;

  /** 是否享受低保政策 */
  isEnjoyTheSubsistenceAllowancePolicy?: boolean;

  /** 低保金额(元\/月) */
  subsistenceAllowanceAmount?: number;

  /**  */
  savedAttachments?: number[];

  /** 家庭成员情况 */
  familyMembersInfoList?: FamilyMembersInfoDto[];

  /**  */
  id?: number;
}

export interface ProjectInviteCreateDto {
  /** 项目名称 */
  displayName?: string;

  /** 是否内部项目 */
  isInternal?: boolean;

  /** 所属系列Id，数据字典,外部项目固定为行业支持 */
  projectSeriesId?: number;

  /** 所属年度 */
  year?: number;

  /** 邀约合作机构Id */
  organizationUnitId?: number[];

  /** 项目负责人Id */
  projectManagerIds?: number[];

  /**  */
  id?: number;
}

export interface ProjectSeriesShortDto {
  /** 系列名称 */
  title?: string;

  /**  */
  id?: number;
}

export interface ProjectInviteDto {
  /** 项目名称 */
  displayName?: string;

  /**  */
  project?: ProjectDto;

  /** 是否内部项目 */
  isInternal?: boolean;

  /**  */
  projectSeries?: ProjectSeriesShortDto;

  /** 所属年度 */
  year?: number;

  /** 邀约合作机构Id */
  organizationUnitId?: number;

  /**  */
  organizationUnit?: OrganizationUnitShortDto;

  /**  */
  projectManagerList?: UserDto[];

  /**  */
  id?: number;
}

export interface ProjectInviteDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: ProjectInviteDto[];
}

export interface ProjectSeriesDto {
  /** 系列名称 */
  title?: string;

  /** 图片 */
  titleImagePath?: string;

  /** 是否公开显示 */
  isPublicShow?: boolean;

  /** 序号 */
  sequence?: number;

  /** 是否默认，默认时不可删除 */
  isDefault?: boolean;

  /**  */
  id?: number;
}

export interface ProjectSeriesDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: ProjectSeriesDto[];
}

export interface ProjectSeriesCreateOrUpdateDto {
  /** 系列名称 */
  title?: string;

  /** 图片 */
  titleImagePath?: string;

  /** 是否公开显示 */
  isPublicShow?: boolean;

  /** 序号 */
  sequence?: number;

  /**  */
  id?: number;
}

export interface ProvinceCreateOrUpdateDto {
  /**  */
  provinceName?: string;

  /**  */
  shortName?: string;

  /**  */
  id?: number;
}

export interface ProvinceDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: ProvinceDto[];
}

export interface DataPermissionSettingDto {
  /**  */
  permissionCode?: string;

  /**  */
  scope?: DataPermissionScopeType;

  /**  */
  details?: string[];
}

export interface RoleCreateOrUpdateDto {
  /**  */
  name?: string;

  /**  */
  displayName?: string;

  /**  */
  normalizedName?: string;

  /**  */
  description?: string;

  /** 是否为默认的角色 */
  isDefault?: boolean;

  /** 是否为固定角色 */
  isStatic?: boolean;

  /**  */
  grantedPermissions?: string[];

  /**  */
  roleScopes?: PermissionDefinitionScope[];

  /**  */
  dataPermissionSettings?: DataPermissionSettingDto[];

  /**  */
  id?: number;
}

export interface RoleDto {
  /**  */
  name?: string;

  /**  */
  displayName?: string;

  /**  */
  normalizedName?: string;

  /**  */
  description?: string;

  /**  */
  grantedPermissions?: string[];

  /**  */
  isStatic?: boolean;

  /**  */
  isDefault?: boolean;

  /**  */
  roleScopes?: PermissionDefinitionScope[];

  /**  */
  id?: number;
}

export interface RoleListDto {
  /**  */
  name?: string;

  /**  */
  displayName?: string;

  /**  */
  isStatic?: boolean;

  /**  */
  isDefault?: boolean;

  /**  */
  creationTime?: Date;

  /**  */
  roleScopes?: PermissionDefinitionScope[];

  /**  */
  id?: number;
}

export interface RoleListDtoListResultDto {
  /**  */
  items?: RoleListDto[];
}

export interface PermissionDto {
  /**  */
  name?: string;

  /**  */
  displayName?: string;

  /**  */
  description?: string;

  /**  */
  id?: number;
}

export interface PermissionDtoListResultDto {
  /**  */
  items?: PermissionDto[];
}

export interface CreateRoleDto {
  /**  */
  name?: string;

  /**  */
  displayName?: string;

  /**  */
  normalizedName?: string;

  /**  */
  description?: string;

  /**  */
  grantedPermissions?: string[];

  /**  */
  id?: number;

  /**  */
  isDefault?: boolean;

  /**  */
  isStatic?: boolean;

  /**  */
  roleScopes?: PermissionDefinitionScope[];
}

export interface GetRoleForEditOutput {
  /**  */
  role?: CreateRoleDto;

  /**  */
  permissions?: PermissionDefinitionDto[];

  /**  */
  grantedPermissions?: PermissionDefinitionDto[];
}

export interface RoleDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: RoleDto[];
}

export interface DisplayItem {
  /**  */
  id?: string;

  /**  */
  displayName?: string;
}

export interface ApplicationInfoDto {
  /**  */
  version?: string;

  /**  */
  releaseDate?: Date;

  /**  */
  features?: object;
}

export interface UserLoginInfoDto {
  /**  */
  name?: string;

  /**  */
  surname?: string;

  /**  */
  userName?: string;

  /**  */
  emailAddress?: string;

  /**  */
  id?: number;
}

export interface TenantLoginInfoDto {
  /**  */
  tenancyName?: string;

  /**  */
  name?: string;

  /**  */
  id?: number;
}

export interface GetCurrentLoginInformationsOutput {
  /**  */
  application?: ApplicationInfoDto;

  /**  */
  user?: UserLoginInfoDto;

  /**  */
  tenant?: TenantLoginInfoDto;

  /**  */
  organizationUnit?: OrganizationUnitDto;

  /**  */
  permissions?: string[];
}

export interface SwiperCreateOrUpdateDto {
  /**  */
  redirectUrl?: string;

  /**  */
  displayOrder?: number;

  /**  */
  titleImageUrl?: string;

  /** 名称 */
  displayName?: string;

  /**  */
  remark?: string;

  /**  */
  cmsAnchorId?: number;

  /**  */
  id?: number;
}

export interface SwiperDto {
  /**  */
  redirectUrl?: string;

  /**  */
  displayOrder?: number;

  /**  */
  titleImageUrl?: string;

  /** 名称 */
  displayName?: string;

  /**  */
  cmsAnchorId?: number;

  /**  */
  remark?: string;

  /**  */
  anchor?: CmsAnchorDto;

  /**  */
  id?: number;
}

export interface SwiperDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: SwiperDto[];
}

export interface CreateTenantDto {
  /**  */
  tenancyName?: string;

  /**  */
  name?: string;

  /**  */
  adminEmailAddress?: string;

  /**  */
  connectionString?: string;

  /**  */
  isActive?: boolean;
}

export interface TenantDto {
  /**  */
  tenancyName?: string;

  /**  */
  name?: string;

  /**  */
  isActive?: boolean;

  /**  */
  id?: number;
}

export interface TenantDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: TenantDto[];
}

export interface TenantAccessRecordCreateDto {
  /**  */
  tenantId?: number;

  /** 类型 */
  type?: string;

  /** 访问日期 */
  date?: Date;
}

export interface TenantAccountRecordDto {
  /** 金额 */
  moneyAmount?: number;

  /**  */
  recordType?: TenantAccountRecordType;

  /** 内容 */
  content?: string;

  /** 是否属于基金托管 */
  isFundOwner?: boolean;

  /** 是否线上支付 */
  isOnLinePayment?: boolean;

  /** 数据字典维护 */
  paymentType?: string;

  /** 对应收入记录ID */
  incomeRecordId?: number;

  /**  */
  isDeleted?: boolean;

  /**  */
  deleterUserId?: number;

  /**  */
  deletionTime?: Date;

  /**  */
  lastModificationTime?: Date;

  /**  */
  lastModifierUserId?: number;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  id?: number;
}

export interface TenantAccountRecordDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: TenantAccountRecordDto[];
}

export interface TenantAccountDto {
  /** 可用余额 */
  availableMoney?: number;

  /** 可用基金余额 */
  availableFundMoney?: number;

  /** 累计拨付金额 */
  appropriatedMoney?: number;

  /**  */
  isDeleted?: boolean;

  /**  */
  deleterUserId?: number;

  /**  */
  deletionTime?: Date;

  /**  */
  lastModificationTime?: Date;

  /**  */
  lastModifierUserId?: number;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  id?: number;
}

export interface TenantBankAccountCreateOrUpdateDto {
  /** 银行账号 */
  bankAccountCode?: string;

  /** 银行名称 */
  bankName?: string;

  /** 户名 */
  bankAccountName?: string;

  /**  */
  id?: number;
}

export interface TenantBankAccountDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: TenantBankAccountDto[];
}

export interface TestDetail {
  /**  */
  year?: number;

  /**  */
  month?: number;

  /**  */
  value?: string;

  /**  */
  id?: number;
}

export interface TestMainCreateOrUpdateDto {
  /**  */
  name?: string;

  /**  */
  title?: string;

  /**  */
  testDetails?: TestDetail[];

  /**  */
  id?: number;
}

export interface TestDetailDto {
  /**  */
  year?: number;

  /**  */
  month?: number;

  /**  */
  value?: string;

  /**  */
  id?: number;
}

export interface TestMainDto {
  /**  */
  name?: string;

  /**  */
  title?: string;

  /**  */
  testDetails?: TestDetailDto[];

  /**  */
  id?: number;
}

export interface TestMainDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: TestMainDto[];
}

export interface AuthenticateModel {
  /**  */
  userNameOrEmailAddress?: string;

  /**  */
  password?: string;

  /**  */
  rememberClient?: boolean;
}

export interface AuthenticateResultModel {
  /**  */
  accessToken?: string;

  /**  */
  encryptedAccessToken?: string;

  /**  */
  expireInSeconds?: number;

  /**  */
  userId?: number;
}

export interface ExternalLoginProviderInfoModel {
  /**  */
  name?: string;

  /**  */
  clientId?: string;
}

export interface ExternalAuthenticateModel {
  /**  */
  authProvider?: string;

  /**  */
  providerKey?: string;

  /**  */
  providerAccessCode?: string;
}

export interface TownCreateOrUpdateDto {
  /**  */
  areaId?: number;

  /**  */
  townName?: string;

  /**  */
  id?: number;
}

export interface TownDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: TownDto[];
}

export interface CreateUserDto {
  /**  */
  userName?: string;

  /**  */
  name?: string;

  /**  */
  surname?: string;

  /**  */
  emailAddress?: string;

  /** 所属部门 */
  departmentId?: number;

  /**  */
  isActive?: boolean;

  /**  */
  roleNames?: string[];

  /**  */
  password?: string;

  /**  */
  organizationUnitId?: number;

  /**  */
  phoneNumber?: string;
}

export interface UserDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: UserDto[];
}

export interface RoleDtoListResultDto {
  /**  */
  items?: RoleDto[];
}

export interface ChangeUserLanguageDto {
  /**  */
  languageName?: string;
}

export interface UserOrganizationUnitDto {
  /**  */
  user?: UserDto;

  /**  */
  organizationUnit?: OrganizationUnitDto;

  /**  */
  userName?: string;

  /**  */
  name?: string;

  /**  */
  surname?: string;

  /**  */
  emailAddress?: string;

  /**  */
  isActive?: boolean;

  /**  */
  fullName?: string;

  /**  */
  lastLoginTime?: Date;

  /**  */
  creationTime?: Date;

  /**  */
  departmentId?: number;

  /**  */
  departmentName?: string;

  /**  */
  roleNames?: string[];

  /**  */
  organizationUnitId?: number;

  /**  */
  phoneNumber?: string;

  /**  */
  userType?: UserType;

  /**  */
  fundId?: number;

  /** 成员图片\/用户头像 */
  headImgUrl?: string;

  /** 公众号openId */
  openId?: string;

  /**  */
  id?: number;
}

export interface UserOrganizationUnitDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: UserOrganizationUnitDto[];
}

export interface UserProfileUpdateDto {
  /** 昵称 */
  name?: string;

  /** 性别 */
  sex?: string;

  /** 住址 */
  address?: string;

  /** 自我介绍 */
  description?: string;

  /**  */
  provinceId?: number;

  /**  */
  cityId?: number;

  /**  */
  headImgUrl?: string;

  /**  */
  id?: number;
}

export interface ChangePasswordDto {
  /**  */
  currentPassword?: string;

  /**  */
  newPassword?: string;
}

export interface ResetPasswordDto {
  /**  */
  adminPassword?: string;

  /**  */
  userId?: number;

  /**  */
  newPassword?: string;
}

export interface ResetPassword4PortalDto {
  /**  */
  phone?: string;

  /**  */
  newPassword?: string;
}

export interface UserTaskCreateOrUpdateDto {
  /**  */
  auditFlowId?: string;

  /**  */
  savedAttachments?: number[];

  /** 紧急程度Id */
  importantLevelId?: number;

  /** TagId */
  tagId?: number;

  /** 被指派人Id */
  permissionUserId?: number;

  /** 对应的活动Id */
  activityId?: number;

  /** 任务标题 */
  title?: string;

  /** 任务内容 */
  content?: string;

  /** 任务开始时间 */
  startTime?: Date;

  /** 任务结束时间 */
  endTime?: Date;

  /**  */
  id?: number;
}

export interface UserTaskDto {
  /**  */
  auditFlowId?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /**  */
  creatorUser?: UserMiniDto;

  /** 紧急程度Id */
  importantLevelId?: number;

  /**  */
  importantLevel?: DataDictionaryDto;

  /** TagId */
  tagId?: number;

  /**  */
  tag?: DataDictionaryDto;

  /** 被指派人Id */
  permissionUserId?: number;

  /**  */
  permissionUser?: UserMiniDto;

  /** 对应的活动Id */
  activityId?: number;

  /**  */
  activity?: ActivityDto;

  /** 任务标题 */
  title?: string;

  /** 任务内容 */
  content?: string;

  /**  */
  type?: TaskType;

  /**  */
  status?: TaskStatus;

  /** 审核不通过理由 */
  sendbackReason?: string;

  /** 任务开始时间 */
  startTime?: Date;

  /** 任务结束时间 */
  endTime?: Date;

  /** 提交时间 */
  submitTime?: Date;

  /** 审核通过时间 */
  approvedTime?: Date;

  /** 审核不通过时间 */
  sendbackTime?: Date;

  /**  */
  isDeleted?: boolean;

  /**  */
  deleterUserId?: number;

  /**  */
  deletionTime?: Date;

  /**  */
  lastModificationTime?: Date;

  /**  */
  lastModifierUserId?: number;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  id?: number;
}

export interface UserTaskDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: UserTaskDto[];
}

export interface UserTaskDtoListResultDto {
  /**  */
  items?: UserTaskDto[];
}

export interface Fund {
  /**  */
  tenantId?: number;

  /**  */
  organizationUnitId?: number;

  /**  */
  creatorUser?: User;

  /**  */
  name?: string;

  /**  */
  titleImage?: string;

  /**  */
  founderName?: string;

  /**  */
  mobileTelephone?: string;

  /**  */
  fixTelephone?: string;

  /**  */
  email?: string;

  /**  */
  qq?: string;

  /**  */
  foundDate?: Date;

  /**  */
  purpose?: string;

  /**  */
  managementFeePercentage?: number;

  /**  */
  intialCaptial?: number;

  /**  */
  capitalSource?: string;

  /**  */
  focusArea?: string;

  /**  */
  summary?: string;

  /**  */
  description?: string;

  /**  */
  viceChairman?: string;

  /**  */
  chairman?: string;

  /**  */
  member?: string;

  /**  */
  contacts?: string;

  /**  */
  type?: FundType;

  /**  */
  status?: ValidStatus;

  /**  */
  honorType?: string;

  /**  */
  isPublished?: boolean;

  /**  */
  raisedAmountTotal?: number;

  /**  */
  donatedPersonTotal?: number;

  /**  */
  expenseAmountTotal?: number;

  /**  */
  directorID?: number;

  /**  */
  director?: User;

  /**  */
  instructionsImage?: string;

  /**  */
  plaqueImage?: string;

  /**  */
  canAnonymous?: boolean;

  /**  */
  hasProducts?: boolean;

  /**  */
  isFundRaising?: boolean;

  /**  */
  fundCategory?: string;

  /**  */
  isDeleted?: boolean;

  /**  */
  deleterUserId?: number;

  /**  */
  deletionTime?: Date;

  /**  */
  lastModificationTime?: Date;

  /**  */
  lastModifierUserId?: number;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  id?: number;
}

export interface UserExtendDto {
  /**  */
  tenantId?: number;

  /**  */
  userType?: UserType;

  /**  */
  userId?: number;

  /**  */
  user?: User;

  /**  */
  fundId?: number;

  /**  */
  fund?: Fund;

  /** 性别 */
  sex?: string;

  /** 职务（数据字典且有对应枚举，所以value为1,2,3,4...） */
  duty?: string;

  /** 身份证号码 */
  idNo?: string;

  /** 所在企业 */
  company?: string;

  /** 企业职务 */
  companyDuty?: string;

  /** 成员图片\/用户头像 */
  headImgUrl?: string;

  /**  */
  provinceId?: number;

  /**  */
  province?: Province;

  /**  */
  cityId?: number;

  /**  */
  city?: City;

  /**  */
  areaId?: number;

  /**  */
  area?: Area;

  /** 住址 */
  address?: string;

  /** 自我介绍 */
  description?: string;

  /** 公众号openId */
  openId?: string;

  /** 小程序openId */
  miniOpenId?: string;

  /** 公众号UnionId */
  unionId?: string;

  /** 生日 */
  birthday?: Date;

  /** 部门Id */
  departmentId?: number;

  /**  */
  isDeleted?: boolean;

  /**  */
  deleterUserId?: number;

  /**  */
  deletionTime?: Date;

  /**  */
  lastModificationTime?: Date;

  /**  */
  lastModifierUserId?: number;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  id?: number;
}

export interface VolunteerDto {
  /** 用户Id */
  userId?: number;

  /**  */
  surName?: string;

  /**  */
  phoneNumber?: string;

  /**  */
  mobile?: string;

  /**  */
  idNo?: string;

  /**  */
  sex?: string;

  /**  */
  birthday?: Date;

  /**  */
  user?: UserDto;

  /**  */
  status?: VolunteerStatus;

  /** 审核通过时自动生成的唯一编号 */
  volunteerOrgCode?: string;

  /** 志愿者等级
默认为0，未来根据服务时长自动增加 */
  level?: number;

  /** 参加时间 */
  joinTime?: Date;

  /**  */
  extensionObject?: object;

  /**  */
  auditFlowId?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /**  */
  isAudited?: boolean;

  /**  */
  totalMinutes?: number;

  /** 服务时长
AgileBoost.Szcharity.CustomDtoMapper */
  totalHours?: number;

  /**  */
  userExtend?: UserExtendDto;

  /**  */
  id?: number;
}

export interface VolunteerDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: VolunteerDto[];
}

export interface VolunteerCreateOrUpdateDto {
  /** 姓名 */
  surName?: string;

  /** 手机号码 */
  mobile?: string;

  /** 身份证号码 */
  idNo?: string;

  /** 性别 */
  sex?: string;

  /** 生日 */
  birthday?: Date;

  /**  */
  formId?: number;

  /**  */
  extensionData?: string;

  /**  */
  extensionObject?: object;

  /**  */
  auditFlowId?: string;

  /**  */
  userId?: number;

  /**  */
  id?: number;
}

export interface VolunteerPagedResultRequestDto {
  /** 志愿者姓名 */
  volunteerName?: string;

  /** 志愿者手机号 */
  volunteerPhone?: string;

  /**  */
  volunteerId?: number;

  /** 志愿者编号 */
  volunteerCode?: string;

  /**  */
  includeUserExtend?: boolean;

  /**  */
  status?: VolunteerStatus;

  /**  */
  sorting?: string;

  /**  */
  skipCount?: number;

  /**  */
  maxResultCount?: number;
}

export interface BatchAuditDto {
  /**  */
  list?: AuditUserLogProxy[];
}

export interface VolunteerDtoListResultDto {
  /**  */
  items?: VolunteerDto[];
}

export interface VolunteerServiceHistoryCreateOrUpdateDto {
  /** 志愿者Id */
  volunteerId?: number;

  /** 对应的活动Id */
  activityId?: number;

  /** 服务开始时间 */
  serviceStartTime?: Date;

  /** 服务结束时间 */
  serviceEndTime?: Date;

  /** 服务时长（小时） */
  serviceHour?: number;

  /** 服务内容 */
  serviceContent?: string;

  /**  */
  serviceType?: ServiceType;

  /** 完成情况 */
  completeStatus?: string;

  /** 评价 */
  appraise?: string;

  /** 评价人姓名 */
  appraiserName?: string;

  /**  */
  id?: number;
}

export interface VolunteerServiceHistoryDto {
  /** 志愿者Id */
  volunteerId?: number;

  /**  */
  volunteer?: VolunteerDto;

  /** 对应的活动Id */
  activityId?: number;

  /**  */
  activity?: ActivityDto;

  /** 服务开始时间 */
  serviceStartTime?: Date;

  /** 服务结束时间 */
  serviceEndTime?: Date;

  /** 服务时常（分钟） */
  serviceMinute?: number;

  /** 服务时长（小时） */
  serviceHour?: number;

  /** 服务内容 */
  serviceContent?: string;

  /**  */
  serviceType?: ServiceType;

  /** 完成情况 */
  completeStatus?: string;

  /** 评价 */
  appraise?: string;

  /** 评价人姓名 */
  appraiserName?: string;

  /** 0：未核销，1：已核销 */
  checkStatus?: boolean;

  /**  */
  id?: number;
}

export interface UserVolunteerInfo {
  /** 服务时长 */
  serviceMinutes?: number;
}

export interface VolunteerServiceHistoryCreateOrUpdateDtoGetForEditOutput {
  /**  */
  data?: VolunteerServiceHistoryCreateOrUpdateDto;

  /**  */
  schema?: any | null;

  /**  */
  uiSchema?: any | null;

  /**  */
  errorSchema?: any | null;
}

export interface VolunteerServiceHistoryDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: VolunteerServiceHistoryDto[];
}

export enum TenantAvailabilityState {
  'Available' = 'Available',
  'InActive' = 'InActive',
  'NotFound' = 'NotFound'
}

export enum VerificationCode {
  'RegisterVercificationCodeSMS' = 'RegisterVercificationCodeSMS',
  'RetrivePasswordVercificationCodeSMS' = 'RetrivePasswordVercificationCodeSMS'
}

export enum ActivityStatus {
  'Deleted' = 'Deleted',
  'Saved' = 'Saved',
  'SendBacked' = 'SendBacked',
  'Submited' = 'Submited',
  'Approved' = 'Approved',
  'Published' = 'Published',
  'Finished' = 'Finished'
}

export enum ActivityTypeEnum {
  'GeneralActivity' = 'GeneralActivity',
  'VolunteerActivity' = 'VolunteerActivity'
}

export enum AttachmentHostType {
  'Temp' = 'Temp',
  'CmsContentTitleImage' = 'CmsContentTitleImage',
  'CmsContentAttachment' = 'CmsContentAttachment',
  'EditorImage' = 'EditorImage',
  'CmsCategory' = 'CmsCategory',
  'Swiper' = 'Swiper',
  'FriendlyLinkLogo' = 'FriendlyLinkLogo',
  'OrganizationUnit' = 'OrganizationUnit',
  'Message' = 'Message',
  'External_Project_Monthly_Summarize_Attachment' = 'External_Project_Monthly_Summarize_Attachment',
  'External_Project_Monthly_Summarize_Photo' = 'External_Project_Monthly_Summarize_Photo',
  'External_Project_Intention' = 'External_Project_Intention',
  'External_Project' = 'External_Project',
  'External_Project_Process_Monitoring' = 'External_Project_Process_Monitoring',
  'External_Project_Progress_Report' = 'External_Project_Progress_Report',
  'External_Project_Summary_Report' = 'External_Project_Summary_Report',
  'External_Project_Close_Report' = 'External_Project_Close_Report',
  'External_Project_Monthly_Summarize_Detail_Attachment' = 'External_Project_Monthly_Summarize_Detail_Attachment',
  'Internal_Project_Monthly_Summarize_Attachment' = 'Internal_Project_Monthly_Summarize_Attachment',
  'Internal_Project' = 'Internal_Project',
  'Internal_Project_Summary_Report' = 'Internal_Project_Summary_Report',
  'Internal_Personal_Year_End_Summary' = 'Internal_Personal_Year_End_Summary',
  'Internal_ServiceRecord' = 'Internal_ServiceRecord',
  'Beneficiary' = 'Beneficiary',
  'ProjectSeries' = 'ProjectSeries',
  'FundApply' = 'FundApply',
  'Fund' = 'Fund',
  'FundModifyApply' = 'FundModifyApply',
  'FundProjectApply' = 'FundProjectApply',
  'FundProject' = 'FundProject',
  'FundProjectModifyApply' = 'FundProjectModifyApply',
  'FundProjectProgress' = 'FundProjectProgress',
  'DonatedAmountConfig' = 'DonatedAmountConfig',
  'Invoice' = 'Invoice',
  'FundAppropriateApply' = 'FundAppropriateApply',
  'FundAppropriateRecord' = 'FundAppropriateRecord',
  'FundUser' = 'FundUser',
  'InvoiceInformation' = 'InvoiceInformation',
  'UserTask' = 'UserTask',
  'Activity' = 'Activity',
  'Job' = 'Job',
  'ApplicationPayment' = 'ApplicationPayment',
  'FundDonationOrder' = 'FundDonationOrder',
  'Volunteer' = 'Volunteer',
  'ElectronicInvoice' = 'ElectronicInvoice'
}

export enum ActivityQrType {
  'Detail' = 'Detail',
  'CheckIn' = 'CheckIn'
}

export enum ActivityApplyStatus {
  'Auditing' = 'Auditing',
  'Return' = 'Return',
  'WaitPay' = 'WaitPay',
  'Approved' = 'Approved',
  'Cancel' = 'Cancel'
}

export enum UserType {
  'Membership' = 'Membership',
  'Tenant' = 'Tenant',
  'Fund' = 'Fund',
  'Platform' = 'Platform'
}

export enum AuditFLowStatus {
  'Closed' = 'Closed',
  'Open' = 'Open'
}

export enum AuditFlowType {
  'AuditOne' = 'AuditOne',
  'AuditAll' = 'AuditAll'
}

export enum ApplyStatus {
  'Cancel' = 'Cancel',
  'Check' = 'Check',
  'Return' = 'Return',
  'Approved' = 'Approved'
}

export enum ClientType {
  'System' = 'System',
  'PC' = 'PC',
  'WeixinMini' = 'WeixinMini',
  'Weixin' = 'Weixin',
  'Backend' = 'Backend'
}

export enum ImportResultType {
  'Inserted' = 'Inserted',
  'Updated' = 'Updated',
  'NotFound' = 'NotFound',
  'ValidationError' = 'ValidationError',
  'Error' = 'Error',
  'DataConvertFailed' = 'DataConvertFailed',
  'Exist' = 'Exist'
}

export enum OrderType {
  'Activity' = 'Activity',
  'Course' = 'Course'
}

export enum OrderStatus {
  'NotPay' = 'NotPay',
  'Expired' = 'Expired',
  'Finished' = 'Finished',
  'Refunded' = 'Refunded',
  'Cancel' = 'Cancel'
}

export enum AuditFlowScope {
  'All' = 'All',
  'PartnerApply' = 'PartnerApply',
  'ExternalProjectIntention' = 'ExternalProjectIntention',
  'DueDiligenceRecord' = 'DueDiligenceRecord',
  'ExternalProject' = 'ExternalProject',
  'ExternalMonthlyPlan' = 'ExternalMonthlyPlan',
  'ExternalMonthlySummarize' = 'ExternalMonthlySummarize',
  'ExternalProjectAdjustment' = 'ExternalProjectAdjustment',
  'ExternalProjectProgressReport' = 'ExternalProjectProgressReport',
  'ExternalProjectProcessMonitoring' = 'ExternalProjectProcessMonitoring',
  'ExternalProjectSummaryReport' = 'ExternalProjectSummaryReport',
  'ExternalProjectCloseReport' = 'ExternalProjectCloseReport',
  'InternalProject' = 'InternalProject',
  'InternalMonthlyPlan' = 'InternalMonthlyPlan',
  'InternalMonthlySummarize' = 'InternalMonthlySummarize',
  'InternalProjectSummaryReport' = 'InternalProjectSummaryReport',
  'InternalPersonalYearEndSummary' = 'InternalPersonalYearEndSummary',
  'Beneficiary' = 'Beneficiary',
  'ServiceRecord' = 'ServiceRecord',
  'ProjectBebeficiaryMapping' = 'ProjectBebeficiaryMapping',
  'CapitalIncomeRecordFromDonation' = 'CapitalIncomeRecordFromDonation',
  'CapitalIncomeRecordFromOther' = 'CapitalIncomeRecordFromOther',
  'PartnerCapitalApply' = 'PartnerCapitalApply',
  'CapitalExpenseRecord' = 'CapitalExpenseRecord',
  'FundApply' = 'FundApply',
  'FundModifyApply' = 'FundModifyApply',
  'FundProjectApply' = 'FundProjectApply',
  'FundProjectModifyApply' = 'FundProjectModifyApply',
  'FundNonCashDonation' = 'FundNonCashDonation',
  'FundAppropriateApply' = 'FundAppropriateApply',
  'Application_Payment_Current_Expenses_Le_5' = 'Application_Payment_Current_Expenses_Le_5',
  'Application_Payment_Current_Expenses_Gt_5' = 'Application_Payment_Current_Expenses_Gt_5',
  'Application_Payment_Expenditure_Charitable_Projects_Le_20' = 'Application_Payment_Expenditure_Charitable_Projects_Le_20',
  'Application_Payment_Expenditure_Charitable_Projects_Gt_20' = 'Application_Payment_Expenditure_Charitable_Projects_Gt_20',
  'Application_Payment_Physical_Investment_Le_100' = 'Application_Payment_Physical_Investment_Le_100',
  'Application_Payment_Physical_Investment_Gt_100' = 'Application_Payment_Physical_Investment_Gt_100',
  'Application_Payment_Investment_Financing_Le_500' = 'Application_Payment_Investment_Financing_Le_500',
  'Application_Payment_Investment_Financing_Gt_500' = 'Application_Payment_Investment_Financing_Gt_500',
  'Application_Payment_Internal_Business_Reconciliation_Le_20' = 'Application_Payment_Internal_Business_Reconciliation_Le_20',
  'Application_Payment_Internal_Business_Reconciliation_Gt_20' = 'Application_Payment_Internal_Business_Reconciliation_Gt_20',
  'Application_Payment_Other' = 'Application_Payment_Other',
  'UserTask' = 'UserTask',
  'Actiivty_Apply' = 'Actiivty_Apply',
  'Volunteer' = 'Volunteer'
}

export enum AuditUserLogStatus {
  'Reject' = 'Reject',
  'Pass' = 'Pass',
  'Back' = 'Back',
  'Continue' = 'Continue'
}

export enum ApprovalCategory {
  'Current_Expenses' = 'Current_Expenses',
  'Expenditure_Charitable_Projects' = 'Expenditure_Charitable_Projects',
  'Physical_Investment' = 'Physical_Investment',
  'Investment_Financing' = 'Investment_Financing',
  'Internal_Business_Reconciliation' = 'Internal_Business_Reconciliation',
  'Other' = 'Other'
}

export enum CurrencyType {
  'RMB' = 'RMB'
}

export enum FundProjectType {
  'Professional' = 'Professional',
  'Personal' = 'Personal',
  'Online' = 'Online',
  'Offline' = 'Offline'
}

export enum ApplicationPaymentValidationStatus {
  'Success' = 'Success',
  'Fail' = 'Fail'
}

export enum ServiceRecordType {
  'Beneficiary' = 'Beneficiary',
  'School' = 'School'
}

export enum WorkflowOfProjectByExternal {
  'ProjectApproval' = 'ProjectApproval',
  'ProgressReport' = 'ProgressReport',
  'SummaryReport' = 'SummaryReport',
  'Closed' = 'Closed',
  'Termination' = 'Termination'
}

export enum ProjectServiceRecordCompleteStatus {
  'NotComplete' = 'NotComplete',
  'PartialComplete' = 'PartialComplete',
  'AllComplete' = 'AllComplete'
}

export enum PayType {
  'Cash' = 'Cash',
  'Transfer' = 'Transfer'
}

export enum ChangeState {
  'UnActive' = 'UnActive',
  'Active' = 'Active'
}

export enum ProjectBudgetCategory {
  'BusinessActivityCost' = 'BusinessActivityCost'
}

export enum ProjectBudgetType {
  'ActivityCost' = 'ActivityCost',
  'AdvertiseCost' = 'AdvertiseCost',
  'AdministrativeCost' = 'AdministrativeCost',
  'PersonnelSalary' = 'PersonnelSalary',
  'Other' = 'Other'
}

export enum ProjectBudgetCapitalSource {
  'Apply' = 'Apply',
  'Self' = 'Self',
  'Other' = 'Other'
}

export enum CapitalProperty {
  'NonFinite' = 'NonFinite',
  'Finite' = 'Finite'
}

export enum IncomeCategory {
  'Interest' = 'Interest',
  'Investment' = 'Investment',
  'Other' = 'Other'
}

export enum CmsCategoryType {
  'Content' = 'Content',
  'Article' = 'Article'
}

export enum CmsContentStatus {
  'Draft' = 'Draft',
  'Published' = 'Published',
  'Deleted' = 'Deleted'
}

export enum DonorType {
  'Personal' = 'Personal',
  'Group' = 'Group',
  'Enterprise' = 'Enterprise'
}

export enum IncomeType {
  'Project' = 'Project',
  'Fund' = 'Fund',
  'Org' = 'Org'
}

export enum ValidStatus {
  'Deleted' = 'Deleted',
  'InValid' = 'InValid',
  'Valid' = 'Valid'
}

export enum ElectronicInvoiceType {
  'Personal' = 'Personal',
  'EnOrOtherOrg' = 'EnOrOtherOrg'
}

export enum CollectWaterStatus {
  'Waiting' = 'Waiting',
  'Confirmed' = 'Confirmed'
}

export enum CustomFormType {
  'OrganizationUnit' = 'OrganizationUnit',
  'InternalProject' = 'InternalProject',
  'Beneficiary' = 'Beneficiary',
  'BeneficiaryServiceRecord' = 'BeneficiaryServiceRecord',
  'SchoolServiceRecord' = 'SchoolServiceRecord',
  'Volunteer' = 'Volunteer',
  'ApplicationPayment' = 'ApplicationPayment'
}

export enum CustomFormDataSourceType {
  'Enum' = 'Enum',
  'DataDictionary' = 'DataDictionary',
  'CustomValues' = 'CustomValues'
}

export enum DonationType {
  'Monthly' = 'Monthly',
  'Commemorative' = 'Commemorative',
  'Birthday' = 'Birthday',
  'Festival' = 'Festival'
}

export enum DonorItemType {
  'NonDirectional' = 'NonDirectional',
  'NamingFund' = 'NamingFund',
  'ProjectDonor' = 'ProjectDonor'
}

export enum DonationCycle {
  'Weekly' = 'Weekly',
  'Monthly' = 'Monthly',
  'Year' = 'Year'
}

export enum DataDictionarySyncMode {
  'MinimumEffect' = 'MinimumEffect',
  'Force' = 'Force'
}

export enum DataPermissionLimitHostType {
  'CmsCategory' = 'CmsCategory'
}

export enum DataPermissionLimitTargetType {
  'User' = 'User',
  'Role' = 'Role'
}

export enum DonatedAmountConfigSourceType {
  'Fund' = 'Fund',
  'FundProject' = 'FundProject'
}

export enum ElectronicInvoiceStatus {
  'ToBeConfirmed' = 'ToBeConfirmed',
  'BillingInProgress' = 'BillingInProgress',
  'Invoiced' = 'Invoiced',
  'Invalid' = 'Invalid',
  'Failed' = 'Failed'
}

export enum ProjectMonthlyPlanCompleteStatus {
  'None' = 'None',
  'Adjust' = 'Adjust',
  'Complete' = 'Complete'
}

export enum ProjectPhaseStatus {
  'NoTask' = 'NoTask',
  'None' = 'None',
  'Ongoing' = 'Ongoing',
  'DelayComplete' = 'DelayComplete',
  'Complete' = 'Complete'
}

export enum FeedbackSourceType {
  'Reception' = 'Reception',
  'Backstage' = 'Backstage'
}

export enum DonateType {
  'NormalDonate' = 'NormalDonate',
  'MonthlyDonate' = 'MonthlyDonate',
  'ProjectNormalDonate' = 'ProjectNormalDonate',
  'ProjectMonthlyDonate' = 'ProjectMonthlyDonate'
}

export enum FundType {
  'Professional' = 'Professional'
}

export enum MessageType {
  'ProjectProgress' = 'ProjectProgress',
  'Organization' = 'Organization',
  'System' = 'System',
  'Fund' = 'Fund',
  'FundProjectProgress' = 'FundProjectProgress',
  'Donor' = 'Donor'
}

export enum FundAccountRecordOperationType {
  'Income' = 'Income',
  'Appropriate' = 'Appropriate',
  'ManageFee' = 'ManageFee',
  'ManageFeeReturn' = 'ManageFeeReturn',
  'ManageFeeAdd' = 'ManageFeeAdd'
}

export enum FundAppropriateType {
  'FundProject' = 'FundProject',
  'Fund' = 'Fund',
  'CaseAppropriation' = 'CaseAppropriation',
  'InternalAppropriation' = 'InternalAppropriation',
  'QuotaAppropriationInTheAnnualPlan' = 'QuotaAppropriationInTheAnnualPlan',
  'SCHProject' = 'SCHProject',
  'SCHPersonal' = 'SCHPersonal',
  'SCHIllness' = 'SCHIllness',
  'FinancingCost' = 'FinancingCost',
  'PerformCost' = 'PerformCost',
  'ProjectCost' = 'ProjectCost',
  'Goods' = 'Goods',
  'TencentDay' = 'TencentDay',
  'PoorDay' = 'PoorDay',
  'Directional' = 'Directional',
  'SupportDepartment' = 'SupportDepartment',
  'CounterpartsSupport' = 'CounterpartsSupport',
  'Other' = 'Other'
}

export enum ManagerFeeChangeType {
  'ManageFeeAdd' = 'ManageFeeAdd',
  'ManageFeeReturn' = 'ManageFeeReturn'
}

export enum FundProjectStatus {
  'Deleted' = 'Deleted',
  'InValid' = 'InValid',
  'Valid' = 'Valid',
  'End' = 'End'
}

export enum WorkflowOfProjectByInternal {
  'ProjectApproval' = 'ProjectApproval',
  'Closed' = 'Closed',
  'Termination' = 'Termination'
}

export enum NotifyTemplateType {
  'ProjectAssessmentPlan' = 'ProjectAssessmentPlan',
  'OrganizationInvestigation' = 'OrganizationInvestigation'
}

export enum OrganizationStatus {
  'Pending' = 'Pending',
  'Approved' = 'Approved',
  'Rejected' = 'Rejected'
}

export enum PermissionDefinitionScope {
  'Foundation' = 'Foundation',
  'Partner' = 'Partner'
}

export enum DataPermissionScopeType {
  'All' = 'All',
  'Mine' = 'Mine',
  'MyDepartment' = 'MyDepartment',
  'MyDepartmentAndSubs' = 'MyDepartmentAndSubs',
  'Specified' = 'Specified'
}

export enum TenantAccountRecordType {
  'Income' = 'Income',
  'Outcome' = 'Outcome',
  'ManageFee' = 'ManageFee',
  'ManageFeeReturn' = 'ManageFeeReturn',
  'ManageFeeAdd' = 'ManageFeeAdd'
}

export enum TaskType {
  'Volunteer' = 'Volunteer',
  'Office' = 'Office'
}

export enum TaskStatus {
  'Waiting' = 'Waiting',
  'SendBack' = 'SendBack',
  'Executing' = 'Executing',
  'Submit' = 'Submit',
  'Complete' = 'Complete',
  'Incomplete' = 'Incomplete'
}

export enum VolunteerStatus {
  'Pending' = 'Pending',
  'Approved' = 'Approved',
  'Rejected' = 'Rejected',
  'Baned' = 'Baned'
}

export enum ServiceType {
  'PunchCard' = 'PunchCard',
  'TaskExecute' = 'TaskExecute',
  'ImportExcel' = 'ImportExcel'
}
